export default {
  loading: "Đang tải",
  quantity: "Số lượng",
  name: "Tên",
  all: "Tất cả",
  yes: "Có",
  no: "Không",
  or: "Hoặc",
  and: "Và",
  in_all: "Tổng cộng",
  Query: "Tra cứu",
  creation: "Tạo",
  Batchquery: "Tra cứu hàng loạt",
  delete: "Xóa",
  checkAll: "Chọn tất cả",
  Save_export_condition: "Lưu điều kiện xuất",
  Total_print: "In tổng số",
  successfully_delete: "Xóa thành công!",
  error_Message: "Thông báo lỗi",
  edit: "Chỉnh sửa",
  editUser: "Chỉnh sửa người dùng",
  confirm: "Xác nhận",
  print: "In",
  today: "Hôm nay",
  yesterday: "Hôm qua",
  enterprise: "Doanh nghiệp",
  personage: "Cá nhân",
  Before_yesterday: "Ngày hôm trước",
  printLog: "In nhật ký",
  check: "Xem",
  Button: "Nút",
  notice: "Ghi chú",
  revocation: "Hủy",
  Query_content: "Nội dung tra cứu",
  Scanning_successful: "Quét thành công",
  successful_operation: "Thao tác thành công!",
  Please_select_orders_to_operate: "Vui lòng chọn đơn hàng cần thao tác",
  Please_select_same_platform_orders:
    "Vui lòng chọn đơn hàng trên cùng một nền tảng để thao tác",
  The_query_is_successful: "Truy vấn thành công",
  Delete_success: "Xóa thành công!",
  operation_failed: "Thao tác thất bại!",
  more: "Thêm",
  click_to_download: "Nhấp để tải xuống",
  More_operations: "Thao tác thêm",
  More_Conditions: "Điều kiện thêm",
  Displaystatus: "Hiển thị trạng thái",
  According: "Hiển thị",
  Total_declared_value: "Tổng giá trị khai báo",
  NoAccording: "Không hiển thị",
  Download_via_QR_code: "Tải xuống qua mã QR",
  Please_select_display_status: "Vui lòng chọn trạng thái hiển thị",
  Path_is_None_Check_whether_the_address_is_correct:
    "Địa chỉ trống, vui lòng kiểm tra xem địa chỉ đã nhập có chính xác không!",
  Is_this_a_piece_of_content_sure_to_delete:
    "Bạn có chắc chắn muốn xóa nội dung này không?",
  phone_number: "Số điện thoại di động",
  Payment_order_number: "Số đơn hàng thanh toán",
  Please_enter_a_phone_number: "Vui lòng nhập số điện thoại di động",
  SystemSettings: "Cài đặt hệ thống",
  please_enter: "Vui lòng nhập",
  old_password: "Mật khẩu cũ",
  Please_enter_your_old_password: "Vui lòng nhập mật khẩu cũ",
  new_password: "Mật khẩu mới",
  Please_enter_basket_length_width_and_height:
    "Vui lòng nhập chiều dài, chiều rộng và chiều cao của giỏ hàng",
  Please_enter_the_order_number: "Vui lòng nhập số đơn hàng",
  Please_enter_the_search_criteria: "Vui lòng nhập điều kiện tìm kiếm",
  uploading: "Tải lên",
  next_step: "Bước tiếp theo",
  last_step: "Bước trước",
  change_password: "Sửa mật khẩu",
  Mission_center: "Trung tâm nhiệm vụ",
  TaskCenter: "Trung tâm nhiệm vụ",
  TaskCenterRegulates: "Quản lý trung tâm nhiệm vụ",
  TaskCenterList: "Trung tâm nhiệm vụ",
  Drag_and_drop_upload: "Kéo và thả để tải lên",
  Successfully_copied_to_clipboard: "Đã sao chép thành công vào khay nhớ tạm",
  Unable_to_copy_to_clipboard: "Không thể sao chép vào khay nhớ tạm",
  The_form_verification_fails_Please_modify_and_try_again:
    "Kiểm tra biểu mẫu không thành công, vui lòng sửa lại và thử lại",
  The_selected_data_is_empty: "Dữ liệu được chọn trống",
  The_added_data_is_empty: "Dữ liệu được thêm vào trống",
  systematic_notification: "Thông báo hệ thống",
  open_in_new_window: "Mở cửa sổ mới",
  successfully_upload: "Tải lên thành công",
  Specify_export_order: "Chỉ định xuất đơn hàng",
  Specified_export_goods: "Chỉ định xuất hàng hóa",
  Export_task_Id: "Xuất ID nhiệm vụ",
  Derived_exception: "Xuất bất thường",
  View_Personal_details: "Xem chi tiết cá nhân",
  not_modified: "Chưa sửa đổi",
  save_as_PDF: "Lưu dưới dạng PDF",
  Download_sheet: "Tải xuống phiếu giao hàng",
  ToolDownload: "Tải xuống công cụ",
  toolName: "Tên công cụ",
  remote_control_software: "Phần mềm điều khiển từ xa",
  Print_plug_in: "Plugin in",
  PDABrowser: "Trình duyệt PDA",
  It_can_be_downloaded_by_clicking_the_button_and_scanning_the_QR_code_by_touching_the_button:
    "Có thể tải xuống bằng cách nhấp vào nút hoặc chạm vào nút để quét mã QR",
  The_user_does_not_have_any_permission_Please_assign_the_permission_to_the_superior_of_the_user:
    "Người dùng này không có bất kỳ quyền nào, vui lòng yêu cầu cấp trên của người dùng đó cấp quyền tương ứng",
  To_use_system_printing_you_need_to_download_a_print_plugin:
    "Cần tải xuống plugin in để sử dụng chức năng in của hệ thống",
  The_current_user_has_no_permission_Please_set_the_permission_and_log_in_again:
    "Người dùng hiện tại chưa được cấp quyền, vui lòng cấp quyền rồi thử đăng nhập lại",
  Using_the_specified_export_order_data_will_overwrite_the_list_of_selected_order_data:
    "Sử dụng xuất dữ liệu đơn hàng được chỉ định sẽ ghi đè lên dữ liệu đơn hàng được chọn trong danh sách",
  This_order_has_not_been_shipped_out_of_the_warehouse_and_cannot_be_reprinted:
    "Đơn hàng này chưa được xuất kho, không thể in lại phiếu giao hàng",
  Interface_communication_failed_Please_refresh_the_page_or_log_in_again_If_the_problem_persists_contact_the_administrator:
    "Giao tiếp giao diện thất bại, vui lòng làm mới trang hoặc đăng nhập lại. Nếu vấn đề vẫn còn, vui lòng liên hệ với quản trị viên",
  Enter_the_client: "Vào ứng dụng khách",
  query_condition: "Điều kiện tìm kiếm",
  Home: "Trang chủ",
  return: "Quay lại",
  Please_upload: "Vui lòng tải lên",
  The_upload_format_is: "Định dạng tải lên là",
  The_file_format_was_wrong_last_time: "Định dạng tệp tải lên không chính xác",
  The_uploaded_file_exceeds_the_specified_size_Procedure:
    "Tệp tải lên vượt quá kích thước quy định, tải lên không thành công.",
  Shop_status: "Trạng thái cửa hàng",
  normal: "Bình thường",
  Authorization_expired: "Quyền truy cập đã hết hạn",
  One_click_out_of_storage: "Xuất kho bằng một nút",
  can_only_choose_one: "Chỉ có thể chọn một",
  Go_to_the_service_platform: "Chuyển đến nền tảng dịch vụ",
  api_Order: "Đơn hàng Api",
  Notification_form: "Đơn hàng đẩy",
  Please_clear_template_format: "Vui lòng xóa định dạng mẫu.",
  announcementsList: "Danh sách thông báo",
  successful_operation_exist: "Đã tồn tại Cấu hình kho thành công",
  new: "Mới",
  no_blank_remains: "Không để trống dòng",
  mass_export: "Xuất hàng loạt",
  Print_controls: "Điều khiển in",
  test: "Kiểm tra",
  The_store_backend_address_must_be_exactly_the_same_as_the_shipping_warehouse_address:
    "Địa chỉ hậu trường cửa hàng phải hoàn toàn trùng khớp với địa chỉ kho xuất hàng.",
  Password: "Mật khẩu",
  Authentication_Code: "Mã xác minh",
  Can_Exchange: "Không nhìn rõ? Nhấp để thay đổi",
  Remember_Password: "Ghi nhớ mật khẩu",
  Login: "Đăng nhập",
  Register_Account: "Đăng ký tài khoản",
  Confirm_PassWord: "Xác nhận mật khẩu",
  Account_Manager_ID: "Số nhân viên quản lý khách hàng",
  identity_card: "Chứng minh nhân dân",
  business_license: "Giấy phép kinh doanh",
  Please_Input_Password: "Vui lòng nhập mật khẩu",
  The_Passwords_Entered_Do_Not_Match: "Hai mật khẩu nhập không khớp nhau",
  Please_Input_Phone_Number: "Vui lòng nhập số điện thoại di động",
  Please_Input_Verification_Code: "Vui lòng nhập mã xác minh",
  Too_Many_Requests_Please_Try_Again_Later:
    "Hoạt động quá thường xuyên, vui lòng thử lại sau!",
  The_SMS_Verification_Code_Has_Been_Sent_Procedure:
    "Đã gửi mã xác minh qua SMS",
  Obtain_SMS_Verification_Code: "Nhận mã xác minh qua SMS",
  Sending_The_Verification_Code: "Đang gửi mã xác minh",
  Email: "Email",
  Phone_Number: "Số điện thoại di động",
  Message_Authentication_Code: "Mã xác minh qua tin nhắn",
  Please_Enter_A_Valid_Email: "Vui lòng nhập địa chỉ email chính xác",
  The_Current_User_Has_Not_Been_Granted_Permissions_Please_Set_The_Permissions_And_Then_Try_Logging_In_Again:
    "Người dùng hiện tại chưa thiết lập quyền, vui lòng thiết lập quyền trước khi thử đăng nhập lại",
  Too_Many_Errors_Please_Enter_The_Verification_Code_And_Try_Again:
    "Số lần lỗi quá nhiều, vui lòng nhập mã xác minh và thử lại",
  Automatic_login_failed_Please_enter_your_account_and_password_manually:
    "Đăng nhập tự động không thành công, vui lòng nhập tài khoản và mật khẩu thủ công",
  Logging_In_Automatically: "Đang đăng nhập tự động",
  Chinese: "Tiếng Trung",
  English: "Tiếng Anh",
  OMS_System: "Ứng dụng khách OMS",
  OMS_System_Admin: "Bảng điều khiển quản lý OMS",
  UserAccount: "Tài khoản người dùng",
  password: "Mật khẩu",
  RememberPassword: "Ghi nhớ mật khẩu",
  ForgotPassword: "Quên mật khẩu",
  RegisterAccount: "Đăng ký tài khoản",
  Register: "Đăng ký",
  login: "Đăng nhập",
  Please_enter_a_user_account: "Chưa nhập tài khoản người dùng",
  Please_enter_the_user_password: "Chưa nhập mật khẩu",
  Obtain_SMS_verification_code: "Nhận mã xác minh qua tin nhắn",
  SignIn: "Đang đăng nhập",
  LoginSuccessful: "Đăng nhập thành công",
  language: "Ngôn ngữ",
  LogOut: "Đăng xuất",
  Skip_logistics_system: "Chuyển sang hệ thống logistics",
  No_need_to_export_content: "Không cần xuất nội dung",
  waiting_in_line: "Đang xếp hàng",
  No_data_yet: "Không có dữ liệu",
  Account_manager_ID: "Số nhân viên quản lý khách hàng",
  message_authentication_code: "Mã xác minh qua tin nhắn",
  The_SMS_verification_code_has_been_sent_Procedure:
    "Đã gửi mã xác minh qua tin nhắn",
  authentication_code: "Mã xác minh",
  Sending_the_verification_code: "Đang gửi mã xác minh",
  Can_exchange: "Không nhìn rõ? Nhấp để thay đổi",
  Export_successfully: "Xuất thành công!",
  Export_task: "Nhiệm vụ xuất",
  print_out_task: "Nhiệm vụ in",
  Derivation_time: "Thời gian xuất",
  Derived_state: "Trạng thái xuất",
  exporting: "Đang xuất",
  Recalculation_successful: "Tính toán lại thành công",
  It_is_being_saved_as_a_PDF: "Đang lưu dưới dạng PDF",
  The_PDF_export_was_successful_The_automatic_download_has_started_If_it_does_not_start_automatically_please_refresh_and_try_again:
    "Xuất PDF thành công, bắt đầu tải xuống tự động, nếu không tự động bắt đầu, vui lòng làm mới và thử lại",
  Export_task_name: "Tên nhiệm vụ",
  download: "Tải xuống",
  download_successfully: "Tải xuống thành công",
  Too_many_errors_Please_enter_the_verification_code_and_try_again:
    "Quá nhiều lỗi, vui lòng nhập mã xác minh và thử lại",
  fopltal: "Thao tác quá thường xuyên, vui lòng thử lại sau!",
  Frequent_operation_please_try_again_later:
    "Thao tác quá thường xuyên, vui lòng thử lại sau!",
  Business_license: "Giấy phép kinh doanh",
  Business_license_File: "Tài liệu giấy phép kinh doanh",
  Identity_card: "Chứng minh nhân dân",
  ID_card_document: "Tài liệu chứng minh nhân dân",
  Identity_card_code: "Số chứng minh nhân dân",
  ID_card_number_of_legal_person: "Số chứng minh nhân dân của pháp nhân",
  Please_enter_the_ID_card_number_of_the_legal_person:
    "Vui lòng nhập số chứng minh nhân dân của pháp nhân",
  Please_enter_the_ID_number: "Vui lòng nhập số chứng minh nhân dân",
  Default_customer: "Khách hàng mặc định",
  Do_you_want_to_confirm_the_cancellation: "Xác nhận hủy bỏ?",
  express_sheet: "Phiếu giao hàng",
  Confirm_activation: "Xác nhận kích hoạt?",
  Please_upload_PDF_file: "Vui lòng tải lên tệp PDF",
  delivered: "Đã giao hàng",
  One_click_export_across_warehouses_is_not_allowed:
    "Không cho phép xuất kho một lần cho nhiều kho!",
  Please_select_the_recipient_country_first_the_receipt_will_be_saved_to_the_server_in_the_corresponding_region:
    "Vui lòng chọn quốc gia của người nhận trước, phiếu giao hàng sẽ được lưu trữ trên máy chủ của khu vực tương ứng",
  data_reorganizing: "Đang sắp xếp dữ liệu",
  Please_upload_the_front_and_back_of_your_ID_card:
    "Vui lòng tải lên mặt trước và mặt sau của chứng minh nhân dân",
  Menu_authorization: "Ủy quyền menu",
  goodsOnline: "Sản phẩm trực tuyến",
  adminGoodsOnline: "Sản phẩm trực tuyến",
  menuID: "ID menu",
  authorization: "Ủy quyền",
  editRoleInfo: "Chỉnh sửa vai trò",
  createRoleInfo: "Tạo vai trò",
  Role_ordering: "Sắp xếp vai trò",
  UserCenter: "Trung tâm cá nhân",
  workbench: "Bàn làm việc",
  announceList: "Danh sách thông báo",
  Processing_Center: "Trung tâm xử lý",
  Outbound: "Xuất kho",
  Order: "Đơn hàng",
  pendingOrders: "Đơn hàng chờ giao",
  Basic_configuration: "Cấu hình cơ bản",
  BasicConfiguration: "Cấu hình cơ bản",
  basketList: "Danh sách giỏ hàng",
  fixedSkuFee: "Phí Sku cố định",
  consumables: "Loại vật tư tiêu hao",
  log: "Nhật ký",
  logType: "Loại nhật ký",
  Please_upload_the_national_emblem_and_portrait:
    "Vui lòng tải lên mặt quốc huy và mặt chân dung",
  oprateLog: "Nhật ký hoạt động",
  oprateInfo: "Thông tin hoạt động",
  Please_enter_a_keyword_to_search: "Vui lòng nhập từ khóa để tìm kiếm",
  MenuRemark: "Ghi chú menu",
  Please_select_whether_to_enable_it: "Vui lòng chọn có kích hoạt hay không",
  Please_select_menu_type: "Vui lòng chọn loại menu",
  menu: "Menu",
  MenuManagement: "Quản lý menu",
  Please_enter_a_menu_name: "Vui lòng nhập tên menu",
  Menu_name: "Tên menu",
  Please_add_the_menu: "Vui lòng thêm menu trước",
  The_same_name_menu_is_not_allowed: "Không cho phép có menu trùng tên!",
  The_data_is_incorrect_adding_failed: "Dữ liệu sai, thêm không thành công",
  viewWarehouseEntry: "Xem phiếu nhập kho",
  PDAStatus: "Trạng thái PDA",
  Task_generation_type: "Loại tạo nhiệm vụ",
  Jump_to_old_system: "Chuyển đến hệ thống cũ",
  This_operation_will_be_one_click_out_of_the_warehouse_and_can_not_be_undone_be_sure_to_confirm_that_the_order_is_complete_careful_operation:
    "Thao tác này sẽ xuất kho bằng một nút bấm và không thể hủy bỏ, hãy đảm bảo rằng hàng hóa trong đơn hàng đầy đủ, hãy thao tác cẩn thận!",
  videoPhotoManagement: "Quản lý quay phim và chụp ảnh",
  storageSpaceServersWarehouse: "Dung lượng lưu trữ máy chủ trong kho",
  videoPhotographyManagementControl: "Kiểm soát quản lý quay phim và chụp ảnh",
  videoPhotoList: "Danh sách quay phim và chụp ảnh",
  returnGoodsRegistrationShelving:
    "Đăng ký trả hàng nhanh Kiểm tra chất lượng và lên kệ",
  returnInventoryManagement: "Quản lý hàng trả lại",
  returnInventoryList: "Danh sách hàng trả lại",
  ShopeeProfitReport: "Báo cáo lợi nhuận Shopee",
  warehouseLevelReport: "Báo cáo dữ liệu thu chi cấp kho",
  platformLevelReport: "Báo cáo dữ liệu thu chi cấp nền tảng",
  customerLevelReport: "Báo cáo dữ liệu thu chi cấp khách hàng",
  storeLevelReport: "Báo cáo dữ liệu thu chi cấp cửa hàng",
  orderLevelReport: "Báo cáo dữ liệu thu chi cấp đơn hàng",
  shopeeOrderProfitReport: "Báo cáo lợi nhuận đơn hàng Shopee",
  shopeeStoreReport: "Báo cáo lợi nhuận cửa hàng Shopee",
  currencyExchangeRate: "Tỷ giá hối đoái",
  currencyExchangeRateList: "Danh sách tỷ giá hối đoái",
  returnWarehouseFlowList: "Danh sách lưu chuyển hàng trả lại kho",
  costRecalculation: "Tính toán lại chi phí",
  chargeGiveSpecial: "Chi phí đặc biệt",
  ShopeeReport: "Báo cáo Shopee",
  TikTokOrderProfitReport: "Báo cáo lợi nhuận đơn hàng TikTok",
  logisticsHandover: "Giao nhận logistics",
  logisticsHandoverTaskList: "Danh sách nhiệm vụ chuyển giao logistics",
  taskScanningFlowList: "Danh sách quét nhiệm vụ",
  handoverTaskList: "Nhiệm vụ chuyển giao",
  tikTokStoreProfitReport: "Báo cáo lợi nhuận cửa hàng TikTok",
  lazadaProfitReport: "Báo cáo lợi nhuận Lazada",
  lazadaOrderProfitReport: "Báo cáo lợi nhuận đơn hàng Lazada",
  lazadaStoreProfitReport: "Báo cáo lợi nhuận cửa hàng Lazada",
  generateInventoryPlan: "Tạo kế hoạch dự trữ hàng",
  inventoryPlanManagement: "Quản lý đơn hàng dự trữ",
  TikTokProfitReport: "Báo cáo lợi nhuận TikTok",
  viewInventoryPlanManagement: "Xem quản lý đơn hàng dự trữ",
  taskFlow: "Danh sách hoạt động nhiệm vụ",
  systemDeductionControl: "Kiểm soát phí hệ thống",
  contractAuthorization: "Ủy quyền hợp đồng",
  contractListCheck: "Xem hợp đồng",
  logisticsHandoverScanningLog: "Nhật ký quét chuyển giao logistics",
  itemTypeRuleSettings: "Cài đặt quy tắc loại hàng",
  addLogisticsChannel: "Tạo kênh logistics",
  editLogisticsChannel: "Chỉnh sửa kênh logistics",
  listOfChannelsToBeConfirmed: "Danh sách kênh chờ xác nhận",
  newlyDevelopedCustomerSetting: "Cài đặt khách hàng mới",
  parent_directory: "Thư mục cấp trên",
  Dictionary_management: "Quản lý từ điển",
  explain: "Mô tả",
  Please_enter_explain: "Vui lòng nhập mô tả",
  warning: "Cảnh báo",
  cancel_authorization: "Hủy ủy quyền",
  Definitive_de_authorization: "Xác nhận hủy ủy quyền?",
  apiPushMotificationList: "Danh sách đẩy",
  platform: "Nền tảng",
  shop: "Cửa hàng",
  Please_select_CustomerId: "Vui lòng chọn ID khách hàng",
  Please_select_shop: "Vui lòng chọn cửa hàng",
  Only_a_single_store_can_be_selected: "Chỉ hỗ trợ chọn một cửa hàng",
  The_transaction_number_and_order_time_cannot_be_empty_at_the_same_time:
    "Số giao dịch và thời gian đặt hàng không thể để trống cùng lúc",
  warehouse: "Kho",
  Warehouse_name: "Tên kho",
  Warehouse_code: "Mã kho",
  storage_location: "Vị trí kho",
  order_number: "Số đơn hàng",
  transaction_number: "Số giao dịch",
  waybill_number: "Số vận đơn",
  logistics_channel: "Kênh logistics",
  Logistics_track: "Hành trình logistics",
  Only_orders_entered_into_the_system_at_the_current_time_15_days_are_processed:
    "Chỉ xử lý các đơn hàng trong vòng 15 ngày kể từ thời điểm hiện tại",
  search: "Tìm kiếm",
  type: "Loại",
  state: "Trạng thái",
  time: "Thời gian",
  country: "Quốc gia",
  Please_enter_country: "Vui lòng nhập quốc gia",
  oprate: "Hoạt động",
  operation_log: "Nhật ký hoạt động",
  thumbnail: "Hình thu nhỏ",
  Bar_code_of_goods: "Mã vạch sản phẩm",
  Commodity_bar_code_and_two_dimensional_code: "Mã QR mã vạch sản phẩm",
  stock_position: "Vị trí kho",
  Orders_in_the_fulfillment: "Đơn hàng đang phân phối",
  Pending_sorting_tasks: "Nhiệm vụ phân loại đang chờ xử lý",
  Sorting_tasks: "Nhiệm vụ phân loại đang xử lý",
  Pending_shipment: "Đang chờ giao hàng",
  In_transit: "Đang giao hàng",
  Irregularity_in_delivery: "Lỗi phân phối",
  Abnormal_quantity_of_distribution: "Số lượng lỗi phân phối",
  The_sorting_task_is_abnormal: "Lỗi nhiệm vụ phân loại",
  Shipment_exception: "Lỗi giao hàng",
  Abnormal_shipment_quantity: "Số lượng lỗi giao hàng",
  log_list: "Danh sách nhật ký",
  Document_ID: "ID hóa đơn",
  task_order_number: "Số nhiệm vụ",
  order_id: "ID đơn hàng",
  Operation_type: "Loại thao tác",
  Operation_Description: "Mô tả thao tác",
  Operator: "Người thực hiện",
  creation_time: "Thời gian tạo",
  No_delivery_basket: "Không có giỏ phân phối",
  No_sorting_basket: "Không có giỏ phân loại",
  time_left: "Còn lại",
  overdue: "Quá hạn",
  days: "Ngày",
  hours: "Giờ",
  minutes: "Phút",
  copy: "Sao chép",
  copu_successful: "Sao chép thành công",
  verify_the_time: "Thời gian xác nhận",
  Transfer_to_oms_time: "Thời gian chuyển sang OMS",
  sorting_time: "Thời gian phân loại",
  Please_tick_the_content_first: "Vui lòng chọn nội dung trước",
  start_date: "Ngày bắt đầu",
  end_date: "Ngày kết thúc",
  to: "Đến",
  Whether_used: "Đã sử dụng chưa",
  Last_three_days: "Ba ngày gần nhất",
  Last_week: "Một tuần gần nhất",
  Last_month: "Một tháng gần nhất",
  Assign_a_distributor: "Chỉ định nhân viên phân phối",
  Please_appoint_a_distributor: "Vui lòng chọn nhân viên phân phối",
  positionTransfer: "Chuyển kho",
  shiftingParkingData: "Chuyển kho",
  Old_storage_location: "Vị trí kho cũ",
  New_storage_location: "Vị trí kho mới",
  Transfer_quantity: "Số lượng chuyển kho",
  Add_transfer_library: "Thêm chuyển kho",
  The_number_of_removable_warehouses: "Số lượng có thể chuyển kho",
  Cannot_scan_the_same_database_location: "Không thể quét cùng một vị trí kho",
  This_product_does_not_exist_in_this_repository_Please_scan_other_repositories:
    "Sản phẩm này không có trong kho, vui lòng quét vị trí kho khác",
  Go_to_OMS1_0: "Chuyển sang OMS1.0",
  The_bar_code_cannot_exceed_100_characters:
    "Mã vạch không được vượt quá 100 ký tự",
  The_SKU_cannot_exceed_100_characters: "SKU không được vượt quá 100 ký tự",
  The_name_of_a_Chinese_product_cannot_exceed_300_characters:
    "Tên sản phẩm bằng tiếng Trung không được vượt quá 300 ký tự",
  The_name_of_an_English_product_cannot_exceed_300_characters:
    "Tên sản phẩm bằng tiếng Anh không được vượt quá 300 ký tự",
  Single_product_distribution: "Phân phối hàng hóa đơn lẻ",
  singleProductDistribution: "Phân phối hàng hóa đơn lẻ",
  tips: "Lưu ý",
  Task_mode: "Phương thức nhiệm vụ",
  Get_task: "Nhận nhiệm vụ",
  Warehouse_partition: "Phân vùng kho",
  Distribution_box_scanning_box: "Hộp phân phối hàng hóa Hộp quét",
  Distribution_basket_code: "Mã số giỏ phân phối hàng hóa",
  Barcode_scanning_box_of_goods: "Hộp quét mã vạch hàng hóa",
  picture: "Hình ảnh",
  Allocated_goods: "Đã phân phối hàng hóa",
  To_be_distributed: "Chờ phân phối hàng hóa",
  stock: "Hàng tồn kho",
  view_details: "Xem chi tiết",
  details: "Chi tiết",
  Logistics_channel: "Kênh logistics",
  Please_enter_customer_ID: "Vui lòng nhập ID khách hàng",
  conveyor: "Băng chuyền",
  please_scan_the_distribution_basket: "Vui lòng quét giỏ phân phối hàng hóa",
  The_basket_does_not_exist: "Giỏ này không tồn tại",
  Quantity_of_goods_allocated: "Số lượng hàng hóa đã phân phối",
  When_you_do_not_need_to_pick_and_ship_you_do_not_need_to_carry_the_basket_number_please_scan_the_distribution_basket_code_directly:
    "Khi không cần phân loại hàng hóa, không cần mang theo mã số giỏ, vui lòng quét trực tiếp mã số giỏ phân phối hàng hóa!s",
  When_scanning_the_sorting_basket_the_basket_number_is_missing_please_rescan:
    "Khi quét giỏ phân loại, nếu thiếu mã số giỏ, vui lòng quét lại",
  Quantity_sorted: "Số lượng đã phân loại",
  Quantity_of_goods_to_be_allocated: "Số lượng chờ phân phối",
  distributor: "Người phân phối hàng hóa",
  Distribution_time: "Thời gian phân phối hàng hóa",
  Total_quantity_to_be_allocated: "Tổng số lượng chờ phân phối",
  abnormal_quantity: "Số lượng bất thường",
  Distribution_start_time: "Thời gian bắt đầu phân phối hàng hóa",
  Distribution_end_time: "Thời gian kết thúc phân phối hàng hóa",
  Bulk_allocation: "Giao hàng hàng loạt",
  Sorting_query: "Truy vấn phân loại",
  Separate_sorting_and_shipping: "Phân loại và giao hàng riêng lẻ",
  Total_sorting_quantity: "Tổng số lượng phân loại",
  Sorting_stage: "Giai đoạn phân loại",
  Sorting_end_time: "Thời gian kết thúc phân loại",
  sorter: "Người phân loại",
  reauthorize: "Tái ủy quyền",
  Prepare_a_single_item_distribution_basket_in_the_current_warehouse:
    "Chuẩn bị một giỏ hàng hóa đơn lẻ trong kho hiện tại",
  Scan_the_distribution_basket: "Quét giỏ hàng hóa",
  Scanning_product_bar_code: "Quét mã vạch hàng hóa",
  Click_the_quantity_of_allocated_goods_to_batch_allocate_goods:
    "Nhấp vào số lượng hàng hóa đã giao để giao hàng hàng loạt",
  Scan_the_corresponding_warehouse_location_for_distribution:
    "Quét vị trí kho tương ứng để phân phối hàng hóa",
  Take_the_goods_that_have_been_allocated_and_scan_the_goods_directly_to_be_shipped:
    "Lấy hàng hóa đã phân phối, quét trực tiếp hàng hóa để giao hàng",
  Click_the_shipped_quantity_to_ship_in_bulk:
    "Nhấp vào số lượng hàng đã giao để giao hàng hàng loạt",
  Click_on_the_selected_quantity_to_pick_in_bulk:
    "Nhấp vào số lượng hàng đã phân loại để phân loại hàng loạt",
  Scan_the_sorting_basket_head: "Quét đầu giỏ phân loại",
  Scan_all_distribution_baskets: "Quét tất cả các giỏ phân phối hàng hóa",
  Place_in_the_corresponding_sorting_basket: "Đặt vào giỏ phân loại tương ứng",
  Scan_the_sorting_basket: "Quét giỏ phân loại",
  Scan_all_products: "Quét tất cả hàng hóa",
  priority_in_delivery: "Giao hàng ưu tiên",
  Confirmation_marked_as_priority_shipment:
    "Xác nhận đánh dấu là giao hàng ưu tiên",
  Click_on_the_shipped_quantity_to_scan_in_bulk:
    "Nhấp vào số lượng đã giao hàng để quét hàng loạt",
  Carry_out_the_corresponding_weighing_photo_operation_to_deliver_the_goods:
    "Thực hiện thao tác cân và chụp ảnh tương ứng để giao hàng",
  multiProductDistribution: "Phân phối nhiều mặt hàng",
  singleItemDelivery: "Giao hàng đơn lẻ",
  Packaging_material: "Vật liệu đóng gói",
  Order_information: "Thông tin đơn hàng",
  orderInfo: "Thông tin đơn hàng",
  total: "Tổng cộng",
  Shipper: "Nhân viên phân phối",
  package_photo: "Ảnh bưu kiện",
  Package_material_information: "Thông tin vật liệu đóng gói",
  Waybill_number: "Số vận đơn",
  Has_been_inspected: "Đã kiểm tra hàng",
  pending_inspection: "Chờ kiểm tra hàng",
  abnormal_delivery: "Sự cố giao hàng",
  Photograph: "Chụp ảnh",
  Enter_key_to_take_a_photo: "Chụp ảnh bằng phím Enter",
  Please_weigh_the_order: "Vui lòng cân đơn hàng",
  Please_photos_the_order: "Vui lòng chụp ảnh đơn hàng",
  Out_of_stock_successfully: "Giao hàng thành công",
  The_order_number_cannot_be_empty: "Không được để trống số đơn hàng!",
  submit: "Gửi",
  send_back: "Trả lại",
  Flag_exception: "Đánh dấu sự cố",
  sensitized: "Kích hoạt",
  weigh: "Cân",
  Remaining_shipment_quantity: "Số lượng hàng còn lại",
  Quantity_shipped: "Số lượng hàng đã giao",
  Quantity_of_goods_to_be_shipped: "Số lượng hàng chờ giao",
  The_barcode_does_not_exist: "Không có mã vạch sản phẩm này",
  Follow_these_steps_to_fill_in_the_standard_template_and_import_the_data:
    "Vui lòng điền vào mẫu chuẩn và nhập dữ liệu theo các bước sau:",
  Header_Entry_order_information_In_the_template_fill_in_the_data_of_the_table_header_from_order_type_to_remarks_Each_row_represents_an_entry_orderentry_order:
    "1. Thông tin đơn hàng đầu tiên/đơn hàng nhập kho: Trong mẫu, điền dữ liệu từ Loại đơn hàng đến Ghi chú, mỗi dòng đại diện cho một đơn hàng nhập kho/đơn hàng đầu tiên.",
  Box_product_information_In_the_template_fill_in_the_table_head_data_from_the_box_number_to_the_weight_KG_box_Each_row_represents_a_box_of_products:
    "2. Thông tin sản phẩm trong thùng: Trong mẫu, điền dữ liệu từ Số thùng đến Trọng lượng KG/thùng, mỗi dòng đại diện cho một thùng sản phẩm.",
  Please_ensure_that_each_item_is_filled_in_accurately_and_follow_the_example_after_downloading_the_standard_template:
    "Hãy đảm bảo điền chính xác từng mục dữ liệu và tải xuống mẫu chuẩn, sau đó điền theo ví dụ.",
  The_weight_must_not_be_less_than_or_equal_to_0:
    "Trọng lượng không được nhỏ hơn hoặc bằng 0.",
  Exceeds_the_maximum_weight_please_re_enter:
    "Nếu vượt quá trọng lượng tối đa, hãy nhập lại.",
  Unable_to_access_the_camera: "Không thể truy cập camera.",
  Error_uploading_files_to_Alibaba_Cloud_Please_contact_the_administrator:
    "Lỗi khi tải tệp lên Alibaba Cloud. Vui lòng liên hệ với quản trị viên.",
  The_number_of_anomalies_entered_is_incorrect:
    "Số lượng bất thường đã nhập là sai.",
  advanceLoadingSingleItemDelivery: "Giao hàng đơn lẻ (tải trước).",
  advanceLoadingMultiProductDelivery: "Giao hàng nhiều sản phẩm (tải trước).",
  advanceLoadingExplosiveDelivery: "Giao hàng sản phẩm bán chạy (tải trước).",
  Only_xlsx_format_files_are_supported_for_import_and_the_size_cannot_exceed_15_MB_A_maximum_of_ten_thousand_rows_of_data_can_be_imported:
    "Chỉ hỗ trợ nhập tệp định dạng xlsx, kích thước không được vượt quá 15MB, hỗ trợ nhập tối đa 10.000 dòng dữ liệu",
  multiProductSorting: "Phân loại nhiều sản phẩm",
  The_sorting_basket_does_not_exist_or_is_already_occupied_Please_refresh_and_try_again:
    "Giỏ phân loại này không tồn tại hoặc đã bị chiếm dụng, vui lòng làm mới và thử lại",
  Basket_state: "Trạng thái giỏ",
  Please_Select_Basket_state: "Vui lòng chọn trạng thái giỏ",
  The_distribution_basket_does_not_exist: "Giỏ phân phối này không tồn tại",
  Sort_the_basket_head: "Đầu giỏ phân loại",
  Task_details: "Chi tiết nhiệm vụ",
  Distribution_basket_not_scanned: "Giỏ phân loại chưa được quét",
  Remaining_sorting_orders: "Đơn hàng phân loại còn lại",
  Quantity_of_remaining_sorting: "Số lượng phân loại còn lại",
  Sorting_abnormal_quantity: "Số lượng phân loại bất thường",
  Sorting_start_time: "Thời gian bắt đầu phân loại",
  The_list_has_been_picked: "Danh sách đã chọn",
  Pick_details: "Chi tiết chọn",
  Sorting_number: "Số phân loại",
  Quantity_picked: "Số lượng đã chọn",
  Quantity_to_be_picked: "Số lượng chờ chọn",
  Bulk_pick_quantity: "Số lượng chọn hàng loạt",
  Allotment_quantity: "Số lượng phân loại",
  number_of_pages: "Số trang",
  Select_the_SKU_that_you_want_to_replace: "Chọn SKU cần thay thế",
  When_entering_transaction_numbers_in_batches_separate_them_with_line_breaks_or:
    "Khi nhập số giao dịch hàng loạt, sử dụng dấu xuống dòng hoặc dấu phẩy để phân tách",
  Multi_product_delivery: "Giao hàng nhiều mặt hàng",
  multiProductDelivery: "Giao hàng nhiều mặt hàng",
  newMultiProductDelivery: "Giao hàng nhiều mặt hàng mới",
  IF_Need_to_take_pictures: "Có cần chụp ảnh không",
  IF_Need_to_be_weighed: "Có cần cân không",
  Priority_Shipping_Orders: "Đơn hàng giao hàng ưu tiên",
  Scanning_sorting_blue_head: "Quét đầu giỏ phân loại",
  Number_of_current_product_types: "Số lượng loại hàng hóa hiện tại",
  kind: "Loại",
  indivual: "Cái",
  dispatcher: "Nhân viên phân loại",
  Shipping_Basket: "Giỏ phân loại",
  Preview_photo: "Xem trước ảnh",
  reshoot: "Chụp lại",
  No_photos_yet: "Không có ảnh",
  determine: "Xác nhận",
  Sorting_error_No_basket_number: "Phân loại sai, không có số giỏ",
  The_current_task_is_complete: "Nhiệm vụ hiện tại đã hoàn thành",
  Loading_a_sheet: "Đang tải phiếu giao hàng",
  Transaction_number_only: "Chỉ số giao dịch",
  Transaction_number_and_order_weight: "Số giao dịch và trọng lượng đơn hàng",
  Waybill_No_only: "Chỉ số vận đơn",
  Shipment_number_and_order_weight_only:
    "Chỉ số vận đơn và trọng lượng đơn hàng",
  Shipping_format: "Định dạng giao hàng",
  Freight_mode: "Phương thức vận chuyển",
  Scan_delivery_information: "Quét thông tin giao hàng",
  add_basket_head: "Thêm đầu giỏ",
  save: "Lưu",
  Cancel: "Hủy",
  sequence: "Số thứ tự",
  Please_enter_basket_header: "Vui lòng nhập đầu giỏ",
  Add_basket: "Thêm giỏ",
  Edit_basket: "Chỉnh sửa giỏ",
  Basket_Type: "Loại giỏ",
  basket_head: "Đầu giỏ",
  basket_name: "Tên giỏ",
  Batch_create_baskets: "Tạo giỏ hàng loạt",
  Please_select_a_basket_type: "Vui lòng chọn loại giỏ",
  Basket_description: "Mô tả giỏ",
  Please_enter_a_basket_description: "Vui lòng nhập mô tả giỏ",
  sorting_basket: "Giỏ phân loại",
  Allotment_basket: "Giỏ phân phối",
  Please_select_a_distribution_basket: "Vui lòng chọn giỏ phân phối",
  Sorting_basket_number: "Số giỏ phân loại",
  Allocation_phase: "Giai đoạn phân phối",
  Allotment_basket_item: "Giỏ phân phối (Sản phẩm đơn lẻ)",
  quality_inspection_basket: "Giỏ kiểm tra chất lượng",
  other_types: "Loại khác",
  Operation_time: "Thời gian hoạt động",
  Can_only_contain_letters_and_numbers: "Chỉ có thể chứa chữ cái và số",
  print_basket_number: "In số giỏ",
  starting_number: "Số bắt đầu",
  Please_enter_the_starting_number: "Vui lòng nhập số bắt đầu",
  end_number: "Số kết thúc",
  Please_enter_the_end_number: "Vui lòng nhập số kết thúc",
  The_label_specification: "Kích thước nhãn",
  The_starting_number_must_be_less_than_the_ending_number:
    "Số kết thúc phải lớn hơn số bắt đầu",
  If_you_enter_the_start_number_2_end_number_5_and_basket_prefix_A_the_basket_will_be_generated_A2_A3_A4_A5:
    "Giả sử nhập số bắt đầu là 2, số kết thúc là 5, đầu giỏ là A, thì sẽ tạo ra các giỏ: A-2, A-3, A-4, A-5",
  custom_specification: "Kích thước nhãn tùy chỉnh",
  operational_context: "Nội dung thao tác",
  Basket_number: "Số giỏ",
  Please_enter_the_basket_name: "Vui lòng nhập số giỏ",
  Bulk_allocation_quantity: "Số lượng phân phối hàng loạt",
  available: "Có sẵn",
  occupy: "Đã sử dụng",
  Allocation_task_for_additional_packing_material_delivery:
    "Nhiệm vụ phân phối hàng hóa với bao bì bổ sung!",
  The_basket_needs_to_be_placed_in_the_special_packing_area_of_the_item:
    "Cần đặt giỏ hàng này vào khu vực đóng gói đặc biệt cho sản phẩm đơn lẻ",
  The_basket_needs_to_be_placed_in_the_special_packing_area_for_explosive_products:
    "Cần đặt giỏ hàng này vào khu vực đóng gói đặc biệt cho sản phẩm bán chạy",
  Please_place_in_the_nearest_single_item_delivery_area:
    "Hoàn thành phân phối hàng hóa! Vui lòng đặt vào khu vực giao hàng sản phẩm đơn lẻ gần nhất",
  Distribution_completed_Please_place_it_in_the_nearest_delivery_area:
    "Hoàn thành phân phối hàng hóa! Vui lòng đặt vào khu vực giao hàng sản phẩm bán chạy gần nhất",
  If_the_inspection_fails_contact_the_administrator:
    "Kiểm tra phiếu giao hàng không thành công, vui lòng liên hệ quản trị viên để xử lý",
  Incorrect_ticket_address_Failed_to_read_the_ticket:
    "Địa chỉ trên phiếu giao hàng không chính xác, không thể đọc phiếu giao hàng",
  Failed_to_parse_the_PDF_content:
    "Nội dung phiếu giao hàng bị hỏng, không thể phân tích nội dung PDF",
  Failed_to_convert_PDF_to_JPG: "Không thể chuyển đổi PDF sang JPG",
  Failed_to_parse_the_JPG_content: "Không thể phân tích nội dung JPG",
  The_surface_bill_does_not_match_the_waybill:
    "Phiếu giao hàng không khớp với phiếu vận chuyển",
  Enter_product_bar_codes_separated_by_SKU_line_breaks_for_batch_query:
    "Vui lòng nhập mã vạch sản phẩm, SKU, cách nhau bằng dấu xuống dòng, nhấp vào nút tra cứu hàng loạt để tra cứu hàng loạt",
  Getting_data: "Đang lấy dữ liệu...",
  The_shipping_mark_is_being_rendered: "Đang hiển thị nhãn hàng...",
  Rendering_box_label: "Đang hiển thị nhãn thùng... .",
  Print_function_saved_as_PDF: "Chức năng in Lưu dưới dạng PDF",
  Set_the_default_printer_to: "Đặt máy in mặc định",
  Microsoft_Print_to_PDF: "Microsoft Print to PDF",
  Or_set_it_in_the_print_window_that_pops_up_after_you_click_Print:
    "Nhấp vào cài đặt trong cửa sổ in bật lên sau khi nhấp vào in",
  After_setting_up_the_printer_click_Print_and_click_OK:
    "Sau khi hoàn tất cài đặt máy in, nhấp vào in rồi nhấp vào xác nhận",
  Note_When_the_printer_does_not_have_suitable_paper_A4_paper_can_be_used_using_the_top_zoom_function_to_adjust:
    "Lưu ý: Khi máy in không có giấy phù hợp, có thể sử dụng giấy A4, sử dụng chức năng thu nhỏ ở trên cùng để điều chỉnh",
  If_the_number_of_export_boxes_exceeds_300_boxes_it_will_be_divided_into_multiple_files_If_you_do_not_want_to_be_divided_into_multiple_files_please_use_the_print_function:
    "Lưu ý: Khi sử dụng tính năng Lưu dưới dạng PDF, nếu số lượng hộp xuất khẩu vượt quá 300 hộp, tệp sẽ được chia thành nhiều tệp riêng biệt. Nếu không muốn chia thành nhiều tệp, vui lòng sử dụng tính năng in.",
  Charge_items: "Loại phí",
  Add_currency_information: "Thêm thông tin phí",
  Edit_currency_information: "Chỉnh sửa thông tin phí",
  special_price: "Giá đặc biệt",
  default_price: "Giá mặc định",
  discounted_price: "Giá ưu đãi",
  Listing_fee: "Phí niêm yết",
  order_processing_fee: "Phí xử lý đơn hàng",
  orderProcessingFee: "Phí vận hành",
  Destruction_delisting_fee: "Phí hủy niêm yết",
  Return_reshelving_fee: "Phí niêm yết lại hàng trả lại",
  Return_listing_fee: "Phí niêm yết hàng trả lại",
  currency: "Tiền tệ",
  currency_Type: "Loại tiền tệ",
  Please_select_currency_type: "Vui lòng chọn loại tiền tệ",
  Please_enter_SKU: "Vui lòng nhập SKU",
  Please_enter_Stock: "Vui lòng nhập kho",
  Please_enter_a_range_fee: "Vui lòng nhập phạm vi chi phí",
  Please_enter_the_number_of_ranges: "Vui lòng nhập phạm vi số lượng",
  Please_select_Charge_items: "Vui lòng chọn loại phí",
  expense_breakdown: "Chi tiết chi phí",
  Order_Status: "Tình trạng đơn hàng",
  Empty_product_details_exist_Please_check_and_try_again:
    "Có chi tiết hàng hóa trống, vui lòng kiểm tra lại và thử lại",
  There_are_duplicate_product_details_Please_check_and_try_again:
    "Có chi tiết hàng hóa trùng lặp, vui lòng kiểm tra lại và thử lại",
  Skus_and_bar_codes_can_only_contain_English_numbers_and_symbols_and_Spaces:
    "SKU, mã vạch sản phẩm chỉ có thể bao gồm các ký tự tiếng Anh, số và ký hiệu (-、.、_、khoảng trắng)",
  After_activation_all_receiving_and_quality_inspection_information_will_be_cleared_The_stage_of_the_inbound_order_will_be_changed_to_Tail_end_Receiving_in_Progress_Please_complete_the_receiving_and_quality_inspection_operations_again:
    "Sau khi kích hoạt, tất cả thông tin nhận hàng và kiểm tra chất lượng sẽ bị xóa, giai đoạn nhập kho sẽ chuyển sang giai đoạn nhận hàng cuối cùng, vui lòng thực hiện lại thao tác nhận hàng và kiểm tra chất lượng",
  If_necessary_please_make_sure_to_save_the_relevant_delivery_and_quality_inspection_information_before_activation:
    "Nếu cần, vui lòng lưu lại thông tin nhận hàng và kiểm tra chất lượng liên quan trước khi kích hoạt",
  SKU: "SKU",
  Modified_by: "Người sửa đổi",
  founder: "Người tạo",
  Please_enter_founder: "Vui lòng nhập người tạo",
  Please_enter_Modified_by: "Vui lòng nhập người sửa đổi",
  tip: "Lưu ý",
  Confirm_before_deleting:
    "Bạn có chắc chắn muốn xóa dữ liệu này không? Sau khi xóa, dữ liệu sẽ không thể khôi phục!",
  other: "Khác",
  ProductID: "Mã hàng hóa",
  batch_number: "Số lô",
  Load_rate: "Tỷ lệ lên kệ",
  Menu_list: "Danh sách menu",
  menuList: "Danh sách menu",
  add_Menu: "Thêm menu mới",
  Batch_add_menu: "Thêm menu mới hàng loạt",
  Edit_Menu: "Chỉnh sửa menu",
  Menu_Name: "Tên menu bằng tiếng Trung",
  Menu_EnName: "Tên menu bằng tiếng Anh",
  Please_enter_the_Menu_Name: "Vui lòng nhập tên menu bằng tiếng Trung",
  Please_enter_the_Menu_EnName: "Vui lòng nhập tên menu bằng tiếng Anh",
  Please_enter_menu_sort: "Vui lòng nhập thứ tự menu",
  Menu_function: "Chức năng menu",
  Menu_Icon: "Biểu tượng",
  catalogue: "Danh mục",
  Menu_Path: "Địa chỉ menu",
  structure_configuration: "Cấu hình cấu trúc",
  Please_enter_the_Menu_Path: "Vui lòng nhập địa chỉ truy cập",
  Menu_Sort: "Thứ tự menu",
  Menu_Code: "Mã menu",
  MenuPlease_enter_the_Menu_Code: "Vui lòng nhập mã menu",
  MenuPlease_enter_the_Menu_address: "Vui lòng nhập địa chỉ menu",
  Please_enter_Menu_Sort: "Vui lòng nhập thứ tự",
  Menu_Name_Not_Null: "Tên menu tiếng Trung không được để trống",
  Menu_EnName_Not_Null: "Tên menu tiếng Anh không được để trống",
  Menu_Code_Not_Null: "Mã menu không được để trống",
  Paren_Menu: "Menu cấp trên",
  Son_Menu: "Menu cấp dưới",
  Please_Select_Paren_Menu: "Vui lòng chọn menu cấp trên",
  Please_Select_Son_Menu: "Vui lòng chọn menu cấp dưới",
  Menu_Level: "Cấp độ menu",
  Menu_creator: "Người tạo menu",
  Menu_modifier: "Người sửa menu",
  Menu_creation_time: "Thời gian tạo menu",
  Menu_change_time: "Thời gian sửa menu",
  Menu_Type: "Loại menu",
  Menu_Stair: "Cấp 1",
  Menu_Second: "Cấp 2",
  Menu_Three: "Cấp 3",
  Visible: "Có hiển thị hay không",
  Remark: "Ghi chú",
  RemarkInfo: "Thông tin ghi chú",
  Please_Input_Remark: "Vui lòng nhập ghi chú",
  scanWaybillNumber: "Quét số vận đơn",
  initialDistributionFlowLog: "Nhật ký phân phối đầu tiên",
  logisticsChannelManagement: "Quản lý kênh logistics",
  logisticsChannelManagementList: "Danh sách quản lý kênh logistics",
  roleInfo: "Thông tin vai trò",
  sysRole: "Danh sách vai trò",
  roleList: "Danh sách vai trò",
  Role_CnName: "Tên vai trò bằng tiếng Trung",
  Role_EnName: "Tên vai trò bằng tiếng Anh",
  Role_Code: "Mã duy nhất của vai trò",
  Role_IsStart: "Có kích hoạt hay không",
  Add_Role: "Thêm vai trò mới",
  Edit_Role: "Thêm vai trò mới",
  Role_Name: "Tên vai trò",
  Please_Input_Role_Name: "Vui lòng nhập tên vai trò",
  Please_Input_Role_CnName: "Vui lòng nhập tên vai trò bằng tiếng Trung",
  Please_Input_Role_EnName: "Vui lòng nhập tên vai trò bằng tiếng Trung",
  Please_Input_Role_Code: "Vui lòng nhập mã duy nhất của vai trò",
  Reset: "Đặt lại",
  ResetQuery: "Đặt lại truy vấn",
  reset_data: "Đặt lại dữ liệu",
  Role_Sort: "Sắp xếp",
  Role_CnName_Not_Null: "Tên vai trò bằng tiếng Trung không được để trống",
  Role_EnName_Not_Null: "Tên vai trò bằng tiếng Anh không được để trống",
  Role_Code_Not_Null: "Mã duy nhất của vai trò không được để trống",
  Accredit_Menu: "Menu ủy quyền",
  Accredit_Stock: "Kho ủy quyền",
  More: "Thêm",
  Editing_role: "Chỉnh sửa vai trò",
  Modifying_Role_Permissions: "Sửa đổi quyền vai trò",
  Role_describe: "Mô tả vai trò",
  blocked_balances: "Đóng băng số dư",
  Amount_of_gift: "Số tiền tặng",
  Adjustment_type: "Loại điều chỉnh",
  Adjustment_blocked_balances: "Điều chỉnh số dư đóng băng",
  Adjustment_Amount_of_gift: "Điều chỉnh số tiền tặng",
  role_state: "Trạng thái vai trò",
  usersList: "Danh sách người dùng",
  usersInfo: "Thông tin người dùng",
  userManagement: "Quản lý người dùng",
  User_Code: "Tài khoản người dùng",
  User_Name: "Tên người dùng",
  User_CnName: "Tên vai trò bằng tiếng Trung",
  Owning_warehouse: "Kho thuộc về",
  Role: "Vai trò",
  RoleManagement: "Quản lý vai trò",
  user_password: "Mật khẩu người dùng",
  staff: "Nhân viên",
  staffManagement: "Quản lý nhân viên",
  dictionaries: "Từ điển",
  region: "Khu vực",
  stateManagement: "Quản lý quốc gia",
  User_Branch: "Bộ phận",
  User_Phone: "Điện thoại di động",
  User_Rank: "Chức danh",
  User_Email: "Email",
  User_EntryDate: "Ngày nhập việc",
  User_Status: "Trạng thái người dùng",
  commonUser: "Người dùng thông thường",
  service: "Dịch vụ khách hàng",
  open: "Bật",
  finance: "Tài chính",
  salesman: "Nhân viên kinh doanh",
  salesmanager: "Giám đốc kinh doanh",
  superuser: "Siêu người dùng",
  overseasagency: "Đại lý nước ngoài",
  Please_select_User_Status: "Vui lòng chọn trạng thái người dùng",
  Please_select_User_Role: "Vui lòng chọn vai trò người dùng",
  Please_select_User_Type: "Vui lòng chọn loại người dùng",
  Please_select_User_Branch: "Vui lòng chọn bộ phận",
  Please_select_User_Sex: "Vui lòng chọn giới tính",
  Please_select_salesman: "Vui lòng chọn nhân viên kinh doanh",
  Please_select_service: "Vui lòng chọn dịch vụ khách hàng",
  User_Type: "Loại người dùng",
  User_Sex: "Giới tính người dùng",
  man: "Nam",
  woman: "Nữ",
  User_Emergency: "Số điện thoại khẩn cấp",
  User_PassWord: "Mật khẩu",
  User_confirmPassWord: "Xác nhận mật khẩu",
  User_IDNumber: "Chứng minh nhân dân",
  User_Address: "Địa chỉ",
  User_Unit: "Đơn vị",
  warehouseList: "Danh sách kho",
  transshipmentdepot: "Kho trung chuyển",
  Please_Input_User_Name: "Vui lòng nhập tên người dùng",
  Please_Input_transshipmentdepot: "Vui lòng nhập kho trung chuyển",
  Please_select_transshipmentdepot: "Vui lòng chọn kho trung chuyển",
  Please_select_stock: "Vui lòng chọn kho",
  Please_Input_User_Code: "Vui lòng nhập mã người dùng",
  Please_Input_User_PassWord: "Vui lòng nhập mật khẩu",
  Please_Input_User_confirmPassWord: "Vui lòng nhập xác nhận mật khẩu",
  Please_Input_User_Rank: "Vui lòng nhập chức danh",
  Please_Input_User_IDNumber: "Vui lòng nhập chứng minh nhân dân",
  Please_Input_User_Emergency: "Vui lòng nhập số điện thoại khẩn cấp",
  Please_Input_User_Phone: "Vui lòng nhập số điện thoại di động",
  Please_enter_the_correct_mobile_number:
    "Vui lòng nhập số điện thoại di động chính xác",
  Please_Input_User_Address: "Vui lòng nhập địa chỉ",
  Please_Input_User_Email: "Vui lòng nhập email",
  Please_enter_the_correct_email_address: "Vui lòng nhập email chính xác",
  Please_Input_User_Unit: "Vui lòng nhập đơn vị",
  Please_Input_User_Status: "Vui lòng chọn trạng thái",
  Please_Input_User_Role: "Vui lòng chọn vai trò",
  Entered_passwords_differ: "Hai mật khẩu nhập không khớp nhau",
  The_password_contains_less_than_characters:
    "Mật khẩu phải có ít nhất 6 ký tự",
  Tpntbco816dolnos: "Mật khẩu phải bao gồm 8-16 ký tự, số và ký hiệu!",
  The_password_must_contain_8_to_16_characters: "Mật khẩu phải có 8-16 ký tự",
  It_is_currently_being_exported: "Đang xuất",
  When_there_are_many_PDFS_to_be_saved_it_is_recommended_to_export_them_in_batches:
    "Khi có nhiều tệp PDF cần lưu, nên xuất từng đợt",
  It_is_recommended_when_there_are_a_large_number_of_PDFS_to_be_saved:
    "Khi có nhiều tệp PDF cần lưu, nên",
  Export_in_batches: "xuất từng đợt",
  The_left_navigation_allows_you_to_select_the_number_of_boxes_to_printSKU_and_quantity:
    "Bạn có thể chọn số lượng hộp in, SKU, số lượng ở thanh điều hướng bên trái",
  Add_User: "Thêm người dùng",
  Please_Select: "Vui lòng chọn",
  Please_select_the_print_size: "Vui lòng chọn kích thước in",
  Please_select_a_single_customer: "Vui lòng chọn khách hàng riêng lẻ",
  Please_select_print_data: "Vui lòng chọn dữ liệu in",
  Please_select_a_single_warehouse: "Vui lòng chọn kho riêng lẻ",
  Please_select_the_same_order_type_order:
    "Vui lòng chọn đơn hàng có cùng loại",
  Please_Select_Task_Name: "Vui lòng chọn tên nhiệm vụ",
  Please_Select_Order: "Vui lòng chọn đơn hàng",
  Please_select_the_business_condition: "Vui lòng chọn tình huống kinh doanh",
  Please_Select_Date: "Vui lòng chọn thời gian",
  Please_select_billing_properties: "Vui lòng chọn thuộc tính tính phí",
  Please_select_whether_it_can_be_edited:
    "Vui lòng chọn có thể chỉnh sửa hay không",
  Enabled: "Kích hoạt",
  Batch_enabled_goods: "Kích hoạt hàng loạt sản phẩm",
  Prohibited_goods_in_bulk: "Tắt hàng loạt sản phẩm",
  Close: "Tắt",
  all_transshipmentdepot: "Tất cả kho trung chuyển",
  all_warehouse: "Tất cả kho",
  Please_select_a_type: "Vui lòng chọn loại",
  Please_select_content: "Vui lòng chọn nội dung",
  Cost_information: "Thông tin chi phí",
  Please_select_a_contact: "Vui lòng chọn người liên hệ",
  The_same_rule_already_exists: "Đã có quy tắc tương tự",
  Please_select_the_goods_for_which_the_storage_location_needs_to_be_changed:
    "Vui lòng chọn hàng hóa cần thay đổi vị trí kho",
  all_partition: "Tất cả phân khu",
  enabled_product: "Kích hoạt hàng hóa",
  prohibited_product: "Vô hiệu hóa hàng hóa",
  set_inventory_warning: "Cài đặt cảnh báo tồn kho",
  When_a_single_warehouse_is_selected_either_the_priority_picking_floor_or_the_priority_picking_zone_must_be_filled_in_one_of_the_two:
    "Khi chọn một kho, tầng ưu tiên phân phối hàng hóa và phân khu ưu tiên phân phối hàng hóa là các trường bắt buộc (chọn một trong hai)",
  department: "Bộ phận",
  Investment_promotion_department: "Bộ phận thu hút đầu tư",
  accounting_department: "Bộ phận tài chính",
  customer_service_department: "Bộ phận dịch vụ khách hàng",
  management_department: "Bộ phận quản lý",
  oversea_location: "Kho hàng nước ngoài",
  distribution: "Phân phối",
  IT: "IT",
  Logistics_Department: "Bộ phận logistics",
  staffList: "Danh sách nhân viên",
  personal_details: "Thông tin cá nhân",
  contact_Information: "Thông tin liên hệ",
  Owning_Information: "Thông tin thuộc về",
  account_Information: "Thông tin tài khoản",
  upload_photo_as_avatar: "Tải lên ảnh đại diện",
  staffInfo: "Thông tin nhân viên",
  staff_name: "Tên nhân viên",
  staff_Code: "Tài khoản nhân viên",
  staff_Status: "Trạng thái nhân viên",
  staff_Role: "Vai trò nhân viên",
  staff_gender: "Giới tính nhân viên",
  staffType: "Loại nhân viên",
  staff_password: "Mật khẩu nhân viên",
  Laborial_Staff: "Nhân viên thông thường",
  Administrator: "Quản trị viên",
  Please_enter_the_employee_name: "Vui lòng nhập tên nhân viên",
  Please_enter_your_employee_ID: "Vui lòng nhập tài khoản nhân viên",
  Please_select_member_type: "Vui lòng chọn loại nhân viên",
  createStaff: "Tạo nhân viên",
  editStaff: "Chỉnh sửa nhân viên",
  Please_select_member: "Vui lòng chọn nhân viên",
  Please_select_an_employee_role: "Vui lòng chọn vai trò nhân viên",
  batch_edit_staff_type: "Chỉnh sửa hàng loạt loại nhân viên",
  create_staff: "Tạo nhân viên",
  batch_create_staff: "Tạo hàng loạt nhân viên",
  batchCreateStaff: "Tạo hàng loạt nhân viên",
  batch_modify: "Chỉnh sửa hàng loạt",
  Import_employees: "Nhập nhân viên",
  Enter_employee_account: "Đăng nhập tài khoản nhân viên",
  Prioritize_stock_allocation: "Phân phối hàng ưu tiên",
  Module_Permissions: "Quyền truy cập mô-đun",
  All_Modules: "Tất cả mô-đun",
  After_selecting_a_module_you_can_view_the_data_of_restricted_modules:
    "Sau khi chọn mô-đun, có thể xem dữ liệu của mô-đun bị hạn chế",
  provided_that_the_corresponding_warehouse_or_transit_permissions_are_set:
    "Với điều kiện đã thiết lập quyền truy cập kho/kho trung chuyển tương ứng",
  Add_consumables_type: "Thêm loại vật tư tiêu hao",
  Edit_consumables_type: "Chỉnh sửa loại vật tư tiêu hao",
  Consumable_name: "Tên vật tư tiêu hao",
  Description_of_consumables: "Mô tả vật tư tiêu hao",
  Please_enter_the_consumable_name: "Vui lòng nhập tên vật tư tiêu hao",
  Please_enter_a_description_of_the_consumable:
    "Vui lòng nhập mô tả vật tư tiêu hao",
  type_name: "Tên loại",
  Type_description: "Mô tả loại",
  Change_the_time: "Thời gian sửa đổi",
  Add_consumables: "Thêm vật tư tiêu hao",
  Add_consumable_information: "Thêm thông tin vật tư tiêu hao",
  Editing_Supplies_Information: "Chỉnh sửa thông tin vật tư tiêu hao",
  Consumables_Code: "Mã vật tư tiêu hao",
  Consumable_size: "Kích thước vật tư tiêu hao",
  Number_of_consumables: "Số lượng vật tư tiêu hao",
  single_standard_price: "Giá tiêu chuẩn đơn vị",
  long: "Chiều dài",
  long_cm: "Chiều dài (cm)",
  outer_box_long_cm_one: "Chiều dài thùng ngoài (cm/chiếc)",
  Receiving_outer_box_long_cm_one: "Chiều dài thùng hàng nhận (cm/chiếc)",
  please_enter_Receiving_outer_box_long_cm_one:
    "Vui lòng nhập chiều dài thùng hàng nhận (cm/chiếc)",
  width: "Chiều rộng",
  width_cm: "Chiều rộng (cm)",
  outer_box_width_cm_one: "Chiều rộng thùng hàng (cm/chiếc)",
  Receiving_outer_box_width_cm_one: "Chiều rộng thùng hàng nhận (cm/chiếc)",
  please_enter_Receiving_outer_box_width_cm_one:
    "Vui lòng nhập chiều rộng thùng hàng nhận (cm/chiếc)",
  Received_weight_KG_one: "Trọng lượng hàng nhận (KG/chiếc)",
  Received_weight_KG: "Trọng lượng hàng nhận",
  please_enter_Received_weight_KG_one:
    "Vui lòng nhập trọng lượng hàng nhận (KG/chiếc)",
  height: "Chiều cao",
  height_cm: "Chiều cao (cm)",
  outer_box_height_cm_one: "Chiều cao hộp bên ngoài (cm/chiếc)",
  Receiving_outer_box_height_cm_one:
    "Chiều cao hộp bên ngoài nhận hàng (cm/chiếc)",
  please_enter_Receiving_outer_box_height_cm_one:
    "Vui lòng nhập chiều cao hộp bên ngoài nhận hàng (cm/chiếc)",
  Please_enter_the_consumable_code: "Vui lòng nhập mã vật tư tiêu hao",
  Please_enter_length_width_and_height:
    "Vui lòng nhập kích thước chiều dài, chiều rộng, chiều cao",
  Please_enter_the_quantity_of_consumables:
    "Vui lòng nhập số lượng vật tư tiêu hao",
  Please_enter_a_single_standard_price: "Vui lòng nhập giá tiêu chuẩn đơn vị",
  Please_select_a_warehouse: "Vui lòng chọn kho",
  Please_enter_warehouse: "Vui lòng nhập kho",
  Please_select_a_consumable_type: "Vui lòng chọn loại vật tư tiêu hao",
  Consumable_Type: "Loại vật tư tiêu hao",
  Billing_way: "Phương thức tính phí",
  The_priority_billing_method_shall_prevail:
    "Dựa trên phương thức tính phí ưu tiên",
  Excluding_the_amount: "Trừ số tiền",
  Automatically_calculate_the_estimated_inventory_formula:
    "Tự động tính toán công thức cảnh báo tồn kho",
  All_billing_methods_will_be_calculated_and_the_highest_fee_will_be_taken_as_the_standard:
    "Sẽ tính toán tất cả các phương thức tính phí, lấy mức phí cao nhất làm chuẩn",
  Billing_attribute: "Thuộc tính tính phí",
  Stores_operation_accounting_attributes: "Thuộc tính tính phí hoạt động kho",
  Precedence_Billing_way: "Phương thức tính phí ưu tiên",
  Please_select_Precedence_Billing_way:
    "Vui lòng chọn phương thức tính phí ưu tiên",
  The_number_of_the_first_charge: "Số lượng tính phí cho sản phẩm đầu tiên",
  The_number_of_the_first_billing_item_must_not_be_less_than_1:
    "Số lượng tính phí cho sản phẩm đầu tiên không được nhỏ hơn 1",
  please_enter_The_number_of_the_first_charge:
    "Vui lòng nhập số lượng tính phí cho sản phẩm đầu tiên",
  Please_enter_the_number_of_items_for_which_the_charge_will_be_calculated:
    "Vui lòng nhập số lượng tính phí cho sản phẩm tiếp theo",
  The_continuation_charge_amount_cannot_be_less_than_1:
    "Số lượng tính phí cho các mặt hàng tiếp theo không được nhỏ hơn 1",
  Please_select_Billing_way: "Vui lòng chọn phương thức tính phí",
  Volume_weight_value: "Giá trị trọng lượng thể tích",
  Please_enter_volume_weight_value:
    "Vui lòng nhập giá trị trọng lượng thể tích",
  Please_enter_the_case_number: "Vui lòng nhập số thùng",
  The_case_number_does_not_exist: "Không có số thùng này!",
  The_sku_does_not_exist: "Không có SKU này",
  Save_receipt: "Lưu hàng nhận",
  Save_receipt_succeed: "Lưu hàng nhận thành công",
  Please_stock_the_goods_at_the_specified_distribution_warehouse:
    "Vui lòng phân phối hàng tại vị trí kho phân phối được chỉ định",
  putaway: "Lên kệ",
  Inventory_batch_number: "Số lô hàng tồn kho",
  unfinished: "Chưa hoàn thành",
  completed: "Đã hoàn thành",
  Export_the_pairing_data: "Xuất dữ liệu ghép đôi",
  Currently_no_floor_is_added_to_the_warehouse_Please_perform_this_operation_after_adding_a_floor:
    "Kho hiện tại chưa thêm tầng, vui lòng thêm tầng trước khi thực hiện thao tác này",
  If_the_selected_data_exists_the_selected_data_is_processed_preferentially_for_batch_processing:
    "Nếu có dữ liệu được chọn, dữ liệu được chọn sẽ được xử lý ưu tiên để xử lý hàng loạt",
  If_the_selected_data_is_not_selected_manually_fill_in_the_box_number_range_for_batch_processing:
    "Nếu không có dữ liệu được chọn, vui lòng nhập thủ công khoảng số thùng để xử lý hàng loạt",
  If_the_field_value_is_empty_the_field_data_is_not_modified:
    "Khi giá trị trường trống hoặc bằng 0,00, dữ liệu trường đó sẽ không được sửa đổi",
  Momentumfee: "Cài đặt phí vận chuyển cho một kiện hàng",
  export: "Xuất",
  Export_the_header_order: "Xuất đơn hàng đầu tiên",
  Export_the_header_list: "Xuất danh sách đầu tiên",
  Export_the_First_bill: "Xuất hóa đơn đầu tiên",
  Export_the_import_and_export_details: "Xuất chi tiết nhập kho/xuất kho",
  Three_sides_before_weight: "Trước tiên là ba cạnh, sau đó là trọng lượng",
  First_weight_then_three_sides: "Trước tiên là trọng lượng, sau đó là ba cạnh",
  First_cubic_then_weight: "Trước tiên là khối lượng, sau đó là trọng lượng",
  First_weight_then_cube: "Trước tiên là trọng lượng, sau đó là khối lượng",
  First_cube_and_then_three_sides:
    "Trước tiên là khối lượng, sau đó là ba cạnh",
  Three_sides_before_the_cube: "Trước tiên là ba cạnh, sau đó là khối lượng",
  entryAndExitDetails: "Chi tiết nhập kho/xuất kho",
  add: "Thêm",
  Batch_add: "Thêm hàng loạt",
  Batch_delete: "Xóa hàng loạt",
  date: "Ngày",
  The_longest_edge: "Cạnh dài nhất",
  Long_side: "Cạnh dài thứ hai",
  The_shortest_edge: "Cạnh ngắn nhất",
  weight: "Trọng lượng",
  Start_weight: "Trọng lượng bắt đầu",
  End_weight: "Trọng lượng kết thúc",
  weight_KG: "Trọng lượng (KG)",
  number: "Số lượng",
  Add_interval: "Thêm khoảng",
  SumThreeSides: "Tổng chiều dài ba cạnh",
  SumThreeSides_CM: "Tổng chiều dài ba cạnh (CM)",
  The_sum_of_the_three_sides_cannot_be_negative:
    "Tổng chiều dài ba cạnh không được âm",
  First_packing_material_cost: "Chi phí bao bì đầu tiên",
  Three_sides_length: "Tổng ba cạnh",
  Three_sides: "Ba cạnh",
  Start_hree_sides_length: "Chiều dài ba cạnh bắt đầu",
  End_hree_sides_length: "Chiều dài ba cạnh kết thúc",
  Three_sides_length_CM: "Tổng ba cạnh (CM)",
  actual_SumThreeSides: "Tổng chiều dài ba cạnh thực tế",
  actual_SumThreeSides_CM: "Tổng chiều dài ba cạnh thực tế (CM)",
  Continued_SKU_packaging_costs: "Chi phí bao bì SKU tiếp theo",
  The_number_of_continuations_is_charged: "Số lượng tính phí tiếp theo",
  Please_enter_the_number_of_continuation_charges:
    "Vui lòng nhập số lượng tính phí tiếp theo",
  cost_a: "Chi phí/cái",
  Cost_attribute: "Thuộc tính chi phí",
  cost_one_day_cube: "Chi phí (ngày/khối)",
  cube: "Khối",
  Start_cube: "Khối bắt đầu",
  End_cube: "Khối kết thúc",
  Extra_charge: "Phí vận hành SKU tiếp theo",
  One_charge: "Phí vận hành SKU đầu tiên",
  One_Packaging_material: "Chi phí bao bì SKU đầu tiên",
  Extra_Packaging_material: "Chi phí bao bì SKU tiếp theo",
  Currency_type: "Đơn vị tiền tệ",
  Original_Currency_type: "Đơn vị tiền tệ ban đầu",
  Packaging_material_cost: "Chi phí bao bì",
  packagingMaterialManagement: "Quản lý bao bì",
  Please_enter_Currency_type: "Vui lòng nhập đơn vị tiền tệ",
  Please_select_Currency_type: "Vui lòng chọn đơn vị tiền tệ",
  Please_enter_The_longest_edge: "Vui lòng nhập cạnh dài nhất",
  Please_enter_Long_side: "Vui lòng nhập cạnh dài thứ hai",
  Please_enter_The_shortest_edge: "Vui lòng nhập cạnh ngắn nhất",
  Please_enter_weight: "Vui lòng nhập trọng lượng",
  Please_enter_quantity: "Vui lòng nhập số lượng",
  Please_enter_SumThreeSides: "Vui lòng nhập tổng chiều dài ba cạnh",
  Please_enter_cost_a: "Vui lòng nhập tổng chiều dài ba cạnh",
  Please_enter_cost: "Vui lòng nhập chi phí",
  Please_enter_Extra_charge: "Vui lòng nhập phí vận hành SKU tiếp theo",
  Please_enter_One_charge: "Vui lòng nhập phí vận hành SKU đầu tiên",
  Please_enter_number: "Vui lòng nhập số lượng",
  Please_enter_One_Packaging_material: "Vui lòng nhập phí bao bì SKU đầu tiên",
  Please_enter_Extra_Packaging_material:
    "Vui lòng nhập phí bao bì SKU tiếp theo",
  Cancel_the_editor: "Hủy chỉnh sửa",
  Cancel_the_add: "Hủy thêm",
  Failed_to_start_the_camera_Please_check_whether_the_camera_is_available_Or_turn_on_the_camera_head:
    "Không thể bật camera, vui lòng kiểm tra xem camera có hoạt động không! Hoặc bật camera",
  This_operation_cannot_be_undone_Do_you_want_to_continue:
    "Thao tác này không thể hoàn tác, có tiếp tục không?",
  size: "Kích thước",
  Please_select_size: "Vui lòng chọn kích thước",
  Please_enter_size: "Vui lòng nhập kích thước",
  Three_high: "Chiều dài, chiều rộng, chiều cao",
  packaging: "Cách đóng gói",
  The_whole_pack: "Đóng gói toàn bộ đơn hàng",
  Pack_by_sku: "Đóng gói theo SKU",
  Packing_according_to_the_entire_order_will_pack_all_the_items_in_the_entire_order_together:
    "Đóng gói theo toàn bộ đơn hàng, tất cả các mặt hàng trong đơn hàng sẽ được đóng gói cùng nhau",
  Package_according_to_SKU_and_pack_together_with_SKU:
    "Đóng gói theo SKU, tất cả các sản phẩm có cùng SKU sẽ được đóng gói cùng nhau",
  All_items_will_be_packaged_separately:
    "Tất cả các sản phẩm sẽ được đóng gói riêng lẻ",
  Create_a_warehouse_entry: "Tạo phiếu nhập kho",
  Separate_product_packaging: "Đóng gói sản phẩm riêng lẻ",
  editCost: "Chỉnh sửa chi phí",
  outbound_pictures: "Chụp ảnh xuất kho",
  photo_list: "Danh sách ảnh",
  scan_pictures: "Quét ảnh",
  scanning_waybill_number: "Quét số vận đơn",
  The_operation_fails_Check_whether_the_input_of_the_waybill_number_is_correct:
    "Thao tác không thành công, vui lòng kiểm tra xem số vận đơn đã nhập có chính xác không",
  Review_images: "Xem ảnh",
  Operation_of: "Người thực hiện",
  start_time: "Thời gian bắt đầu",
  End_days: "Số ngày kết thúc",
  Please_enter_the_start_time: "Vui lòng nhập thời gian bắt đầu",
  Please_enter_the_end_time: "Vui lòng nhập thời gian kết thúc",
  The_input_start_time_cannot_be_negative:
    "Thời gian bắt đầu nhập không được là số âm",
  The_end_time_cannot_be_negative:
    "Thời gian kết thúc nhập không được là số âm",
  The_start_time_cannot_be_later_than_the_end_time:
    "Thời gian bắt đầu không được lớn hơn thời gian kết thúc",
  The_end_time_cannot_be_later_than_the_start_time:
    "Thời gian kết thúc không được nhỏ hơn thời gian bắt đầu",
  end_time: "Thời gian kết thúc",
  Batch_set_roles: "Cài đặt hàng loạt vai trò",
  Bulletin: "Thông báo",
  BulletinManagement: "Quản lý thông báo",
  Bulletin_Type: "Loại thông báo",
  Bulletin_Name: "Tên thông báo",
  This_window_asks_if_you_want_to_leave:
    "Cửa sổ này hỏi bạn có muốn thoát không",
  The_information_you_enter_may_not_be_saved:
    "Thông tin bạn nhập có thể không được lưu",
  New_announcement: "Thêm thông báo",
  announcementState: "Trạng thái thông báo",
  workOrder: "Quản lý phiếu công việc",
  workOrderList: "Danh sách phiếu công việc",
  work_order_ID: "ID phiếu công việc",
  problem_description: "Mô tả vấn đề",
  problem_types: "Loại vấn đề",
  processed_time: "Thời gian xử lý",
  processor: "Người xử lý",
  discuss: "Bình luận",
  ranking: "Đánh giá",
  turn_off_time: "Thời gian đóng",
  New_work_order: "Thêm phiếu công việc",
  result_of_handling: "Kết quả xử lý",
  Please_enter_the_work_order_ID: "Vui lòng nhập ID phiếu công việc",
  Please_provide_the_description_of_the_problem: "Vui lòng nhập mô tả vấn đề",
  Please_provide_the_result_of_handling: "Vui lòng nhập kết quả xử lý",
  Work_order_information: "Thông tin phiếu công việc",
  Should_this_work_order_be_invalidated:
    "Hủy bỏ Phiếu công việc này có bị hủy bỏ không?",
  to_deal_with: "Xử lý",
  Work_order_processing: "Xử lý phiếu công việc",
  reply: "Trả lời",
  Please_select_the_type_of_question: "Vui lòng chọn loại vấn đề",
  Please_select_the_rating_level: "Vui lòng chọn mức đánh giá",
  Please_enter_your_evaluation: "Vui lòng nhập đánh giá",
  initiator: "Người khởi tạo",
  Adding_dictionary_Categories: "Thêm phân loại từ điển",
  DictionaryList: "Danh sách từ điển",
  dictionaryList: "Danh sách từ điển",
  EditDictionary: "Chỉnh sửa từ điển",
  Please_enter_the_dictionary_name: "Vui lòng nhập tên từ điển",
  Name_of_dictionary: "Tên từ điển",
  Chinese_name: "Tên tiếng Trung",
  English_name: "Tên tiếng Anh",
  Goods_Chinese_name: "Tên sản phẩm tiếng Trung",
  Goods_English_name: "Tên sản phẩm tiếng Anh",
  setpoint: "Giá trị cài đặt",
  Please_enter_Chinese_name: "Vui lòng nhập tên tiếng Trung",
  Please_enter_English_name: "Vui lòng nhập tên tiếng Anh",
  Please_enter_setpoint: "Vui lòng nhập giá trị cài đặt",
  Add_dictionary: "Thêm từ điển",
  Batch_Add_dictionary: "Thêm từ điển hàng loạt",
  value: "Giá trị",
  Please_add_the_dictionary_first: "Vui lòng thêm từ điển trước",
  Chinese_name_English_name_does_not_allow_null_value:
    "Tên tiếng Trung/tiếng Anh không được để trống",
  The_value_cannot_be_modified_after_it_is_set_Please_confirm_and_add_it_after_completion:
    "Giá trị đã cài đặt sẽ không thể sửa đổi, vui lòng xác nhận trước khi thêm!",
  Batch_Add_Parent_Directory: "Thêm thư mục cấp trên hàng loạt",
  recently: "Gần đây",
  day: "Ngày",
  Warehouse_capacity: "Dung lượng kho",
  Warehouse_capacity_data: "Dữ liệu dung lượng kho",
  Service_storage_capacity: "Dung lượng kho sử dụng",
  Storage_capacity_in_transit: "Dung lượng kho đang vận chuyển",
  Residual_storage_capacity: "Dung lượng kho còn lại",
  Use_of_space: "Vị trí kho sử dụng",
  Available_space: "Vị trí kho có thể sử dụng",
  financial_data: "Dữ liệu tài chính",
  all_costs: "Tất cả chi phí",
  storage_charges: "Tiền thuê kho",
  Removal_fee: "Phí hạ hàng",
  Returnable_shelving_fee: "Phí trả hàng",
  other_expenses: "Chi phí khác",
  Order_data: "Dữ liệu đơn hàng",
  Orderto_be_supplied: "Đơn hàng chờ giao hàng",
  Order_In_transit: "Đơn hàng đang giao hàng",
  Orderto_shipped: "Đơn hàng đã giao hàng",
  Nearly_a_day: "Gần đây",
  Last_seven_days: "Gần đây 7 ngày",
  The_last_thirty_days: "Gần đây 30 ngày",
  Nearly_ninety_days: "Gần đây 90 ngày",
  Customer_details: "Chi tiết khách hàng",
  TC_data: "Dữ liệu chặng đầu",
  TC_wait_for_receiving: "Chặng đầu chờ nhận hàng",
  Transfer_Warehouse_Receipt: "Nhận hàng tại kho trung chuyển",
  Transit_warehouse_receiving_time: "Thời gian nhận hàng tại kho trung chuyển",
  in_transit: "Đang vận chuyển",
  The_Last_Leg_Received: "Đã nhận hàng cuối cùng",
  finish: "Hoàn thành",
  Warehouse_entry_data: "Dữ liệu phiếu nhập kho",
  Transit_warehouse_to_receive_goods: "Chờ nhận hàng tại kho trung chuyển",
  The_last_leg_to_be_received: "Chờ nhận hàng cuối cùng",
  To_be_inspected: "Chờ kiểm tra chất lượng",
  To_be_put_on_the_shelf: "Chờ lên kệ",
  Return_data: "Dữ liệu trả hàng",
  Customer_ID: "ID khách hàng",
  ClientManagement: "Quản lý khách hàng",
  Customer: "Khách hàng",
  spread: "Mở rộng",
  pack_up: "Thu gọn",
  Put_away_the_menu: "Thu gọn menu",
  Customer_List: "Danh sách khách hàng",
  clientList: "Danh sách khách hàng",
  advanced_query: "Tìm kiếm nâng cao",
  Customer_account_number: "Tài khoản khách hàng",
  Please_enter_account_number: "Vui lòng nhập tài khoản khách hàng",
  Customer_account_name: "Tên khách hàng",
  Please_enter_account_name: "Vui lòng nhập tên khách hàng",
  Customer_account_state: "Trạng thái khách hàng",
  Please_enter_account_state: "Vui lòng nhập trạng thái khách hàng",
  unverified: "Chưa xác nhận",
  approve: "Đã phê duyệt",
  Approval_failure: "Không phê duyệt",
  Api_Order: "Đơn hàng API",
  Notification_Form: "Đơn hàng đẩy",
  handbill: "Đơn hàng thủ công",
  forbidden: "Vô hiệu hóa",
  audit: "Đang xem xét",
  Contract_to_be_signed: "Chờ ký hợp đồng",
  cell_phone_number: "Số điện thoại",
  Please_enter_cell_phone_number: "Vui lòng nhập số điện thoại",
  Please_select_cell_phone_number: "Vui lòng chọn trạng thái khách hàng",
  Please_select_Customer: "Vui lòng chọn khách hàng",
  company_name: "Công ty",
  corporate_company: "Công ty pháp nhân",
  Please_enter_company_name: "Vui lòng nhập tên công ty",
  registration_time: "Thời gian đăng ký",
  clearing_form: "Phương thức thanh toán",
  Please_select_clearing_form: "Vui lòng chọn phương thức thanh toán",
  Please_select_whether_to_renew: "Vui lòng chọn có gia hạn hay không",
  Starting_amount: "Số tiền bắt đầu",
  Closing_amount: "Số tiền kết thúc",
  prejunction: "Thanh toán trước",
  monthly_balance: "Thanh toán hàng tháng",
  balance_outstanding: "Số dư",
  Please_enter_balance_outstanding: "Vui lòng nhập số dư",
  Please_enter_contact_information: "Vui lòng nhập thông tin liên lạc",
  Please_select_balance_outstanding: "Vui lòng chọn số dư",
  Please_select_the_shipping_to_transit_bin_method:
    "Vui lòng chọn phương thức vận chuyển đến kho trung chuyển",
  have: "Có",
  without: "Không",
  Add_customer: "Thêm khách hàng",
  Batch_upload: "Tải lên hàng loạt",
  reset_passwords: "Đặt lại mật khẩu",
  Limit_adjustment: "Điều chỉnh hạn mức",
  allot_salesman: "Phân công nhân viên kinh doanh",
  allot_service: "Phân công nhân viên chăm sóc khách hàng",
  Customer_Name: "Tên khách hàng",
  subordinate_companies: "Công ty thuộc về",
  contact_information: "Thông tin liên lạc",
  account_frozen: "Số tiền bị đóng băng",
  line_of_credit: "Hạn mức tín dụng",
  No_currency_available: "Hiện không có loại tiền tệ",
  Set_currency: "Cài đặt loại tiền tệ",
  account_type: "Loại tài khoản",
  account_state: "Trạng thái tài khoản",
  Merchant_name: "Tên thương nhân",
  Merchant_Number: "Số thương nhân",
  Corporate_name: "Tên pháp nhân",
  Corporate_Identity_Card: "Chứng minh nhân dân pháp nhân",
  Corporate_phone_number: "Số điện thoại di động pháp nhân",
  Business_license_registration_address: "Địa chỉ đăng ký giấy phép kinh doanh",
  business_address: "Địa chỉ văn phòng",
  Unified_social_credit_code: "Mã số tín dụng xã hội thống nhất",
  Please_enter_unified_social_credit_code:
    "Vui lòng nhập mã số tín dụng xã hội thống nhất",
  user_role: "Vai trò người dùng",
  service_team: "Đội ngũ dịch vụ",
  Distribution_service_team: "Phân công đội ngũ dịch vụ",
  Please_select_a_customer: "Vui lòng chọn một khách hàng",
  available_balance: "Số dư có thể sử dụng",
  Audit_customer: "Xác minh khách hàng",
  Confirm_to_audit_the_customer: "Xác nhận xác minh khách hàng này",
  Please_enter_the_customer_mobile_number:
    "Vui lòng nhập số điện thoại di động của khách hàng",
  New_account_login_will_overwrite_the_data_of_the_original_account_whether_to_continue:
    "Đăng nhập tài khoản mới sẽ ghi đè dữ liệu tài khoản cũ, có tiếp tục không?",
  Set_up_warehouse: "Cài đặt kho",
  Set_up_a_transit_warehouse: "Cài đặt kho trung chuyển",
  Full_warehouse_or_not: "Có phải toàn bộ kho không?",
  Whether_all_transfer_warehouse: "Có phải toàn bộ kho trung chuyển không?",
  Total_balance: "Tổng số dư",
  client_info: "Thông tin khách hàng",
  clientInfo: "Thông tin khách hàng",
  createClient: "Tạo khách hàng",
  editClient: "Chỉnh sửa khách hàng",
  basic_information: "Thông tin cơ bản",
  address_message: "Thông tin địa chỉ",
  QQ_WeChat: "QQ/WeChat",
  QQ_WeChat_ID_Not_Nickname: "QQ/WeChat (không phải biệt danh)",
  oblast_province: "Tỉnh/Thành phố",
  province: "Tỉnh",
  district: "Quận",
  Please_enter_oblast: "Vui lòng nhập tỉnh",
  city: "Thành phố",
  Please_enter_city: "Vui lòng nhập thành phố",
  location: "Địa chỉ",
  shipping_address: "Địa chỉ nhận hàng",
  Alternate_delivery_address: "Địa chỉ nhận hàng dự phòng",
  Please_enter_location: "Vui lòng nhập địa chỉ",
  financial_information: "Thông tin tài chính",
  customer_code: "Mã khách hàng",
  Customer_mailbox: "Email khách hàng",
  Customer_mobile_phone_number: "Số điện thoại khách hàng",
  customer_company: "Công ty khách hàng",
  Superior_account: "Tài khoản cấp trên",
  service_conditions: "Tình hình kinh doanh",
  underway: "Đang tiến hành",
  Terminated: "Đã kết thúc",
  delivery_method: "Phương thức giao hàng",
  assigner: "Người phân phối",
  operating_log: "Nhật ký hoạt động",
  auditor: "Người kiểm duyệt",
  audit_time: "Thời gian kiểm duyệt",
  Identifying_people: "Người xác nhận",
  acknowledging_time: "Thời gian xác nhận",
  Whether_to_send_back_ERP: "Có gửi lại ERP không",
  Return_time: "Thời gian gửi lại",
  Return_result: "Kết quả gửi lại",
  Account_top_up_details: "Chi tiết nạp tiền vào tài khoản",
  accountTopUpDetails: "Chi tiết nạp tiền vào tài khoản",
  Recharge_method: "Phương thức nạp tiền",
  Storage_query: "Tra cứu kho",
  storageQuery: "Tra cứu kho",
  account_recharge: "Nạp tiền vào tài khoản",
  accountRecharge: "Nạp tiền vào tài khoản",
  online_trading: "Giao dịch trực tuyến",
  Online_payment: "Thanh toán trực tuyến",
  money: "Số tiền",
  Please_enter_the_money: "Vui lòng nhập số tiền",
  Recharge_type: "Loại nạp tiền",
  The_page_you_visited_does_not_exist_Please_check_whether_the_network_connection_is_normal_or_check_whether_the_address_input_is_correct:
    "Trang bạn truy cập không tồn tại, vui lòng kiểm tra kết nối mạng hoặc xem lại địa chỉ đã nhập có chính xác không!",
  The_orders_that_have_been_shipped_and_failed_to_be_shipped_can_be_scanned_and_reprinted_here_Orders_that_have_been_shipped_can_be_reprinted_here_Note_The_order_must_be_the_order_placed_in_your_task_list:
    "Đã quét đơn hàng đã giao hàng không thành công, bạn có thể in lại đơn hàng tại đây; đơn hàng đã giao hàng có thể in lại phiếu giao hàng tại đây. (Lưu ý: Đơn hàng phải là đơn hàng trong danh sách nhiệm vụ của bạn)",
  Confirm_the_mark_is_abnormal: "Xác nhận đánh dấu bất thường?",
  operation_procedure: "Quy trình thao tác",
  Operating_Instructions: "Hướng dẫn thao tác",
  general: "Chung",
  system_wide: "Toàn hệ thống",
  clientSide: "Khách hàng",
  Management: "Quản lý",
  Announcement_title: "Tiêu đề thông báo",
  Announcement_content: "Nội dung thông báo",
  Announcement_Number: "Số thông báo",
  Please_enter_Announcement_title: "Vui lòng nhập tiêu đề thông báo",
  Please_enter_Announcement_Number: "Vui lòng nhập số thông báo",
  Please_enter_Announcement_content: "Vui lòng nhập nội dung thông báo",
  Please_select_Bulletin_Type: "Vui lòng chọn loại thông báo",
  title: "Tiêu đề",
  method: "Phương pháp yêu cầu",
  requestMethod: "Phương thức yêu cầu",
  operUrl: "URL thao tác",
  operIp: "Địa chỉ IP thao tác",
  operLocation: "Địa điểm thao tác",
  operParam: "Tham số thao tác",
  status: "Trạng thái",
  errorMsg: "Thông tin lỗi",
  operTime: "Thời gian thao tác",
  Success: "Thành công",
  Failure: "Thất bại",
  Inventory_order_list: "Danh sách đơn hàng kho",
  inventoryOrderList: "Danh sách đơn hàng kho",
  inventoryAllOrderList: "Tất cả đơn hàng",
  abnormalTransportationList: "Lỗi vận chuyển",
  warehouse_order_management: "Quản lý đơn hàng kho",
  logistics: "Logistics",
  logistics_status: "Trạng thái logistics",
  Please_select_Logistics_channel: "Vui lòng chọn kênh logistics",
  Platform_state: "Trạng thái nền tảng",
  Please_select_Platform_state: "Vui lòng chọn trạng thái nền tảng",
  Please_enter_order_number: "Vui lòng nhập số đơn hàng",
  Please_enter_waybill_number: "Vui lòng nhập số vận đơn",
  Please_enter_transaction_number: "Vui lòng nhập số giao dịch",
  Priority_delivery: "Giao hàng ưu tiên",
  Priority_delivery_order: "Đơn hàng giao hàng ưu tiên",
  Non_priority_delivery_orders: "Đơn hàng giao hàng không ưu tiên",
  Platform_setting_priority_delivery: "Nền tảng thiết lập giao hàng ưu tiên",
  Manually_set_priority_delivery: "Thiết lập giao hàng ưu tiên thủ công",
  Please_select_Priority_delivery:
    "Vui lòng chọn có giao hàng ưu tiên hay không",
  shipping_method: "Phương thức giao hàng",
  Please_select_shipping_method: "Vui lòng chọn phương thức giao hàng",
  Please_select_logistics_status: "Vui lòng chọn trạng thái logistics",
  Please_select_platform: "Vui lòng chọn nền tảng",
  time_of_payment: "Thời gian thanh toán",
  Please_select_time_of_payment: "Vui lòng chọn thời gian thanh toán",
  Please_select_Recharge_method: "Vui lòng chọn phương thức nạp tiền",
  To_be_reviewed: "Đang chờ phê duyệt",
  drop_shipping: "Đang chờ giao hàng",
  Being_distributed: "Đang phân phối hàng",
  shipped: "Đã giao hàng",
  have_been_voided: "Đã hủy",
  have_been_reject: "Đã từ chối",
  Get_the_tracking_number: "Lấy số vận đơn",
  Set_up_order_package_materials: "Cài đặt vật liệu đóng gói đơn hàng",
  Forward_delivery: "Chuyển sang trạng thái chờ giao hàng",
  cancellation: "Hủy",
  Cancelled_order: "Hủy đơn hàng",
  activate: "Kích hoạt",
  Get_order: "Lấy đơn hàng",
  Get_order_time: "Lấy thời gian đặt hàng",
  Upload_sheet: "Tải lên phiếu giao hàng",
  processing_batch: "Xử lý hàng loạt",
  Return_for_review: "Trả lại để chờ phê duyệt",
  Print_sheet: "In phiếu giao hàng",
  Preview_the_waybill: "Xem trước phiếu giao hàng",
  Printing_sheet: "Đang in phiếu giao hàng...",
  Preview_failed_orders: "Xem trước đơn hàng bị lỗi",
  create_order: "Tạo đơn hàng",
  createOrder: "Tạo đơn hàng",
  Batch_create_order: "Tạo đơn hàng hàng loạt",
  stores_expired: "Giấy phép cửa hàng đã hết hạn",
  Push_or_not: "Có đẩy hay không",
  Please_select_whether_to_push: "Vui lòng chọn có đẩy hay không",
  Please_select_order_status: "Vui lòng chọn trạng thái đơn hàng",
  Platform_logistics_channel: "Kênh logistics nền tảng",
  master_bill_number: "Số đơn hàng chính",
  WMS_status: "Trạng thái WMS",
  destination_country: "Quốc gia đích",
  Platform_remarks: "Ghi chú nền tảng",
  Warehouse_presence_remarks: "Có ghi chú kho",
  No_warehouse_remarks_exist: "Không có ghi chú kho",
  Warehouse_note: "Ghi chú kho",
  Delivery_of_abnormal_information: "Thông tin vận chuyển bất thường",
  Remaining_delivery_time: "Thời gian giao hàng còn lại",
  order_amount: "Số tiền đơn hàng",
  primitive_money: "Đơn vị tiền tệ gốc",
  Order_profit: "Lợi nhuận đơn hàng",
  profit_margin: "Tỷ suất lợi nhuận",
  delivery_time: "Thời gian xuất kho",
  Deduct_time: "Thời gian trừ phí",
  Save_the_current_search_conditions: "Lưu điều kiện tìm kiếm hiện tại",
  No_data_is_selected: "Chưa chọn bất kỳ dữ liệu nào!",
  No_customer_has_been_selected: "Chưa chọn bất kỳ khách hàng nào!",
  The_order_was_cancelled_successfully: "Đơn hàng đã bị hủy thành công!",
  Order_activation_success: "Đơn hàng đã được kích hoạt thành công!",
  Orders_have_been_prioritized_for_delivery:
    "Đơn hàng đã được đặt ưu tiên giao hàng!",
  OrderInfo: "Chi tiết đơn hàng",
  Modify_remarks: "Sửa ghi chú",
  Quick_query_condition: "Điều kiện truy vấn nhanh",
  Marked_delivery: "Đánh dấu giao hàng",
  Please_select_a_piece_of_data: "Vui lòng chọn một dữ liệu",
  Marked_delivery_Succeed: "Đánh dấu giao hàng thành công",
  Marked_delivery_lose: "Đánh dấu giao hàng thất bại",
  Systematic_item_list: "Chi tiết hàng hóa hệ thống",
  not_available: "Không có",
  multiattribute: "Nhiều thuộc tính",
  multiattributeID: "ID nhiều thuộc tính",
  Please_select_an_order_from_the_same_warehouse:
    "Vui lòng chọn đơn hàng trong cùng một kho",
  Batch_replacement_of_SKUs: "Thay thế SKU hàng loạt",
  replace_SKU: "Thay thế SKU",
  delete_SKU: "Xóa SKU",
  add_sku: "Thêm SKU",
  Only_one_SKU_can_be_replaced: "Chỉ hỗ trợ thay thế SKU đơn lẻ",
  Select_the_sku_that_you_want_to_replace: "Chọn SKU cần thay thế",
  Select_the_new_SKU: "Chọn SKU mới",
  Whether_the_product_has_a_barcode: "Sản phẩm có dán mã vạch không",
  Duplicate_SKUs_appear: "Xuất hiện SKU trùng lặp",
  Printing: "Đang in...",
  Please_select_a_type_of_basket: "Vui lòng chọn một loại giỏ hàng",
  printPreview: "Xem trước bản in",
  designPrinting: "Thiết kế bản in",
  Delete_an_order: "Xóa đơn hàng",
  Pairing_or_not: "Có ghép đôi không",
  type_of_merchandize: "Loại sản phẩm",
  Print_type: "Loại bản in",
  The_uploaded_file_format_is_incorrect: "Lỗi định dạng tệp tải lên",
  Currently_only_single_order_upload_is_supported:
    "Hiện chỉ hỗ trợ tải lên đơn hàng đơn lẻ",
  Save_as_PDF: "Lưu dưới dạng PDF",
  downloading: "Đang tải xuống",
  Direct_printing: "In trực tiếp",
  Confirm_submission: "Xác nhận gửi?",
  quantity_of_order: "Số lượng đơn hàng",
  hour: "Thời gian",
  The_task_can_be_obtained_directly: "Có thể lấy nhiệm vụ trực tiếp",
  You_need_to_scan_the_distribution_basket_to_get_the_task:
    "Cần quét giỏ hàng để lấy nhiệm vụ",
  When_the_task_type_is_multi_product_you_can_choose_whether_to_allocate_goods_by_floor:
    "Khi chọn loại nhiệm vụ là nhiều mặt hàng, mới có thể chọn có phân phối hàng theo tầng hay không",
  Whether_to_scan_the_warehouse_location_when_distributing_goods:
    "Khi phân phối hàng, có cần quét vị trí kho hay không",
  When_the_task_type_is_multi_product_the_matching_and_sending_function_cannot_be_enabled:
    "Khi chọn loại nhiệm vụ là nhiều mặt hàng, không thể bật tính năng phân phối và phát hàng cùng lúc",
  presell: "Bán trước",
  stockoutOrder: "Đơn hàng hết hàng",
  No_out_of_stock_orders: "Đơn hàng không hết hàng",
  Online_product_Pictures: "Hình ảnh sản phẩm trực tuyến",
  After_the_warehouse_is_selected_the_corresponding_inventory_will_be_returned:
    "Sau khi chọn kho xuất hàng, kho tương ứng sẽ được truyền lại",
  Transfer_the_tracking_number_to_obtain: "Đang chuyển số vận đơn",
  Transfer_the_tracking_number_to_obtain_or_pending_shipment:
    "Đang chuyển số vận đơn/Chờ giao hàng",
  Orders_with_a_tracking_number_will_automatically_be_moved_to_awaiting_shipment_while_orders_without_a_tracking_number_will_enter_tracking_number_retrieval:
    "Các đơn hàng có số vận đơn sẽ tự động chuyển sang trạng thái chờ giao hàng, các đơn hàng không có số vận đơn sẽ chuyển sang trạng thái đang lấy số vận đơn.",
  The_tracking_number_exists: "Có số vận đơn",
  No_waybill_number_exists: "Không có số vận đơn",
  has_waybill_number: "Có số vận đơn",
  no_waybill_number: "Không có số vận đơn",
  Whether_out_of_stock: "Có hết hàng không",
  stockout: "Hết hàng",
  stockout_short: "Hết hàng",
  Platform_and_Shop: "Nền tảng/cửa hàng",
  Whether_the_waybill_number_exists: "Có số vận đơn không",
  Presence_platform_remarks: "Có ghi chú nền tảng",
  No_platform_remarks: "Không có ghi chú nền tảng",
  has_platform_remark: "Có ghi chú nền tảng",
  no_platform_remark: "Không có ghi chú nền tảng",
  Presence_remark: "Có ghi chú",
  No_remarks_exist: "Không có ghi chú",
  has_remark: "Có ghi chú",
  no_remark: "Không có ghi chú",
  Split_order: "Đơn hàng tách",
  Unsplit_order: "Đơn hàng không tách",
  Advance_order: "Đơn hàng bán trước",
  Non_advance_order: "Đơn hàng không bán trước",
  Matching_order: "Đơn hàng ghép",
  Already_paired_Order: "Đơn hàng đã ghép",
  unpaired_Order: "Đơn hàng chưa ghép",
  Traffic_anomaly: "Sự cố vận chuyển",
  A_traffic_exception_exists_Procedure: "Có sự cố vận chuyển",
  No_traffic_exception_exists: "Không có sự cố vận chuyển",
  has_transportation_abnormal: "Có sự cố vận chuyển",
  no_transportation_abnormal: "Không có sự cố vận chuyển",
  allTask: "Tất cả nhiệm vụ",
  todayTask: "Nhiệm vụ hôm nay",
  todayTask17: "Nhiệm vụ hôm nay 17",
  todayTask14: "Nhiệm vụ hôm nay 14",
  yesterdayTask: "Nhiệm vụ hôm qua",
  New_quick_query: "Thêm tìm kiếm nhanh",
  Order_status_inquiry: "Tìm kiếm trạng thái đơn hàng",
  The_tracking_number_is_being_obtained: "Đang lấy số vận đơn...",
  Submit_the_order_task: "Nhiệm vụ đơn hàng đã gửi",
  Mixed_shipment_or_not: "Có giao hàng hỗn hợp không",
  Order_task_submitted_today_00_00_00_18_00_00:
    "Nhiệm vụ đơn hàng đã gửi từ 00:00:00 đến 18:00:00 hôm nay",
  Order_task_submitted_yesterday_00_00_00_23_59_59:
    "Nhiệm vụ đơn hàng được gửi từ 00:00:00 đến 23:59:59 ngày hôm qua",
  This_operation_will_permanently_delete_the_query_condition_Do_you_want_to_continue:
    "Thao tác này sẽ xóa vĩnh viễn điều kiện tìm kiếm, có tiếp tục không?",
  After_obtaining_the_tracking_number_it_will_be_automatically_transferred_to_the_agent_for_delivery:
    "Sau khi lấy được số vận đơn, đơn hàng sẽ tự động chuyển sang trạng thái chờ giao hàng",
  The_input_format_is_incorrect_English_is_not_allowed_only_three_decimal_places:
    "Định dạng nhập sai, không cho phép sử dụng chữ cái, chỉ cho phép ba chữ số thập phân",
  Once_the_QR_code_scanning_is_initiated_it_will_be_invalid_Repeated_scanning_will_fail_the_verification_and_the_transaction_needs_to_be_re_initiated:
    "Mã QR nạp tiền trực tuyến sẽ hết hiệu lực sau khi quét một lần, quét lại sẽ không được xác minh, cần phải bắt đầu lại giao dịch",
  Confirm_the_transfer_pending: "Xác nhận chuyển sang trạng thái chờ xử lý",
  transfer_pending: "Chuyển sang trạng thái chờ xử lý",
  When_the_task_type_is_multi_product_if_delivery_inspection_is_disabled_there_is_no_need_to_scan_all_SKUs_of_the_corresponding_order_scanning_one_SKU_will_allow_the_corresponding_order_to_be_shipped_If_enabled_all_SKUs_of_the_order_need_to_be_scanned:
    "Khi loại nhiệm vụ là nhiều mặt hàng, nếu tắt chức năng kiểm tra hàng hóa trước khi giao hàng, thì không cần quét tất cả các mã SKU của đơn hàng tương ứng, chỉ cần quét một mã SKU, đơn hàng tương ứng sẽ được xuất kho. Nếu bật chức năng này, thì cần quét tất cả các mã SKU của đơn hàng.",
  When_the_task_type_is_single_product_and_the_match_and_send_function_is_enabled_There_is_no_need_to_wait_for_the_allocation_task_to_be_completely_finished_Once_some_SKUs_are_allocated_you_can_operate_the_orders_of_the_corresponding_allocated_SKUs_for_shipping:
    "Khi loại nhiệm vụ là một mặt hàng, bật tính năng phân phối và giao hàng đồng thời. Không cần đợi nhiệm vụ phân phối hoàn tất, chỉ cần một phần SKU được phân phối xong là có thể tiến hành giao hàng cho đơn hàng có SKU đã được phân phối tương ứng.",
  Enable_this_function_and_single_product_orders_can_be_obtained_in_multi_product_allocation:
    "Bật tính năng này, trong phân phối nhiều mặt hàng sẽ có thể lấy được đơn hàng một mặt hàng.",
  Expired_stores: "Cửa hàng đã hết hạn",
  The_transportation_of_goods_in_the_past_seven_days_has_been_abnormal:
    "Sự cố giao hàng trong 7 ngày gần đây",
  Whether_to_exclude_submission_rules: "Có loại trừ quy tắc gửi",
  Not_excluded_submission_rules: "Không loại trừ quy tắc gửi",
  Excluded_submission_rules: "Loại trừ quy tắc gửi",
  Whether_to_exclude_automatic_packaging_rules:
    "Có loại trừ quy tắc đóng gói tự động không",
  Not_excluded_automatic_packaging_rules:
    "Không loại trừ quy tắc đóng gói tự động",
  Excluded_automatic_packaging_rules: "Loại trừ quy tắc đóng gói tự động",
  Cancel_excluded_submission_rules: "Hủy loại trừ quy tắc gửi",
  Cancel_excluded_automatic_packaging_rules:
    "Hủy loại trừ quy tắc đóng gói tự động",
  Excluded_all_rules: "Loại trừ tất cả quy tắc",
  Cancel_excluded_all_rules: "Hủy loại trừ tất cả quy tắc",
  Refresh_platform_status: "Làm mới trạng thái nền tảng",
  Only_supports_operations_for_API_orders_with_a_delivery_deadline_within_12_hours_and_push_orders_created_later_than_12_hours:
    "Chỉ hỗ trợ thao tác Đơn hàng API trong vòng 12 giờ trước thời hạn giao hàng và Đơn hàng đẩy sau 12 giờ kể từ thời điểm tạo",
  shipping_label: "Phiếu giao hàng",
  shipping_label_exists: "Có phiếu giao hàng",
  no_shipping_label_exists: "Không có phiếu giao hàng",
  has_label: "Có phiếu giao hàng",
  no_label: "Không có phiếu giao hàng",
  out_of_stock_orders: "Đơn hàng hết hàng",
  No_waybill_number: "Không có số vận đơn",
  // has_platform_remark:"Có ghi chú trên nền tảng",
  has_warehouse_remark: "Có ghi chú kho",
  no_warehouse_remark: "Không có ghi chú kho",
  is_split_orders: "Đơn hàng được chia nhỏ",
  is_presell_orders: "Đơn hàng bán trước",
  Unpaired: "Chưa được ghép đôi",
  Get_the_logistics_track: "Lấy thông tin theo dõi logistics",
  Latest_updates: "Cập nhật mới nhất",
  Logistics_information_is_being_pulled: "Đang lấy thông tin logistics",
  package_information: "Thông tin bao bì",
  Chinese_product_name: "Tên sản phẩm bằng tiếng Trung",
  English_product_name: "Tên sản phẩm bằng tiếng Anh",
  Obtaining_tracking_number: "Đang lấy số vận đơn",
  No_abnormalities: "Không có bất thường",
  Submission_rules_are_not_excluded: "Không loại trừ quy tắc gửi",
  The_submission_rule_is_excluded: "Đã loại trừ quy tắc gửi",
  Automatic_packaging_material_rules_not_excluded:
    "Chưa loại trừ quy tắc bao bì tự động",
  The_automatic_packaging_rules_have_been_excluded:
    "Đã loại trừ quy tắc bao bì tự động",
  The_number_of_selected_orders_cannot_exceed_100:
    "Số lượng đơn hàng chọn không được vượt quá 100",
  Reship: "Giao hàng lại",
  Transfer_cancellation_exception: "Chuyển sang hủy bất thường",
  Returned_without_generation: "Trả lại chưa tạo",
  The_currently_selected_order_has_no_delivery_exceptions_and_requires_no_action:
    "Đơn hàng hiện được chọn không có bất thường trong giao hàng, không cần thao tác",
  If_you_need_to_check_the_inventory_information_of_the_products_please_select_the_option_on_the_right:
    "Nếu cần xem thông tin hàng tồn kho, vui lòng chọn nút bên phải",
  Add_Warehouse_Product_Inventory_Details: "Thêm chi tiết hàng tồn kho kho",
  editOrder: "Chỉnh sửa đơn hàng",
  bulk_edit: "Chỉnh sửa hàng loạt",
  empty: "Xóa",
  consigner: "Người gửi",
  shipper: "Người gửi hàng",
  Order_deduction: "Phí đơn hàng",
  Select_sender: "Chọn người gửi",
  Please_enter_consigner: "Vui lòng nhập người gửi",
  Sender_information: "Thông tin người gửi",
  consigner_address: "Địa chỉ người gửi",
  Please_enter_consigner_address: "Vui lòng nhập địa chỉ người gửi",
  consignee_information: "Thông tin người nhận",
  recipients: "Người nhận",
  recipientsList: "Danh sách người nhận",
  Save_as_a_regular_recipient: "Lưu làm người nhận thường xuyên",
  Select_recipients: "Chọn người nhận",
  Please_enter_recipients: "Vui lòng nhập người nhận",
  Only_one_recipient_can_be_selected: "Chỉ có thể chọn một người nhận",
  Please_enter_the_recipient_name_for_query:
    "Vui lòng nhập tên người nhận để tìm kiếm",
  postcode: "Mã bưu chính",
  Please_enter_postcode: "Vui lòng nhập mã bưu chính",
  recipients_country: "Quốc gia của người nhận",
  Please_enter_recipients_country: "Vui lòng nhập quốc gia của người nhận",
  Please_select_recipients_country: "Vui lòng chọn quốc gia của người nhận",
  Please_select_recipients: "Vui lòng chọn người nhận",
  type_of_shipping: "Phương thức vận chuyển",
  Please_enter_type_of_shipping: "Vui lòng nhập phương thức vận chuyển",
  Please_select_type_of_shipping: "Vui lòng chọn phương thức vận chuyển",
  Alternate_recipient_address: "Địa chỉ người nhận dự phòng",
  Please_enter_Alternate_recipient_address:
    "Vui lòng nhập địa chỉ người nhận dự phòng",
  commodity_information: "Thông tin hàng hóa",
  Select_product: "Chọn sản phẩm",
  Save_until_reviewed: "Lưu vào danh sách chờ duyệt",
  Submit_to_consignment: "Gửi đến danh sách chờ giao hàng",
  Batch_set_package_materials: "Cài đặt hàng loạt vật liệu đóng gói",
  Please_add_packing_material: "Vui lòng thêm vật liệu đóng gói",
  under: "Dưới đây",
  Please_enter_the_tracking_number_information:
    "Vui lòng nhập số đơn hàng Thông tin vận chuyển",
  Please_select_the_estimated_time_of_arrival:
    "Vui lòng chọn thời gian dự kiến đến kho",
  Only_a_single_recipient_can_be_selected: "Chỉ cho phép chọn một người nhận",
  Please_enter_a_combination_SKU: "Vui lòng nhập SKU kết hợp",
  The_number_of_empty_combination_SKUs_exists_Check_and_try_again:
    "Có số lượng SKU kết hợp trống, vui lòng kiểm tra lại và thử lại",
  Please_enter_the_combination_SKU_name: "Vui lòng nhập tên SKU kết hợp",
  Click_to_select_the_row_data_doubleclick_to_select_the_row_data_and_confirm_the_current_selection_data:
    "Nhấp để chọn dữ liệu dòng này, nhấp đúp để chọn dữ liệu dòng này và xác nhận dữ liệu hiện đang chọn!",
  tagged: "Có nhãn",
  No_mark: "Không có nhãn",
  Import_recipients: "Nhập người nhận",
  agree: "Đồng ý",
  reject: "Từ chối",
  cancellationOrder: "Hủy đơn hàng",
  reason_for_refusal: "Lý do từ chối",
  Please_enter_reason_for_refusal: "Vui lòng chọn lý do từ chối",
  Application_for_cancellation_of_time: "Thời gian yêu cầu hủy",
  expiration_time: "Thời gian hết hạn",
  reason_of_cancellation: "Lý do hủy",
  Please_Select_Warehouse_First: "Vui lòng chọn kho trước",
  Please_Select_Packaging_Method_First:
    "Vui lòng chọn phương thức đóng gói trước",
  Number_Of_Loops: "Số vòng",
  Please_Select_Packaging_Material: "Vui lòng chọn vật liệu đóng gói",
  Please_Select_Packaging_Method: "Vui lòng chọn phương thức đóng gói",
  Please_Enter_Number_Of_Loops: "Vui lòng nhập số vòng",
  Order_Packaging: "Vật liệu đóng gói đơn hàng",
  Packaging_Method: "Phương thức đóng gói",
  Packaging_Material_Type: "Loại vật liệu đóng gói",
  Whole_Order_Packaging: "Đóng gói toàn bộ đơn hàng",
  Packaging_By_SKU: "Đóng gói theo SKU",
  Individual_Product_Packaging: "Đóng gói từng mặt hàng riêng lẻ",
  Volume: "Khối lượng",
  Unit_Price: "Giá đơn vị",
  Please_Enter_Quantity: "Vui lòng nhập số lượng",
  Packaging_Material_Type_And_Packaging_Method_Must_Be_Filled_In_Simultaneously:
    "Loại vật liệu đóng gói và phương thức đóng gói phải được điền cùng lúc",
  first_leg: "Chặng đầu",
  Head_process_management: "Quản lý chặng đầu",
  FirstLegOrderManagement: "Quản lý đơn hàng chặng đầu",
  firstLegOrderList: "Danh sách đơn hàng chặng đầu",
  firstBillingList: "Danh sách hóa đơn chặng đầu",
  First_billing_list: "Danh sách hóa đơn chặng đầu",
  FirstLegOrderStatus: "Trạng thái đơn hàng chặng đầu",
  FirstLegOrderNumber: "Số đơn hàng chặng đầu",
  Headway_tracking_number_Order_number_Grabway_information:
    "Số đơn hàng đầu tiên/Số đơn hàng/Thông tin vận chuyển hàng hóa",
  First_order_stage: "Giai đoạn đơn hàng đầu tiên",
  Please_enter_FirstLegOrderNumber: "Vui lòng nhập số đơn hàng đầu tiên",
  warehouse_entry_number: "Số đơn hàng nhập kho",
  Please_enter_warehouse_entry_number: "Vui lòng nhập số đơn hàng nhập kho",
  createoriginReceivingInboundOrder: "Tạo đơn hàng nhập kho đầu tiên",
  editOriginReceivingInboundOrder: "Chỉnh sửa đơn hàng nhập kho đầu tiên",
  editHeaderList: "Chỉnh sửa đơn hàng đầu tiên",
  firstLegOrderId: "ID đầu tiên",
  draft: "Bản nháp",
  audited: "Đã được phê duyệt",
  abnormal: "Bất thường",
  Self_delivery_warehouse: "Tự giao đến kho",
  The_customer_sends_it_to_the_transit_warehouse:
    "Khách hàng tự giao đến kho trung chuyển",
  Door_to_door_collection: "Nhận hàng tại nhà",
  Transfer_warehouse_contact_logistics_to_customer_designated_address_collection:
    "Kho trung chuyển liên hệ với bộ phận logistics để nhận hàng tại địa chỉ do khách hàng chỉ định",
  Warehouse_entry_stage: "Giai đoạn đơn nhập kho",
  Warehouse_entry_description: "Mô tả đơn nhập kho",
  Batch_number_issued_by_three_warehouses: "Số lô do kho bên thứ ba phát hành",
  Three_party_warehouse_PO_number: "Số PO kho bên thứ ba",
  Storage_single_status: "Trạng thái đơn nhập kho",
  destination: "Điểm đến",
  Other_destinations: "Điểm đến khác",
  Other_address: "Địa chỉ khác",
  Other_address_contacts: "Người liên hệ địa chỉ khác",
  Other_address_Contact_number: "Số điện thoại người liên hệ địa chỉ khác",
  Estimated_time_of_arrival: "Thời gian dự kiến đến kho",
  Channel_type: "Loại kênh",
  Please_select_a_destination: "Vui lòng chọn điểm đến",
  Please_select_Channel_type: "Vui lòng chọn loại kênh",
  Self_delivered: "Tự giao",
  Take_in: "Nhận hàng",
  total_quantity: "Tổng số lượng",
  odd: "Số đơn",
  push: "Đẩy",
  Do_not_push: "Không đẩy",
  Edit_cabinet_number: "Chỉnh sửa số tủ",
  Cargo_pull_information: "Thông tin vận chuyển",
  odd_Cargo_pull_information: "Số đơn hàng/thông tin vận chuyển",
  First_billing_stage: "Giai đoạn hóa đơn đầu tiên",
  First_pass_single_stage: "Giai đoạn đơn hàng đầu tiên",
  Delivery_to_transit_warehouse: "Phương thức vận chuyển đến kho trung chuyển",
  Reserved_gross_weight: "Tổng trọng lượng đặt trước",
  Total_number_of_reservations: "Tổng số khối đặt trước",
  Total_number_of_quantity: "Tổng số lượng đặt trước",
  Total_number_of_packages_arrived: "Tổng số kiện thực tế",
  Actual_gross_weight: "Tổng trọng lượng thực tế",
  Actual_total_number_of_squares: "Tổng số khối thực tế",
  Total_number_of_appointments: "Tổng số kiện đặt trước",
  Total_number_of_boxes_booked: "Tổng số thùng đặt trước",
  Cost_per_cubic_meter_KG: "Chi phí mỗi khối/kg",
  expense_per_cubic_meter_KG: "Chi phí mỗi khối/kg",
  Total_number_of_billed_squares: "Tổng số khối tính phí",
  Gross_chargeable_weight: "Tổng trọng lượng tính phí",
  Additional_charge_per_cubic_meter_KG: "Phí bổ sung mỗi mét khối/kg",
  Surcharge_cost_per_cubic_meter_KG: "Chi phí bổ sung mỗi mét khối/kg",
  container_number: "Số container",
  Please_enter_container_number: "Vui lòng nhập số container",
  Please_select_a_stuffing_time: "Vui lòng nhập thời gian xếp container",
  Customer_remarks: "Ghi chú của khách hàng",
  Customer_service_remarks: "Ghi chú của bộ phận chăm sóc khách hàng",
  Financial_remarks: "Ghi chú của bộ phận tài chính",
  Abnormal_remarks: "Ghi chú bất thường",
  please_enter_Abnormal_remarks: "Vui lòng nhập ghi chú bất thường",
  receiving_time: "Thời gian nhận hàng",
  consignee: "Người nhận hàng",
  Delivery_time: "Thời gian nhận hàng trung chuyển",
  Estimated_time_to_transit_warehouse: "Thời gian dự kiến đến kho trung chuyển",
  Destination_arrival_time: "Thời gian đến điểm đến",
  submission_time: "Thời gian gửi",
  Create_a_Customer_ID: "Tạo ID khách hàng",
  The_operation_failed_because_an_empty_box_exists_Please_modify_the_box_and_try_again:
    "Thao tác không thành công, có container rỗng, vui lòng sửa lại và thử lại!",
  The_operation_failed_because_there_is_an_empty_amount_of_incoming_storage_Please_modify_it_and_try_again:
    "Thao tác không thành công, có số lượng nhập kho rỗng, vui lòng sửa lại và thử lại!",
  viewOriginReceivingInboundOrder: "Xem đơn hàng nhập kho đầu tiên",
  firstReceiptGoods: "Nhận hàng đầu tiên",
  goods_receiving_information: "Thông tin nhận hàng",
  consignment_sheet: "Danh sách nhận hàng",
  firstBillingDetails: "Chi tiết hóa đơn đầu tiên",
  billing_details: "Chi tiết hóa đơn",
  billingDetails: "Chi tiết hóa đơn",
  Inventory_SKU_List: "Danh sách SKU tồn kho",
  inventorySKUIist: "Danh sách SKU tồn kho",
  First_order_number: "Số đơn hàng đầu tiên",
  Entry_number: "Số đơn hàng nhập kho",
  Financial_verification_time: "Thời gian xác minh tài chính",
  Verify_collection_time: "Thời gian xác minh thu tiền",
  Total_freight: "Tổng chi phí vận chuyển",
  freight_amount: "Chi phí vận chuyển",
  Total_freight_cost: "Tổng chi phí vận chuyển",
  gross_profit: "Tổng lợi nhuận",
  Gross_surcharge: "Tổng phụ phí",
  Basic_query: "Truy vấn cơ bản",
  Logistics_inquiry: "Truy vấn logistics",
  logisticsInquiry: "Truy vấn logistics",
  Logistics_batch: "Lô logistics",
  Number_of_scans: "Số lượng quét",
  Successful_quantity: "Số lượng thành công",
  Number_of_failures: "Số lượng thất bại",
  Remark_query: "Truy vấn ghi chú",
  Time_query: "Truy vấn thời gian",
  Amount_inquiry: "Truy vấn số tiền",
  settlement_date: "Thời gian thanh toán",
  Statement_number: "Số hóa đơn thanh toán",
  Supplier_settlement: "Thanh toán nhà cung cấp",
  viewFirstBillingDetails: "Xem chi tiết hóa đơn đầu tiên",
  stuffing_time: "Thời gian đóng container",
  Changing_Customer_ID: "Sửa đổi ID khách hàng",
  Submit_initial_billing: "Gửi hóa đơn đầu tiên",
  Return_the_initial_bill: "Hoàn trả hóa đơn chặng đầu",
  freight_inquiry: "Truy vấn hàng hóa",
  Starting_weight: "Trọng lượng ban đầu",
  Initial_number: "Số khối ban đầu",
  End_square: "Số khối cuối cùng",
  Starting_number_of_packages: "Số lượng ban đầu",
  End_number_of_packages: "Số lượng cuối cùng",
  Initial_quantity: "Số lượng ban đầu",
  End_quantity: "Số lượng cuối cùng",
  Actual_quantity_arrived: "Số lượng hàng hóa thực tế đến",
  Reservation_quantity: "Số lượng đặt trước",
  The_number_of_received_boxes_is_inconsistent_with_the_number_of_reserved_boxes_whether_to_continue_to_submit:
    "Số lượng thùng hàng nhận không khớp với số lượng đặt trước, có tiếp tục gửi không?",
  First_leg_deduction_fee: "Phí chặng đầu",
  Advance_payment: "Thanh toán chặng đầu",
  Transfer_warehouse_to_collect: "Nhận hàng tại kho trung chuyển",
  Shipping_to_overseas_warehouse: "Vận chuyển đến kho nước ngoài",
  Overseas_warehouse_delivery: "Giao hàng tại kho nước ngoài",
  There_are_mandatory_fields_in_the_received_information:
    "Thông tin vận chuyển có các mục bắt buộc phải điền nhưng chưa được điền",
  There_are_mandatory_fields_in_the_channel_information:
    "Thông tin vận chuyển có các mục bắt buộc phải điền nhưng chưa được điền",
  There_are_no_required_fields_in_the_delivery_information:
    "Thông tin đến kho có các mục bắt buộc phải điền nhưng chưa được điền",
  Please_select_a_delivery_type: "Vui lòng chọn loại giao hàng",
  warehousing: "Nhập kho",
  pick_up_in_a_store: "Tự nhận hàng",
  delivery: "Giao hàng",
  delivery_address: "Địa chỉ giao hàng",
  Store_goods_directly_in_overseas_warehouses:
    "Lưu trữ hàng hóa trực tiếp tại kho nước ngoài",
  The_customer_will_receive_the_goods_from_the_overseas_warehouse_by_himself:
    "Khách hàng tự đến kho hàng ở nước ngoài để nhận hàng",
  By_overseas_warehouse_contact_logistics_delivery_to_the_customer_designated_location:
    "Kho hàng ở nước ngoài liên hệ với đơn vị vận chuyển để giao hàng đến địa điểm do khách hàng chỉ định",
  Upload_credentials: "Tải lên chứng từ",
  credentials: "Chứng từ",
  Please_select_the_same_channel_type: "Vui lòng chọn loại kênh tương tự",
  replacement_expense: "Đặt lại chi phí",
  Set_the_replacement_charge_according_to_the_head_charge:
    "Đặt lại chi phí theo chi phí vận chuyển đầu tiên",
  Reset_the_current_order_cost_by_the_actual_number_of_square_feet:
    "Đặt lại chi phí đơn hàng hiện tại theo số lượng thực tế",
  Reset_the_current_order_charge_according_to_the_actual_order:
    "Đặt lại chi phí đơn hàng hiện tại theo phương thức thực tế của đơn hàng",
  Order_different_goods_attributes_warehouse_transit_warehouse_billing_method_currency_customer_will_use_the_current_cost_Settings_to_calculate_the_cost:
    "Các thuộc tính hàng hóa khác nhau của đơn hàng, kho, kho trung chuyển, phương thức tính phí, loại tiền tệ, khách hàng sẽ được tính phí theo cài đặt chi phí hiện tại.",
  Freight_cost_surcharge_cost_default_value_is_set_for_the_current_order_cost_corresponding_to_the_maximum_amount_cubic_KG:
    "Chi phí vận chuyển, chi phí phụ phí, giá trị mặc định là chi phí đơn hàng hiện tại tương ứng với số tiền tối đa (khối lượng/kg).",
  Freight_cubic_meter_KG: "Chi phí vận chuyển (khối lượng/kg)",
  Additional_charge_cubic_meter_KG: "Phụ phí (khối lượng/kg)",
  freight_cost_cubic_meter_KG: "Chi phí vận chuyển (khối lượng/kg)",
  Surcharge_cost_cubic_meter_KG: "Chi phí phụ phí (khối lượng/kg)",
  The_content_is_not_filled_in: "Có nội dung chưa điền",
  Please_scan_the_head_track_number: "Vui lòng quét mã đơn hàng đầu tiên",
  Please_scan_a_valid_header_tracking_number:
    "Vui lòng quét mã đơn hàng đầu tiên hợp lệ",
  Attributes_of_goods_received: "Thuộc tính hàng hóa nhận",
  Commodity_property: "Thuộc tính hàng hóa",
  Import_order: "Nhập đơn hàng",
  Click_Upload: "Nhấp vào tải lên",
  Click_here_to_download_the_template: "Nhấp vào đây để tải xuống mẫu",
  Download_template: "Tải xuống mẫu",
  DeliveryTime: "Thời gian vận chuyển",
  Start_time_of_inspection: "Thời gian bắt đầu kiểm tra chất lượng",
  End_time_of_inspection: "Thời gian kết thúc kiểm tra chất lượng",
  Shelf_start_time: "Thời gian bắt đầu lên kệ",
  End_shelf_time: "Thời gian kết thúc lên kệ",
  Billing_information: "Thông tin hóa đơn",
  evidence_of_payment: "Chứng từ thanh toán",
  Be_generating: "Đang tạo",
  Entering_a_custom_size_will_override_the_selected_print_size:
    "Nhập kích thước tùy chỉnh sẽ ghi đè kích thước in đã chọn",
  import_first_receipt_goods: "Nhập hàng hóa đầu tiên",
  View_the_inbound_and_outbound_flows: "Xem dòng chảy nhập kho/xuất kho",
  tracking_number: "Số vận đơn",
  edit_tracking_number: "Chỉnh sửa số vận đơn",
  transit_time: "Thời gian vận chuyển",
  loading_time: "Thời gian xếp hàng",
  preset_Exception_Remark: "Ghi chú bất thường cài sẵn",
  Batch_Modify_Product_Billing_Attributes:
    "Sửa đổi hàng loạt thuộc tính tính phí hàng hóa",
  Please_Select_Product_Billing_Attributes:
    "Vui lòng chọn thuộc tính tính phí hàng hóa",
  Product_Billing_Attributes: "Thuộc tính tính phí hàng hóa",
  stockManagement: "Quản lý nhập kho",
  Warehouse_entry_list: "Danh sách phiếu nhập kho",
  warehouseEntryList: "Danh sách phiếu nhập kho",
  warehouseReceiptList: "Danh sách nhận hàng phiếu nhập kho",
  over_time: "Hết thời gian",
  Hit_shelves_on_time: "Lên kệ kịp thời",
  Number_of_SKUs: "Số lượng SKU",
  SKU_total_quantity: "Tổng số lượng SKU",
  qualified_quantity: "Số lượng đạt tiêu chuẩn",
  Quantity_of_reserved_storage: "Số lượng đặt hàng nhập kho",
  Number_of_reserved_storage_parties: "Số lượng đặt hàng nhập kho",
  time_efficiency: "Thời gian hiệu lực",
  On_shelf_rate: "Tỷ lệ lên kệ kịp thời",
  Whether_it_is_forced_into_transit: "Có bắt buộc vận chuyển không",
  Store_entry_details: "Chi tiết phiếu nhập kho",
  Damaged_quantity: "Số lượng hư hỏng",
  Miss_delivery: "Thiếu hàng",
  Miss_delivery_quantity: "Số lượng thiếu",
  wrongly_send: "Gửi nhầm",
  wrongly_send_quantity: "Số lượng gửi nhầm",
  Warehousing_to_receive_goods: "Nhận hàng nhập kho",
  warehousingReceiveGoods: "Nhận hàng nhập kho",
  inventoryEntryListChecked: "Danh sách phiếu nhập kho chờ kiểm tra chất lượng",
  inventoryEntryList: "Danh sách phiếu nhập kho chờ lên kệ",
  Inbound_inspection: "Kiểm tra chất lượng nhập kho",
  inboundInspection: "Kiểm tra chất lượng nhập kho",
  Quality_inspection_quantity: "Số lượng kiểm tra chất lượng",
  quality_testing: "Kiểm tra chất lượng",
  Batch_quality_inspection: "Kiểm tra chất lượng hàng loạt",
  Obtaining_quality_Inspection_Task: "Lấy nhiệm vụ kiểm tra chất lượng",
  Generate_a_quality_check_task: "Phân công nhiệm vụ kiểm tra chất lượng",
  Setting_priority_inspection: "Đặt ưu tiên kiểm tra chất lượng",
  The_inspection_quantity_cannot_be_empty:
    "Số lượng kiểm tra chất lượng không được để trống",
  Disabled_Excess_Check_quantity_cannot_be_greater_than_the_scheduled_check_quantity:
    "Khi chưa bật kiểm tra chất lượng vượt quá, số lượng kiểm tra chất lượng không được lớn hơn số lượng đặt trước",
  Abnormal_quality_inspection_quantity:
    "Số lượng kiểm tra chất lượng bất thường",
  enter_the_qualified_quantity: "Vui lòng nhập số lượng đạt tiêu chuẩn",
  enter_the_breakage_quantity: "Vui lòng nhập số lượng hư hỏng",
  enter_the_lack_send_quantity: "Vui lòng nhập số lượng thiếu hàng",
  enter_the_wrongly_send_quantity: "Vui lòng nhập số lượng gửi nhầm",
  enter_the_actual_weight: "Vui lòng nhập trọng lượng thực tế",
  enter_the_actual_length: "Vui lòng nhập chiều dài thực tế",
  enter_the_actual_width: "Vui lòng nhập chiều rộng thực tế",
  enter_the_actual_height: "Vui lòng nhập chiều cao thực tế",
  length_CM: "Chiều dài (CM)",
  width_CM: "Chiều rộng (CM)",
  height_CM: "Chiều cao (CM)",
  widht_MM: "Chiều rộng (MM)",
  height_MM: "Chiều cao (MM)",
  There_may_be_print_incompatibilities_when_using_custom_printing:
    "Khi sử dụng in tùy chỉnh, nội dung in có thể không tương thích",
  This_parameter_is_valid_only_when_the_width_and_height_are_greater_than_0:
    "Chỉ có hiệu lực khi điền kích thước chiều rộng và chiều cao lớn hơn 0",
  Create_mis_sent_SKUs: "Tạo SKU gửi nhầm",
  The_number_of_missent_SKUs_cannot_be_0:
    "Số lượng SKU gửi nhầm không được bằng 0",
  Only_a_single_item_can_be_selected: "Chỉ cho phép chọn một mặt hàng",
  Number_of_SKUs_sent_incorrectly: "Số lượng SKU gửi nhầm",
  The_inspection_of_the_sku_has_been_completed_Scan_other_SKUs:
    "SKU này đã hoàn thành kiểm tra chất lượng, vui lòng quét SKU khác",
  The_inspection_Label_quantity_cannot_be_empty:
    "Vui lòng điền số lượng dán nhãn",
  The_inspection_Label_quantity_cannot_be_greater_than_the_qualified_quantity:
    "Số lượng nhãn kiểm tra chất lượng không được lớn hơn số lượng đạt tiêu chuẩn",
  Please_scan_the_receipt_number: "Vui lòng quét số đơn hàng nhập kho",
  Quality_inspector: "Người kiểm tra chất lượng",
  Quality_inspection_information: "Thông tin kiểm tra chất lượng",
  Product_real_information: "Thông tin thực tế về sản phẩm",
  printBoxLabel: "In nhãn thùng",
  Print_head_entry_slip: "In đơn hàng nhập kho đầu tiên",
  Print_shipping_mark_and_case_label: "In nhãn thùng hàng",
  Print_storage_box_label: "In nhãn thùng nhập kho",
  Quantity_labeled: "Số lượng đã dán nhãn",
  Quantity_inspected: "Số lượng đã kiểm tra chất lượng",
  Printing_product_bar_code: "In mã vạch sản phẩm",
  unpackingInspection: "Kiểm tra chất lượng khi mở thùng",
  fastQualityInspectionAndShelf: "Kiểm tra chất lượng nhanh và lên kệ",
  qualityInspectionTaskList: "Danh sách nhiệm vụ kiểm tra chất lượng",
  shelvesTaskList: "Danh sách nhiệm vụ lên kệ",
  Ordinary_quality_inspection: "Kiểm tra chất lượng thông thường",
  Rapid_quality_inspection: "Kiểm tra chất lượng nhanh",
  Please_enter_SKU_or_product_barcode: "Vui lòng nhập mã SKU/mã vạch sản phẩm",
  batch_input: "Nhập bằng một nút",
  Please_enter_the_number_of_boxes: "Vui lòng nhập số lượng thùng",
  Order_types: "Loại đơn hàng",
  entering_the_warehouse: "Nhập kho",
  FirstLegOrder: "Đơn hàng đầu tiên",
  InventoryOrder: "Đơn hàng nhập kho",
  FirstLegOrder_AND_InventoryOrder: "Đơn hàng đầu tiên + đơn hàng nhập kho",
  InventoryOrderType: "Loại đơn hàng nhập kho",
  InventoryOrderID: "ID đơn hàng nhập kho",
  ThirdPartyInventoryOrder: "Đơn hàng nhập kho của kho ba bên",
  Receive_information: "Thông tin nhận hàng",
  Receiving_address: "Địa chỉ nhận hàng",
  transport_information: "Thông tin vận chuyển",
  Arrival_information: "Thông tin đến kho",
  delivery_type: "Phương thức giao hàng",
  Push_order: "Đẩy đơn hàng",
  Push_order_Type: "Đẩy trạng thái đơn hàng",
  Please_select_delivery_type: "Vui lòng chọn phương thức giao hàng",
  Please_select_Order_types: "Vui lòng chọn loại đơn hàng",
  Please_select_a_task_type: "Vui lòng chọn loại nhiệm vụ",
  detailed_address: "Địa chỉ chi tiết",
  Please_enter_detailed_address: "Vui lòng nhập địa chỉ chi tiết",
  Please_enter_phone: "Vui lòng nhập số điện thoại liên lạc",
  Select_a_contact: "Chọn người liên lạc",
  phone: "Số điện thoại liên lạc",
  warehouse_address: "Địa chỉ kho",
  Warehouse_information: "Thông tin kho",
  freight_information: "Thông tin vận chuyển",
  Please_enter_mode_of_transportation: "Vui lòng nhập phương thức vận chuyển",
  Please_enter_warehouse_address: "Vui lòng nhập địa chỉ kho",
  Please_select_Estimated_time_to_transit_warehouse:
    "Vui lòng chọn thời gian dự kiến đến kho trung chuyển",
  Please_select_an_estimated_time_to_warehouse:
    "Vui lòng chọn thời gian dự kiến đến kho",
  Shipping_to_transit_warehouse_method:
    "Phương thức vận chuyển đến kho trung chuyển",
  Pure_warehouse_receipt_does_not_support_door_to_door_collection:
    "Đơn hàng nhập kho thuần túy không hỗ trợ nhận hàng tại nhà",
  General_container_number: "Tổng số thùng",
  cargo_list: "Danh sách hàng hóa",
  cargoInfo: "Thông tin hàng hóa",
  personalized_setting: "Cài đặt cá nhân",
  Navigation_bar_style: "Kiểu thanh điều hướng",
  window: "Cửa sổ",
  windowAddress: "Địa chỉ cửa sổ",
  printContent: "Nội dung in",
  printingQuantity: "Số lượng in",
  isShowCnName: "Có hiển thị tên tiếng Trung không",
  isShowMadeInChina: "Có hiển thị Made in China không",
  isShowTime: "Có hiển thị thời gian không",
  The_cargo_list_is_empty: "Danh sách hàng hóa trống",
  add_cargo_list: "Thêm danh sách hàng hóa",
  batch_add_cargo_list: "Thêm danh sách hàng hóa hàng loạt",
  total_value: "Tổng giá trị",
  outer_box_length: "Chiều dài thùng ngoài",
  Please_enter_outer_box_length: "Vui lòng nhập chiều dài thùng ngoài",
  outer_box_width: "Chiều rộng thùng ngoài",
  Please_enter_outer_box_width: "Vui lòng nhập chiều rộng thùng hàng",
  outer_box_height: "Chiều cao thùng hàng",
  Please_enter_outer_box_height: "Vui lòng nhập chiều cao thùng hàng",
  Receiving_container_length: "Chiều dài thùng hàng nhận hàng",
  Receiving_container_width: "Chiều rộng thùng hàng nhận hàng",
  Receiving_container_height: "Chiều cao thùng hàng nhận hàng",
  Received_weight: "Trọng lượng nhận hàng",
  carton_size: "Kích thước thùng hàng",
  Please_select_whether_there_is_a_label: "Vui lòng chọn có nhãn hay không",
  Please_enter_the_customer_name: "Vui lòng nhập tên khách hàng",
  box: "Thùng",
  boxNumber: "Số thùng",
  product_details: "Chi tiết hàng hóa",
  add_product_details: "Thêm chi tiết hàng hóa",
  remove: "Xóa",
  product_image: "Hình ảnh sản phẩm",
  Eng_Cn_Name: "Tên hàng hóa bằng tiếng Trung",
  Please_enter_Eng_Cn_Name: "Vui lòng nhập tên hàng hóa bằng tiếng Trung",
  Eng_En_Name: "Tên hàng hóa bằng tiếng Anh",
  Please_enter_Eng_En_Name: "Vui lòng nhập tên sản phẩm bằng tiếng Anh",
  unit_price: "Giá đơn vị",
  Please_enter_unit_price: "Vui lòng nhập giá đơn vị",
  Is_there_a_mark: "Có nhãn hay không",
  goodsCode: "Mã vạch sản phẩm",
  model: "Mẫu mã",
  Please_enter_model: "Vui lòng nhập mẫu mã",
  material: "Chất liệu",
  stage: "Giai đoạn",
  product_code: "Mã sản phẩm",
  Please_enter_material: "Vui lòng nhập chất liệu",
  customs_code: "Mã hải quan",
  Please_enter_customs_code: "Vui lòng nhập mã hải quan",
  brand: "Thương hiệu",
  Please_enter_brand: "Vui lòng nhập thương hiệu",
  List_of_goods_not_selected_for_addition:
    "Danh sách hàng hóa chưa được chọn thêm",
  There_is_an_empty_container_number_Please_fill_in_the_container_number_and_try_again:
    "Có số thùng rỗng, vui lòng điền số thùng rồi thử lại!",
  Property_of_goods: "Thuộc tính hàng hóa",
  Please_select_goods_attributes: "Vui lòng chọn thuộc tính hàng hóa",
  CollectInfo: "Thông tin nhận hàng",
  Repeated_SKUs_appear: "Xuất hiện SKU trùng lặp",
  Save_to_draft: "Lưu vào bản nháp",
  batch_processing: "Xử lý hàng loạt",
  Quantity_in_storage: "Số lượng nhập kho",
  Dimensional_synchronization: "Đồng bộ kích thước",
  The_batch_list_is_not_selected:
    "Danh sách hàng hóa chưa chọn xử lý hàng loạt",
  Total_storage_quantity: "Tổng số lượng nhập kho",
  Gross_cargo_weight: "Tổng trọng lượng hàng hóa",
  Shipping_Information: "Thông tin giao hàng",
  Delivery_type: "Loại giao hàng",
  box_quantity: "Số lượng thùng",
  Size_of_the_outer_box_received: "Kích thước thùng hàng nhận",
  not_receive_the_goods: "Chưa nhận hàng",
  received: "Đã nhận hàng",
  Take_pictures_of_receiving_goods: "Hình ảnh nhận hàng",
  Receive_goods_in_one_box: "Nhận hàng từng thùng",
  Double_receipt: "Nhận hàng trùng lặp",
  Write_back_time: "Thời gian ghi lại",
  Write_back_result: "Kết quả ghi lại",
  Single_box_Only_one_box_can_be_selected:
    "Nhận hàng từng thùng Chỉ cho phép chọn từng thùng",
  The_receiving_list_has_empty_value_and_cannot_be_saved:
    "Danh sách nhận hàng có giá trị trống, không lưu được",
  No_box_was_selected_to_save_the_receipt:
    "Không chọn bất kỳ thùng hàng nào để lưu",
  Duplicate_receipt_is_detected_whether_to_duplicate_receipt:
    "Phát hiện nhận hàng trùng lặp, có phải nhận hàng trùng lặp không?",
  Whether_excess_inspection: "Có vượt quá kiểm tra chất lượng không?",
  Priority_inspection: "Có ưu tiên kiểm tra chất lượng không?",
  Only_a_single_entry_ticket_can_be_selected:
    "Chỉ cho phép chọn một phiếu nhập kho",
  The_box_number_already_exists: "Số thùng hàng sai, vui lòng nhập lại",
  Please_enter_the_box_number: "Vui lòng nhập số thùng hàng",
  The_inspection_of_all_the_current_container_numbers_has_been_completed:
    "Tất cả số thùng hàng hiện tại đã hoàn thành kiểm tra chất lượng",
  There_is_no_quality_inspection_data_for_the_current_container_number:
    "Hiện tại không có dữ liệu kiểm tra chất lượng cho số thùng này, vui lòng quét lại!",
  The_SKU_does_not_exist_in_the_current_container_number:
    "Số thùng hiện tại không tồn tại SKU này",
  inspected: "Đã kiểm tra chất lượng",
  Not_inspected: "Chưa kiểm tra chất lượng",
  Successful_receipt: "Nhận hàng thành công",
  Submit_and_print: "Gửi và in",
  Print_head_list: "In phiếu vận chuyển đầu tiên",
  Header_list: "Danh sách vận chuyển đầu tiên",
  printHeaderList: "In danh sách vận chuyển đầu tiên",
  printSubMitHeaderList: "In và gửi danh sách vận chuyển đầu tiên",
  First_shipping_mark: "Nhãn vận chuyển đầu tiên",
  printFirsShippingMark: "In nhãn vận chuyển đầu tiên",
  printSubMitFirsShippingMark: "In và gửi nhãn vận chuyển đầu tiên",
  First_single_box_label: "Nhãn vận chuyển đầu tiên cho từng thùng",
  Warehouse_single_box_label: "Nhãn nhập kho cho từng thùng",
  printFirstSingleBoxLabelAndWarehouseSingleBoxLabel:
    "In nhãn vận chuyển đầu tiên + nhãn kho",
  printSubMitFirstSingleBoxLabelAndWarehouseSingleBoxLabel:
    "In và gửi nhãn vận chuyển đầu tiên + nhãn kho",
  Select_individual_order: "Vui lòng chọn một đơn hàng",
  total_number_packages: "Tổng số lượng",
  total_weight_KG: "Tổng trọng lượng (KG)",
  Gross_cube_CBM: "Tổng khối lượng (CBM)",
  Gross_cube: "Tổng khối lượng",
  Export_data_priority: "Ưu tiên xuất dữ liệu",
  Specified_exported_data: "Chỉ định xuất dữ liệu",
  List_selection_data: "Chọn dữ liệu từ danh sách",
  List_filtering_data: "Lọc dữ liệu từ danh sách",
  distributionManagement: "Quản lý phân phối hàng hóa",
  printInventoryEntryList: "In danh sách nhập kho",
  The_form_verification_failed_Please_check_and_try_again:
    "Kiểm tra biểu mẫu không thành công, vui lòng kiểm tra lại và thử lại",
  The_product_bar_code_does_not_exist_in_the_current_task_list_or_has_been_put_on_the_shelf:
    "Phiếu nhiệm vụ hiện tại không có mã vạch sản phẩm này hoặc đã được lên kệ, vui lòng quét lại!",
  Inventory_entry_list: "Danh sách phiếu nhập kho",
  Print_the_inventory_entry_list: "In danh sách phiếu nhập kho",
  One_click_out_and_print_the_pick_list:
    "Xuất kho và in phiếu lấy hàng bằng một nút bấm",
  One_click_out_the_warehouse_and_print_the_invoice:
    "Xuất kho và in phiếu giao hàng bằng một nút bấm",
  Only_confirmation_time_is_supported: "Chỉ hỗ trợ thời gian xác nhận",
  Please_select_confirmation_time: "Vui lòng chọn thời gian xác nhận",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "Chỉ lưu thời gian xác nhận theo giờ, phút, giây, khi tra cứu nhanh sẽ mặc định là ngày hôm nay",
  The_current_operation_cannot_be_undone_Do_you_want_to_continue:
    "Không thể hủy thao tác hiện tại, có tiếp tục không?",
  Quantities_that_have_not_passed_quality_inspection_will_be_considered_entirely_unqualified:
    "Số lượng chưa qua kiểm tra chất lượng sẽ được coi là không đạt tiêu chuẩn",
  Edit_warehouse_remark: "Sửa đổi ghi chú kho",
  Submit_to_listed: "Gửi đến đã lên kệ",
  Has_the_quality_inspection_been_completed:
    "Đã hoàn thành kiểm tra chất lượng chưa?",
  Forecast_error_message: "Thông báo lỗi dự báo",
  Take_pictures_out_of_the_warehouse: "Ảnh chụp xuất kho",
  Online_product_details: "Chi tiết hàng hóa trực tuyến",
  Product_preview: "Ảnh xem trước hàng hóa",
  declared_value: "Giá trị khai báo",
  Weight_KG_piece: "Trọng lượng (KG/cái)",
  Weight_KG_box: "Trọng lượng (KG/thùng)",
  Declared_value_USD_piece: "Giá trị khai báo (USD/cái)",
  Please_enter_Declared_value_USD_piece:
    "Vui lòng nhập giá trị khai báo (USD/cái)",
  Please_enter_Weight_KG_piece: "Vui lòng nhập trọng lượng (KG/cái)",
  CommodityManagement: "Quản lý hàng hóa",
  commodity: "Hàng hóa",
  commodityName: "Tên hàng hóa",
  Online_product_name: "Tên hàng hóa trực tuyến",
  SKUManagement: "Quản lý SKU",
  inventorySKUManagement: "Quản lý SKU tồn kho",
  inventorySKU: "SKU tồn kho",
  EditInventorySKU: "SKU tồn kho",
  inventorySKUName: "Tên SKU tồn kho",
  inventorySKUList: "Danh sách SKU tồn kho",
  inventorySKUImage: "Hình ảnh SKU tồn kho",
  Click_to_upload_stock_SKU_picture: "Nhấp để tải lên hình ảnh SKU tồn kho",
  Click_to_upload_combined_SKU_images: "Nhấp để tải lên hình ảnh SKU kết hợp",
  Import_goods: "Nhập sản phẩm",
  Batch_create_goods: "Tạo sản phẩm hàng loạt",
  Edit_the_combined_SKU: "Chỉnh sửa SKU kết hợp",
  bar_code: "Mã vạch",
  Commodity_billing_attribute: "Thuộc tính tính phí sản phẩm",
  Editable_or_not: "Có thể chỉnh sửa",
  Combination_quantity: "Số lượng kết hợp",
  Add_stock_SKUs: "Thêm SKU tồn kho",
  Please_enter_inventorySKU: "Vui lòng nhập SKU tồn kho",
  Please_enter_bar_code: "Vui lòng nhập mã vạch",
  product_Cn_name: "Tên sản phẩm bằng tiếng Trung",
  Please_enter_product_Cn_name: "Vui lòng nhập tên sản phẩm bằng tiếng Trung",
  product_En_name: "Tên sản phẩm bằng tiếng Anh",
  Please_enter_product_En_name: "Vui lòng nhập tên sản phẩm bằng tiếng Anh",
  initiate_mode: "Trạng thái kích hoạt",
  Please_select_initiate_mode: "Vui lòng chọn trạng thái kích hoạt",
  inventory_status: "Trạng thái kho",
  Please_select_inventory_status: "Vui lòng chọn trạng thái kho",
  Alarm_threshold_status: "Trạng thái ngưỡng cảnh báo",
  Please_select_Alarm_threshold_status:
    "Vui lòng chọn trạng thái ngưỡng cảnh báo",
  Last_two_weeks: "Hai tuần gần nhất",
  Last_two_month: "Hai tháng gần nhất",
  Last_three_month: "Ba tháng gần nhất",
  actual_weight_KG: "Trọng lượng thực tế (KG)",
  Actual_Trilateral_sum_CM: "Tổng chiều dài ba cạnh thực tế (CM)",
  Actual_size_CM: "Kích thước thực tế (CM)",
  physical_length: "Chiều dài thực tế",
  physical_width: "Chiều rộng thực tế",
  physical_height: "Chiều cao thực tế",
  size_CM: "Kích thước (CM)",
  Actual_size: "Kích thước thực tế",
  print_size: "Kích thước in",
  Custom_size: "Kích thước tùy chỉnh",
  Custom_size_print: "In kích thước tùy chỉnh",
  Please_enter_actual_weight: "Vui lòng nhập trọng lượng thực tế",
  Please_enter_actual_Trilateral_sum_CM:
    "Vui lòng nhập tổng chiều dài ba cạnh thực tế (CM)",
  Please_enter_actual_weight_KG: "Vui lòng nhập trọng lượng thực tế (KG)",
  Please_enter_actual_size: "Vui lòng nhập kích thước thực tế",
  inventory_quantity: "Tổng lượng hàng tồn kho",
  Total_occupied_inventory: "Tổng lượng hàng tồn kho đã sử dụng",
  Total_cubic_number_of_inventory: "Tổng khối lượng hàng tồn kho",
  Total_unshipped_quantity: "Tổng lượng hàng tồn kho chưa giao",
  Total_available_inventory: "Tổng lượng hàng tồn kho có thể sử dụng",
  Available_Stock: "Hàng tồn kho có thể sử dụng",
  Total_number_of_cubes_in_transit: "Tổng khối lượng hàng đang vận chuyển",
  Total_number_in_transit: "Tổng lượng hàng tồn kho đang vận chuyển",
  Total_unavailable_inventory_quantity:
    "Tổng lượng hàng tồn kho không thể sử dụng",
  In_transit_inventory: "Hàng tồn kho đang vận chuyển",
  Sales_Volume_7_14_30_60_90: "Doanh số bán hàng (7/14/30)",
  Sales_Volume_60_90: "Doanh số bán hàng (60/90)",
  Sales_Volume_45_60_90: "Doanh số bán hàng (45/60/90)",
  Forecast_30_day_average_daily_sales:
    "Dự báo doanh số bán hàng trung bình hàng ngày trong 30 ngày",
  Number_of_warnings: "Số lượng cảnh báo",
  Alert_stock: "Hàng tồn kho cảnh báo",
  Whether_to_calculate_alert_inventory_automatically:
    "Có tự động tính toán hàng tồn kho cảnh báo hay không",
  Please_select_Whether_to_calculate_alert_inventory_automatically:
    "Vui lòng chọn có tự động tính toán hàng tồn kho cảnh báo hay không",
  Automatic_calculation_mode: "Phương pháp tính toán tự động",
  purchase_price: "Giá mua",
  Please_select_SKU: "Vui lòng chọn SKU",
  portfolioSKUManagement: "Quản lý SKU kết hợp",
  portfolioSKUList: "Danh sách SKU kết hợp",
  product_barcode: "Mã vạch sản phẩm",
  Please_enter_the_product_barcode: "Vui lòng nhập mã vạch sản phẩm",
  Select_all_boxes: "Chọn tất cả các thùng",
  Reset_option: "Đặt lại lựa chọn",
  Modify_the_print_quantity_of_the_selected_item:
    "Sửa đổi số lượng in của sản phẩm đã chọn",
  Please_enter_the_product_barcode_for_screening:
    "Vui lòng nhập mã vạch sản phẩm để lọc",
  Inventory_warning_does_not_allow_duplicate_warehouses:
    "Cảnh báo hàng tồn kho không cho phép xuất hiện kho trùng lặp",
  isReceiveWarningNotice: "Có nhận thông báo cảnh báo hay không",
  Last_release_date: "Ngày lên kệ gần nhất",
  Add_early_warning: "Thêm hàng tồn kho cảnh báo",
  Days_of_existing_warning: "Số ngày đã cảnh báo",
  Please_enter_the_number_of_alerts: "Vui lòng nhập hàng tồn kho cảnh báo",
  Please_enter_the_expected_number_of_days: "Vui lòng nhập số ngày cảnh báo",
  Please_select_automatic_calculation_mode:
    "Vui lòng chọn phương pháp tính toán tự động",
  Please_select_whether_to_receive_an_alert_notification:
    "Vui lòng chọn có nhận thông báo cảnh báo hay không",
  Average_daily_sales_for_the_last_7_days:
    "Doanh số bán hàng trung bình hàng ngày trong 7 ngày gần nhất",
  Average_daily_sales_for_the_last_15_days:
    "Doanh số bán hàng trung bình hàng ngày trong 15 ngày gần nhất",
  Average_daily_sales_for_the_last_30_days:
    "Doanh số bán hàng trung bình hàng ngày trong 30 ngày gần nhất",
  Average_weekly_sales: "Doanh số bán hàng trung bình hàng tuần",
  Sales_time_meets_12_months_week: "Thời gian bán hàng đáp ứng 12 (tháng/tuần)",
  Total_sales_in_the_last_12_weeks_month_divided_by_12:
    "Tổng doanh số bán hàng trong 12 (tuần/tháng) gần nhất ÷ 12",
  Average_monthly_sales: "Doanh số bán hàng trung bình hàng tháng",
  The_data_was_updated_in_the_early_hours_of_the_next_day:
    "Thời gian cập nhật dữ liệu là rạng sáng ngày hôm sau",
  The_sales_time_does_not_meet_12_months_week:
    "Thời gian bán hàng không đáp ứng 12 (tháng/tuần)",
  Total_sales_in_months_weeks_sold_divided_by_the_number_of_months_weeks_sold:
    "Tổng doanh số bán hàng (tháng/tuần) ÷ Số lượng bán hàng (tháng/tuần)",
  Set_inventory_warning_in_batches: "Cài đặt cảnh báo tồn kho hàng loạt",
  combination_SKU_Chinese_name: "Tên SKU kết hợp bằng tiếng Trung",
  combination_SKU_English_name: "Tên SKU kết hợp bằng tiếng Anh",
  Add_the_combined_SKU: "Thêm SKU kết hợp",
  Combine_SKU_images: "Hình ảnh SKU kết hợp",
  combined_SKU: "SKU kết hợp",
  Portfolio_inventory: "Tồn kho kết hợp",
  goodsImage: "Hình ảnh sản phẩm",
  viewPortfolioSKU: "Xem SKU kết hợp",
  Historical_operation_record: "Lịch sử thao tác",
  Edit_inventory_SKU_list: "Chỉnh sửa danh sách SKU tồn kho",
  editInventorySkuList: "Chỉnh sửa danh sách SKU tồn kho",
  viewInventorySkuList: "Xem danh sách SKU tồn kho",
  createInventorySkuList: "Tạo danh sách SKU tồn kho",
  Only_common_products_can_be_selected:
    "Chỉ có thể chọn nhiều sản phẩm thông thường",
  inventory_management: "Quản lý kho",
  inventoryManagement: "Quản lý kho",
  Unavailable_inventory: "Có kho không sử dụng được",
  inventoryList: "Danh sách kho",
  product_material: "Chất liệu sản phẩm",
  Please_select_product_material: "Vui lòng chọn chất liệu sản phẩm",
  Product_bar_code: "Mã vạch sản phẩm",
  Reference_number: "Số tham chiếu",
  update_specified_goods: "Cập nhật sản phẩm chỉ định",
  pull_specified_goods: "Tải sản phẩm chỉ định",
  please_select_data: "Vui lòng chọn dữ liệu",
  Select_a_single_SKU_for_operation: "Vui lòng chọn một SKU để thao tác",
  update_successfully: "Cập nhật thành công",
  pull_successfully: "Tải thành công",
  please_enter_link_id: "Vui lòng nhập ID liên kết",
  subordinate_Account: "Tài khoản phụ",
  Authorized_subaccount: "Ủy quyền tài khoản phụ",
  Assign_subaccount: "Phân bổ tài khoản phụ",
  Please_select_the_subaccount_that_you_want_to_authorize:
    "Vui lòng chọn tài khoản phụ cần ủy quyền",
  Please_select_a_sub_account: "Vui lòng chọn tài khoản phụ",
  modifyProductInformationList: "Sửa đổi danh sách thông tin sản phẩm",
  batchCreateCombinedsku: "Tạo SKU kết hợp hàng loạt",
  batch_create_combined_sku: "Tạo SKU kết hợp hàng loạt",
  Please_check_the_data_first: "Vui lòng chọn dữ liệu trước",
  Import_the_combined_SKU: "Nhập SKU kết hợp",
  batchCreateSubAccount: "Tạo tài khoản phụ hàng loạt",
  batch_Create_SubAccounts: "Tạo tài khoản phụ hàng loạt",
  Import_subAccounts: "Nhập tài khoản phụ",
  Import_to_modify_the_product_barcode: "Nhập Sửa đổi mã vạch sản phẩm",
  modify_the_product_barcode: "Sửa đổi mã vạch sản phẩm",
  Set_the_default_allocation_of_the_first_trip_fee:
    "Đặt phí vận chuyển chia sẻ mặc định",
  Default_allocation_of_first_trip_fee: "Phí vận chuyển chia sẻ mặc định",
  Default_first_leg_fee: "Phí vận chuyển mặc định",
  Default_allocation_of_first_trip_fee_only_used_for_order_profit_report_calculation_statistics:
    "Chi phí vận chuyển chia sẻ mặc định chỉ được sử dụng để tính toán báo cáo lợi nhuận đơn hàng",
  Includes_the_quantity_to_be_reviewed_and_reviewed_received_in_the_transit_warehouse_and_in_transit_and_in_the_last_leg_and_received_in_the_last_leg_and_in_the_quality_inspection_and_inspected_but_not_yet_listed:
    "Bao gồm số lượng đang chờ phê duyệt, đã phê duyệt, nhận hàng tại kho trung chuyển, đang vận chuyển, đang nhận hàng cuối cùng, đã nhận hàng cuối cùng, đang kiểm tra chất lượng, đã kiểm tra chất lượng nhưng chưa lên kệ",
  This_operation_will_permanently_delete_sku:
    "Thao tác này sẽ xóa vĩnh viễn SKU",
  Batch_modification_of_purchase_prices: "Sửa đổi giá mua hàng hàng loạt",
  Batch_modification_of_default_allocation_of_headhaul_fees:
    "Sửa đổi hàng loạt chi phí vận chuyển chia sẻ mặc định",
  Original_purchase_price: "Giá mua ban đầu",
  New_purchase_price: "Giá mua mới",
  The_original_default_allocation_of_the_origin_leg_cost:
    "Chi phí vận chuyển chia sẻ mặc định ban đầu",
  New_default_allocation_of_origin_charges:
    "Chi phí vận chuyển chia sẻ mặc định mới",
  Modify_the_purchase_price: "Sửa đổi giá mua",
  Form_modification_of_purchase_price: "Sửa đổi giá mua trên biểu mẫu",
  Modify_the_default_allocation_of_origin_charges:
    "Sửa đổi chi phí vận chuyển chia sẻ mặc định",
  Modify_the_default_allocation_of_the_initial_transportation_cost_in_the_form:
    "Sửa đổi chi phí vận chuyển chia sẻ mặc định trên biểu mẫu",
  Import_and_modify_the_purchase_price_and_the_default_headway_cost_allocation:
    "Nhập và sửa đổi giá mua và chi phí vận chuyển mặc định",
  Greater_than_0_001_and_less_than_9999999: "Lớn hơn 0,001 và nhỏ hơn 9999999",
  Unusable_inventory_quantity: "Số lượng hàng tồn kho không sử dụng được",
  createGoods: "Tạo sản phẩm",
  product_information: "Thông tin sản phẩm",
  Please_enter_product_information: "Vui lòng nhập thông tin sản phẩm",
  product_specification: "Thông số kỹ thuật sản phẩm",
  Product_declaration: "Khai báo sản phẩm",
  procurement_price: "Giá mua",
  Please_enter_cost_price: "Vui lòng nhập giá thành",
  Please_enter_procurement_price: "Vui lòng nhập giá mua",
  volume_cm: "Thể tích (cm³)",
  actual_volume: "Thể tích thực tế",
  actual_volume_cm: "Thể tích thực tế (cm³)",
  commercial_specification: "Thông số kỹ thuật sản phẩm",
  Please_enter_commercial_specification:
    "Vui lòng nhập thông số kỹ thuật sản phẩm",
  Product_name_Chinese: "Tên sản phẩm khai báo (tiếng Trung)",
  Please_enter_Product_name: "Vui lòng nhập tên sản phẩm khai báo",
  Product_name_English: "Tên sản phẩm khai báo (tiếng Anh)",
  country_of_origin: "Nguồn gốc",
  Please_enter_country_of_origin: "Vui lòng nhập nguồn gốc",
  Days_of_purchase: "Số ngày mua hàng",
  Please_enter_Days_of_purchase: "Vui lòng nhập số ngày mua hàng",
  product_attribute: "Thuộc tính sản phẩm",
  Special_commodity_attribute: "Thuộc tính sản phẩm đặc biệt",
  Please_select_product_properties: "Vui lòng chọn thuộc tính sản phẩm",
  inventory_warning: "Cảnh báo tồn kho",
  Early_warning_inventory: "Tồn kho cảnh báo",
  Days_of_warning: "Số ngày cảnh báo",
  Please_enter_Early_warning_inventory: "Vui lòng nhập tồn kho cảnh báo",
  Please_enter_Days_of_warning: "Vui lòng nhập số ngày cảnh báo",
  Calculating_early_warning_inventory: "Cách tính tồn kho cảnh báo",
  Automatic_calculation_of_early_warning_inventory:
    "Tự động tính tồn kho cảnh báo",
  Alert_inventory_is_equal_to_alert_days_multiplied_by_daily_sales:
    "Cảnh báo tồn kho = Số ngày cảnh báo * Doanh số bán hàng mỗi ngày",
  Click_to_upload: "Nhấp để tải lên",
  Only_jpg_or_png_files_with_a_maximum_size_of_2048kb_can_be_uploaded:
    "Chỉ có thể tải lên tệp jpg hoặc png, không quá 2048kb",
  Please_upload_product_pictures: "Vui lòng tải lên hình ảnh sản phẩm",
  Please_enter_dimensions_of_length_width_and_height_greater_than_zero:
    "Vui lòng nhập kích thước chiều dài, chiều rộng và chiều cao lớn hơn 0",
  The_operation_failed__Please_check_the_content_and_submit_again:
    "Thao tác không thành công, vui lòng kiểm tra nội dung đã điền và gửi lại",
  editorialGoods: "Chỉnh sửa sản phẩm",
  viewGoods: "Xem sản phẩm",
  Enter_SKU_and_bar_code_separated_by_commas_comma:
    "Vui lòng nhập SKU, mã vạch, cách nhau bằng dấu phẩy",
  Please_enter_sku: "Vui lòng nhập SKU",
  delete_in_batches_sku: "Xóa hàng loạt SKU",
  Select_the_sku_that_you_want_to_delete: "Chọn SKU cần xóa",
  Select_the_SKUs_that_you_want_to_add: "Chọn SKU cần thêm",
  And_enter_the_number_of_SKUs_you_want_to_add: "Và nhập số lượng SKU cần thêm",
  Select_the_SKU_that_you_want_to_modify: "Vui lòng chọn SKU cần sửa đổi",
  Enter_the_number_of_SKUs_that_you_want_to_modify:
    "Và nhập số lượng SKU cần sửa đổi",
  Select_the_SKU_for_which_you_want_to_modify_the_repository:
    "Vui lòng chọn SKU cần sửa đổi kho",
  And_select_a_new_warehouse: "và chọn kho mới",
  Adding_SKUs_in_bulk: "Thêm SKU hàng loạt",
  Edit_note: "Chỉnh sửa ghi chú",
  select_sku: "Chọn SKU",
  Type_query: "Tìm kiếm theo loại",
  Export_goods: "Xuất sản phẩm",
  Export_incoming_and_outgoing_records: "Xuất bản ghi nhập kho/xuất kho",
  product_list: "Danh sách sản phẩm",
  product_list_sub_warehouse: "Danh sách sản phẩm (chia kho)",
  serial_Number: "Số hiệu",
  Create_distribution_control: "Tạo kiểm soát phân phối hàng",
  Number_of_generated_tasks: "Tạo số lượng nhiệm vụ",
  create_task: "Tạo nhiệm vụ",
  Delivery_process_2_cannot_use_border_variation:
    "Quy trình giao hàng 2 Không thể sử dụng phân phối hàng bên lề",
  If_a_check_order_exists_during_task_generation_the_check_order_task_is_preferentially_generated:
    "Khi tạo nhiệm vụ, nếu có đơn hàng được chọn, nhiệm vụ đơn hàng được chọn sẽ được tạo trước",
  warehouse_management: "Quản lý kho",
  warehouseOperation: "Hoạt động kho",
  warehouse_Number: "Số kho",
  Please_enter_warehouse_Number: "Vui lòng nhập số kho",
  Please_enter_warehouse_partition: "Vui lòng nhập phân vùng kho",
  goods_shelf: "Kệ",
  goods_shelf_info: "Thông tin kệ",
  Shelf_type: "Loại kệ",
  Please_enter_Shelf_type: "Vui lòng nhập loại kệ",
  Shelf_layer: "Tầng kệ",
  Please_enter_Shelf_layer: "Vui lòng nhập tầng kệ",
  Storage_rack: "Hàng kệ",
  Please_enter_Storage_rack: "Vui lòng nhập hàng kệ",
  Shelf_size_length_width_and_height: "Kích thước kệ (dài * rộng * cao)",
  Shelf_cube: "Khối lượng kệ/m³",
  Please_enter_Shelf_cube: "Vui lòng nhập khối lượng kệ",
  Library_location_information: "Thông tin vị trí kho",
  Storage_location_type: "Loại vị trí kho",
  Please_enter_Storage_location_type: "Vui lòng nhập loại vị trí kho",
  SKU_storage_type: "Loại lưu trữ SKU",
  Please_enter_goods_shelf: "Vui lòng nhập kệ",
  Please_enter_Residual_storage_capacity:
    "Vui lòng nhập dung lượng kho còn lại",
  Please_enter_Storage_capacity_in_transit:
    "Vui lòng nhập dung lượng kho đang vận chuyển",
  Please_enter_Service_storage_capacity:
    "Vui lòng nhập dung lượng kho đang sử dụng",
  Please_select_the_currency_of_charge: "Vui lòng chọn loại tiền tệ tính phí",
  Storage_location_SKU: "SKU vị trí kho",
  Please_enter_Storage_location_SKU: "Vui lòng nhập SKU vị trí kho",
  Initial_storage: "Dung lượng kho bắt đầu",
  End_storage: "Dung lượng kho kết thúc",
  Add_partition: "Thêm phân vùng",
  Edit_partition: "Chỉnh sửa phân vùng",
  partition_number: "Số phân vùng",
  Please_enter_partition: "Vui lòng nhập phân vùng",
  Please_enter_partition_number: "Vui lòng nhập số phân vùng",
  Please_select_floor: "Vui lòng chọn tầng",
  partition: "Phân vùng",
  floor: "Tầng",
  Batch_pairing: "Ghép nối hàng loạt",
  storey: "Tầng",
  Single_SKU: "SKU đơn",
  Multiple_SKU: "Nhiều SKU",
  Add_warehouse: "Thêm kho",
  Edit_warehouse: "Chỉnh sửa kho",
  Add_storage_location: "Thêm vị trí kho",
  contacts: "Người liên hệ",
  Please_enter_contacts: "Vui lòng nhập người liên hệ",
  Warehouse_zip_code: "Mã bưu điện kho",
  Please_enter_Warehouse_zip_code: "Vui lòng nhập mã bưu điện kho",
  Toll_currency: "Đơn vị tiền tệ tính phí",
  Please_enter_Toll_currency: "Vui lòng nhập đơn vị tiền tệ tính phí",
  Warehouse_recipient: "Người nhận hàng tại kho",
  Recipient_phone_number: "Số điện thoại người nhận hàng",
  Warehouse_capacity_m: "Dung lượng kho/m³",
  Service_storage_capacity_m: "Dung lượng sử dụng/m³",
  Storage_capacity_in_transit_m: "Dung lượng đang vận chuyển/m³",
  Residual_storage_capacity_m: "Dung lượng còn lại/m³",
  Zoned_storage_m: "Dung lượng phân vùng/m³",
  Storage_location_Storage_capacity_m: "Dung lượng vị trí kho/m³",
  Storage_capacity_SKU: "SKU dung lượng kho",
  Bind_the_library_location_SKU: "SKU vị trí kho liên kết",
  Pick_the_warehouse_location: "Vị trí kho lấy hàng",
  Shelf_coding: "Mã kệ",
  Please_enter_Shelf_coding: "Vui lòng nhập mã kệ",
  Shelf_name: "Tên kệ",
  Please_enter_Shelf_name: "Vui lòng nhập tên kệ",
  Shelf_length: "Chiều dài kệ",
  Please_enter_Shelf_length: "Vui lòng nhập chiều dài kệ",
  Shelf_weight: "Chiều rộng kệ",
  Please_enter_Shelf_weight: "Vui lòng nhập chiều rộng kệ",
  Shelf_height: "Chiều cao kệ",
  Please_enter_Shelf_height: "Vui lòng nhập chiều cao kệ",
  single_face: "Một mặt",
  two_sided: "Hai mặt",
  Warehouse_location_number: "Số vị trí kho",
  Location_number: "Số vị trí kho",
  Edit_library_location: "Chỉnh sửa vị trí kho",
  Only_one_table_can_be_imported_simultaneously:
    "Chỉ cho phép nhập một bảng cùng lúc",
  Only_tables_can_be_imported: "Chỉ cho phép nhập bảng",
  Only_select_tables_are_allowed: "Chỉ cho phép chọn bảng",
  Import_a_single_table_first: "Vui lòng nhập một bảng trước",
  Unselected_formula: "Chưa chọn công thức",
  Selection_result_table: "Chọn bảng kết quả",
  Please_select_table: "Vui lòng chọn bảng",
  Only_one_table_can_be_selected: "Chỉ cho phép chọn một bảng",
  Manually_insert_data: "Chèn dữ liệu thủ công",
  The_current_table_is: "Bảng hiện tại là",
  Trigger_name: "Tên kích hoạt",
  Please_enter_Trigger_name: "Vui lòng nhập tên kích hoạt",
  libraryLocationList: "Danh sách vị trí kho",
  Back_libraryLocationList: "Quay lại danh sách vị trí kho",
  have_been_used: "Đã sử dụng",
  unused: "Chưa sử dụng",
  print_Library_location_number: "In số vị trí kho",
  quantity_in_stock: "Số lượng tồn kho",
  Inventory_occupancy: "Số lượng tồn kho đã sử dụng",
  Inventory_warning_quantity: "Số lượng cảnh báo tồn kho",
  deposit_type: "Loại lưu trữ",
  The_location_type: "Loại vị trí kho",
  sectionList: "Danh sách phân vùng",
  shelvesList: "Danh sách kệ",
  Batch_delete_shelves: "Xóa hàng loạt kệ",
  Modify_the_partition_number: "Sửa đổi số phân vùng",
  Modify_the_shelf_number: "Sửa đổi số kệ",
  Modify_the_storage_location_number: "Sửa đổi số vị trí kho",
  Please_enter_the_shelf_number: "Vui lòng nhập số kệ",
  Import_modified_partition_codes: "Nhập mã phân vùng sửa đổi",
  Import_and_modify_the_shelf_number: "Nhập số kệ sửa đổi",
  Import_and_modify_the_storage_location_numbers: "Nhập số vị trí kho sửa đổi",
  Please_select_the_shelves_you_want_to_delete: "Vui lòng chọn kệ cần xóa",
  Confirm_to_delete_the_shelfs: "Xác nhận xóa kệ",
  goods_shelf_number: "Số kệ",
  regional_management: "Quản lý khu vực",
  countriesList: "Danh sách quốc gia",
  Added_country: "Thêm quốc gia",
  Bulk_add_countries: "Thêm hàng loạt quốc gia",
  Please_select_country: "Vui lòng chọn quốc gia",
  Please_select_Destination_warehouse: "Vui lòng chọn kho đích",
  Destination_warehouse: "Kho đích",
  recipientManagement: "Quản lý người nhận",
  Please_enter_the_recipient_name: "Vui lòng nhập tên người nhận",
  Please_enter_the_recipient_phone_number:
    "Vui lòng nhập số điện thoại người nhận",
  Recipient_name: "Tên người nhận",
  Receiver_Address: "Địa chỉ người nhận",
  Add_recipient: "Thêm người nhận",
  Edit_recipient: "Chỉnh sửa người nhận",
  Recipient_email_address: "Email người nhận",
  Please_select_the_full_region: "Vui lòng chọn khu vực hoàn chỉnh",
  Please_select_a_region: "Vui lòng chọn khu vực",
  financialManagement: "Quản lý tài chính",
  financialReports: "Báo cáo tài chính",
  cost: "Chi phí",
  costmanagement: "Quản lý chi phí",
  costType: "Tình trạng chi phí",
  costSetting: "Cài đặt chi phí",
  Client_editing: "Chỉnh sửa khách hàng",
  AmazonBaiyiUS: "Amazon Baiyikexun Mỹ",
  amazonBaiyiUS: "Amazon Baiyikexun Mỹ",
  month: "Tháng",
  turnover: "Doanh thu",
  The_amount_of_the_platform_should_be_lent: "Số tiền nền tảng phải trả",
  The_wrong_amount_should_be_lent: "Số tiền trả sai",
  have_already_settled: "Đã thanh toán",
  consolidate_orders: "Hợp nhất đơn hàng",
  refund: "Hoàn tiền",
  rebates: "Hoàn tiền một phần",
  Refund_and_compensation: "Hoàn tiền bồi thường",
  compensate: "Bồi thường",
  Unlent_amount: "Số tiền chưa trả",
  deleteTable: "Xóa bảng",
  Confirm_deletion_table: "Xác nhận xóa bảng",
  Recharge_time: "Thời gian nạp tiền",
  Please_select_a_Recharge_time: "Vui lòng chọn thời gian nạp tiền",
  Add_top_up: "Thêm nạp tiền",
  exchange_rate: "Tỷ giá hối đoái",
  Amount_actually_paid: "Số tiền thanh toán thực tế",
  Please_enter_the_Amount_actually_paid:
    "Vui lòng nhập số tiền thanh toán thực tế",
  Currency_of_payment: "Đơn vị tiền tệ thanh toán",
  Please_enter_the_Currency_of_payment:
    "Vui lòng nhập đơn vị tiền tệ thanh toán",
  The_currency_of_the_deposit: "Đơn vị tiền tệ nạp tiền",
  Please_enter_the_The_currency_of_the_deposit:
    "Vui lòng nhập đơn vị tiền tệ nạp tiền",
  service_charge: "Phí dịch vụ",
  accounting_date: "Thời gian nhận tiền",
  Please_select_a_accounting_date: "Vui lòng chọn thời gian nhận tiền",
  note: "Ghi chú",
  Top_up_number: "Số nạp tiền",
  recharge_amount: "Số tiền nạp",
  Balance_before_recharge: "Số dư trước khi nạp",
  Balance_after_recharge: "Số dư sau khi nạp",
  The_charge_shall_not_be_greater_than_the_amount_of_the_deposit:
    "Phí dịch vụ không được lớn hơn số tiền nạp",
  Recharge_information: "Thông tin nạp tiền",
  Please_select_a_billing_time: "Vui lòng chọn thời gian thanh toán",
  Please_enter_the_statement_number: "Vui lòng nhập số hóa đơn thanh toán",
  Please_select_a_recharge_type: "Vui lòng chọn loại nạp tiền",
  About_to_jump_to_the_recharge_page: "Sắp chuyển sang trang nạp tiền",
  state_of_payment: "Trạng thái thanh toán",
  Continue_to_pay: "Tiếp tục thanh toán",
  during_the_payment: "Đang thanh toán",
  payment_failure: "Thanh toán không thành công",
  have_expired: "Đã hết hạn",
  canceled: "Đã hủy",
  Completed_transaction: "Giao dịch đã hoàn tất",
  Uncompleted_transaction: "Giao dịch chưa hoàn tất",
  failure_of_transaction: "Giao dịch thất bại",
  Only_a_single_task_can_be_selected: "Chỉ có thể chọn một nhiệm vụ duy nhất",
  Please_select_a_basket: "Vui lòng chọn giỏ hàng",
  Sheet_address: "Địa chỉ trên phiếu giao hàng",
  Recommended_storage_location: "Vị trí kho được đề xuất",
  The_product_is_finished: "Sản phẩm này đã hoàn tất",
  initial_workpiece: "Sản phẩm đầu tiên",
  follow_up_workpiece: "Sản phẩm tiếp theo",
  aggregate_amount: "Tổng số tiền",
  Daily_order_volume: "Số lượng đơn hàng hàng ngày",
  Total_order_processing_fee: "Tổng phí xử lý đơn hàng",
  Average_unit_price_per_order: "Giá trung bình mỗi đơn hàng",
  Total_number_of_SKUs_for_shipment: "Tổng số SKU giao hàng",
  Average_unit_price_per_SKU: "Giá trung bình mỗi SKU",
  orderProcessingFeeSet: "Phí xử lý đơn hàng",
  Additional_cost: "Thêm chi phí",
  Additional_Max_cost: "Thêm chi phí tối đa",
  Add_order_processing_fee: "Thêm phí xử lý đơn hàng",
  Additional_charge: "Phí bổ sung",
  Rate_number: "Mã số tiêu chuẩn phí",
  type_of_cost: "Loại chi phí",
  Please_select_type_of_cost: "Vui lòng chọn loại chi phí",
  Please_enter_Additional_charge: "Vui lòng nhập phí bổ sung",
  Please_enter_Rate_number: "Vui lòng nhập mã số tiêu chuẩn phí",
  Out_of_range_first_SKU_operating_fee:
    "Phí vận hành SKU đầu tiên vượt quá phạm vi",
  Please_enter_Out_of_range_first_SKU_operating_fee:
    "Vui lòng nhập phí vận hành SKU đầu tiên vượt quá phạm vi",
  Continued_SKU_operating_fee_out_of_range:
    "Phí vận hành SKU tiếp theo vượt quá phạm vi",
  Please_enter_Continued_SKU_operating_fee_out_of_range:
    "Vui lòng nhập phí vận hành SKU tiếp theo vượt quá phạm vi",
  Cost_of_first_packing_material_out_of_range:
    "Phí bao bì đầu tiên vượt quá phạm vi",
  Please_enter_Cost_of_first_packing_material_out_of_range:
    "Vui lòng nhập chi phí bao bì đầu tiên vượt quá phạm vi",
  SKU_packaging_costs_are_exceeded:
    "Chi phí bao bì SKU tiếp theo vượt quá phạm vi",
  Please_enter_SKU_packaging_costs_are_exceeded:
    "Vui lòng nhập chi phí bao bì SKU tiếp theo vượt quá phạm vi",
  The_number_of_out_of_range_continuums_is_charged:
    "Số lượng tính phí cho các mặt hàng tiếp theo vượt quá phạm vi",
  Please_enter_The_number_of_out_of_range_continuums_is_charged:
    "Vui lòng nhập số lượng tính phí cho các mặt hàng tiếp theo vượt quá phạm vi",
  The_input_add_fee_has_no_value_Please_check_and_try_again:
    "Chi phí thêm đã nhập có giá trị trống, vui lòng kiểm tra lại và thử lại",
  Please_add_the_charges: "Vui lòng thêm chi phí",
  The_charge_standard_number_cannot_be_repeated:
    "Mã số tiêu chuẩn tính phí không được trùng lặp",
  Out_of_range_listing_fees: "Phí lên kệ vượt quá giới hạn",
  Out_of_range_Destruction_delisting_fee:
    "Phí hủy bỏ và hạ kệ vượt quá giới hạn",
  Out_of_range_Return_listing_fee: "Phí trả lại hàng vượt quá giới hạn",
  Three_sides_are_preferred: "Ưu tiên chiều dài ba cạnh",
  Preferred_weight: "Ưu tiên trọng lượng",
  packagingMaterialCost: "Phí bao bì",
  Package_material_coding: "Mã bao bì",
  Please_enter_Package_material_coding: "Vui lòng nhập mã bao bì",
  Packing_material_name: "Tên bao bì",
  Please_enter_Packing_material_name: "Vui lòng nhập tên bao bì",
  Packing_material_length: "Chiều dài bao bì",
  Please_enter_Package_material_length: "Vui lòng nhập chiều dài bao bì",
  Packing_material_width: "Chiều rộng bao bì",
  Please_enter_Package_material_width: "Vui lòng nhập chiều rộng bao bì",
  Packing_material_height: "Chiều cao bao bì",
  Packing_material_Weight: "Trọng lượng bao bì",
  Please_enter_Packing_material_height: "Vui lòng nhập chiều cao bao bì",
  Packing_material_quantity: "Số lượng bao bì",
  Please_enter_Packing_material_quantity: "Vui lòng nhập số lượng bao bì",
  Packing_material_type: "Loại bao bì",
  Please_enter_Packing_material_type: "Vui lòng nhập loại bao bì",
  add_Packing_material: "Thêm bao bì",
  edit_Packing_material: "Chỉnh sửa bao bì",
  Batch_add_Packing_material: "Thêm bao bì hàng loạt",
  quantity_of_commodity: "Số lượng hàng hóa",
  The_box_number_does_not_exist: "Số thùng này không tồn tại",
  Packaging_material_picture: "Hình ảnh bao bì",
  createCost: "Chi phí tạo",
  Please_upload_picture_of_package_material: "Vui lòng tải lên hình ảnh bao bì",
  expenseDeduction: "Chi phí bù trừ",
  Add_a_premium_deduction: "Thêm chi phí bù trừ",
  Expense_reimbursement_type: "Loại chi phí bù trừ",
  Please_select_the_type_of_reimbursement: "Vui lòng chọn loại chi phí bù trừ",
  Please_select_packing_material: "Vui lòng chọn bao bì",
  Please_select_a_packaging_method: "Vui lòng chọn cách đóng gói",
  Set_the_packaging_mode_in_batches: "Cài đặt cách đóng gói hàng loạt",
  Please_enter_barcode_SKU_Chinese_product_name_English_product_name:
    "Vui lòng nhập SKU, mã vạch hàng hóa, tên hàng hóa bằng tiếng Trung, tên hàng hóa bằng tiếng Anh, nhấp vào nút tìm kiếm để tìm kiếm",
  Please_enter_barcode_SKU:
    "Vui lòng nhập SKU, mã vạch hàng hóa, nhấp vào nút tìm kiếm để tìm kiếm",
  Please_enter_the_order_number_separated_by_line_breaks_or_commas:
    "Vui lòng nhập số đơn hàng, cách nhau bằng dấu xuống dòng hoặc dấu phẩy",
  Packing_material_billing_type: "Loại tính phí vật liệu đóng gói",
  Minimum_charge_amount: "Số tiền tính phí tối thiểu",
  Number_of_warnings_must_not_exceed_the_quantity_in_stock:
    "Số lượng cảnh báo không được vượt quá số lượng tồn kho",
  default_packaging_material: "Vật liệu đóng gói mặc định",
  packingMaterialDetail: "Chi tiết vật liệu đóng gói",
  packing_material_info: "Thông tin vật liệu đóng gói",
  import_order_processing_fee: "Phí xử lý nhập đơn hàng",
  import_storage_charges: "Phí thuê kho nhập hàng",
  import_fixed_sku_fees: "Phí SKU cố định nhập hàng",
  import_first_pass_cost: "Phí vận chuyển đầu tiên nhập hàng",
  setFeesByTemplate: "Thiết lập phí theo mẫu",
  The_amount_of_the_deduction: "Số tiền bù trừ phí",
  viewFixedSKUFee: "Xem phí SKU cố định",
  SpecialAprovalNumber: "Số phê duyệt đặc biệt",
  Special_Customer_ID: "ID khách hàng phê duyệt đặc biệt",
  Addition_special_fees: "Tạo phê duyệt đặc biệt về phí",
  Special_approval_for_import_fees: "Nhập phê duyệt đặc biệt về phí",
  The_current_approver: "Người phê duyệt hiện tại",
  Whether_to_be_anonymous_or_not: "Có ẩn danh hay không",
  Work_order_source: "Nguồn phiếu công việc",
  Notes_should_not_exceed_1000_characters:
    "Chiều dài ghi chú không được vượt quá 1000 ký tự",
  Pending_approval_currently: "Người phê duyệt hiện tại",
  Currently_awaiting_review: "Đang chờ phê duyệt",
  firstPassCostSetting: "Cài đặt phí vận chuyển đầu tiên",
  firstPassCost: "Phí vận chuyển đầu tiên",
  freight_cost_cube_KG: "Chi phí vận chuyển (m3/kg)",
  freight_cost: "Chi phí vận chuyển",
  fixed_cost: "Chi phí",
  profit: "Lợi nhuận",
  Please_enter_the_shipping_cost: "Vui lòng nhập chi phí vận chuyển",
  Surcharge_cost_cube_KG: "Chi phí phụ phí (m3/kg)",
  Surcharge_cost: "Chi phí phụ phí",
  Please_enter_the_Surcharge_cost: "Vui lòng nhập chi phí phụ phí",
  Out_of_range_freight_cube_KG: "Phí vận chuyển vượt quá phạm vi (m3/kg)",
  Out_of_range_freight: "Phí vận chuyển vượt quá phạm vi",
  Please_enter_Out_of_range_freight:
    "Vui lòng nhập phí vận chuyển vượt quá phạm vi",
  Overreach_surcharge_cube_KG: "Phụ phí vượt quá phạm vi (m3/kg)",
  Overreach_surcharge: "Phụ phí vượt quá phạm vi",
  Please_enter_Overreach_surcharge_cube_KG:
    "Vui lòng nhập phí phụ thu vượt quá phạm vi",
  Minimum_number_of_charging_parties: "Khối lượng tính phí tối thiểu",
  Please_enter_Minimum_number_of_charging_parties:
    "Vui lòng nhập khối lượng tính phí tối thiểu",
  Start_greater_than: "Bắt đầu (>)",
  cutoff: "Kết thúc (<=)",
  additional_charge_cube_KG: "Phí phụ thu (khối/kg)",
  additional_charge: "Phí phụ thu",
  Minimum_chargeable_weight: "Trọng lượng tính phí tối thiểu",
  Please_enter_Minimum_chargeable_weight:
    "Vui lòng nhập trọng lượng tính phí tối thiểu",
  The_added_fee_is_empty: "Phí thêm vào trống",
  The_added_cost_has_a_null_value_The_creation_failed_Please_modify_the_cost_and_try_again:
    "Phí thêm vào có giá trị trống, không thể tạo, vui lòng sửa lại và thử lại",
  The_start_of_the_added_fee_is_not_equal_to_the_end_Please_modify_it_and_try_again:
    "Chi phí thêm vào không bằng chi phí kết thúc, vui lòng sửa lại và thử lại",
  Volume_weight_calculation_method_cubic_divide_volume_weight_is_worth_the_result_compare_the_weight_which_big_which:
    "Cách tính trọng lượng thể tích: khối/trọng lượng thể tích cho kết quả, so sánh trọng lượng, lấy giá trị lớn hơn",
  Length_cm_X_width_cm_X_height_cm_volume_weight_value:
    "Khối: (chiều dài (cm) * chiều rộng (cm) * chiều cao (cm) / trọng lượng thể tích) / 1000000",
  There_are_no_packing_materials_for_the_warehouse:
    "Hiện không có vật liệu đóng gói cho kho này",
  Printing_control: "Đang in",
  Several_tasks: "tác vụ",
  code: "mã",
  await: "Chờ",
  second: "giây",
  request_timeout: "Yêu cầu hết thời gian chờ",
  Stop_query: "Dừng truy vấn",
  Edit_the_entry_slip: "Chỉnh sửa phiếu nhập kho",
  Deduction_amount: "Số tiền khấu trừ bổ sung",
  Deduction_personnel: "Người khấu trừ bổ sung",
  Deduction_time: "Thời gian khấu trừ bổ sung",
  fixedSkuFees: "Chi phí SKU cố định",
  Added_fixed_SKU_fee: "Thêm chi phí SKU cố định",
  edit_fixed_SKU_fee: "Chỉnh sửa chi phí SKU cố định",
  Select_Add_SKUs: "Chọn thêm SKU",
  storageCharges: "Phí thuê kho",
  List_of_warehouse_rental_charges: "Danh sách phí thuê kho",
  listWarehouseRentalCharges: "Danh sách phí thuê kho",
  Start_days: "Số ngày bắt đầu",
  time_Info: "Thông tin thời gian",
  Warehousing_charge: "Phí thuê kho",
  Days_in_storage: "Số ngày nhập kho",
  warehousing_time: "Thời gian nhập kho",
  edit_cost: "Chỉnh sửa phí",
  please_enter_SKU: "Vui lòng nhập SKU",
  Operator_query: "Người thực hiện truy vấn",
  Minimum_length_of_three_sides: "Chiều dài ba cạnh tối thiểu",
  Maximum_length_of_three_sides: "Chiều dài ba cạnh tối đa",
  The_input_fee_cannot_be_negative: "Phí nhập không được âm",
  Storage_rental_days_are_calculated_at_the_beginning_of_each_SKU_incoming_batch:
    "Mỗi lô nhập kho SKU bắt đầu tính ngày thuê kho",
  labellingCharge: "Phí dán nhãn",
  Label_quantity: "Số lượng dán nhãn",
  Label_or_not: "Có dán nhãn hay không",
  special_CostId: "Số đặc biệt",
  special_CustomerId: "ID khách hàng đặc biệt",
  finish_time: "Thời gian kết thúc",
  additionSpecialFees: "Tạo phí đặc biệt",
  additionSpecialFeesEdit: "Chỉnh sửa phí đặc biệt",
  viewSpecialApprovalExpenses: "Xem phí đặc biệt",
  comeupReview: "Gửi để kiểm duyệt",
  Special_approval_information: "Thông tin đặc biệt",
  Whether_to_invalidate_this_special_approval_for_expenses:
    "Có hủy bỏ phí đặc biệt này hay không",
  After_approval_the_original_fee_settings_will_be_overwritten_Please_carefully_check_if_the_settings_are_correct:
    "Sau khi được kiểm duyệt, cài đặt phí ban đầu sẽ bị ghi đè, vui lòng kiểm tra cẩn thận xem cài đặt có chính xác hay không",
  Please_select_the_same_type_of_special_order:
    "Vui lòng chọn đơn hàng đặc biệt cùng loại",
  Financial_statement: "Báo cáo tài chính",
  financialStatement: "Báo cáo tài chính",
  tableConfigurationList: "Danh sách cấu hình bảng",
  Add_configuration_table: "Thêm bảng cấu hình",
  table_name: "Tên bảng",
  table_ID: "ID bảng",
  table_name_data_type: "Loại dữ liệu tên bảng",
  tier: "Cấp độ",
  Required_or_not: "Có bắt buộc điền không",
  Enable_or_not: "Có kích hoạt không",
  Add_field: "Thêm trường",
  field_name: "Tên trường",
  field_ID: "ID trường",
  Field_data_type: "Loại dữ liệu trường",
  to_lead: "Nhập",
  Multiple_table_import: "Nhập nhiều bảng",
  Serial_number_multi_table_import: "Nhập nhiều bảng theo số sê-ri",
  inportSuccess: "Nhập thành công",
  Drag_the_file_here: "Kéo tệp vào đây",
  Only_xls_xlsx_csv__files_can_be_uploaded_and_the_size_does_not_exceed_100_MB:
    "Chỉ có thể tải lên tệp xls/xlsx/csv và không quá 100MB",
  formulaConfiguration: "Cấu hình công thức",
  Add_a_single_table_formula: "Thêm công thức bảng đơn",
  Edit_a_single_table_formula: "Chỉnh sửa công thức bảng đơn",
  Add_a_multi_table_formula: "Thêm công thức nhiều bảng",
  Edit_table_formula: "Chỉnh sửa công thức bảng",
  List: "Bảng",
  data_processing_type: "Loại xử lý dữ liệu",
  operator_symbol: "Toán tử",
  summation: "Tổng hợp",
  Specified_data: "Dữ liệu chỉ định",
  Marker_text: "Ghi chú văn bản",
  de_weight: "Loại bỏ trùng lặp",
  equation: "Công thức",
  equation_Name: "Tên công thức",
  Sign_Color: "Màu ghi chú",
  Result_field: "Trường kết quả",
  Selection_formula: "Chọn công thức",
  Selection_result_List: "Chọn bảng kết quả",
  Please_select_the_result_table: "Vui lòng chọn bảng kết quả",
  Only_one_result_table_can_be_selected: "Chỉ cho phép chọn một bảng kết quả",
  resultList: "Bảng kết quả",
  serial_number: "Số sê-ri",
  Serial_number: "Số thứ tự",
  Please_enter_the_serial_number: "Vui lòng nhập số thứ tự",
  Please_upload_the_certificate: "Vui lòng tải lên chứng từ",
  include: "Bao gồm",
  delete_batch: "Xóa lô",
  Specified_number_of_rows: "Chỉ định số dòng",
  Batch_process_field_data_types: "Xử lý hàng loạt Loại dữ liệu trường",
  Please_enter_the_serial_number_of_the_batch_you_want_to_delete:
    "Vui lòng nhập số sê-ri của lô cần xóa",
  editFinancialStatement: "Chỉnh sửa báo cáo tài chính",
  Add_trigger: "Thêm kích hoạt",
  Collection_management: "Quản lý thu nợ",
  Please_enter_the_tracking_number_separated_by_commas_or_newlines:
    "Vui lòng nhập số vận đơn, cách nhau bằng dấu phẩy hoặc dấu xuống dòng",
  Please_enter_the_transaction_number_separated_by_commas_or_line_breaks:
    "Vui lòng nhập số giao dịch, cách nhau bằng dấu phẩy hoặc dấu xuống dòng",
  Please_enter_the_head_order_number_separated_by_a_comma_or_a_newline:
    "Vui lòng nhập số đơn hàng đầu tiên, cách nhau bằng dấu phẩy hoặc dấu xuống dòng",
  Please_enter_the_receipt_number_separated_by_a_comma_or_a_newline:
    "Vui lòng nhập số phiếu nhập kho, cách nhau bằng dấu phẩy hoặc dấu xuống dòng",
  registerReturnOrder: "Nhận hàng trả lại",
  returnOrderGrounding: "Trả hàng lên kệ",
  Number_of_remaining_shelves: "Số lượng còn lại trên kệ",
  please_enter_Number_of_shelves: "Vui lòng điền số lượng lên kệ",
  Batch_registration_basket: "Đăng ký giỏ hàng hàng loạt",
  registration_basket: "Đăng ký giỏ hàng",
  Today_is_total_revenue: "Tổng thu nhập hôm nay",
  Today_is_total_expenditure: "Tổng chi tiêu hôm nay",
  Today_is_balance: "Số dư hôm nay",
  Yesterday_is_balance: "Số dư hôm qua",
  ConsolidationOfSimilar: "Hợp nhất các chi phí cùng loại",
  sales_return: "Trả hàng",
  return_management: "Quản lý trả hàng",
  returnManagement: "Quản lý trả hàng",
  returnList: "Danh sách trả hàng",
  Claim_status: "Tình trạng nhận hàng",
  date_issued: "Thời gian lên kệ",
  valid_time: "Thời gian hiệu lực",
  Create_a_return_form: "Tạo phiếu trả hàng",
  Edit_a_return_form: "Chỉnh sửa phiếu trả hàng",
  Receiving_warehouse: "Kho nhận hàng",
  logistics_provider: "Nhà vận chuyển",
  Return_note: "Ghi chú trả hàng",
  processing_scheme: "Giải pháp xử lý",
  Product_picture: "Hình ảnh sản phẩm",
  Select_add_item: "Chọn thêm hàng hóa",
  Claim_time: "Thời gian nhận hàng",
  Temporary_storage_number: "Số tạm lưu",
  viewReturnNote: "Xem phiếu trả hàng",
  Claimed: "Đã nhận",
  unclaimed: "Chưa nhận",
  Parcel_information: "Thông tin bưu kiện",
  Package_picture: "Hình ảnh bưu kiện",
  Package_details: "Chi tiết bưu kiện",
  Number_of_shelves: "Số lượng lên kệ",
  unqualified_quantity: "Số lượng không đạt tiêu chuẩn",
  Quantity_of_abandonment: "Số lượng bỏ đi",
  // Return_Basket:"Giỏ hàng trả hàng',",
  Image: "Hình ảnh",
  Return_StockUnit: "Vị trí kho trả hàng",
  // Actual_Weight:"Trọng lượng thực',",
  // Actual_Lenth:"Chiều dài thực',",
  // Actual_Width:"Chiều rộng thực',",
  // Actual_Height:"Chiều cao thực',",
  Receiving_Warehouse: "Kho nhận hàng",
  Claim_ReturnOrderMsagess:
    "Gói hàng hiện tại chưa được đăng ký, tiếp tục điền thông tin và nhấp vào Lưu để đăng ký vào khu vực nhận hàng!",
  Please_enter_the_tracking_number: "Vui lòng nhập số vận đơn",
  Please_enter_the_warehouse: "Vui lòng chọn kho hàng",
  Please_enter_the_logistics_provider: "Vui lòng nhập nhà vận chuyển",
  Please_enter_the_temporary_number: "Vui lòng nhập số tạm giữ",
  Please_enter_the_sku: "Vui lòng chọn SKU",
  Package_picture_isNotNull: "Hình ảnh gói hàng không được để trống",
  ReturnOrder_ItemProduct_IsNotSkuQuantityNull:
    "Số lượng SKU hàng trả lại không được để trống",
  ReturnOrder_ItemProduct_IsNotQuantityNull:
    "Số lượng hàng trả lại không được để trống",
  Please_add_the_return_order_item: "Vui lòng thêm hàng trả lại",
  Reject: "Từ chối",
  Abandon: "Bỏ đi",
  Ground_Quantity: "Số lượng đã lên kệ",
  Stay_Ground_Quantity: "Số lượng chờ lên kệ",
  Please_select_the_basket: "Vui lòng quét giỏ hàng trả lại",
  Handle_Remark: "Ghi chú xử lý",
  Please_add_the_commodity: "Vui lòng thêm sản phẩm",
  Please_fill_in_the_required_information:
    "Vui lòng điền thông tin chi tiết về kích thước thực tế",
  Please_enter_the_unqualified_quantity:
    "Vui lòng nhập số lượng không đạt tiêu chuẩn",
  The_unqualified_quantity_cannot_be_greater_than_the_product_quantity:
    "Số lượng không đạt tiêu chuẩn không được lớn hơn số lượng hàng hóa",
  Generate_shelf_task: "Phân công nhiệm vụ lên kệ",
  Please_enter_the_solution: "Vui lòng nhập phương án xử lý",
  Please_upload_pictures: "Vui lòng tải lên hình ảnh",
  //quality_testing:"quality_testing:'Kiểm tra chất lượng',",
  Return_StockUnits: "Hàng trả lại tồn kho",
  Actual_Weight: "Trọng lượng thực tế (kg/cái)",
  Actual_Lenth: "Chiều dài thực tế",
  Actual_Width: "Chiều rộng thực tế",
  Actual_Height: "Chiều cao thực tế",
  Actual_Lenth_unit: "Chiều dài thực tế (CM)",
  Actual_Width_unit: "Chiều rộng thực tế (CM)",
  Actual_Height_unit: "Chiều cao thực tế (CM)",
  Actual_Size: "Chiều dài, chiều rộng, chiều cao thực tế (CM)",
  Return_Basket: "Giỏ hàng trả lại",
  ThirdParty_Warehousing: "Kho ba bên",
  Determine_whether_to_reject: "Có xác định từ chối không?",
  Determine_whether_to_abandon: "Có xác định hủy bỏ không?",
  returnOrderStayGrounding: "Danh sách hàng trả lại chờ lên kệ",
  Please_select_a_product_that_belongs_to_this_customer:
    "Vui lòng chọn sản phẩm thuộc về khách hàng này",
  Viewing_Delivery_logs: "Xem nhật ký giao hàng",
  Reprint_face_sheet: "In lại phiếu giao hàng",
  By_default_the_quantity_of_reserved_storage_is_regarded_as_the_qualified_quantity_during_batch_inspection:
    "Khi kiểm tra chất lượng hàng loạt, số lượng nhập kho theo lịch hẹn sẽ được mặc định là số lượng đạt tiêu chuẩn, sản phẩm đã được dán nhãn mặc định, có tiếp tục không?",
  When_the_return_form_of_the_claim_area_is_unclaimed_for_more_than_30_days_it_will_automatically_enter_the_destruction_area:
    "Khi phiếu trả hàng trong khu vực nhận hàng quá 30 ngày mà không có ai nhận, hàng sẽ tự động được chuyển vào khu vực tiêu hủy",
  Failure_to_claim_within_30_days_automatically_enters_the_destruction_zone:
    "30 ngày không có ai nhận hàng sẽ tự động chuyển vào khu vực tiêu hủy",
  claim: "Nhận hàng",
  Please_enter_separated_by_commas_or_newlines:
    "Vui lòng nhập, dùng dấu phẩy hoặc dấu xuống dòng để phân tách",
  Import_returns: "Nhập hàng trả lại",
  attribution: "Chủ sở hữu",
  unfinishedReturnTaskList: "Danh sách nhiệm vụ trả hàng chưa hoàn thành",
  finishedReturnTaskList: "Danh sách nhiệm vụ trả hàng đã hoàn thành",
  Viewing_print_logs: "Xem nhật ký in",
  batch_abandon: "Loại bỏ hàng loạt",
  The_minimum_value_is: "Giá trị tối thiểu là",
  The_original_product_cannot_be_deleted_if_there_is_a_shortage_or_defective_product_please_fill_in_the_unqualified_quantity:
    "Không thể xóa sản phẩm gốc, nếu có sản phẩm hết hàng hoặc bị lỗi, vui lòng điền số lượng không đạt tiêu chuẩn",
  Confirm_return_pending_review: "Xác nhận trả hàng để chờ duyệt",
  Confirm_abandon: "Xác nhận hủy bỏ",
  Cofirm_modify_warehouse: "Xác nhận sửa đổi kho",
  Verify_tracking_number: "Xác minh số vận đơn",
  publish: "Đăng",
  publishLazada: "Sản phẩm trực tuyến Lazada",
  publishShopee: "Sản phẩm trực tuyến Shopee",
  publishTikTok: "Sản phẩm trực tuyến TikTok",
  tiktokGoodsOnline: "Sản phẩm trực tuyến TikTok",
  lazadaGoodsOnline: "Sản phẩm trực tuyến Lazada",
  shopeeGoodsOnline: "Sản phẩm trực tuyến Shopee",
  lazadaTrusteeshipGoodsOnline: "Sản phẩm trực tuyến Lazada được lưu trữ",
  Goods_to_be_released: "Sản phẩm chờ phát hành",
  CNSC_Goods_to_be_released: "Sản phẩm CNSC chờ phát hành",
  Global_commodity: "Sản phẩm toàn cầu",
  Site_goods: "Sản phẩm trang web",
  Link_ID: "ID liên kết",
  Link_Name: "Tên liên kết",
  Link_SKU: "SKU liên kết",
  Variant_ID: "ID biến thể",
  master_map: "Hình ảnh chính",
  onLineSKU: "SKU trực tuyến",
  pair: "Ghép nối",
  Paired_inventory_SKUs: "Ghép nối",
  pairLog: "Nhật ký ghép nối",
  unpair: "Hủy ghép nối",
  Modified_pairing: "Sửa đổi ghép nối",
  PlatformAuthorization: "Ủy quyền nền tảng",
  store_management: "Quản lý cửa hàng",
  ShopAuthorization: "Ủy quyền cửa hàng",
  shopAuthorization: "Ủy quyền cửa hàng",
  Add_authorization: "Thêm ủy quyền",
  name_of_shop: "Tên cửa hàng",
  store_name: "Tên cửa hàng",
  korach: "Có thể lấy",
  Being_drawn: "Đang lấy",
  Please_enter_the_name_of_the_shop: "Vui lòng nhập tên cửa hàng",
  Platform_store_name: "Tên cửa hàng trên nền tảng",
  authorization_status: "Trạng thái ủy quyền",
  be_authorized: "Đã ủy quyền",
  Authorization_successful: "Ủy quyền thành công",
  unauthorized: "Chưa ủy quyền",
  privileged_time: "Thời gian ủy quyền",
  Expiration_time_of_authorization: "Thời gian hết hạn ủy quyền",
  Is_the_address_consistent: "Địa chỉ có khớp nhau không",
  Manually_synchronize_the_repository: "Đồng bộ hóa kho thủ công",
  After_authorization_automatically_pull_orders_within_half_a_month_automatically_pull_returns_within_half_a_month_and_online_product_information_within_half_a_year:
    "Sau khi ủy quyền, tự động lấy các đơn hàng trong vòng nửa tháng, tự động lấy các hàng trả lại trong vòng nửa tháng, thông tin sản phẩm trực tuyến trong vòng nửa năm",
  After_authorization_automatically_pull_online_products_that_have_been_updated_within_half_a_year:
    "Sau khi ủy quyền, tự động lấy hàng hóa trực tuyến có cập nhật trong vòng nửa năm",
  Platform_SKUs_have_changed_please_pay_attention_to_re_pairing_otherwise_the_original_platform_SKUs_and_stock_SKUs_are_still_paired:
    "SKU nền tảng có thay đổi, xin lưu ý ghép nối lại, nếu không sẽ vẫn là ghép nối SKU nền tảng ban đầu và SKU kho",
  Replace_the_pairing_the_goods_information_of_the_previous_order_will_not_be_replaced_with_the_newly_paired_goods_please_go_to_the_order_list_to_modify_the_goods:
    "Thay đổi ghép nối, thông tin hàng hóa của đơn hàng trước đó sẽ không thực hiện thay đổi hàng hóa ghép nối mới, vui lòng sửa đổi hàng hóa trong danh sách đơn hàng.",
  After_the_dissolution_of_the_relationship_the_product_information_of_the_previous_order_will_not_be_unpaired_After_the_manual_pairing_the_new_pairing_logic_will_not_be_executed_for_the_previously_paired_order_Please_go_to_the_order_list_to_modify_the_product:
    "Sau khi hủy kết nối, thông tin hàng hóa trong các đơn hàng trước đó sẽ không được thực hiện hủy kết nối, sau khi kết nối lại thủ công, các đơn hàng đã được kết nối trước đó sẽ không thực hiện logic kết nối mới, vui lòng sửa đổi hàng hóa trong danh sách đơn hàng.",
  Pull_goods: "Tải hàng hóa",
  Recent_pull_time: "Thời gian tải gần nhất",
  Store_pull_status: "Trạng thái tải cửa hàng",
  Store_pull_exception: "Lỗi tải cửa hàng",
  Store_Pull_time: "Thời gian tải cửa hàng",
  Last_7_days: "7 ngày gần nhất",
  Last_30_days: "30 ngày gần nhất",
  Last_90_days: "90 ngày gần nhất",
  Last_180_days: "180 ngày gần nhất",
  Stores_that_have_not_shipped_within_2_months_will_be_automatically_invalidated:
    "Cửa hàng không giao hàng trong 2 tháng sẽ tự động bị hủy bỏ",
  Latest_shipping_time: "Thời gian giao hàng cuối cùng",
  Last_3_months: "3 tháng gần nhất",
  Beginning_to_pull_the_time: "Thời gian bắt đầu lấy hàng",
  Ending_pull_time: "Thời gian kết thúc lấy hàng",
  WMSmissionContro: "Kiểm soát nhiệm vụ WMS",
  Configuration_task_type: "Cấu hình loại nhiệm vụ",
  please_select_Configuration_task_type: "Vui lòng chọn cấu hình loại nhiệm vụ",
  Distribution_task_generation_control_type:
    "Kiểm soát loại tạo nhiệm vụ phân phối hàng hóa",
  please_select_Distribution_task_generation_control_type:
    "Vui lòng chọn loại kiểm soát tạo nhiệm vụ phân phối hàng hóa",
  Task_order_quantity: "Số lượng đơn hàng nhiệm vụ",
  Please_enter_the_Task_order_quantity:
    "Vui lòng nhập số lượng đơn hàng nhiệm vụ",
  Maximum_order_number: "Số lượng đơn hàng tối đa",
  Please_enter_the_Maximum_order_number:
    "Vui lòng nhập số lượng đơn hàng tối đa",
  Allocation_inquiry: "Truy vấn phân phối hàng hóa",
  Whether_to_allocate_goods_by_floor: "Có phân phối hàng hóa theo tầng không",
  please_select_Whether_to_allocate_goods_by_floor:
    "Vui lòng chọn có phân phối hàng hóa theo tầng hay không",
  Whether_the_storage_space_can_be_allocated:
    "Vị trí kho dự trữ có thể phân phối hàng hóa không",
  please_select_Whether_the_storage_space_can_be_allocated:
    "Vui lòng chọn vị trí kho dự trữ có thể phân phối hàng hóa hay không",
  Order_allocation_timeout_time:
    "Thời gian chờ phân phối hàng hóa theo đơn hàng",
  Please_enter_the_Order_allocation_timeout_time:
    "Vui lòng nhập thời gian chờ phân phối hàng hóa theo đơn hàng",
  Generate_timeout_order_tasks_first:
    "Ưu tiên tạo nhiệm vụ đơn hàng quá thời gian chờ",
  please_select_Generate_timeout_order_tasks_first:
    "Vui lòng chọn ưu tiên tạo nhiệm vụ đơn hàng quá thời gian",
  Match_and_send: "Phân phối và giao hàng đồng thời",
  please_select_Match_and_send:
    "Vui lòng chọn phân phối và giao hàng đồng thời",
  Delivery_weighing: "Có cân hàng hóa khi giao hàng không",
  please_select_Delivery_weighing:
    "Vui lòng chọn có cân hàng hóa khi giao hàng không",
  Do_you_want_to_take_photos: "Có chụp ảnh hàng hóa khi giao hàng không",
  Is_the_shipment_recorded: "Có quay video hàng hóa khi giao hàng không",
  please_select_Do_you_want_to_take_photos:
    "Vui lòng chọn có chụp ảnh hàng hóa khi giao hàng không",
  Check_whether_the_goods_are_delivered:
    "Có kiểm tra hàng hóa khi giao hàng không",
  please_select_Check_whether_the_goods_are_delivered:
    "Vui lòng chọn có kiểm tra hàng hóa khi giao hàng không",
  Whether_the_whole_sorting_task_is_shipped:
    "Có phân loại hàng hóa khi giao hàng không",
  please_select_Whether_the_whole_sorting_task_is_shipped:
    "Vui lòng chọn có phân loại toàn bộ nhiệm vụ trước khi giao hàng hay không",
  Delivery_inquiry: "Tra cứu giao hàng",
  New_task_control: "Kiểm soát nhiệm vụ mới",
  Edit_task_control: "Chỉnh sửa kiểm soát nhiệm vụ",
  Allocation_information: "Thông tin phân loại hàng hóa",
  shipping_information: "Thông tin giao hàng",
  Multi_floor_combination_distribution: "Phân loại hàng hóa kết hợp nhiều tầng",
  Distribute_goods_while_shipping: "Phân loại hàng hóa và giao hàng cùng lúc",
  Total_allocation_quantity: "Tổng số lượng phân loại hàng hóa",
  Total_shipment_quantity: "Tổng số lượng giao hàng",
  Delivery_phase: "Giai đoạn giao hàng",
  Delivery_start_time: "Thời gian bắt đầu giao hàng",
  Delivery_end_time: "Thời gian kết thúc giao hàng",
  Abnormal_query: "Tra cứu sự cố",
  need: "Cần",
  do_without: "Không cần",
  Please_enter_basket_remarks: "Vui lòng nhập ghi chú giỏ hàng",
  Failed_to_print_sheet_please_rescan:
    "In phiếu giao hàng không thành công, vui lòng quét lại",
  Single_print_success: "In phiếu giao hàng thành công",
  batch_delivery: "Giao hàng hàng loạt",
  Bulk_shipment_quantity: "Số lượng giao hàng hàng loạt",
  Whether_to_scan_the_database: "Có quét vị trí kho không",
  Please_confirm_that_the_goods_have_been_returned_to_the_original_warehouse:
    "Vui lòng xác nhận đã đặt hàng hóa trở lại vị trí kho ban đầu",
  Return_the_order_to_ungenerated: "Trả lại đơn hàng về trạng thái chưa tạo",
  Return_the_order_to_a_draft: "Trả lại đơn hàng về trạng thái bản nháp",
  Return_the_order_to_the_pending_review_status:
    "Trả lại đơn hàng về trạng thái chờ duyệt",
  Item_task_list: "Danh sách nhiệm vụ hàng hóa đơn lẻ",
  itemTaskList: "Danh sách nhiệm vụ hàng hóa đơn lẻ",
  Multi_task_list: "Danh sách nhiệm vụ hàng hóa nhiều loại",
  multiTaskList: "Danh sách nhiệm vụ hàng hóa nhiều loại",
  Packing_material_condition: "Tình trạng bao bì",
  Basket_quantity: "Số lượng giỏ hàng",
  viewWarehouseEntryList: "Xem danh sách phiếu nhập kho",
  No_combo_SKU_images_uploaded: "Vui lòng tải lên hình ảnh SKU kết hợp",
  Whether_sorting_and_delivery_is_required:
    "Có cần phân loại hàng hóa để giao hàng không",
  delivery_process: "Quy trình giao hàng",
  delivery_process_one: "Quy trình giao hàng 1",
  delivery_process_two: "Quy trình giao hàng 2",
  Delivery_flow_2_does_not_allow_the_use_of_border_variations:
    "Quy trình giao hàng 2 không cho phép sử dụng phương pháp phân loại hàng hóa trong khi giao hàng",
  Delivery_process_2_Multi_floor_distribution_is_not_allowed:
    "Quy trình giao hàng 2 không cho phép sử dụng phương pháp phân loại hàng hóa trên nhiều tầng",
  Default_delivery_process_scanning_the_corresponding_basket_for_goods_sorting_and_delivery:
    "Quy trình giao hàng mặc định, quét giỏ tương ứng để phân loại hàng hóa và giao hàng",
  Goods_are_sorted_and_no_baskets_are_needed_for_delivery:
    "Hàng hóa được phân loại, không cần giỏ để giao hàng",
  Multiple_products_and_edge_matching_edge_division_unusable_volume:
    "Không được sử dụng thể tích cho nhiều mặt hàng và phân loại đồng thời",
  Use_the_delivery_flow_for_multi_product_tasks_2_The_border_variation_is_not_allowed:
    "Nhiệm vụ nhiều mặt hàng sử dụng quy trình giao hàng 2 không được phép sử dụng phân loại đồng thời",
  surfTheInternet: "Có kết nối mạng không",
  surfExternalOrder: "Có cho phép đơn hàng bên ngoài không",
  Please_choose_surfTheInternet: "Vui lòng chọn có kết nối mạng hay không",
  Please_choose_surfExternalOrder:
    "Vui lòng chọn có cho phép đơn hàng bên ngoài hay không",
  Whether_to_go_online_refers_to_whether_the_platform_api_interface_is_called_to_verify_whether_the_logistics_trajectory_has_been_collected:
    "Có kết nối mạng hay không có nghĩa là có gọi giao diện API nền tảng để xác minh hành trình logistics có được nhận hay không.",
  Preview_sheet: "Xem trước phiếu giao hàng",
  If_the_bill_is_abnormal_contact_the_administrator:
    "Phiếu giao hàng có sự cố, vui lòng liên hệ quản trị viên để xử lý.",
  Exit_Printing: "Thoát in",
  single_product: "Sản phẩm đơn lẻ",
  paperTask: "Nhiệm vụ trên giấy",
  multiProductPaperDistribution: "Phân phối nhiều sản phẩm trên giấy",
  singleProductPaperDistribution: "Phân phối sản phẩm đơn lẻ trên giấy",
  obtainPaperDistributionOfSingleProduct:
    "Lấy phân phối sản phẩm đơn lẻ trên giấy",
  completeThePaperDistributionOfTheSingleProduct:
    "Hoàn thành phân phối sản phẩm đơn lẻ trên giấy",
  obtainMultiProductPaperDistribution: "Lấy phân phối nhiều sản phẩm trên giấy",
  completeMultiProductPaperDistribution:
    "Hoàn thành phân phối nhiều mặt hàng trên giấy",
  Paper_tracking_number: "Số đơn hàng trên giấy",
  basket: "Giỏ hàng",
  basket_Info: "Thông tin giỏ hàng",
  specified_Quantity: "Số lượng chỉ định",
  Individual_product_operation: "Thao tác mặt hàng đơn lẻ",
  Multiple_product_operation: "Thao tác nhiều mặt hàng",
  multipleProductOperation: "Thao tác nhiều mặt hàng",
  multiple_products: "Nhiều mặt hàng",
  order_quantity: "Số lượng đơn hàng",
  volume: "Thể tích",
  describe: "Mô tả",
  taskList: "Danh sách nhiệm vụ",
  Extra_packing_material: "Vật liệu đóng gói thêm",
  Additional_packing_material_exists: "Có vật liệu đóng gói thêm",
  listOrdersShipped: "Danh sách đơn hàng chờ giao",
  listAbnormalShipment: "Danh sách đơn hàng chờ giao có sự cố",
  Order_phase: "Giai đoạn đơn hàng",
  order_source: "Nguồn đơn hàng",
  Quantity_occupied: "Số lượng chiếm dụng",
  The_address_of_the_bill_is_empty_Contact_the_administrator:
    "Địa chỉ trên phiếu giao hàng trống, vui lòng liên hệ với quản trị viên để xử lý",
  The_address_of_the_bill_is_empty: "Địa chỉ trên phiếu giao hàng trống",
  There_are_orders_with_empty_waybill_numbers_in_the_selected_orders_so_the_waybill_cannot_be_previewed:
    "Trong đơn hàng đã chọn có đơn hàng có số vận đơn trống, không thể xem trước phiếu giao hàng",
  Please_scan: "Vui lòng quét",
  Please_scan_the_barcode: "Vui lòng quét mã vạch sản phẩm",
  Modify_the_number_of_SKUs: "Sửa đổi số lượng SKU",
  Modified_warehouse: "Sửa đổi kho",
  Submitted_to_be_reviewed: "Gửi để chờ phê duyệt",
  Commit_back_not_generated: "Gửi lại chưa tạo",
  Back_to_not_generated: "Trả lại chưa tạo",
  Back_to_draft: "Trả lại bản nháp",
  Return_to_pending_review: "Trả lại để chờ phê duyệt",
  priority: "Ưu tiên",
  secondary: "Thứ yếu",
  order_inquiry: "Truy vấn đơn hàng",
  info_query: "Truy vấn thông tin",
  Print_basket_number: "In số giỏ hàng",
  Back_to_basket_list: "Quay lại danh sách giỏ hàng",
  Sorting_starts_numbering: "Số bắt đầu phân loại",
  Sorting_end_number: "Số kết thúc phân loại",
  Tripartite_warehouse_information: "Thông tin kho ba bên",
  Threeway_warehouse_OP_number: "Số OP kho ba bên",
  Batch_sorting: "Phân loại hàng loạt",
  The_sorting_number_of_the_current_scan_is: "Số phân loại hiện đang quét là",
  Print_the_sorting_basket_head: "In đầu giỏ hàng phân loại",
  List_of_shipped_orders: "Danh sách đơn hàng đã giao",
  listShippedOrders: "Danh sách đơn hàng đã giao",
  taskID: "ID nhiệm vụ",
  Please_enter_taskID: "Vui lòng nhập ID nhiệm vụ",
  There_are_no_tasks_in_the_basket: "Giỏ hàng hiện tại không có nhiệm vụ",
  bulk_print: "In hàng loạt",
  to_do_list_ID: "ID đơn hàng",
  task_type: "Loại nhiệm vụ",
  List_of_tasks_in_allocation: "Danh sách nhiệm vụ đang phân phối hàng",
  listTasksAllocation: "Danh sách nhiệm vụ đang phân phối hàng",
  Sorting_task_list: "Danh sách nhiệm vụ đang phân loại",
  sortingTaskList: "Danh sách nhiệm vụ đang phân loại",
  List_of_tasks_being_shipped: "Danh sách nhiệm vụ đang giao hàng",
  listTasksBeingShipped: "Danh sách nhiệm vụ đang giao hàng",
  Printing_successfully_Stopped_printing: "In thành công, dừng in",
  List_of_shipped_tasks: "Danh sách nhiệm vụ đã giao hàng",
  listShippedTasks: "Danh sách nhiệm vụ đã giao hàng",
  explosiveOperation: "Hoạt động sản phẩm hot",
  explosiveDistribution: "Phân phối sản phẩm hot",
  explosiveDelivery: "Giao hàng sản phẩm hot",
  explosiveList: "Danh sách sản phẩm hot",
  Order_origin_currency: "Tiền tệ gốc của đơn hàng",
  Out_of_storage: "Đang xuất kho",
  Print_failed_Please_check_and_try_again:
    "In thất bại! Vui lòng kiểm tra lại và thử lại",
  One_click_out_completed: "Hoàn thành xuất kho bằng một nút bấm",
  not_finished: "Chưa kết thúc",
  have_not_started: "Chưa bắt đầu",
  If_the_printing_is_not_successful_for_more_than_5_seconds_the_printing_ends:
    "In hơn 5 giây mà không bắt được trạng thái thành công, kết thúc in",
  Whether_it_is_a_paper_task: "Có phải là nhiệm vụ trên giấy không",
  Checking_the_sheet: "Đang kiểm tra phiếu giao hàng",
  A_sheet_is_being_printed: "Đang in phiếu giao hàng",
  System_deduction: "Hệ thống trừ phí",
  Get_the_distribution_task: "Lấy nhiệm vụ phân phối hàng",
  Reprint_the_distribution_sheet: "In lại phiếu phân phối hàng",
  invoice: "Hóa đơn",
  HOT: "Sản phẩm bán chạy",
  print_TaskId: "In ID nhiệm vụ",
  Generating_task: "Đang tạo nhiệm vụ",
  distributionControl: "Kiểm soát phân phối hàng",
  Order_distribution_time_zone: "Khu vực phân phối hàng của đơn hàng",
  Order_distribution_sorting_field: "Trường sắp xếp phân phối hàng",
  automatic_printing: "In tự động",
  Non_automatic_printing: "Không in tự động",
  Automatic_printing_of_distribution_slips: "In tự động phiếu phân phối hàng",
  Automatically_prints_the_task_ID: "Tự động in ID nhiệm vụ",
  The_time_zone_already_exists: "Khu vực thời gian này đã tồn tại",
  Add_Time_zone: "Thêm khu vực thời gian",
  example: "Ví dụ",
  Ungenerated_task: "Chưa tạo nhiệm vụ",
  completed_distribution: "Đã hoàn thành phân phối hàng",
  Order_submission_time: "Thời gian gửi đơn hàng",
  Please_select_automatic_printing: "Vui lòng chọn in tự động",
  Please_select_order_distribution_sorting_field:
    "Vui lòng chọn trường sắp xếp phân phối hàng",
  The_entered_time_zone_must_be_longer_than_one_hour_from_the_existing_time_zone:
    "Khu vực thời gian nhập vào phải lớn hơn khu vực thời gian hiện tại ít nhất một giờ",
  The_time_zone_must_be_between_0100_and_2300:
    "Thời gian nhập vào phải nằm trong khoảng 01:00-23:00",
  Support_input_time_zone_return_to_add_the_input_time_zone_needs_to_exist_in_the_selection_value:
    "Có thể chọn trực tiếp thời gian, nhập múi giờ và nhấn Enter để thêm, lưu ý: múi giờ nhập phải có trong danh sách lựa chọn",
  Sort_by_order_submission_time_from_morning_to_night:
    "Sắp xếp theo thời gian gửi đơn hàng từ sớm đến muộn",
  The_order_is_sorted_by_the_repository_number_and_the_next_repository_order_task_will_be_performed_only_after_processing_the_current_repository_order_task:
    "Sắp xếp theo số vị trí kho, chỉ xử lý đơn hàng vị trí kho hiện tại xong mới xử lý đơn hàng vị trí kho tiếp theo",
  Sort_by_sku_the_current_sku_is_completed_before_proceeding_to_the_next_sku:
    "Sắp xếp theo SKU, chỉ tiến hành SKU tiếp theo sau khi hoàn thành SKU hiện tại",
  Generate_earlier_time_zone_tasks_first:
    "Ưu tiên tạo nhiệm vụ múi giờ sớm hơn",
  If_the_order_distribution_time_zone_is_not_set_it_will_not_be_divided_by_time_Only_the_order_distribution_sorting_field_will_be_sorted_to_generate_the_order:
    "Nếu không thiết lập múi giờ phân phối đơn hàng, sẽ không phân chia theo thời gian. Chỉ sắp xếp theo trường sắp xếp phân phối đơn hàng để tạo đơn hàng.",
  Pre_0_yesterday_orders_are_preferentially_generated:
    "Ưu tiên tạo đơn hàng trước 0 giờ (ngày hôm qua)",
  Generate_orders_from_0000_to_1200:
    "Tạo đơn hàng trong khoảng thời gian từ 00:00 đến 12:00",
  Generate_orders_after_1200_to_before_2400: "Tạo đơn hàng từ 12:00 đến 24:00.",
  Please_enter_the_number_of_tasks: "Vui lòng nhập số lượng nhiệm vụ.",
  Please_select_a_single_order_type: "Vui lòng chọn một loại đơn hàng.",
  Please_scan_task_ID: "Vui lòng quét ID nhiệm vụ.",
  Whether_to_limit_the_sorting_and_delivery_to_the_same_person:
    "Có giới hạn phân loại và giao hàng cho cùng một người không?",
  Mixed_shipments_are_possible_for_orders_of_different_task_types:
    "Các đơn hàng thuộc các loại nhiệm vụ khác nhau có thể được giao hàng hỗn hợp.",
  task_bound_person: "Người liên kết nhiệm vụ.",
  remaining_products: "Số lượng sản phẩm còn lại trên kệ.",
  Please_perform_wms_task_control_first:
    "Vui lòng thực hiện kiểm soát nhiệm vụ wms trước.",
  The_current_warehouse_has_not_performed_wms_task_control:
    "Kho hiện tại chưa thực hiện kiểm soát nhiệm vụ wms",
  whether_batch_ship: "Có giao hàng hàng loạt không",
  hot_item_whether_batch_ship:
    "Có giao hàng hàng loạt cho sản phẩm bán chạy không",
  manualEntryAndExitList: "Danh sách nhập kho/xuất kho thủ công",
  Manual_Entry_and_exit_slip_number: "Số đơn nhập kho/xuất kho thủ công",
  Manual_Entry_and_exit_slip_type: "Loại nhập kho/xuất kho thủ công",
  Manual_Entry_and_exit_slip_status: "Trạng thái nhập kho/xuất kho thủ công",
  accomplish_Time: "Thời gian hoàn thành",
  audits: "Xem xét",
  Create_ManualEntryAndExit: "Tạo đơn nhập kho/xuất kho thủ công",
  Please_fill_in_the_audit_remarks: "Vui lòng điền ghi chú xem xét",
  audit_remarks: "Ghi chú xem xét",
  pass_the_audit: "Xem xét thông qua",
  The_inventory_will_be_changed_after_clicking:
    "Sau khi nhấp vào xác nhận, kho sẽ thay đổi",
  Clicking_OK_will_flag_the_exception:
    "Nhấp vào xác nhận sẽ được đánh dấu là bất thường",
  Click_OK_and_it_will_be_rejected: "Sau khi nhấp vào xác nhận, sẽ bị từ chối",
  Number_of_shelvesd: "Số lượng kệ",
  Type_of_outgoing_and_incoming_accounts: "Loại nhập/xuất kho",
  If_a_recommended_repository_exists_the_recommended_repository_is_selected_by_default:
    "Khi có vị trí kho được đề xuất, vị trí kho được đề xuất sẽ được chọn mặc định",
  If_a_recommended_repository_exists_the_recommended_repository_is_entered_by_default:
    "Khi có vị trí kho được đề xuất, vị trí kho được đề xuất sẽ được nhập mặc định",
  Consolidation_of_similar_expenses: "Hợp nhất chi phí cùng loại",
  Add_Consolidation_of_similar_expenses: "Thêm hợp nhất chi phí cùng loại",
  Monthly_Expense_List: "Danh sách chi tiêu hàng tháng",
  Name_of_the_expense_item: "Tên mục chi phí",
  Accounting_in: "Ghi sổ",
  Accounting_out: "Xuất sổ",
  in_out_account: "Ghi sổ",
  Sku_and_quantity: "SKU và số lượng hàng hóa",
  Billing_weight: "Trọng lượng tính phí",
  Charge_quantity: "Cài đặt chi phí số lượng tính phí",
  Charge_weight: "Cài đặt chi phí trọng lượng",
  Cost_setting_Cube: "Cài đặt chi phí khối lượng",
  cost_setting_Three_sides_length_CM: "Cài đặt chi phí ba cạnh và",
  Cost_set_three_sides_long: "Cài đặt chi phí ba cạnh dài",
  goods_cobe: "Khối lượng hàng hóa",
  goods_Three_sides_length_CM: "Ba cạnh dài hàng hóa",
  goods_weight: "Trọng lượng hàng hóa",
  type_of_fee: "Loại chi phí",
  Item_code: "Mã hàng hóa",
  Fill_in_the_positive_balance_of_recharge_and_fill_in_the_negative_balance_of_deduction:
    "Nạp tiền vào số dư, trừ số dư vào số âm",
  stock_in_and_stock_out_record: "Ghi chép nhập kho và xuất kho",
  storage_location_number: "Số vị trí kho",
  Entry_quantity: "Số lượng thay đổi trong kho",
  total_inventory_quantity: "Tổng số lượng trong kho",
  Current_batch_inventory_quantity: "Số lượng trong kho của lô hiện tại",
  Batch_stock_quantity: "Tổng số lượng trong kho của vị trí kho",
  Batch_occupied_inventory_quantity: "Số lượng trong kho của lô",
  life: "Thời gian lưu kho",
  Has_stock: "Có hàng trong kho",
  No_stock: "Không có hàng trong kho",
  Has_No_stock: "Có hàng trong kho hay không",
  stock_type: "Loại hàng trong kho",
  Entry_time: "Thời gian nhập kho",
  Tripartite_storage: "Hàng trong kho của bên thứ ba",
  General_stock: "Hàng trong kho thông thường",
  Unusable_inventory: "Hàng không sử dụng được",
  Entry_and_exit_records: "Xem chi tiết hàng trong kho",
  grounding: "Đưa lên kệ",
  Shelf_in_bulk: "Đưa lên kệ hàng loạt",
  Number_of_shelvesds: "Số lượng đưa lên kệ",
  Unshelved: "Chưa đưa lên kệ",
  Already_listed: "Đã đưa lên kệ",
  Multiple_quantity: "Số lượng phát hành nhiều",
  Shelf_batch: "Lô lên kệ",
  Check_the_storage_details: "Xem chi tiết nhập kho/xuất kho",
  operate_successfully: "Hoạt động thành công",
  Print_the_default_size_paper_distribution:
    "In phiếu giao hàng giấy kích thước mặc định",
  Print_A4_size_distribution: "In phiếu giao hàng giấy kích thước A4",
  Print_100_150_size_distribution: "In phiếu giao hàng giấy kích thước 100*150",
  The_customer_password_will_be_reset_to_ESTP_mobile_number:
    "Mật khẩu khách hàng sẽ được đặt lại thành: ESTP+số điện thoại di động",
  Get_a_shelf_task: "Nhận nhiệm vụ lên kệ",
  Please_select_some_user: "Người lên kệ",
  Prioritize_shelving: "Đặt ưu tiên lên kệ",
  Please_select_the_type_of_manual_entry_ticket:
    "Vui lòng chọn loại phiếu nhập kho/xuất kho thủ công",
  Please_select_warehouse: "Vui lòng chọn kho",
  Please_select_the_warehouse_location: "Vui lòng chọn vị trí kho",
  Please_scan_the_database_location: "Vui lòng quét vị trí kho",
  Select_date_time: "Chọn ngày giờ",
  please_select_stockId: "Vui lòng chọn kho",
  please_select_stockzone: "Vui lòng chọn khu vực",
  please_select_shelf: "Vui lòng chọn kệ",
  Please_scan_sku: "Vui lòng quét SKU",
  please_select_auditUser: "Vui lòng chọn người kiểm duyệt",
  Storage_type: "Loại nhập kho/xuất kho",
  Billing_quantity: "Số lượng tính phí",
  Cost_type: "Loại chi phí",
  frozenBillingDetails: "Chi tiết hóa đơn bị đóng băng",
  storage_location_capacity: "Dung lượng vị trí kho",
  product_capacity: "Dung lượng sử dụng sản phẩm",
  recommendstorage_location_type: "Loại vị trí kho được đề xuất",
  Operational_query: "Truy vấn thao tác",
  Please_scan_the_basket: "Vui lòng quét mã giỏ hàng!",
  The_number_of_shelves_cannot_be_greater_than_the_qualified_number:
    "Số lượng lên kệ không được lớn hơn số lượng hợp lệ",
  Whether_batch_shelves: "Có xếp hàng loạt không",
  Please_select_the_same_warehouse_entry_form_to_submit:
    "Vui lòng chọn phiếu nhập kho cùng kho để gửi!",
  The_database_bit_number_does_not_exist: "Không có số vị trí kho này",
  replacement_cost: "Đặt lại chi phí",
  Create_a_breakout_task: "Tạo nhiệm vụ bán chạy",
  Match_and_divide: "Phân phối và phân chia",
  matchAndDivide: "Phân phối và phân chia",
  Online_SKU_images: "Hình ảnh SKU trực tuyến",
  Seller_SKU: "SKU của người bán",
  AbnormalRemarks: "Ghi chú bất thường",
  Store_SKU: "SKU của cửa hàng",
  Authorization_assignment: "Gán giá trị ủy quyền",
  Please_enter_the_AccessToken: "Vui lòng nhập AccessToken",
  Please_enter_the_RefreshToken: "Vui lòng nhập RefreshToken",
  APITokenInformation: "Thông tin mã API",
  authorization_management: "Quản lý ủy quyền",
  authorization_message: "Thông tin ủy quyền",
  companyName: "Tên công ty",
  Print_a_paper_distribution: "In phiếu phân phối hàng hóa trên giấy",
  Select_case_number: "Chọn số thùng",
  Starting_box_number: "Số thùng bắt đầu",
  End_box_number: "Số thùng kết thúc",
  picker: "Người lấy hàng",
  Pick_date: "Ngày lấy hàng",
  print_time: "Thời gian in",
  sku_quantity: "Số lượng SKU",
  Refill_slip_number: "Số phiếu bù trừ",
  Whether_to_cancel_supplementary_deduction: "Có chắc chắn hủy bù trừ không?",
  irredeemable: "Không thể hủy lại",
  This_item_is_out_of_stock: "Hàng hóa này không có trong kho",
  The_repository_does_not_exist: "Không có vị trí kho này",
  flowingWaterInAndOutOfStorage: "Dòng chảy nhập kho/xuất kho",
  Generation_task_type: "Tạo loại nhiệm vụ",
  View_the_default_log_of_the_initial_shipping_fee_for_modifying_the_purchase_price:
    "Xem sửa đổi giá mua hàng Nhật ký phí vận chuyển mặc định",
  warehouseEntryControl: "Kiểm soát nhập kho/trả hàng",
  Add_the_entry_ticket_control: "Thêm kiểm soát hệ thống",
  Edit_entry_slip_control: "Chỉnh sửa kiểm soát hệ thống",
  Whether_to_open_excess_inspection:
    "Có bật kiểm tra chất lượng vượt quá không",
  Control_the_number_of_boxes_generated_during_inspection_tasks:
    "Kiểm soát số lượng thùng được tạo trong nhiệm vụ kiểm tra chất lượng",
  Control_the_number_of_SKUs_generated_by_the_mount_task:
    "Kiểm soát số lượng SKU được tạo trong nhiệm vụ lên kệ",
  Create_entry_ticket_control: "Tạo kiểm soát hệ thống",
  Enter_0_for_the_entire_build_task:
    "Nhập 0 để tạo nhiệm vụ cho toàn bộ đơn hàng",
  Whether_To_return_the_package_to_take_photos:
    "Có chụp ảnh gói hàng trả lại không",
  Control_The_number_of_boxes_generated_for_a_quality_inspection_task_indicates_the_number_of_boxes_generated_when_a_worker_obtains_a_quality_inspection_task_Set_0_to_the_entire_generation_task:
    "Kiểm soát số lượng thùng được tạo cho nhiệm vụ kiểm tra chất lượng là số lượng thùng được tạo khi công nhân nhận nhiệm vụ kiểm tra chất lượng, nhập 0 để tạo nhiệm vụ cho toàn bộ đơn hàng",
  Control_the_number_of_SKU_types_generated_for_the_shelf_task_to_the_number_of_SKU_types_generated_when_obtaining_the_shelf_task_Fill_in_0_for_the_entire_single_generation_task:
    "Kiểm soát số lượng SKU được tạo cho nhiệm vụ lên kệ là số lượng SKU được tạo khi công nhân nhận nhiệm vụ lên kệ, nhập 0 để tạo nhiệm vụ cho toàn bộ đơn hàng",
  Whether_to_take_a_picture_of_the_return_is_whether_to_take_a_picture_of_the_package_when_the_return_receipt_is_received:
    "Có chụp ảnh hàng trả lại hay không là có chụp ảnh gói hàng khi nhận hàng trả lại hay không",
  There_are_mandatory_fields_that_are_not_filled_in_Please_fill_them_in_and_try_again:
    "Có trường bắt buộc chưa điền, vui lòng điền rồi thử lại",
  inbound_and_return_control: "Kiểm soát nhập kho/trả hàng",
  Subaccount_management: "Quản lý tài khoản phụ",
  subaccountList: "Danh sách tài khoản phụ",
  Subaccount_number: "Số tài khoản phụ",
  subaccount_name: "Tên tài khoản phụ",
  Please_enter_a_subaccount_name: "Vui lòng nhập tên tài khoản phụ",
  Add_a_subaccount: "Thêm tài khoản phụ",
  subAccountRoleInfo: "Thông tin tài khoản phụ",
  payment_type: "Phương thức thanh toán",
  Whether_to_terminate_services: "Có chấm dứt hoạt động không",
  Subaccount_role: "Vai trò tài khoản phụ",
  Please_add_product: "Vui lòng thêm hàng hóa",
  An_empty_container_number_exists_Please_check_and_try_again:
    "Có số thùng trống, vui lòng kiểm tra rồi thử lại",
  An_empty_number_exists_Please_check_and_try_again:
    "Có số lượng trống, vui lòng kiểm tra lại và thử lại",
  Submit_success: "Gửi thành công!",
  cancellation_of_order: "Hủy đơn hàng",
  Cancel_a_task: "Hủy nhiệm vụ",
  Confirm_cancellation_of_order: "Xác nhận hủy đơn hàng",
  Confirm_cancel_task: "Xác nhận hủy nhiệm vụ",
  Order_operation: "Thao tác đơn hàng",
  Cancel_an_order: "Hủy đơn hàng",
  Undo_to_exception: "Hủy thành bất thường",
  Undo_to_ungenerated: "Hủy thành chưa tạo",
  cancelOrder: "Hủy đơn hàng",
  Please_enter_the_waybill_number_Only_100_waybills_are_supported_at_a_time_separated_by_line_breaks:
    "Vui lòng nhập số vận đơn, mỗi lần chỉ hỗ trợ 100 vận đơn, cách nhau bằng dấu xuống dòng",
  Order_cancellation_Pick_stock_please_return_the_stock_to_the_original_shelf_order_cancellation_directly_to_the_confirmation:
    "Đơn hàng đã được chọn hàng hủy chọn hàng tồn kho, vui lòng đặt hàng tồn kho trở lại kệ hàng ban đầu, đơn hàng sẽ được hủy trực tiếp đến trạng thái đang xác nhận",
  automaticProcessingRule: "Quy tắc xử lý tự động",
  Rule_name: "Tên quy tắc",
  Rule_type: "Loại quy tắc",
  priority_level: "Mức độ ưu tiên",
  Rule_description: "Mô tả quy tắc",
  Rule_subitem: "Phần phụ của quy tắc",
  Modification_time: "Thời gian sửa đổi",
  Modified_successfully: "Sửa đổi thành công",
  content: "Nội dung",
  Please_add_at_least_one_rule: "Vui lòng thêm ít nhất một quy tắc",
  Please_select_the_rule_type_first: "Vui lòng chọn loại quy tắc trước",
  Rule_detail: "Chi tiết quy tắc",
  sku_matching_mode: "Phương thức khớp SKU",
  packing_type: "Loại đóng gói",
  Please_select_at_least_one_rule: "Vui lòng chọn ít nhất một quy tắc",
  Only_process_the_orders_that_have_been_pending_review_for_15_days_from_the_current_system_time_and_the_inventory_sufficient:
    "Chỉ xử lý các đơn hàng đang chờ phê duyệt trong hệ thống trong vòng 15 ngày kể từ thời điểm hiện tại và có đủ hàng tồn kho.",
  Customer_inquiry_Please_enter_only_numbers:
    "Để tra cứu thông tin khách hàng, vui lòng nhập số thuần túy.",
  listWarehouseRentalChargesDetail: "Chi tiết hóa đơn thuê kho",
  warehouseRentalBillSKUDetails: "Chi tiết SKU hóa đơn thuê kho",
  list_warehouse_rental_charges_detail: "Chi tiết hóa đơn thuê kho",
  Inventory_batch: "Chi tiết hàng tồn kho",
  Upload_file_error_Upload_acsv_XLS_XLSX_file:
    "Tệp tải lên có lỗi! Vui lòng tải lên tệp có đuôi .CSV, .XLS, .XLSX",
  There_are_unfinished: "Có nhiệm vụ chưa hoàn thành",
  task: "nhiệm vụ",
  Whether_to_process: "Có đi xử lý không",
  chart_type: "Loại biểu đồ",
  Excluding_today: "Không bao gồm ngày hôm nay",
  rop_shipping_product_ranking_list: "Bảng xếp hạng hàng hóa chờ giao",
  single_Product_Single_Order: "Số lượng đơn hàng",
  single_Product_Multi_Order: "Số lượng đơn hàng nhiều",
  singleProductMultiOrder: "Số lượng đơn hàng nhiều",
  multi_Product_Multi_Order: "Số lượng nhiều sản phẩm",
  multiProductMultiOrder: "Số lượng nhiều sản phẩm",
  single_product_single_order_drop_shipping_product_quantity_ranking_list:
    "Bảng xếp hạng số lượng hàng hóa đơn lẻ chờ giao hàng",
  single_Product_Multi_Order_drop_shipping_product_quantity_ranking_list:
    "Bảng xếp hạng số lượng hàng hóa đơn lẻ nhiều chờ giao hàng",
  multi_product_Multi_order_drop_shipping_product_quantity_ranking_list:
    "Bảng xếp hạng số lượng hàng hóa đa dạng và số lượng lớn đang chờ giao hàng",
  to_do_task: "Nhiệm vụ cần làm",
  value_added_services: "Dịch vụ gia tăng",
  The_timeout_is_set_to_a_certain_time: "Thời gian cài đặt quá hạn là",
  Recent_announcements: "Thông báo gần đây",
  See_more: "Xem thêm",
  next: "Tiếp theo",
  warehouseHolidayList: "Danh sách ngày lễ kho hàng",
  holidayDate: "Ngày lễ",
  overdueSetting: "Cài đặt quá hạn",
  overdueTime: "Thời gian quá hạn",
  Import_warehouse_holidays: "Nhập ngày lễ kho hàng",
  overdue_Duration: "Thời gian quá hạn",
  Warehouse_during_holidays: "Ngày lễ kho hàng",
  product_item_type: "Loại hàng hóa",
  Update_the_product_diversion_number: "Cập nhật mã phân loại hàng hóa",
  Do_you_need_to_update_the_product_diversion_number:
    "Có cập nhật mã phân loại hàng hóa hay không",
  Priority_calculation_method: "Phương pháp tính toán ưu tiên",
  formula_mode: "Phương pháp tính toán",
  Add_range: "Thêm phạm vi",
  Add_the_maximum_range: "Thêm phạm vi tối đa",
  The_input_range_for_addition_contains_null_values_Please_check_and_try_again:
    "Phạm vi thêm vào có giá trị trống, vui lòng kiểm tra lại và thử lại",
  Imported_part_type_rule_setting: "Nhập cài đặt quy tắc loại hàng hóa",
  set_type: "Loại cài đặt",
  calculation_type: "Loại tính toán",
  calculate_the_time_type: "Loại thời gian tính toán",
  calculated_value: "Giá trị tính toán",
  overseas_warehouse_fees: "Phí kho hàng nước ngoài",
  First_leg_fees: "Chi phí vận chuyển đầu tiên",
  Days: "Số ngày",
  Month: "Tháng",
  Add_newly_developed_customers: "Thêm khách hàng mới",
  Delete_newly_developed_customers: "Xóa khách hàng mới",
  Please_select_set_type: "Vui lòng chọn loại cài đặt",
  Please_select_calculation_type: "Vui lòng chọn loại tính toán",
  Please_select_calculate_the_time_type:
    "Vui lòng chọn loại thời gian tính toán",
  Whether_to_use_the_strategy_of_new_order_volume_for_the_entire_month:
    "Có sử dụng chiến lược số lượng đơn hàng mới trong cả tháng không",
  Please_enter_the_calculated_value: "Vui lòng nhập giá trị tính toán",
  The_calculated_value_must_be_greater_than_zero:
    "Giá trị tính toán phải lớn hơn 0",
  When_the_time_type_is_month_the_value_cannot_exceed_twelve:
    "Khi loại thời gian tính toán là tháng, giá trị này không được vượt quá 12",
  The_month_corresponding_to_the_starting_time_obtained_from_the_calculation_type:
    "Tháng bắt đầu tính toán tương ứng với loại tính toán,",
  For_new_customers_this_will_no_longer_be_counted_after_this_month:
    "là khách hàng mới, sau tháng này sẽ không tính nữa",
  The_time_type_is_month: "Loại thời gian tính toán là tháng:",
  Using_the_strategy_of_total_monthly_new_orders_If_the_data_generation_time_is_the_1st_day:
    "Sử dụng chiến lược lượng đơn hàng mới trong cả tháng: Nếu thời gian tạo dữ liệu là ngày 1,",
  Even_if_the_entire_current_month_has_a_high_volume_of_new_customer_orders_if_this_is_the_case_for_any_other_days:
    "thì cả tháng hiện tại là lượng đơn hàng của khách hàng mới, nếu là ngày khác,",
  The_number_of_new_development_customer_orders_will_be_available_from_the_start_date_until_the_end_of_next_month:
    "từ ngày bắt đầu đến cuối tháng sau đều là số lượng đơn hàng của khách hàng mới.",
  Unutilized_monthly_new_order_volume_strategy_For_the_month_for_which_the_starting_time_was_determined_based_on_the_calculation_type:
    "Không sử dụng chiến lược số lượng đơn hàng mới trong cả tháng: đối với tháng bắt đầu tính toán theo loại tính toán,",
  For_the_volume_of_new_customer_orders:
    "là số lượng đơn hàng của khách hàng mới.",
  The_time_type_for_calculation_is_in_days:
    "Loại thời gian tính toán là số ngày:",
  The_start_and_end_times_are_calculated_by_adding_the_first_occurrence_time_of_the_corresponding_type_to_the_corresponding_calculated_value_in_days_months:
    "Thời gian bắt đầu và thời gian kết thúc được tính bằng cách cộng thời gian xuất hiện lần đầu tiên của loại tương ứng với giá trị tính toán tương ứng (số ngày/tháng).",
  For_example_The_calculation_type_is: "Ví dụ: Loại tính toán bằng:",
  Enter_into_inventory_set_the_time_type_to_days_and_the_calculation_value_to_15:
    "Nhập kho, loại thời gian tính toán bằng: số ngày, giá trị tính toán bằng: 15",
  Assuming_the_initial_listing_date_is_2025_11_01_then_the_number_of_new_customer_orders_would_be_2025_11_01_to_2025_11_15:
    "Giả sử thời gian lên kệ lần đầu tiên là: 2025-11-01, thì thời gian bắt đầu và kết thúc của đơn hàng khách hàng mới là: 2025-11-01~2025-11-15.",
  During_this_period_the_orders_that_were_dispatched_are_all_counted_as_the_sales_volume_for_new_customers:
    "Tất cả các đơn hàng xuất kho trong khoảng thời gian này đều được tính là đơn hàng của khách hàng mới.",
  count_method: "Phương pháp kiểm kê",
  Whether_to_automatically_generate_count_tasks: "Tự động tạo nhiệm vụ kiểm kê",
  Whether_to_freeze_inventory: "Đóng băng kiểm kê hàng tồn kho",
  whether_Difference_count: "Kiểm kê chênh lệch",
  count_setting: "Cài đặt kiểm kê",
  When_there_is_an_count_surplus_or_count_deficit_the_next_round_of_count_tasks_will_be_generated_after_the_end_of_the_count_until_the_final_count:
    "Khi xuất hiện tình trạng tồn kho dương hoặc tồn kho âm, sau khi kiểm kê kết thúc, nhiệm vụ kiểm kê tiếp theo sẽ được tạo ra, cho đến khi kiểm kê cuối cùng.",
  Indicates_how_many_rounds_of_count_are_required_If_only_one_round_of_count_is_required_the_value_is_one_If_you_need_to_count_two_rounds_it_is_two_and_so_on:
    "Cho biết cần thực hiện bao nhiêu vòng kiểm kê, nếu chỉ kiểm kê một vòng thì là 1; nếu cần kiểm kê hai vòng thì là 2, v.v.",
  Count_round: "Số vòng kiểm kê",
  max_count_round: "Số vòng kiểm kê tối đa",
  The_types_of_count_tasks_are_divided_into_light_count_and_dark_count:
    "Loại nhiệm vụ kiểm kê được chia thành kiểm kê công khai và kiểm kê bí mật.",
  If_the_light_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_will_be_displayed_If_dark_count_is_selected_the_specific_number_of_SKU_inventory_to_be_counted_is_not_displayed:
    "Nếu chọn kiểm kê công khai, số lượng cụ thể của SKU cần kiểm kê sẽ được hiển thị; nếu chọn kiểm kê bí mật, số lượng cụ thể của SKU cần kiểm kê sẽ không được hiển thị.",
  Whether_multiple_rounds_of_count_can_be_the_same_person:
    "Có thể cùng một người thực hiện nhiều vòng kiểm kê không?",
  If_the_automatic_generation_of_count_tasks_is_not_enabled_the_task_to_be_counted_is_not_automatically_generated:
    "Nếu không bật tính năng tự động tạo nhiệm vụ kiểm kê, nhiệm vụ kiểm kê sẽ không được tạo tự động.",
  If_you_need_to_restart_the_automatic_generation_of_the_count_task_the_time_of_the_automatic_generation_of_the_count_task_will_start_in_the_morning_of_the_next_day:
    "Nếu cần bật lại tính năng tự động tạo nhiệm vụ kiểm kê, thời gian tự động tạo nhiệm vụ kiểm kê sẽ bắt đầu tính từ rạng sáng ngày hôm sau.",
  count_methods_are_divided_into_SKU_count_and_count_by_warehouse_location:
    "Phương pháp kiểm kê được chia thành kiểm kê theo SKU và kiểm kê theo vị trí kho.",
  According_to_the_SKU_count_all_the_storage_locations_that_have_this_SKU_stock_will_be_counted_and_only_the_time_of_the_last_SKU_count_will_be_updated:
    "Kiểm kê theo SKU, tất cả các vị trí kho có tồn kho SKU này sẽ được kiểm kê và chỉ cập nhật thời gian kiểm kê SKU lần cuối.",
  If_the_count_is_taken_by_warehouse_location_all_SKUs_with_inventory_in_the_warehouse_location_will_be_counted_and_only_the_last_count_time_of_the_warehouse_location_will_be_updated:
    "Kiểm kê theo vị trí kho sẽ kiểm kê tất cả SKU có trong kho và chỉ cập nhật thời gian kiểm kê lần cuối của vị trí kho.",
  Subtract_the_last_SKU_or_warehouse_count_time_according_to_the_current_days_find_the_qualified_data_and_generate_the_count_task:
    "Dựa trên số ngày hiện tại trừ đi thời gian kiểm kê lần cuối của SKU/vị trí kho, tìm kiếm dữ liệu phù hợp và tạo nhiệm vụ kiểm kê.",
  The_cycle_of_the_count_task_is_automatically_generated:
    "Tự động tạo chu kỳ nhiệm vụ kiểm kê",
  Indicates_how_many_count_details_exist_in_an_automatic_count_task:
    "Cho biết số lượng chi tiết kiểm kê trong một nhiệm vụ kiểm kê tự động.",
  For_example_if_the_task_method_is_SKUs_and_the_number_of_automatically_generated_tasks_for_library_locations_and_SKUs_is_ten_the_count_details_contain_10_different_SKUs:
    "Ví dụ: Khi phương pháp kiểm kê là SKU và số lượng nhiệm vụ tự động tạo (vị trí kho/SKU) là 10, chi tiết kiểm kê sẽ có 10 SKU khác nhau.",
  Automatic_generation_task: "Tự động tạo nhiệm vụ",
  check_log: "Xem nhật ký",
  Not_less_than_two: "Không được nhỏ hơn 2",
  Quantity_of_need_to_counted: "Số lượng cần kiểm kê",
  Quantity_of_actually_count: "Số lượng thực tế",
  Quantity_of_wait_to_count: "Số lượng cần kiểm kê",
  Quantity_of_count_loss: "Số lượng thiếu hụt",
  Quantity_of_count_profit: "Số lượng dư thừa",
  task_number: "Số nhiệm vụ",
  finally: "Cuối cùng",
  execution_time_of_count: "Thời gian thực hiện kiểm kê",
  executor_of_count: "Người thực hiện kiểm kê",
  execute_count: "Thực hiện kiểm kê",
  check_count_details: "Xem chi tiết kiểm kê",
  The_total: "Tổng",
  Need_to_count_rounds: "Số lần kiểm kê cần thiết",
  current_count_rounds: "Lần kiểm kê hiện tại",
  counter: "Người kiểm kê",
  quantity_of_occupy_stock: "Số lượng hàng tồn kho chiếm dụng",
  quantity_of_disabled_stock: "Số lượng hàng tồn kho không sử dụng được",
  storage_location_final_count_time:
    "Thời gian kiểm kê cuối cùng của vị trí kho",
  product_final_count_time: "Thời gian kiểm kê cuối cùng của hàng hóa",
  Manually_generate_count_task: "Tự động tạo nhiệm vụ kiểm kê",
  Designated_counter: "Chỉ định người kiểm kê",
  Data_from_different_warehouses_exists_Ensure_that_the_selected_data_belongs_to_the_same_warehouse:
    "Có dữ liệu của các kho khác nhau, vui lòng xác nhận dữ liệu được chọn thuộc cùng một kho!",
  The_warehouse_is_not_set_for_count_please_set_for_count_first:
    "Kho này chưa được thiết lập kiểm kê, vui lòng thiết lập kiểm kê trước",
  please_add_data_first: "Vui lòng thêm dữ liệu trước!",
  count_task_number: "Số nhiệm vụ kiểm kê",
  stock_batch: "Lô hàng tồn kho",
  stock_batch_ID: "ID lô hàng tồn kho",
  stock_batch_Num: "Số lượng lô hàng tồn kho",
  Number_of_quarantined_shelves: "Số lượng hàng hóa bị cách ly",
  Original_batch_shelf_time: "Thời gian lên kệ của lô hàng ban đầu",
  Isolated_storage_location: "Vị trí kho bị cách ly",
  Whether_the_inventory_is_out_of_storage_location:
    "Có phải là hàng tồn kho ngoài kho không",
  Isolation_shelf_time: "Thời gian lên kệ bị cách ly",
  Quarantine_inventory_shelving_task_number:
    "Số nhiệm vụ lên kệ hàng tồn kho bị cách ly",
  Mission_start_shelf_time: "Thời gian bắt đầu lên kệ của nhiệm vụ",
  Mission_completed_shelf_time: "Thời gian hoàn thành nhiệm vụ lên kệ",
  Task_remarks: "Ghi chú nhiệm vụ",
  Original_storage_location: "Vị trí kho ban đầu",
  Isolation_shelf_space: "Vị trí kho cách ly lên kệ",
  Complete_the_task: "Hoàn thành nhiệm vụ",
  Fetch_task: "Nhận nhiệm vụ",
  Complete_this_round_of_tasks: "Hoàn thành nhiệm vụ vòng này",
  Current_total_stock: "Tổng kho hiện tại",
  Real_time: "Thời gian thực",
  Task_rotation: "Vòng nhiệm vụ",
  Add_non_existing_stock_in_storage_location:
    "Thêm kho không có vị trí hiện tại",
  count_loss_reason: "Lý do thiếu hụt",
  count_loss_remark: "Ghi chú thiếu hụt",
  count_loss_type: "Loại thiếu hụt",
  Defective_product: "Hàng kém chất lượng",
  lack: "Thiếu",
  Current_stock: "Kho hiện tại",
  Inventory_quantity_at_the_end_of_the_last_round:
    "Số lượng kho khi kết thúc kiểm kê vòng trước",
  Quantity_of_actually_count_of_last_round_count: "Số lượng thực tế vòng trước",
  Quantity_of_count_profit_of_last_round_count: "Số lượng thừa vòng trước",
  Quantity_of_count_loss_of_last_round_count: "Số lượng thiếu vòng trước",
  End_time_of_last_round_count: "Thời gian kết thúc kiểm kê vòng trước",
  count_checked_and_no_problem_stock:
    "Hàng tồn kho đã kiểm kê, không có vấn đề",
  Missing_or_damaged_quantity: "Số lượng thiếu/hư hỏng",
  The_amount_that_exceeds_the_real_time_current_inventory:
    "Số lượng vượt quá hàng tồn kho hiện tại (thời gian thực)",
  Whether_the_real_time_current_inventory_is_different_from_the_Inventory_quantity_at_the_end_of_the_last_round:
    "Hàng tồn kho hiện tại (thời gian thực) có khác với số lượng hàng tồn kho khi kết thúc kiểm kê vòng trước không",
  Please_complete_the_current_task_first:
    "Vui lòng hoàn thành nhiệm vụ hiện tại trước",
  The_storage_location_does_not_exist_or_has_been_completed:
    "Vị trí kho không tồn tại hoặc đã hoàn thành",
  The_bar_code_does_not_exist_or_has_been_completed:
    "Mã vạch sản phẩm không tồn tại hoặc đã hoàn thành",
  Please_scan_the_storage_location_and_scan_the_product_bar_code_and_enter_the_quantity_of_actually_count:
    "Vui lòng quét vị trí kho, mã vạch sản phẩm và nhập số lượng thực tế",
  Cancel_count_task: "Hủy nhiệm vụ kiểm kê",
  count_details: "Chi tiết kiểm kê",
  count_log: "Nhật ký kiểm kê",
  Confirm_whether_to_cancel_the_count_task: "Xác nhận hủy nhiệm vụ kiểm kê",
  countSetting: "Cài đặt kiểm kê",
  stockStorageLocationList: "Danh sách vị trí kho",
  countTaskList: "Danh sách nhiệm vụ kiểm kê",
  countTask: "Nhiệm vụ kiểm kê",
  IsolatedStorageLocationList: "Danh sách vị trí kho cách ly",
  isolatedShelfTaskList: "Danh sách nhiệm vụ lên kệ cách ly",
  isolatedShelfTask: "Nhiệm vụ lên kệ cách ly",
  pendingClaimList: "Chờ bồi thường",
  countDetails: "Chi tiết kiểm kê",
  Please_scan_the_storage_location: "Vui lòng quét vị trí kho",
  please_confirm_exist_storage_location_data_first:
    "Vui lòng xác nhận trước rằng có dữ liệu vị trí kho",
  Isolated_storage_location_listing_task_number:
    "Số nhiệm vụ lên kệ vị trí kho bị cách ly",
  task_start_time: "Thời gian bắt đầu nhiệm vụ",
  task_end_time: "Thời gian kết thúc nhiệm vụ",
  Whether_the_inventory_is_not_in_the_original_storage_location:
    "Có phải là hàng tồn kho không phải vị trí kho ban đầu không",
  The_actual_number_of_products_on_shelves: "Số lượng sản phẩm thực tế lên kệ",
  the_time_that_product_listing_to_the_isolated_storage_location:
    "Thời gian sản phẩm được lên kệ vị trí kho bị cách ly",
  Please_scan_the_Original_storage_location:
    "Vui lòng quét vị trí kho ban đầu trước",
  please_confirm_exist_Original_storage_location_data_first:
    "Vui lòng xác nhận trước rằng có dữ liệu vị trí kho ban đầu",
  this_task_is_completed: "Nhiệm vụ này đã hoàn thành",
  the_storage_location_do_not_exist_or_is_not_isolated_storage_location:
    "Vị trí kho này không tồn tại hoặc không thuộc vị trí kho cách ly",
  Whether_to_force_the_task_to_complete:
    "Có bắt buộc hoàn thành nhiệm vụ không",
  The_inventory_has_been_counted_to_the_last_product_and_the_count_task_is_to_be_finished_Is_it_confirmed_that_it_is_completed:
    "Đã kiểm kê đến sản phẩm cuối cùng, sắp kết thúc nhiệm vụ kiểm kê, có xác nhận hoàn thành không",
  unoccupied_quantity: "Số lượng chưa sử dụng",
  occupied_quantity: "Số lượng đã sử dụng",
  return_order: "Phiếu trả hàng",
  manual_entry_and_exit: "Nhập kho thủ công",
  Shifting_storage_location: "Chuyển vị trí kho",
  Shifting_warehouse: "Chuyển kho",
  can_no_be_zero: "Không thể là 0",
  When_this_feature_is_enabled_customers_will_not_be_able_to_use_this_inventory_to_submit_orders_during_the_count:
    "Kích hoạt chức năng này, khi kiểm kê, khách hàng sẽ không thể sử dụng kho hàng này để đặt hàng",
  Will_not_be_able_to_operate_this_inventory:
    "Không thể thao tác với kho hàng này",
  If_the_whether_Difference_count_is_equal_yes_the_count_rounds_default_is_two_and_it_cannot_be_less_than_two:
    "Nếu có sự chênh lệch trong kiểm kê, số lần kiểm kê sẽ mặc định là 2 và không thể nhỏ hơn 2.",
  It_is_used_to_control_the_maximum_count_rounds_when_there_is_a_difference_in_count_quantity:
    "Dùng để kiểm soát số lần kiểm kê tối đa khi có sự chênh lệch trong kiểm kê",
  modifiable: "Có thể sửa đổi",
  When_there_is_no_difference_it_is_the_final_count_round:
    "Khi không có sự chênh lệch, đây là số lần kiểm kê cuối cùng",
  whether_the_profit_is_isolated_from_the_warehouse_on_the_shelf:
    "Liệu hàng tồn kho có được cách ly và lên kệ không",
  uncounted: "Chưa kiểm kê",
  Have_counted: "Đã kiểm kê",
  whether_Difference: "Có chênh lệch",
  inventory_position_has_not_been_counted_in_recent_N_days:
    "Vị trí kho chưa kiểm kê trong N ngày gần đây",
  goods_have_not_been_counted_in_recent_N_days:
    "Hàng hóa chưa kiểm kê trong N ngày gần đây",
  Total_quantity_of_goods_in_warehouse: "Tổng số lượng hàng hóa trong kho",
  goods_type_quantity: "Số loại hàng hóa",
  Whether_the_inventory_loss_is_not_available_for_storage:
    "Thiếu hụt có được đặt lên kệ vị trí kho không sử dụng không",
  Unavailable_library_positions: "Vị trí kho không sử dụng",
  When_the_unavailable_storage_location_is_selected_for_shelving_the_inventory_of_goods_that_are_in_short_supply_during_the_inventory_check_will_be_automatically_shelved_to_the_unavailable_storage_location:
    "Khi chọn đặt lên kệ vị trí kho không sử dụng, khi thực hiện kiểm kê, hàng hóa thiếu hụt sẽ tự động được đặt lên kệ vị trí kho không sử dụng",
  When_the_inventory_counting_settings_select_this_item_as_yes_executing_the_final_inventory_counting_if_there_is_a_profit_will_generate_an_isolated_shelving_task_and_move_the_profit_goods_to_the_isolated_library_position:
    "Khi cài đặt kiểm kê chọn mục này là Có, sau khi thực hiện kiểm kê cuối cùng, nếu phát hiện hàng tồn kho dương, sẽ tạo nhiệm vụ lên kệ cách ly, chuyển hàng tồn kho dương sang vị trí kho cách ly.",
  When_the_inventory_counting_settings_select_this_item_as_no_executing_the_final_inventory_counting_if_there_is_a_profit_will_directly_correct_the_real_time_inventory_and_move_the_profit_goods_to_the_normal_inventory:
    "Khi cài đặt kiểm kê chọn mục này là Không, sau khi thực hiện kiểm kê cuối cùng, nếu có hàng tồn kho dương, sẽ trực tiếp điều chỉnh hàng tồn kho thời gian thực, hàng tồn kho dương sẽ được điều chỉnh trực tiếp vào hàng tồn kho bình thường.",
  There_are_no_unavailable_locations_in_the_current_warehouse_so_if_you_need_to_set_them_go_to_Add_them_first:
    "Kho hiện tại không có vị trí kho không sử dụng, nếu cần thiết lập, vui lòng thêm trước",
  isolated_storage_location_down: "Loại bỏ vị trí kho cách ly",
  isolated_storage_unit_no: "Số vị trí kho cách ly",
  isolated_storage_unit_quantity: "Số lượng vị trí kho cách ly",
  no_such_storage_unit_in_warehouse: "Kho này không có số vị trí kho này",
  cannot_exceed_isolated_quantity:
    "Không được lớn hơn số lượng vị trí kho cách ly",
  Inventory_cannot_be_removed_from_the_shelves:
    "Loại bỏ hàng tồn kho không sử dụng",
  The_quantity_cannot_be_empty_and_must_be_a_number:
    "Số lượng không được để trống và phải là số",
  Can_only_be_a_positive_integer: "Chỉ có thể là số nguyên dương",
  Confirm_recount: "Xác nhận kiểm kê lại",
  Take_stock_again: "Kiểm kê lại",
  At_the_end_of_the_final_inventory_round_the_quantity_of_stock_exceeded_expectations:
    "Khi kết thúc vòng kiểm kê cuối cùng, số lượng hàng tồn kho vượt quá dự kiến",
  At_the_end_of_the_final_inventory_round_the_quantity_of_missing_or_defective_stock:
    "Khi kết thúc vòng kiểm kê cuối cùng, số lượng hàng tồn kho thiếu hoặc bị lỗi",
  Actual_inventory_quantity_at_the_end_of_the_final_counting_round:
    "Số lượng hàng tồn kho thực tế khi kết thúc vòng kiểm kê cuối cùng",
  Round_Start_Time: "Thời gian bắt đầu vòng kiểm kê",
  Round_End_Time: "Thời gian kết thúc vòng kiểm kê",
  Whether_to_independently_choose_the_inventory_execution_method:
    "Có tự chọn phương thức thực hiện kiểm kê hay không",
  Select_inventory_execution_method: "Chọn phương thức thực hiện kiểm kê",
  Directly_deduct_from_inventory: "Trừ trực tiếp hàng tồn kho",
  Place_on_unavailable_storage_location: "Đưa lên kệ không sử dụng",
  When_the_inventory_setting_is_selected_as_Yes_during_inventory_execution_if_there_is_a_loss_in_quantity_you_can_choose_whether_to_directly_deduct_from_inventory_or_shelve_in_unavailable_locations:
    "Khi cài đặt kiểm kê chọn Có cho mục này, nếu có số lượng hàng tồn kho thiếu hụt khi thực hiện kiểm kê, bạn có thể tự chọn Trừ trực tiếp vào hàng tồn kho hoặc Đặt hàng lên kệ không sử dụng.",
  viewOrderProcessingFee: "Xem phí xử lý đơn hàng",
  goods_ranking_list: "Bảng xếp hạng sản phẩm",
  Bar_chart: "Biểu đồ cột",
  weeks: "Tuần",
  hot: "Bán chạy",
  unsalable: "Bán chậm",
  Line_chart: "Biểu đồ đường",
  Total_account_balance: "Tổng số dư tài khoản",
  Account_balance: "Số dư tài khoản",
  Number_of_authorized_stores: "Số lượng cửa hàng đã được ủy quyền",
  Number_of_authorized_expired_stores: "Số lượng cửa hàng đã hết hạn ủy quyền",
  Time_period: "Khoảng thời gian",
  Sales_volume: "Doanh số bán hàng",
  Commodity_inventory: "Hàng tồn kho",
  Commodity_inventory_storage_location: "Hàng tồn kho (theo vị trí kho)",
  You_have_an_expired_license_store_to_deal_with:
    "Bạn có cửa hàng hết hạn ủy quyền cần xử lý",
  years: "Năm",
  Historical_announcemen: "Thông báo lịch sử",
  This_year: "Năm nay",
  Number_of_squares: "Số lượng",
  shipment: "Số lượng hàng gửi",
  Release_time: "Thời gian phát hành",
  Frozen_balance: "Số dư bị đóng băng",
  Frozen: "Đóng băng",
  Store_shipment: "Số lượng hàng gửi của cửa hàng",
  is_total_orders_click_on_the_detailed_data_to_view_the_order_list:
    "Tổng số lượng đơn hàng, nhấp vào dữ liệu chi tiết để xem danh sách số lượng đơn hàng",
  Real_time_total_orders_of_the_day_click_on_the_detailed_data_to_view_the_storage_order_list:
    "Tổng số lượng đơn hàng thực tế trong ngày, nhấp vào dữ liệu chi tiết để xem danh sách đơn hàng kho",
  Created_nearly_seven_days_ago: "Thời gian tạo gần 7 ngày",
  Warehouse_order: "Đơn hàng kho",
  Does_not_include_today_is_sales: "Không bao gồm doanh số bán hàng hôm nay",
  Pie_chart: "Biểu đồ hình tròn",
  This_week: "Tuần này",
  Current_month: "Tháng này",
  Unread_announcement: "Thông báo chưa đọc",
  months: "Tháng",
  main_account: "Tài khoản chính",
  head_entry: "Nhập kho đầu tiên",
  First_Leg_Order: "Đơn hàng đầu tiên",
  exception_First_Leg_Order: "Đơn hàng đầu tiên bất thường",
  In_the_stock_shelves: "Đang nhập kho và lên kệ",
  Hello_welcome_to_use_estp_oms: "Xin chào, chào mừng bạn sử dụng Yisuifei OMS",
  Hello_welcome_to_use_Hyperdimensional_OMS:
    "Xin chào, chào mừng bạn sử dụng Chaowei IoT OMS",
  customer_number: "Số khách hàng",
  Top_up_immediately: "Nạp tiền ngay",
  Sales_Volume: "Doanh số bán hàng",
  Data_last_updated: "Thời gian cập nhật dữ liệu gần nhất",
  Beijing_time: "Giờ Bắc Kinh",
  obligation_first_leg_order: "Đơn hàng đầu tiên chờ thanh toán",
  Total_square_inventory: "Tổng số lượng hàng tồn kho",
  go: "Đi đến",
  Temporarily_unavailable_please_contact_the_administrator:
    "Tạm thời không thể xem, vui lòng liên hệ với quản trị viên",
  The_operation_succeeds_and_The_data_is_refreshed_successfully:
    "Hoạt động thành công, dữ liệu được làm mới thành công",
  number_of_SKU: "Số lượng SKU",
  Exclusive_Investment_Promotion: "Đầu tư độc quyền",
  Exclusive_customer_service: "Dịch vụ khách hàng độc quyền",
  inventory_all_quantity: "Tổng số lượng hàng tồn kho",
  Total_number_inventory_in_transit:
    "Tổng số lượng hàng tồn kho đang vận chuyển",
  Order_out_today: "Số lượng đơn hàng hôm nay",
  Order_out_today_yesterday: "Số lượng đơn hàng hôm qua",
  Timeout_failed_to_complete_the_task: "Nhiệm vụ quá thời hạn chưa hoàn thành",
  Overdue_order: "Đơn hàng quá hạn",
  Warehousing_order: "Đơn hàng nhập kho",
  Quantity_of_goods_in_stock_today:
    "Số lượng đơn hàng nhập kho và lên kệ hôm nay",
  Number_of_SKUs_in_storage_today: "Số lượng SKU nhập kho và lên kệ hôm nay",
  Return_order: "Đơn hàng trả lại",
  Order_quantity_of_return_today: "Số lượng đơn hàng trả lại hôm nay",
  Number_of_SKUs_returned_today: "Số lượng SKU trả lại hôm nay",
  First_billing: "Hóa đơn đầu tiên",
  unaudited_customer_number: "Số lượng khách hàng chờ duyệt",
  toBePaidOrderList: "Đơn hàng chờ thanh toán",
  toBePaid: "Chờ thanh toán",
  Whether_the_product_is_sold_or_not_will_be_calculated_every_day_if_not_the_number_of_unsalable_days_will_be_added_by_one_and_if_there_is_the_number_of_unsalable_days_will_be_reset_to_zero:
    "Mỗi ngày sẽ tính toán xem hàng hóa có bán được hay không, nếu không bán được thì số ngày ế hàng sẽ tăng thêm một, nếu bán được thì số ngày ế hàng sẽ về 0.",
  The_sum_of_pending_shipment_distribution_and_shipment:
    "Tổng số lượng chờ giao hàng, đang phân phối hàng, đang giao hàng",
  The_number_to_be_reviewed: "Số lượng chờ duyệt",
  The_sum_of_the_delivery_exceptions_in_the_pending_review_and_waybill_number_acquisition:
    "Tổng số đơn hàng đang chờ phê duyệt, đang lấy số vận đơn và có sự cố vận chuyển",
  You_do_not_have_permission_to_access_this_page:
    "Bạn không có quyền truy cập trang này",
  salesReportForSKU: "Báo cáo doanh số SKU",
  salesReportForWarehouse: "Báo cáo doanh số kho",
  salesReportForPlatform: "Báo cáo doanh số nền tảng",
  salesReportForCountry: "Báo cáo doanh số quốc gia",
  salesReportForStore: "Báo cáo doanh số cửa hàng",
  product_quantity_sold: "Số lượng hàng hóa bán ra",
  Average_daily_sales: "Doanh số trung bình hàng ngày",
  Product_name_in_Chinese_and_English:
    "Tên hàng hóa bằng tiếng Trung và tiếng Anh",
  unsalableGoodsReport: "Báo cáo hàng hóa tồn kho",
  unsalable_days: "Số ngày tồn kho",
  overdueList: "Danh sách quá hạn",
  overdueDetailList: "Danh sách chi tiết quá hạn",
  customerDailyConsumptionFlow: "Dòng tiền tiêu dùng hàng ngày của khách hàng",
  customerMonthlyConsumptionFlow:
    "Dòng tiền tiêu dùng hàng tháng của khách hàng",
  commodityItemNumberReport: "Báo cáo mã hàng hóa",
  financialOperations: "Báo cáo hoạt động tài chính",
  dailyBalance: "Số dư hàng ngày của khách hàng",
  shipmentReport: "Báo cáo lượng hàng xuất",
  warehouseShipmentReport: "Báo cáo lượng hàng xuất kho",
  platformShipmentReport: "Báo cáo lượng hàng xuất nền tảng",
  countryShipmentReport: "Báo cáo lượng hàng xuất quốc gia",
  storeShipmentReport: "Báo cáo lượng hàng xuất cửa hàng",
  Trend_chart: "Biểu đồ xu hướng",
  system_setting_overdue_time: "Thiết lập thời gian quá hạn của hệ thống",
  overdue_order_number: "Số lượng đơn hàng quá hạn",
  overdue_data: "Ngày quá hạn",
  order_overdue_delivery_time: "Thời gian giao hàng quá hạn của đơn hàng",
  order_delivery_time: "Thời gian giao hàng của đơn hàng",
  Daily_cost_trend_chart: "Biểu đồ xu hướng chi phí hàng ngày",
  total_Daily_cost_trend_chart: "Biểu đồ xu hướng tổng chi phí hàng ngày",
  Total_cost: "Tổng chi phí",
  clientShipmentReport: "Báo cáo lượng hàng hóa giao của khách hàng",
  warehouseDailyReport: "Báo cáo hàng ngày của kho",
  dailyOrderAllocationReport: "Báo cáo phân phối hàng hóa hàng ngày",
  monthlyOrderAllocationReport: "Báo cáo phân phối hàng hóa hàng tháng",
  dailyOrderSortReport: "Báo cáo phân loại hàng hóa hàng ngày",
  monthlyOrderSortReport: "Báo cáo phân loại hàng hóa hàng tháng",
  dailyOrderDeliverReport: "Báo cáo giao hàng hàng ngày",
  monthlyOrderDeliverReport: "Báo cáo giao hàng hàng tháng",
  task_finish_number: "Số lượng nhiệm vụ hoàn thành",
  order_product_number: "Số lượng hàng hóa đặt hàng",
  total_time_spent: "Tổng thời gian tiêu tốn",
  order_count: "Số lượng đơn hàng",
  dailyLogisticsReturnReceiptReport: "Báo cáo hàng ngày về nhận hàng trả lại",
  dailyCustomerLogisticsReturnReceiptReport:
    "Báo cáo hàng ngày về nhận hàng trả lại của khách hàng",
  dailyCustomeReturnGoodsReceiptReport:
    "Báo cáo hàng trả lại của khách hàng hàng ngày",
  orderToBeReviewedOutOfStockReport:
    "Báo cáo hàng thiếu trong đơn hàng chờ duyệt",
  monthlyCustomeReturnGoodsReceiptReport:
    "Báo cáo hàng trả lại của khách hàng hàng tháng",
  customerShippedQuantityByWarehouse: "Số lượng hàng hóa khách hàng gửi (kho)",
  goodsSalesVolumeByTotalSku: "Số lượng hàng hóa bán ra (tổng SKU)",
  goodsSalesVolumeByWarehouse: "Số lượng hàng hóa bán ra (kho)",
  The_create_time_is_about_N_days: "Thời gian tạo gần N ngày",
  Quantity_out_of_stock: "Số lượng hàng thiếu",
  this_day: "Trong ngày",
  goodsOutOfStockReport: "Báo cáo hàng thiếu",
  out_of_stock_days: "Số ngày thiếu hàng",
  out_of_stock_date: "Ngày thiếu hàng",
  dailyConsumptionFlow: "Doanh thu hàng ngày",
  monthlyConsumptionFlow: "Doanh thu hàng tháng",
  warehouse_hourly_uncleared_orders: "Đơn hàng chưa xử lý mỗi giờ tại kho",
  responsible_person: "Người chịu trách nhiệm",
  total_unshipped_quantity: "Tổng số lượng chưa giao hàng",
  total_shipped_quantity: "Tổng số lượng đã giao hàng",
  ratio: "Tỷ lệ",
  warehouse_hourly_shipping: "Giao hàng mỗi giờ tại kho",
  total_order_quantity: "Tổng số lượng đơn hàng",
  outbound_count: "Số lượng xuất kho",
  orderTimelinessMonitoringTable: "Bảng theo dõi thời gian giao hàng",
  hourlyShippingReport: "Báo cáo giao hàng mỗi giờ",
  Packing_timeliness_rate: "Hiệu suất đóng gói",
  monthlyOrderVolumeInvestmentPromotionOfficerReport:
    "Báo cáo số lượng đơn hàng hàng tháng của nhân viên kinh doanh",
  monthlyOrderVolumeInvestmentPromotionDepartmentReport:
    "Báo cáo số lượng đơn hàng hàng tháng của bộ phận kinh doanh",
  monthlyOrderVolumeCustomerReport:
    "Báo cáo số lượng đơn hàng hàng tháng của khách hàng",
  monthlyOrderVolumeCountryReport:
    "Báo cáo số lượng đơn hàng hàng tháng của quốc gia",
  monthlyOrderVolumeWarehouseReport:
    "Báo cáo số lượng đơn hàng hàng tháng của kho",
  monthlyOrderVolumePlatformrReport:
    "Báo cáo số lượng đơn hàng hàng tháng của nền tảng",
  investment_Promotion_Officer: "Nhân viên kinh doanh",
  investment_Promotion_Department: "Bộ phận thu hút đầu tư",
  average_daily_order_volume: "Số lượng đơn hàng trung bình mỗi ngày",
  average_daily_proportion: "Tỷ lệ trung bình mỗi ngày",
  total_order_volume: "Tổng số lượng đơn hàng",
  total_order_volume_proportion: "Tỷ lệ tổng số lượng đơn hàng",
  number_of_newly_developed_customers: "Số lượng khách hàng mới",
  the_total_order_volume_of_newly_developed_customers:
    "Số lượng đơn hàng của khách hàng mới",
  the_proportion_of_new_customer_orders: "Tỷ lệ đơn hàng của khách hàng mới",
  only_100_order_numbers_are_supported_at_a_time:
    "Chỉ hỗ trợ 100 số đơn hàng mỗi lần",
  separated_by_newlines: "Dùng dấu ngắt dòng để phân tách",
  get_label: "Lấy nhãn",
  get_success: "Lấy thành công",
  printLabel: "In nhãn",
  dailyInventory: "Hàng tồn kho hàng ngày",
  record_date: "Ngày ghi chép",
  inventory_grounding_time: "Thời gian lên kệ hàng tồn kho",
  daily_inventory_list: "Danh sách hàng tồn kho hàng ngày",
  deliveryTime: "Thời gian xuất kho",
  lastUpdateTime: "Thời gian cập nhật",
  completeTime: "Thời gian hoàn thành",
  settleAccountsTime: "Thời gian thanh toán",
  stockId: "Kho",
  orderType: "Loại",
  orderId: "Số đơn hàng",
  trackingNo: "Số vận đơn",
  referenceNo: "Số tham chiếu",
  skuNum: "Số lượng SKU*",
  fileUrl: "Địa chỉ quay phim",
  video_storage_address: "Địa chỉ lưu trữ quay phim",
  filePhotoUrl: "Ảnh chụp xuất kho",
  createUserId: "Người xuất kho",
  starCreateTime: "Thời gian bắt đầu xuất kho",
  endCreateTime: "Thời gian kết thúc xuất kho",
  totalStorageSpace: "Tổng dung lượng lưu trữ",
  usedStorageSpace: "Dung lượng lưu trữ đã sử dụng",
  remainingStorageSpace: "Dung lượng lưu trữ còn lại",
  serverIP: "IP máy chủ",
  serverName: "Tên máy chủ",
  warehouseServerPort: "Cổng",
  storageFilePath: "Đường dẫn tệp lưu trữ",
  addStorageSpaceServersWarehouse: "Thêm dung lượng lưu trữ máy chủ trong kho",
  editStorageSpaceServersWarehouse:
    "Chỉnh sửa dung lượng lưu trữ máy chủ trong kho",
  please_select_warehouse: "Vui lòng chọn kho",
  please_select_serverIP: "Vui lòng chọn IP máy chủ",
  please_select_serverName: "Vui lòng nhập tên máy chủ",
  please_select_serverPort: "Vui lòng nhập cổng máy chủ",
  video_snapshot_information: "Thông tin ảnh chụp màn hình video",
  platformAuthorization: "Ủy quyền nền tảng",
  authorizedStoreList: "Cửa hàng được ủy quyền",
  this_data_has_no_outbound_time: "Dữ liệu này không có thời gian xuất kho",
  please_choose_again: "Vui lòng chọn lại",
  total_cloud_server_storage_video_access_path:
    "Đường dẫn truy cập video lưu trữ trên máy chủ đám mây tổng hợp",
  total_cloud_server_storage_image_access_path:
    "Đường dẫn truy cập hình ảnh lưu trữ trên máy chủ đám mây tổng hợp",
  total_cloud_server_storage_outbound_snapshot:
    "Ảnh chụp lưu trữ trên máy chủ đám mây tổng hợp",
  total_cloud_server_storage_video_address:
    "Địa chỉ lưu trữ video trên máy chủ đám mây tổng hợp",
  unpackRegisterReturnPackage: "Đăng ký vào khu vực nhận hàng",
  registerInClaimArea: "Đăng ký trả hàng sau khi mở gói hàng",
  Please_select_the_quick_registration_type: "Vui lòng chọn loại đăng ký nhanh",
  Change_storage_location: "Thay đổi vị trí kho",
  productId: "ID sản phẩm",
  Please_select_the_product_details_first: "Vui lòng chọn chi tiết sản phẩm",
  basket_listing: "Đặt vào giỏ hàng",
  Please_enter_the_basket_for_listing: "Vui lòng nhập giỏ hàng",
  locationId: "ID vị trí kho",
  automatic_return_listing: "Tự động đặt hàng trả lại",
  not_automatically_listed: "Không tự động đặt hàng",
  shelf_return_warehouse_location: "Tự động đưa hàng trả lại lên kệ",
  registerList: "Không tự động đưa lên kệ",
  Is_the_qualified_quantity_0_saved_to_the_rejection_stage:
    "Số lượng đạt chuẩn là 0, có lưu lại đến giai đoạn từ chối không?",
  Is_the_qualified_quantity_0_saved:
    "Số lượng đạt chuẩn là 0, có lưu lại không?",
  Please_upload_photo_of_the_package: "Vui lòng tải lên ảnh gói hàng",
  The_actual_data_of_the_product_must_be_all_greater_than_0:
    "Tất cả dữ liệu thực tế của hàng hóa phải lớn hơn 0",
  Please_enter_the_qualified_and_unqualified_quantity:
    "Vui lòng nhập tổng số lượng",
  Please_select_the_billing_attribute_for_the_product:
    "Vui lòng chọn thuộc tính tính phí hàng hóa",
  Please_complete_the_selection_of_warehouse_location_number_first:
    "Vui lòng hoàn thành việc chọn số vị trí kho trước",
  Multiple_products_please_select_multiple_SKU_types_and_location_numbers:
    "Nếu có nhiều hàng hóa, vui lòng chọn số vị trí kho loại SKU nhiều",
  Is_it_confirmed_that_there_is_a_difference_in_the_dimensions_of_the_three_sides_of_the_currently_inspected_product_compared_to_the_previous_inspected_product:
    "Kích thước ba cạnh của hàng hóa kiểm tra chất lượng hiện tại khác với kích thước ba cạnh của hàng hóa kiểm tra chất lượng trước đó, có xác nhận không?",
  Is_it_confirmed_that_there_is_a_difference_between_the_actual_weight_of_the_current_quality_inspection_product_and_the_actual_weight_of_the_previous_quality_inspection:
    "Trọng lượng thực tế của hàng hóa kiểm tra chất lượng hiện tại khác với trọng lượng thực tế của hàng hóa kiểm tra chất lượng trước đó, có xác nhận không?",
  The_qualified_quantity_cannot_exceed_the_total_quantity:
    "Số lượng hợp lệ không được lớn hơn tổng số lượng",
  The_current_storage_location_is_a_single_SKU_storage_location_which_has_been_selected_by_other_products:
    "Vị trí kho hiện tại là vị trí kho SKU đơn, đã được chọn bởi hàng hóa khác",
  batch_return_warehouse_relocation: "Chuyển kho hàng trả lại hàng loạt",
  automatically_print_the_inventory_transfer_list:
    "Tự động in danh sách chuyển kho",
  print_the_inventory_transfer_list: "In danh sách chuyển kho",
  view_SKU_transaction_history: "Xem dòng SKU",
  Inventory_transfer_task_ID: "ID nhiệm vụ chuyển kho",
  print_list: "In danh sách",
  commodity_income: "Thu nhập hàng hóa",
  refund_fee: "Chi phí hoàn tiền",
  shippingFee: "Chi phí vận chuyển",
  shippingIncomFee: "Thu nhập vận chuyển",
  discountFee: "Tổng chiết khấu",
  serviceFee: "Phí dịch vụ",
  commissionFee: "Hoa hồng",
  taxFee: "Thuế",
  advertisingFee: "Chi phí quảng cáo",
  paymentFee: "Phí thanh toán",
  warehousePackingFee: "Phí đóng gói kho",
  otherFee: "Thu chi khác",
  orderIncomeFee: "Thu nhập từ đơn hàng",
  platformName: "Tên nền tảng",
  FinancialRecognition: "Xác nhận tài chính",
  Pending_warehouse_transfer: "Chờ chuyển kho",
  To_be_received: "Chờ nhận",
  convertToWaitingForReception: "Chuyển sang chờ nhận",
  Please_enter_the_warehouse_location_number: "Vui lòng nhập số vị trí kho",
  Please_choose_to_add_SKU: "Vui lòng thêm SKU",
  returnInventoryQuantity: "Số lượng hàng trả lại",
  controlTime: "Thời gian kiểm soát",
  Transfer_of_warehouse_completed: "Đã chuyển kho",
  Revoked: "Đã hủy",
  The_current_warehouse_type_is_shelf_to_return_location_Please_select_a_new_warehouse:
    "Loại kho hiện tại là kho hàng lên kệ đến kho hàng trả lại, vui lòng chọn lại kho",
  recommended_shelf_location: "Kho được đề xuất",
  Is_the_measurement_size_correct: "Kiểm tra kích thước có chính xác không",
  Please_add_SKU: "Vui lòng thêm SKU",
  Currency_for_profit_calculation: "Đơn vị tiền tệ tính lợi nhuận",
  Order_delivery_time: "Thời gian xuất kho đơn hàng",
  Last_update_time: "Thời gian cập nhật cuối cùng",
  operatorUserId: "Người dùng thao tác",
  total_inventory_batch: "Tổng kho hiện tại",
  Please_select_the_recommended_storage_location_for_listing:
    "Vui lòng chọn kho được đề xuất",
  Please_select_the_data_that_needs_to_be_transferred_to_the_warehouse_first:
    "Vui lòng chọn dữ liệu cần chuyển kho trước",
  Import_inventory_list: "Nhập danh sách kho",
  Return_warehouse_location_Return_pending_review:
    "Kho trả hàng Trả hàng đang chờ phê duyệt",
  Inventory_transfer_task_removal_flow: "Nhiệm vụ chuyển kho Loại bỏ hàng",
  The_inventory_quantity_for_the_return_warehouse_relocation_cannot_be_0:
    "Số lượng hàng tồn kho chuyển kho của kho trả hàng không được bằng 0",
  The_current_return_order_is_marked_as_abandoned_by_the_customer_and_will_be_automatically_discarded_after_saving:
    "Hiện tại, đơn hàng trả hàng của khách hàng được đánh dấu là hủy bỏ, sau khi lưu sẽ tự động hủy bỏ",
  Final_order_placement_time: "Thời gian lấy đơn hàng cuối cùng",
  Last_updated_listing_time: "Thời gian cập nhật danh sách cuối cùng",
  Product_SKU: "SKU hàng hóa",
  sales_volumes: "Số lượng bán",
  Platform_settlement_amount: "Số tiền thanh toán trên nền tảng",
  Order_product_sales_revenue: "Doanh thu bán hàng của đơn hàng",
  Cost_of_goods: "Chi phí hàng hóa",
  merchandise_procurement_cost: "Chi phí mua hàng",
  First_leg_freight: "Phí vận chuyển đầu tiên",
  Platform_shipping_fee: "Phí vận chuyển trên nền tảng",
  Actual_shipping_cost: "Phí vận chuyển thực tế",
  The_buyer_pays_the_shipping_fee: "Người mua thanh toán phí vận chuyển",
  Platform_freight_subsidy: "Trợ cấp vận chuyển của nền tảng",
  Revenue_from_3PL_freight_refund: "Thu nhập hoàn trả vận chuyển 3PL",
  Platform_fees: "Phí nền tảng",
  Platform_commission: "Hoa hồng nền tảng",
  Alliance_commission: "Hoa hồng liên minh",
  Transaction_fee: "Phí giao dịch",
  Platform_activity_expenses: "Phí hoạt động nền tảng",
  Additional_plan_service_fee: "Phí dịch vụ kế hoạch bổ sung",
  threePL_insurance_premium: "Phí bảo hiểm 3PL",
  Seller_pays_cross_border_tax: "Người bán thanh toán thuế xuyên biên giới",
  Freight_service_tax_SST: "Thuế dịch vụ vận chuyển SST",
  Withholding_tax: "Thuế khấu trừ",
  Overseas_return_service_fee: "Phí dịch vụ trả hàng nước ngoài",
  Value_added_tax_VAT: "Thuế giá trị gia tăng (VAT)",
  Product_and_Service_Tax: "Thuế dịch vụ sản phẩm",
  Coupons_Discounts: "Phiếu giảm giá & chiết khấu",
  Seller_Coupons: "Phiếu giảm giá của người bán",
  Shopee_discount: "Giảm giá Shopee",
  Shopee_coin_deduction: "Khấu trừ bằng tiền Shopee",
  Shopee_discount_return: "Hoàn lại giảm giá Shopee",
  refund_amount: "Số tiền hoàn lại",
  Other_platform_expenses: "Các chi phí khác của nền tảng",
  place_an_order_time: "Thời gian đặt hàng",
  createTime: "Thời gian đặt hàng",
  Refund_product_amount: "Số tiền hoàn lại hàng hóa",
  updateTime: "Thời gian cập nhật",
  Original_price_of_the_product: "Giá gốc hàng hóa",
  merchandise_discount: "Giảm giá hàng hóa",
  Sellers_product_discount: "Giảm giá hàng hóa của người bán",
  Shopee_Coupons: "Phiếu giảm giá Shopee",
  Shopee_coin_exchange: "Đổi tiền Shopee",
  The_buyer_pays_the_transaction_fee: "Người mua thanh toán phí giao dịch",
  The_buyer_pays_the_total_amount: "Tổng số tiền người mua thanh toán",
  Estimated_shipping_cost: "Chi phí vận chuyển ước tính",
  The_seller_bears_the_shipping_cost: "Người bán chịu chi phí vận chuyển",
  Platform_compensation_amount: "Số tiền bồi thường của nền tảng",
  Service_fees_charged_for_participating_in_the_sellers_free_shipping_plan:
    "Phí dịch vụ thu khi tham gia chương trình miễn phí vận chuyển của người bán",
  Order_reverse_shipping_service_tax_shipping_service_tax:
    "Thuế dịch vụ vận chuyển ngược đơn hàng + thuế dịch vụ vận chuyển",
  SG_Goods_and_Services_Tax_MY_LVG_Goods_Ta:
    "Thuế hàng hóa và dịch vụ SG/Thuế hàng hóa MY LVG",
  Cross_border_goods_tax_logistics_clearance_service_fees_service_tax_on_low_value_goods_imported_from_Singapore_anti_dumping_duty_on_imported_goods:
    "Thuế hàng hóa xuyên biên giới + Phí dịch vụ thông quan của nhà vận chuyển + Thuế dịch vụ hàng hóa giá trị thấp nhập khẩu vào Singapore + Thuế chống bán phá giá hàng hóa nhập khẩu",
  The_amount_of_fees_charged_to_the_seller_for_failure_to_deliver_the_order:
    "Số tiền phí thu từ người bán do không giao được đơn hàng",
  Return_order_return_shipping_fee: "Phí vận chuyển trả lại hàng",
  refundShippingSubsidyFee: "Thu nhập từ bảo hiểm vận chuyển trả lại hàng",
  Compensation_provided_by_the_platform_for_lost_or_damaged_packages:
    "Bồi thường do nền tảng cung cấp do mất mát, hư hỏng bưu kiện",
  Import_of_MY_low_value_goods_subject_to_service_tax:
    "Thuế dịch vụ đối với hàng hóa giá trị thấp nhập khẩu vào MY",
  Profit_margin_Profit_Order_payment_for_product_amount_Financial_currency_exchange_rate:
    "Tỷ suất lợi nhuận = Lợi nhuận ÷ (Số tiền thanh toán hàng hóa trong đơn hàng × Tỷ giá hối đoái tiền tệ tài chính)",
  Charges_incurred_for_packages_requiring_signature_confirmation_services:
    "Chi phí phát sinh từ các gói hàng cần xác nhận bằng chữ ký",
  Profit_Order_paid_product_amount_Actual_shipping_fee_Buyer_paid_shipping_fee_Platform_shipping_subsidy_3PL_shipping_fee_refund_income_Commission_Alliance_commission_Transaction_fee_Service_fee_Platform_activity_fee_Additional_planned_service_fee_3PL_insurance_fee_Seller_paid_cross_border_tax_Shipping_service_tax_SST_Withholding_tax_Overseas_return_service_fee_Value_added_tax_VAT_Product_service_tax_Seller_discount_coupon_Shopee_discount_Shopee_gold_coin_deduction_Shopee_discount_refund_Refund_product_amount_Return_order_return_shipping_fee_Return_shipping_insurance_income_Platform_other_fees_Order_adjustment_amount_x_Financial_currency_exchange_rate_Product_procurement_cost_First_leg_shipping_fee_Warehouse_rental_Listing_fee_Order_processing_fee:
    "Lợi nhuận = (giá trị hàng hóa trong đơn hàng - chi phí vận chuyển thực tế + chi phí vận chuyển do người mua thanh toán + trợ cấp vận chuyển của nền tảng + thu nhập từ hoàn trả chi phí vận chuyển 3PL - hoa hồng - hoa hồng liên kết - phí giao dịch - phí dịch vụ - chi phí hoạt động nền tảng - phí dịch vụ chương trình bổ sung - phí bảo hiểm 3PL - thuế xuyên biên giới do người bán thanh toán - thuế dịch vụ vận chuyển SST - thuế thu nhập - Phí dịch vụ trả hàng ở nước ngoài - Thuế giá trị gia tăng (VAT) - Thuế dịch vụ sản phẩm - Phiếu giảm giá của người bán - Giảm giá Shopee - Trừ tiền vàng Shopee + Hoàn lại giảm giá Shopee - Số tiền hàng hóa được hoàn lại - Phí vận chuyển trả hàng + Thu nhập từ bảo hiểm vận chuyển trả hàng - Các chi phí khác của nền tảng + Số tiền điều chỉnh đơn hàng) × Tỷ giá hối đoái tài chính - (Chi phí mua hàng hóa + Phí vận chuyển đầu tiên + Tiền thuê kho + Phí lên kệ + Phí xử lý đơn hàng)",
  Profit_Order_payment_for_product_amount_Actual_Freight_Buyer_Paid_Freight_Platform_Freight_Subsidy_3PL_Freight_Return_Revenue_Commission_Alliance_Commission_Transaction_Fee_Service_Fee_Platform_Activity_Fee_Additional_Plan_Service_Fee_3PL_Insurance_Fee_Seller_Paid_Cross_border_Tax_Freight_Service_Tax_SST_Withholding_Tax_Overseas_Return_Service_Fee_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupon_Shopee_Discount_Shopee_Gold_Coin_Deduction_Shopee_Discount_Return_Refund_Product_Amount_Return_Order_Return_Freight_Return_Freight_Insurance_Income_Platform_Other_Fees_Financial_Currency_Exchange_Rate_Product_Procurement_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "Lợi nhuận = (Số tiền thanh toán hàng hóa trong đơn hàng - Chi phí vận chuyển thực tế + Chi phí vận chuyển do người mua thanh toán + Trợ cấp chi phí vận chuyển của nền tảng + Thu nhập hoàn lại chi phí vận chuyển 3PL - Hoa hồng - Hoa hồng liên kết - Phí giao dịch - Phí dịch vụ - Chi phí hoạt động nền tảng - Phí dịch vụ chương trình bổ sung - Phí bảo hiểm 3PL - Thuế xuyên biên giới do người bán thanh toán - Thuế dịch vụ vận chuyển SST - Thuế khấu trừ - Phí dịch vụ trả hàng quốc tế - Thuế giá trị gia tăng (VAT) - Thuế dịch vụ sản phẩm - Phiếu giảm giá của người bán - Giảm giá Shopee - Trừ tiền xu Shopee + Hoàn lại giảm giá Shopee - Số tiền hàng hóa được hoàn lại - Phí vận chuyển trả hàng + Thu nhập từ bảo hiểm vận chuyển trả hàng - Các chi phí khác của nền tảng) × Tỷ giá hối đoái tiền tệ tài chính - (Chi phí mua hàng + Phí vận chuyển đầu tiên + Phí kho bãi + Phí lên kệ + Phí xử lý đơn hàng)",
  Profit_Order_payment_for_product_amount_actual_shipping_cost_buyer_paid_shipping_cost_platform_shipping_subsidy_seller_bears_shipping_cost_seller_discount_coupon_gold_coin_deduction_platform_discount_subsidy_commission_product_service_tax_platform_activity_fee_installment_payment_handling_fee_advertising_fee_payment_handling_fee_platform_compensation_amount_platform_other_fees_refunded_product_amount_return_order_return_shipping_cost_Exchange_rate_product_procurement_cost_first_leg_shipping_cost_warehouse_rental_shelving_fee_order_processing_fee:
    "Lợi nhuận = (Giá trị hàng hóa thanh toán trong đơn hàng - Phí vận chuyển thực tế + Phí vận chuyển do người mua thanh toán + Trợ cấp phí vận chuyển của nền tảng - Phí vận chuyển do người bán chịu - Phiếu giảm giá của người bán - Trừ tiền vàng + Trợ cấp ưu đãi của nền tảng - Hoa hồng - Thuế dịch vụ sản phẩm - Phí hoạt động nền tảng - Phí thanh toán trả góp - Chi phí quảng cáo - Phí thanh toán + Số tiền bồi thường của nền tảng + Các chi phí khác của nền tảng - Số tiền hoàn lại hàng hóa - Phí vận chuyển trả hàng) *Tỷ giá hối đoái - (Chi phí mua hàng + Chi phí vận chuyển đầu tiên + Chi phí thuê kho + Chi phí lên kệ + Chi phí xử lý đơn hàng)",
  Profit_Discounted_product_subtotal_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Coupon_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Commission_Exchange_Rate_Product_Purchase_Cost_First_leg_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "Lợi nhuận = (Tổng giá trị hàng hóa sau khi giảm giá - Tiền hoàn lại - Chi phí vận chuyển thực tế + Chi phí vận chuyển do người bán thanh toán + Trợ cấp chi phí vận chuyển của nền tảng - Chi phí vận chuyển đổi hàng - Chiết khấu chi phí vận chuyển của người bán - Hoa hồng TSP - Hoa hồng nền tảng - Hoa hồng liên minh - Chi phí giao dịch - Phí dịch vụ SFP - Phí dịch vụ - Phí dịch vụ chương trình bổ sung - Phí bảo hiểm logistics - Thuế dịch vụ vận chuyển SST - Thuế giá trị gia tăng (VAT) - Thuế dịch vụ sản phẩm - Phiếu giảm giá của người bán - Phí vận chuyển đơn hàng trả lại - Các chi phí khác của nền tảng - Phí thanh toán thẻ tín dụng + Số tiền điều chỉnh của nền tảng - Đóng góp sinh thái - Phí xử lý) * Tỷ giá hối đoái - (Chi phí mua hàng + Phí vận chuyển đầu tiên + Phí kho + Phí lên kệ + Phí xử lý đơn hàng)",
  storeCurrency: "Đơn vị tiền tệ của cửa hàng",
  escrowCurrency: "Đơn vị tiền tệ tài chính",
  exchangeRate: "Tỷ giá hối đoái đơn vị tiền tệ tài chính",
  income_expenditure_information: "Thông tin thu chi",
  expense_item: "Mục chi phí",
  revenue_expenditure: "Thu chi",
  Take_the_actual_bill_and_the_buyer_pays_the_shipping_fee:
    "Lấy hóa đơn thực tế Người mua thanh toán phí vận chuyển",
  percent: "Tỷ lệ",
  Order_payment_for_product_amoun: "Số tiền thanh toán hàng hóa trong đơn hàng",
  The_last_update_time_of_profit_and_expense_data_automatically_updated_when_platform_orders_change_or_settle:
    "Thời gian cập nhật dữ liệu chi phí lợi nhuận lần cuối, tự động cập nhật khi có thay đổi đơn hàng trên nền tảng hoặc khi thanh toán",
  Take_the_settlement_time_of_the_order_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_When_the_settlement_time_is_empty_it_means_that_the_platform_has_not_ended_yet:
    "Lấy thời gian thanh toán đơn hàng, thời gian thanh toán đơn hàng không phải trên nền tảng lấy thời gian chuyển đơn hàng sang trạng thái [Hoàn thành], thời gian thanh toán trống nghĩa là nền tảng chưa kết thúc",
  Take_the_final_settlement_time_of_the_order_Payment_Period_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:
    "Lấy thời gian thanh toán cuối cùng của đơn hàng (Thời gian thanh toán), thời gian thanh toán của đơn hàng không thuộc nền tảng lấy thời gian chuyển đơn hàng sang trạng thái [Hoàn thành], thời gian thanh toán trống có nghĩa là nền tảng chưa kết thúc",
  Take_the_final_settlement_date_of_the_order_Settlement_Date_and_for_non_platform_orders_take_the_time_when_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_empty_it_means_the_platform_has_not_ended_yet:
    "Lấy thời gian thanh toán cuối cùng của đơn hàng (Ngày thanh toán), thời gian thanh toán của đơn hàng không thuộc nền tảng lấy thời gian chuyển đơn hàng sang trạng thái [Hoàn thành], thời gian thanh toán trống có nghĩa là nền tảng chưa kết thúc",
  The_system_calculates_the_estimated_settlement_amount_of_the_order_based_on_the_income_of_the_order_platform_fees_minus_the_expenditure_of_the_order_platform_fees_Please_compare_and_verify_it_with_the_settlement_amount_of_the_platform:
    "Hệ thống tính toán số tiền thanh toán dự kiến của đơn hàng dựa trên thu nhập từ phí nền tảng đơn hàng - chi phí nền tảng đơn hàng, vui lòng đối chiếu và xác minh với số tiền thanh toán của nền tảng.",
  Estimated_settlement_amount: "Số tiền thanh toán dự kiến",
  The_order_payment_completion_time_the_time_when_the_funds_have_been_transferred_is_recorded_For_non_platform_orders_the_settlement_time_is_determined_by_the_moment_the_order_is_moved_to_the_Completed_status_If_the_settlement_time_is_blank_it_indicates_that_the_platform_has_not_finalized_the_order:
    "Thời gian hoàn thành thanh toán đơn hàng (tiền đã được chuyển khoản), thời gian thanh toán cho các đơn hàng không thuộc nền tảng là thời điểm đơn hàng chuyển sang trạng thái [Hoàn thành], nếu thời gian thanh toán trống nghĩa là nền tảng chưa kết thúc.",
  The_time_when_the_platform_status_of_the_order_changes_to_Competed_Cancelled:
    "Thời gian trạng thái đơn hàng trên nền tảng chuyển sang Competed/Cancelled.",
  Retrieve_the_system_order_outbound_time:
    "Lấy thời gian xuất kho đơn hàng hệ thống.",
  Seller_bears_the_shipping_cost_actual_shipping_cost_buyer_pays_the_shipping_cost_platform_shipping_subsidy_3PL_shipping_cost_refund_income_not_included_in_order_profit_calculation_for_operational_analysis_reference_only:
    "Phí vận chuyển do người bán chịu = phí vận chuyển thực tế - phí vận chuyển do người mua thanh toán - trợ cấp phí vận chuyển nền tảng - thu nhập hoàn trả phí vận chuyển 3PL (không tham gia tính toán lợi nhuận đơn hàng, chỉ dùng để tham khảo phân tích hoạt động).",
  time_filtering: "Lọc thời gian.",
  Exchange_rate_setting_System_settings_Currency_exchange_rate_Currency_exchange_rate_list:
    "Cài đặt tỷ giá hối đoái: Cài đặt hệ thống -- Tỷ giá hối đoái tiền tệ -- Danh sách tỷ giá hối đoái tiền tệ;",
  The_system_converts_the_original_currency_of_the_store_into_the_financial_currency_for_profit_based_on_the_exchange_rate:
    "Hệ thống sẽ chuyển đổi tiền tệ gốc của cửa hàng thành tiền tệ tài chính lợi nhuận theo tỷ giá hối đoái;",
  When_the_currency_exchange_rate_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:
    "Khi chưa cài đặt tỷ giá hối đoái tiền tệ, hệ thống sẽ không thực hiện đồng bộ hóa dữ liệu, sau khi cài đặt, dữ liệu sẽ được đồng bộ hóa sau 24 giờ cùng ngày.",
  deduction_currency_value_system_settings_Currency_exchange_rate_Exchange_rates_in_the_currency_exchange_rate_list_Record_the_exchange_rate_when_obtaining_the_order_revenue_and_expenditure_for_the_first_time_and_do_not_update_the_exchange_rate_value_in_the_profit_afterwards_When_the_currency_exchange_rate_is_not_set_it_defaults_to_0_When_the_exchange_rate_value_can_be_obtained_in_subsequent_automatic_updates_it_will_be_updated:
    "Đơn vị tiền tệ của cửa hàng chuyển đổi thành đơn vị tiền tệ tài chính, lấy giá trị từ Cài đặt hệ thống ➡ Tỷ giá hối đoái ➡ Tỷ giá hối đoái trong danh sách tỷ giá hối đoái, khi lần đầu tiên nhận được thu nhập và chi tiêu của đơn hàng, ghi lại tỷ giá hối đoái, sau đó không cập nhật giá trị tỷ giá hối đoái trong lợi nhuận, khi chưa thiết lập tỷ giá hối đoái, mặc định tính 0, sau đó tự động cập nhật khi có thể lấy được giá trị tỷ giá hối đoái",
  Please_set_the_conversion_exchange_rate_between_the_relevant_store_currency_and_the_financial_deduction_currency_which_will_be_used_for_calculating_order_profit_report_data:
    "Vui lòng thiết lập tỷ giá chuyển đổi tiền tệ cửa hàng và tiền tệ khấu trừ tài chính, sẽ được sử dụng để tính toán dữ liệu báo cáo lợi nhuận đơn hàng.",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only:
    "Không tham gia tính toán lợi nhuận đơn hàng, chỉ dùng để tham khảo phân tích hoạt động.",
  The_actual_settlement_amount_on_the_platform_is_not_included_in_the_calculation_of_order_profits_and_is_only_for_operational_analysis_reference:
    "Số tiền thanh toán thực tế của nền tảng, không tham gia tính toán lợi nhuận đơn hàng, chỉ dùng để tham khảo phân tích hoạt động.",
  The_procedures_for_sellers_to_participate_in_the_PayLater_program_and_receive_fees:
    "Phí thủ tục mà người bán tham gia chương trình PayLater phải trả.",
  Freight_subsidies_and_rewards_provided_by_the_platform_Freight_subsidies_provided_by_the_platform_for_sellers_to_ship_Delivery_rewards_obtained_by_sellers_signing_a_joint_sponsorship_free_delivery_plan:
    "Khoản trợ cấp và phần thưởng vận chuyển do nền tảng cung cấp + khoản trợ cấp vận chuyển do nền tảng cung cấp cho người bán khi giao hàng + phần thưởng giao hàng mà người bán nhận được khi ký kết chương trình đồng tài trợ giao hàng miễn phí.",
  billID: "ID hóa đơn",
  Deduct_a_20_refund_management_fee_from_the_total_amount_of_returned_items:
    "Phí quản lý hoàn tiền 20% được trừ từ tổng số tiền hoàn trả hàng trả lại.",
  Service_fees_charged_for_participating_in_on_site_special_programs_service_fees_charged_for_participating_in_bonus_rebates_service_fees_charged_for_using_Tiktok_Mall_servers_charged_for_participating_in_coupon_plans_service_fees_charged_for_participating_in_limited_time_rush_purchase_service_fees_charged_for_promotional_activities_service_fees_charged_for_pre_purchase_plans:
    "Phí dịch vụ thu khi tham gia chương trình đặc biệt tại chỗ + Phí dịch vụ thu khi tham gia chương trình hoàn tiền thưởng + Phí dịch vụ thu khi sử dụng TikTok Mall + Phí dịch vụ thu khi tham gia chương trình phiếu giảm giá + Phí dịch vụ thu khi tham gia chương trình mua hàng giới hạn thời gian + Phí dịch vụ thu khi tham gia chương trình khuyến mãi + Phí dịch vụ thu khi tham gia chương trình đặt hàng trước",
  difference_amount: "Số tiền chênh lệch",
  bill_type: "Loại hóa đơn",
  recalculateTime: "Thời gian tính lại hóa đơn",
  Please_fill_in_the_task_number_first: "Vui lòng điền số nhiệm vụ trước",
  Payment_time: "Thời gian xuất hóa đơn",
  part_number: "Số hóa đơn",
  The_commission_paid_by_the_seller_to_the_creator_alliance_advertising_commission_commission_purchased_through_partner_links_eligible_advertising_order_commission:
    "Hoa hồng mà người bán trả cho người sáng tạo + hoa hồng quảng cáo liên kết + hoa hồng mua hàng qua liên kết đối tác + hoa hồng đơn hàng quảng cáo đủ điều kiện",
  Please_enter_SKU_line_break_or_comma_separated:
    "Vui lòng nhập SKU, cách nhau bằng dấu xuống dòng hoặc dấu phẩy",
  Recalculate_warehouse_rental_fees: "Tính lại phí kho",
  Recalculate_manual_outbound_fees: "Tính lại phí xuất kho thủ công",
  Recalculate_manual_warehousing_fees: "Tính lại phí nhập kho thủ công",
  Recalculate_the_return_item_listing_fee: "Tính lại phí trả hàng lên kệ",
  Recalculate_storage_fees: "Tính lại phí nhập kho",
  Recalculate_storage_order_operation_fees:
    "Tính lại phí vận hành đơn hàng kho",
  Please_select_the_delivery_time: "Vui lòng chọn thời gian xuất kho",
  Copy_the_expense_settings_to_the_specified_warehouse:
    "Sao chép cài đặt phí vào kho chỉ định",
  Specify_the_customer: "Khách hàng chỉ định",
  Customers_who_need_to_be_copied: "Khách hàng cần sao chép",
  If_you_do_not_select_it_it_means_that_all_customers_are_selected:
    "Nếu không chọn, có nghĩa là chọn tất cả khách hàng",
  Exclude_customers: "Loại trừ khách hàng",
  Excluded_customers: "Khách hàng bị loại trừ",
  Specify_the_warehouse: "Kho chỉ định",
  The_warehouse_that_was_copied: "Kho được sao chép",
  Template_warehouse: "Kho mẫu",
  Specify_the_warehouse_from_which_the_data_originated:
    "Kho chỉ định nguồn dữ liệu",
  If_it_is_empty_it_is_equivalent_to_the_specified_warehouse:
    "Nếu trống, thì tương đương với kho chỉ định",
  Template_customers: "Khách hàng mẫu",
  Generate_the_header_fee_settings_according_to_the_specified_template:
    "Tạo cài đặt phí vận chuyển theo mẫu chỉ định",
  The_type_of_expense: "Loại phí",
  Order_Processing_Fees: "Phí xử lý đơn hàng",
  Warehouse_rental_fee: "Phí thuê kho",
  Labelling_fee: "Phí dán nhãn",
  Head_fee: "Phí vận chuyển",
  Packaging_material_fee: "Phí bao bì",
  Please_select_a_specified_warehouse: "Vui lòng chọn kho chỉ định",
  Configure_at_least_one_item: "Vui lòng cấu hình ít nhất một mục",
  Adjust_the_price_of_the_first_leg_in_batches:
    "Điều chỉnh giá vận chuyển hàng loạt",
  Freight_costs: "Chi phí vận chuyển",
  OverRange_shipping_rates: "Phí vận chuyển vượt quá phạm vi",
  On_the_basis_of_the_original_treatment_the_positive_number_increases_the_price_and_the_negative_number_decreases_the_price:
    "Xử lý trên cơ sở ban đầu, số dương tăng giá, số âm giảm giá",
  Copy_additional_service_fees: "Sao chép chi phí dịch vụ gia tăng",
  Specify_the_customer_from_which_the_data_originated:
    "Khách hàng nguồn dữ liệu chỉ định",
  Please_select_a_module_type: "Vui lòng chọn loại mô-đun",
  copy_approval_template: "Sao chép mẫu phê duyệt",
  copy_template: "Sao chép mẫu",
  replace_approver: "Thay thế người phê duyệt",
  Original_approver: "Người phê duyệt ban đầu",
  Approver: "Người phê duyệt",
  Please_select_the_module_type_first: "Vui lòng chọn loại mô-đun trước",
  Please_select_the_task_stage: "Vui lòng chọn giai đoạn nhiệm vụ",
  Please_select_the_valueAdded_type: "Vui lòng chọn loại gia tăng",
  Please_select_a_template_customer: "Vui lòng chọn khách hàng mẫu",
  Please_select_a_template_warehouse: "Vui lòng chọn kho mẫu",
  modify_information: "Sửa đổi thông tin",
  receiving_SMS_number: "Số nhận tin nhắn",
  early_warning_balance: "Cảnh báo số dư",
  whether_to_receive_SMS_messages: "Có nhận tin nhắn hay không",
  Not_less_than_zero: "Không được nhỏ hơn 0",
  wechat_binding_status: "Trạng thái liên kết WeChat",
  get_qrcode: "Lấy mã QR",
  untie: "Hủy liên kết",
  refresh_binding_status: "Làm mới trạng thái liên kết",
  bound: "Đã liên kết",
  not_yet_bound: "Chưa liên kết",
  whether_to_untie: "Có hủy liên kết không",
  officialAccountPushLogs: "Danh sách nhật ký đẩy công khai",
  The_type_of_message: "Loại tin nhắn",
  Push_status: "Trạng thái đẩy",
  Push_customers: "Khách hàng đẩy",
  Push_content: "Nội dung đẩy",
  Push_time: "Thời gian đẩy",
  Push_the_OpenID: "OpenID đẩy",
  creator: "Người tạo",
  The_push_succeeded: "Đẩy thành công",
  Push_failed: "Đẩy thất bại",
  Please_enter_a_name_for_the_subAccount: "Vui lòng nhập tên tài khoản phụ",
  Please_enter_your_mobile_phone_number: "Vui lòng nhập số điện thoại di động",
  Please_select_a_role: "Vui lòng chọn vai trò",
  Please_select_Enable_status: "Vui lòng chọn trạng thái kích hoạt",
  role: "Vai trò",
  roleGrade: "Cấp độ vai trò",
  Enabled_status: "Trạng thái kích hoạt",
  The_name_of_the_subAccount: "Tên tài khoản phụ",
  Mobile_phone_number: "Số điện thoại di động",
  mailbox: "Email",
  Confirm_your_password: "Xác nhận mật khẩu",
  The_warehouse_to_which_it_belongs: "Kho thuộc về",
  Transit_warehouses: "Kho trung chuyển",
  Select_all: "Chọn tất cả",
  operate: "Thao tác",
  Delete: "Xóa",
  Please_enter_your_password: "Vui lòng nhập mật khẩu",
  Please_enter_your_password_correctly_first:
    "Vui lòng nhập mật khẩu chính xác",
  Please_enter_your_confirmation_password: "Vui lòng nhập mật khẩu xác nhận",
  The_password_entered_twice_is_inconsistent:
    "Hai mật khẩu nhập không khớp nhau",
  This_is_used_to_restrict_the_account_to_only_be_able_to_select_the_next_lower_role_level_when_creating_or_modifying_employee_accounts_during_operations_based_on_the_current_account_is_role_level:
    "Được sử dụng để giới hạn tài khoản khi tạo/sửa đổi tài khoản nhân viên, chỉ có thể chọn vai trò cấp dưới của vai trò cấp hiện tại của tài khoản",
  Modify_the_quality_inspection_quantity:
    "Sửa đổi số lượng kiểm tra chất lượng",
  When_there_is_a_labeled_quantity_prioritize_the_fee_deduction_and_the_refund_of_the_labeling_fee_to_avoid_double_deductions:
    "Khi có số lượng nhãn đã dán, vui lòng xử lý trước việc khấu trừ chi phí và hoàn trả chi phí dán nhãn để tránh trừ phí nhiều lần",
  Please_enter_your_inquiry: "Vui lòng nhập nội dung truy vấn",
  Please_select_the_level_3_data_you_want_to_modify:
    "Vui lòng chọn dữ liệu cấp ba cần sửa đổi",
  Select_the_data_in_the_same_task:
    "Vui lòng chọn dữ liệu trong cùng một nhiệm vụ",
  The_number_of_quality_inspections_cannot_be_greater_than_the_number_of_appointments:
    "Số lượng kiểm tra chất lượng không được lớn hơn số lượng đặt trước",
  The_number_of_labels_cannot_be_greater_than_the_qualified_quantity:
    "Số lượng dán nhãn không được lớn hơn số lượng đạt tiêu chuẩn",
  There_is_a_labeled_quantity: "Có số lượng đã dán nhãn",
  Whether_to_continue: "Có tiếp tục không",
  The_operation_was_canceled: "Đã hủy thao tác",
  Please_check_the_secondary_data: "Vui lòng chọn dữ liệu cấp hai",
  Please_check_the_boxes_under_the_same_shipping_list:
    "Vui lòng chọn các thùng trong cùng một phiếu nhập kho",
  Please_select_the_products_in_the_same_task:
    "Vui lòng chọn các sản phẩm trong cùng một nhiệm vụ",
  Please_check_only_one_task: "Vui lòng chỉ chọn một nhiệm vụ",
  Please_tick_the_box: "Vui lòng chọn",
  Please_check_only_one_inbound_order: "Vui lòng chỉ chọn một phiếu nhập kho",
  Please_check_the_Inbound_List_or_Inbound_List_box:
    "Vui lòng chọn phiếu nhập kho hoặc thùng hàng trong phiếu nhập kho",
  operation_cancelled: "Đã hủy thao tác",
  Complete_quality_inspection_in_batches:
    "Hoàn thành kiểm tra chất lượng hàng loạt",
  The_quantity_to_be_inspected: "Số lượng chờ kiểm tra chất lượng",
  The_quantity_has_been_inspected: "Số lượng đã kiểm tra chất lượng",
  sku: "sku",
  inspected_quantity: "Số lượng đã kiểm tra chất lượng",
  labelled_quantity: "Số lượng đã dán nhãn",
  actual_length_cm: "Chiều dài thực tế (CM)",
  actual_width_cm: "Chiều rộng thực tế (CM)",
  actual_height_cm: "Chiều cao thực tế (CM)",
  actual_weight_kg: "Trọng lượng thực tế (KG)",
  commodity_billing_attribute: "Thuộc tính tính phí hàng hóa",
  Confirm_quality_inspection_information:
    "Xác nhận thông tin kiểm tra chất lượng",
  No_need_for_confirmation: "Không cần xác nhận",
  to_be_confirmed: "Chờ xác nhận",
  acknowledged: "Đã xác nhận",
  Quality_inspection_information_status:
    "Trạng thái thông tin kiểm tra chất lượng",
  Confirm_the_actual_weight_length_width_height_and_whether_the_billing_attributes_of_the_goods_are_correct:
    "Xác nhận trọng lượng thực tế, chiều dài, chiều rộng, chiều cao, thuộc tính tính phí hàng hóa có chính xác không",
  Please_verify_the_actual_weight_dimensions_length_width_height_and_the_billing_attributes_of_the_goods_to_prevent_any_abnormal_deductions_of_fees:
    "Vui lòng xác nhận trọng lượng thực tế, chiều dài, chiều rộng, chiều cao, thuộc tính tính phí hàng hóa có chính xác không để tránh bị trừ phí bất thường",
  Please_input_inspection_quantity:
    "Vui lòng nhập số lượng kiểm tra chất lượng",
  please_input_unqualified_quantity:
    "Vui lòng nhập số lượng không đạt tiêu chuẩn",
  please_input_labeled_quantity: "Vui lòng nhập số lượng dán nhãn",
  please_input_positive_number: "Vui lòng nhập số dương",
  please_input_qualified_quantity: "Vui lòng nhập số lượng đạt tiêu chuẩn",
  please_select_is_there_a_mark: "Vui lòng chọn có nhãn hay không",
  please_input_actual_length: "Vui lòng nhập chiều dài thực tế",
  please_input_actual_width: "Vui lòng nhập chiều rộng thực tế",
  please_input_actual_height: "Vui lòng nhập chiều cao thực tế",
  please_input_actual_weight: "Vui lòng nhập trọng lượng thực tế",
  please_select_commodity_billing_attribute:
    "Vui lòng chọn thuộc tính tính phí hàng hóa",
  please_input_quantity: "Vui lòng nhập số lượng",
  appointment_quantity: "Số lượng đặt trước",
  whether_to_go_to_configure_warehouse_inbound_task_control_settings:
    "Có muốn đến kho để nhận nhiệm vụ kiểm soát cài đặt không?",
  please_check: "Vui lòng đánh dấu",
  inspection_quantity_cannot_exceed_reserved_quantity:
    "Số lượng kiểm tra chất lượng không được lớn hơn số lượng đặt trước",
  labeled_quantity_cannot_exceed_qualified_quantity:
    "Số lượng dán nhãn không được lớn hơn số lượng đạt tiêu chuẩn",
  box_number: "Số thùng",
  special_commodity_confirm: "Hàng hóa đặc biệt, có xác nhận không?",
  box_number_error_please_reenter: "Số thùng sai, vui lòng nhập lại",
  please_input_box_number: "Vui lòng nhập số thùng",
  please_input_goods_code: "Vui lòng nhập mã vạch hàng hóa",
  current_box_number_no_goods_code:
    "Số thùng hiện tại không tồn tại mã vạch hàng hóa này",
  duplicate_sku_box_number: "Xuất hiện số SKU trùng lặp",
  operation_successful: "Hoạt động thành công",
  product_entry_number: "Số đơn hàng nhập kho",
  product: "Sản phẩm",
  has_labeled_quantity_continue: "Có số lượng đã dán nhãn, có tiếp tục không?",
  please_input_real_length: "Vui lòng nhập chiều dài thực tế",
  please_input_real_width: "Vui lòng nhập chiều rộng thực tế",
  please_input_real_height: "Vui lòng nhập chiều cao thực tế",
  please_input_real_weight: "Vui lòng nhập trọng lượng thực tế",
  real_length_cm: "Chiều dài thực tế (CM)",
  real_width_cm: "Chiều rộng thực tế (CM)",
  real_height_cm: "Chiều cao thực tế (CM)",
  real_weight_kg: "Trọng lượng thực tế (KG)",
  commodity_chinese_name: "Tên tiếng Trung",
  commodity_english_name: "Tên tiếng Anh",
  labeled_quantity: "Số lượng đã dán nhãn",
  this_time_labeled_quantity: "Số lượng dán nhãn lần này",
  There_is_an_incorrect_location_number: "Số kho có lỗi",
  Please_fill_it_out: "Vui lòng điền",
  shelved_quantity: "Số lượng đã lên kệ",
  recommended_storage_location_number: "Số kho đề xuất",
  reserved_commodity_quantity: "Số lượng hàng đặt trước",
  Task_time: "Thời gian nhiệm vụ",
  set_priority_quality_inspection: "Cài đặt kiểm tra chất lượng ưu tiên",
  pause_task: "Tạm dừng nhiệm vụ",
  activate_task: "Kích hoạt nhiệm vụ",
  modify_quality_inspection_num: "Sửa đổi số lượng kiểm tra chất lượng",
  to_be_generated: "Đang tạo",
  uncompleted: "Chưa hoàn thành",
  paused: "Đã tạm dừng",
  Rebinding_task: "Thay đổi nhiệm vụ",
  Mandate_Holder: "Người thực hiện nhiệm vụ",
  task_id: "ID nhiệm vụ",
  customer_id: "ID khách hàng",
  task_executor: "Người thực hiện nhiệm vụ",
  task_quality_inspection_start_time:
    "Thời gian bắt đầu kiểm tra chất lượng nhiệm vụ",
  task_quality_inspection_end_time:
    "Thời gian kết thúc kiểm tra chất lượng nhiệm vụ",
  total_reserved_quantity: "Tổng số lượng đặt trước",
  total_qualified_quantity: "Tổng số lượng đạt yêu cầu",
  total_unqualified_quantity: "Tổng số lượng không đạt yêu cầu",
  is_task_paused: "Có tạm dừng nhiệm vụ không",
  is_priority_quality_inspection: "Có ưu tiên kiểm tra chất lượng không",
  Rebinding: "Thay đổi ràng buộc",
  is_excess_quality_inspection_task:
    "Có phải là nhiệm vụ kiểm tra chất lượng vượt quá không",
  reserved_quantity: "Số lượng đặt hàng",
  excess_quantity: "Số lượng phát hành quá nhiều",
  lack_send_quantity: "Số lượng phát hành quá ít",
  breakage_quantity: "Số lượng hư hỏng",
  is_wrongly_sent_sku: "Có phải là SKU phát hành sai không",
  Please_select_the_assignee: "Vui lòng chọn người thực hiện nhiệm vụ",
  original_qualified_quantity: "Số lượng đạt yêu cầu ban đầu",
  original_labeled_quantity: "Số lượng dán nhãn ban đầu",
  original_lack_send_quantity: "Số lượng phát hành quá ít ban đầu",
  original_breakage_quantity: "Số lượng hư hỏng ban đầu",
  please_select: "Vui lòng chọn",
  confirm_operation: "Xác nhận thao tác?",
  prompt: "Lưu ý",
  cancel: "Hủy",
  set_priority_shelves: "Đặt ưu tiên lên kệ",
  total_shelved_quantity: "Tổng số lượng lên kệ",
  is_priority_shelves: "Có ưu tiên lên kệ không",
  batch_complete_shelves: "Hoàn thành lên kệ hàng loạt",
  shelves_layer: "Số tầng kệ",
  shelves_column: "Số hàng kệ",
  shelves_cube: "Dung lượng",
  Mark_the_number_of_anomalies: "Đánh dấu số lượng bất thường",
  Please_enter_a_valid_number: "Vui lòng nhập số hợp lệ",
  Please_enter_an_integer_greater_than_0: "Vui lòng nhập số nguyên lớn hơn 0",
  The_current_row_data_is_abnormal_The_qualified_quantity_cannot_be_less_than_the_quantity_that_has_been_put_on_the_shelves:
    "Dữ liệu hàng hiện tại bất thường, số lượng đạt chuẩn không thể nhỏ hơn số lượng đã lên kệ",
  The_abnormal_quantity_cannot_exceed: "Số lượng bất thường không thể lớn hơn",
  Exchange_shipping_fee: "Phí vận chuyển đổi hàng",
  Seller_shipping_discount: "Ưu đãi phí vận chuyển của người bán",
  TSP_commission: "Hoa hồng TSP",
  Transportation_insurance_premium: "Phí bảo hiểm vận chuyển",
  Credit_card_payment_processing_fee: "Phí thanh toán thẻ tín dụng",
  SFP_service_fee: "Phí dịch vụ SFP",
  Ecological_donation: "Đóng góp sinh thái",
  Transportation_Service_Tax_SST: "Thuế dịch vụ vận chuyển SST",
  Platform_adjustment_amount: "Số tiền điều chỉnh nền tảng",
  TikTok_Coupons: "Phiếu giảm giá TikTok",
  TikTok_product_discounts: "Giảm giá sản phẩm TikTok",
  Add_multiple_SKU: "Thêm SKU gửi nhiều lần",
  Add_wrongly_sent_SKU: "Thêm SKU gửi nhầm",
  preview_file: "Xem trước tệp",
  all_file_number: "Tổng số tệp",
  can_preview_file_number: "Số tệp có thể xem trước",
  can_not_preview_file_number: "Số tệp không thể xem trước",
  current_preview_file: "Tệp đang xem trước",
  download_all: "Tải xuống tất cả",
  download_file: "Tải xuống tệp",
  upload_file: "Tải lên tệp",
  add_type_of_value_added_expense: "Thêm loại phí gia tăng",
  type_of_value_added: "Loại gia tăng",
  revocation_time: "Thời gian hủy",
  can_preview: "Có thể xem trước",
  can_not_preview: "Không thể xem trước",
  task_phase: "Giai đoạn nhiệm vụ",
  customer_file: "Tệp khách hàng",
  view_file: "Xem tệp",
  warehouse_file: "Tệp kho",
  a: "Cái",
  freight: "Phí vận chuyển",
  special_expense: "Phí đặc biệt",
  revocation_operator: "Người hủy",
  accomplish_operator: "Người hoàn thành",
  confirm_audit: "Xác nhận kiểm duyệt",
  return_to_be_audit: "Trả lại để kiểm duyệt",
  filename: "Tên tệp",
  value_added_task_id: "ID nhiệm vụ giá trị gia tăng",
  whether_to_submit: "Có gửi hay không",
  cancelled_operation: "Đã hủy thao tác",
  transfer_inventory_customer: "Chuyển kho khách hàng",
  whether_to_audit: "Có kiểm duyệt hay không",
  whether_to_return_to_be_audit: "Có trả lại để kiểm duyệt hay không",
  only_can_upload: "Chỉ có thể tải lên",
  file_and_not_more_than_300_MB: "tệp, không quá 300MB",
  add_expense_item: "Thêm mục phí",
  add_settings_of_value_added_expense: "Thêm cài đặt phí giá trị gia tăng",
  default_expense: "Phí mặc định",
  valueAddedServiceTask: "Nhiệm vụ dịch vụ giá trị gia tăng",
  operateValueAddedServiceTask: "Thao tác nhiệm vụ dịch vụ giá trị gia tăng",
  valueAddedServiceTaskDetail: "Chi tiết nhiệm vụ dịch vụ giá trị gia tăng",
  valueAddedServiceFee: "Phí dịch vụ giá trị gia tăng",
  valueAddedServiceList: "Danh sách dịch vụ giá trị gia tăng",
  approverList: "Danh sách người phê duyệt",
  approvalProcesstemplate: "Mẫu quy trình phê duyệt",
  Import_the_approval_process_template: "Nhập mẫu quy trình phê duyệt",
  SKU_Inventory_Transfer: "Chuyển kho SKU",
  Full_Inventory: "Toàn bộ kho",
  Transfer_the_entire_inventory_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_in_all_warehouses_After_the_task_is_completed_the_product_barcode_and_SKU_will_have_a_suffix:
    "Chuyển toàn bộ kho SKU tương ứng trong hệ thống sang khách hàng tương ứng. Sau khi hoàn thành nhiệm vụ, mã vạch hàng hóa và SKU sẽ được thêm hậu tố",
  Partial_Inventory: "Một phần kho",
  Transfer_the_specified_quantity_of_the_corresponding_SKU_in_the_system_to_the_specified_customer_Re_labeling_is_required:
    "Chuyển kho hàng với số lượng chỉ định trong hệ thống của SKU tương ứng sang khách hàng tương ứng. Cần dán nhãn lại.",
  Label_Removal: "Xé nhãn",
  Common_scenarios_include_removing_the_specified_barcode_from_the_product_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:
    "Tình huống thường gặp, xé nhãn mã vạch chỉ định trên hàng hóa. Tùy theo mức độ khó xử lý, kho hàng sẽ định giá lại nhiệm vụ này.",
  Replace_Product_Barcode: "Thay đổi mã vạch hàng hóa",
  Replace_the_barcode_on_the_product_with_the_system_barcode_Common_scenarios_include_incorrect_barcode_content_mismatch_with_system_settings_damaged_barcode_stained_barcode_and_aged_barcode_that_cannot_be_recognized:
    "Thay thế mã vạch trên hàng hóa bằng mã vạch trong hệ thống. Tình huống thường gặp: nội dung mã vạch hàng hóa sai, không phù hợp với nội dung cài đặt trong hệ thống, mã vạch hàng hóa bị hỏng, bị bẩn, mã vạch hàng hóa bị cũ không thể nhận dạng.",
  Replace_Other_Labels_on_Products: "Thay thế nhãn khác trên hàng hóa",
  Replace_the_labels_on_products_according_to_requirements_If_the_processing_is_complex_please_describe_it_clearly_or_provide_detailed_information_The_warehouse_will_re_price_this_task_based_on_the_difficulty_of_processing:
    "Xử lý thay thế nhãn trên hàng hóa theo yêu cầu. Nếu xử lý phức tạp, vui lòng mô tả rõ ràng hoặc cung cấp thông tin chi tiết. Tùy theo mức độ khó khăn của việc xử lý, kho sẽ định giá lại nhiệm vụ này.",
  Processing: "Chế biến",
  Common_scenarios_include_processing_the_packaging_box_bubble_wrap_and_specified_products_transported_to_the_warehouse_If_it_is_complex_please_provide_a_detailed_operation_process_It_can_be_created_together_with_the_creation_of_the_inventory_receipt_or_added_as_a_value_added_service_before_the_inventory_receipt_starts_inspection:
    "Tình huống thường gặp: Chế biến hộp đóng gói, màng bong bóng và hàng hóa được chỉ định được vận chuyển đến kho. Nếu việc xử lý phức tạp, vui lòng cung cấp quy trình hoạt động chi tiết. Có thể tạo cùng lúc khi tạo phiếu nhập kho hoặc thêm dịch vụ giá trị gia tăng trước khi bắt đầu kiểm tra chất lượng phiếu nhập kho.",
  Assembly: "Lắp ráp",
  Common_scenarios_include_assembling_multiple_products_into_a_new_product_or_multiple_assemblies_of_products_and_adjusting_the_inventory_for_corresponding_shelf_up_and_shelf_down_operations_after_assembly_If_there_are_complex_assembly_operations_please_provide_detailed_explanations_and_example_files:
    "Tình huống thường gặp: Lắp ráp nhiều hàng hóa thành một sản phẩm mới hoặc lắp ráp hàng hóa nhiều lần, sau khi lắp ráp, kho sẽ điều chỉnh tương ứng việc lên kệ và xuống kệ. Nếu có thao tác lắp ráp phức tạp, vui lòng mô tả chi tiết và cung cấp tài liệu ví dụ chi tiết.",
  transfer_customer_id: "Chuyển ID khách hàng",
  Transfer_inventory_to_use_current_label:
    "Chuyển kho có sử dụng nhãn hiện tại không",
  If_selected_the_product_barcode_of_the_transferred_party_will_be_changed_to_the_current_SKU_barcode_If_not_selected_the_product_barcode_of_the_transferred_party_will_remain_unchanged:
    "Chọn Có, sau khi chuyển kho, mã vạch hàng hóa của bên được chuyển sẽ trở thành mã vạch SKU hiện tại. Chọn Không, mã vạch của hàng hóa được chuyển sẽ không thay đổi",
  file: "Tệp",
  select_inventory: "Chọn kho hàng",
  Save_and_Submit: "Lưu và gửi",
  greater_than_0_number: "Số lớn hơn 0",
  batch_submit: "Gửi hàng loạt",
  batch_return_to_be_audit: "Trả lại hàng loạt để chờ phê duyệt",
  batch_revoke: "Hủy hàng loạt",
  batch_confirm: "Xác nhận hàng loạt",
  Confirm_revoke: "Xác nhận hủy?",
  The_remarks_are_the_same_as_the_original: "Ghi chú giống như ghi chú ban đầu",
  task_info: "Thông tin nhiệm vụ",
  Audit_flow: "Quy trình phê duyệt",
  Joint_approval: "Phê duyệt chung",
  Single_approval: "Phê duyệt riêng",
  Process_flow: "Quy trình xử lý",
  Module_type: "Loại mô-đun",
  processing: "Đang xử lý",
  add_flow: "Thêm quy trình",
  edit_flow: "Chỉnh sửa quy trình",
  select_auditor: "Chọn người phê duyệt",
  Audit_details: "Chi tiết phê duyệt",
  Approval_level: "Cấp phê duyệt",
  approver_Type: "Loại phê duyệt",
  comfirm_delete: "Xác nhận xóa?",
  please_set_audit_flow: "Vui lòng thiết lập quy trình phê duyệt",
  valueAddedServiceFeeDetail: "Chi tiết phí dịch vụ giá trị gia tăng",
  addValueAddedServiceTask: "Tạo nhiệm vụ dịch vụ giá trị gia tăng",
  expense_deduction_details: "Chi tiết khấu trừ phí",
  createValueAddedServiceTask: "Tạo nhiệm vụ dịch vụ giá trị gia tăng",
  editValueAddedServiceTask: "Chỉnh sửa nhiệm vụ dịch vụ giá trị gia tăng",
  create_Task: "Tạo nhiệm vụ",
  set_Audit_Flow: "Thiết lập quy trình phê duyệt",
  return_Audit_Flow: "Hủy quy trình phê duyệt",
  batch_confirm_audit: "Xác nhận phê duyệt hàng loạt",
  set_process_flow: "Thiết lập quy trình xử lý",
  return_process_flow: "Hủy quy trình xử lý",
  batch_complete_task: "Hoàn thành nhiệm vụ hàng loạt",
  Edit_price: "Chỉnh sửa giá",
  Joint_audit: "Phê duyệt chung",
  Single_audit: "Phê duyệt riêng",
  add_approver: "Thêm người phê duyệt",
  print_task: "In nhiệm vụ",
  view_audit_process: "Xem quy trình phê duyệt",
  view_process_flow: "Xem quy trình xử lý",
  confirm_complete_task: "Xác nhận hoàn thành nhiệm vụ",
  billing_type: "Loại tính phí",
  mark_Exception: "Đánh dấu bất thường",
  replenishmentTaskControl: "Kiểm soát nhiệm vụ bổ sung hàng hóa",
  replenishmentList: "Danh sách nhiệm vụ bổ sung hàng hóa",
  Picking_storage_location_number: "Số kho lấy hàng",
  Inventory_storage_location_number: "Số kho dự trữ hàng hóa",
  Order_quantity_awaiting_replenishment:
    "Số lượng hàng hóa cần bổ sung theo đơn đặt hàng",
  Replenishment_control_threshold_quantity:
    "Số lượng ngưỡng kiểm soát bổ sung hàng hóa",
  Picking_items_below_the_threshold_based_on_the_current_inventory_quantity:
    "Số lượng hàng hóa hiện có trong kho lấy hàng dưới ngưỡng",
  Inventory_threshold_for_picking_warehouse_locations:
    "Ngưỡng hàng hóa trong kho lấy hàng",
  Number_of_task_varieties: "Số lượng loại hàng hóa trong nhiệm vụ",
  No_recommended_storage_location_Default_replenishment_quantity_is_not_specified:
    "Không có vị trí kho được đề xuất Số lượng bổ sung hàng tồn kho mặc định",
  Generate_replenishment_task: "Tạo nhiệm vụ bổ sung hàng tồn kho",
  Create_replenishment_task_control:
    "Tạo kiểm soát nhiệm vụ bổ sung hàng tồn kho",
  Only_video_and_image_formats_are_supported_for_preview_for_other_types_of_files_please_download_them_and_view_them:
    "Chỉ hỗ trợ xem trước định dạng video và hình ảnh, các loại tệp khác vui lòng tải xuống để xem",
  returnRemark: "Ghi chú trả lại",
  The_length_of_this_note_does_not_exceed_2000_characters:
    "Độ dài ghi chú không quá 2000",
  shopeeOnlineProductDetails: "Chi tiết sản phẩm trực tuyến Shopee",
  lazadaOnlineProductDetails: "Chi tiết sản phẩm trực tuyến Lazada",
  tiktokOnlineProductDetails: "Chi tiết sản phẩm trực tuyến Tiktok",
  lazadaHostTheOnlineProductDetails:
    "Chi tiết hàng hóa trực tuyến do Lazada quản lý",
  Shop_SKU: "SKU cửa hàng",
  Inventory_SKU: "SKU tồn kho",
  Multi_attribute_ID: "ID đa thuộc tính",
  Pairing_Log: "Nhật ký ghép đôi",
  "Confirm_unpairing?": "Confirm_unpairing?",
  Prompt: "Thông báo",
  Confirm: "Xác nhận",
  Operation_successful: "Hoạt động thành công",
  Deletion_cancelled: "Đã hủy xóa",
  Unpair: "Hủy ghép đôi",
  Online_SKU_Image: "Hình ảnh SKU trực tuyến",
  Multi_attribute: "Đa thuộc tính",
  Inventory_SKU_Image: "Hình ảnh SKU tồn kho",
  Chinese_Name: "Tên tiếng Trung",
  English_Name: "Tên tiếng Anh",
  Store: "Cửa hàng",
  Inventory_Sync_Time: "Thời gian đồng bộ hóa tồn kho",
  Inventory_Sync_Quantity: "Số lượng đồng bộ hóa tồn kho",
  Online_SKU: "SKU trực tuyến",
  Please_select_customer_first: "Vui lòng chọn khách hàng trước",
  Please_check_only_one_item: "Vui lòng chỉ chọn một mục",
  Inventory_synchronization_time: "Thời gian đồng bộ hóa kho",
  Inventory_synchronization_quantity: "Số lượng đồng bộ hóa kho",
  Handover_task_order_number: "Số đơn giao nhận",
  taskStatus: "Trạng thái nhiệm vụ",
  delivery_door: "Cổng giao hàng",
  trailer_number: "Số xe tải",
  handover_person: "Người giao nhận",
  handover_start_time: "Thời gian bắt đầu giao nhận",
  handover_end_time: "Thời gian kết thúc giao nhận",
  handover_attachments: "Phụ lục giao nhận",
  Ended: "Đã kết thúc",
  handoverTime: "Thời gian giao nhận",
  scan_the_flow_chart: "Quét dòng chảy",
  upload_attachments: "Tải lên phụ lục",
  print_handover_form: "In phiếu giao nhận",
  scanTime: "Thời gian quét",
  orderDetails: "Chi tiết đơn hàng",
  handover_scanning_time: "Thời gian quét giao nhận",
  scan_people: "Người quét",
  create_handover_task: "Tạo nhiệm vụ chuyển giao",
  end_handover_task: "Kết thúc nhiệm vụ chuyển giao",
  Are_you_sure_to_end_the_current_friendship_task:
    "Xác nhận kết thúc nhiệm vụ chuyển giao hiện tại",
  end_handover_task_success: "Kết thúc nhiệm vụ chuyển giao thành công",
  created_successfully: "Tạo thành công",
  Please_enter_the_task_number: "Vui lòng nhập số nhiệm vụ",
  marking_can_be_posted_for_outbound_shipment:
    "Đánh dấu có thể dán phiếu xuất kho",
  remove_the_label_from_the_outbound_shipment: "Xóa có thể dán phiếu xuất kho",
  selected_product: "Đã chọn hàng hóa",
  can_be_posted_and_shipped_from_the_warehouse: "Kho có thể dán phiếu xuất kho",
  batch_posting_outbound_information: "Thông tin xuất kho dán phiếu hàng loạt",
  scan: "Quét",
  batch_labeling_posting_and_outbound: "Đánh dấu xuất kho dán phiếu hàng loạt",
  batch_deletion_of_tags_stickers_and_outbound_shipments:
    "Xóa hàng loạt đánh dấu xuất kho",
  amount_money: "Số tiền",
  logisticsControlList: "Kiểm soát chuyển giao logistics",
  Confirm_the_deletion_of_the_logistics_handover_processr:
    "Xác nhận xóa chuyển giao logistics?",
  New_logistics_handover_added: "Thêm chuyển giao logistics",
  taskSchedulingList: "Danh sách lịch trình nhiệm vụ",
  taskLogList: "Danh sách nhật ký nhiệm vụ",
  serverList: "Danh sách máy chủ",
  Task_name: "Tên nhiệm vụ",
  Task_type: "Loại nhiệm vụ",
  Task_priority: "Mức độ ưu tiên nhiệm vụ",
  Distribution_rules: "Quy tắc phân phối",
  Port_path: "Đường dẫn cổng",
  Minimum_running_memory: "Bộ nhớ chạy tối thiểu",
  Minimum_running_CPU: "CPU chạy tối thiểu",
  Whether_it_is_enabled: "Có bật không",
  Asynchronous_distribution: "Phân phối không đồng bộ",
  Scheduled_execution: "Thực hiện theo lịch",
  Periodical_execution: "Thực hiện theo chu kỳ",
  Last_run_start_time: "Thời gian bắt đầu chạy gần nhất",
  Please_enter_a_name_for_the_task: "Vui lòng nhập tên nhiệm vụ",
  Please_enter_a_task_priority: "Vui lòng nhập mức độ ưu tiên nhiệm vụ",
  Please_enter_a_distribution_rule: "Vui lòng nhập quy tắc phân phối",
  Please_enter_the_port_path: "Vui lòng nhập đường dẫn cổng",
  Please_enter_the_minimum_running_memory:
    "Vui lòng nhập bộ nhớ chạy tối thiểu",
  Please_enter_the_minimum_running_CPU: "Vui lòng nhập CPU chạy tối thiểu",
  Distribute_parameter_content: "Nội dung tham số phân phối",
  Unusual_content: "Nội dung bất thường",
  Abnormal_time: "Thời gian bất thường",
  Server_status: "Trạng thái máy chủ",
  Server_name: "Tên máy chủ",
  Server_port: "Cổng máy chủ",
  memory: "Bộ nhớ",
  Update_the_server_information: "Cập nhật thông tin máy chủ",
  listWarehouseTransferTasks: "Danh sách nhiệm vụ chuyển kho",
  Move_out_Of_Warehouse: "Chuyển ra kho",
  Move_into_warehouse: "Chuyển vào kho",
  Completion_time_warehouse_transfer: "Thời gian hoàn thành chuyển kho",
  Please_select_to_move_out_of_the_warehouse: "Vui lòng chọn kho chuyển ra",
  Please_select_to_move_into_the_warehouse: "Vui lòng chọn kho nhập",
  Moving_in_and_out_of_the_warehouse_is_not_allowed_to_be_repeated:
    "Không được lặp lại việc chuyển vào và chuyển ra kho",
  Warehouse_transfer_task_number: "Số nhiệm vụ chuyển kho",
  Remove_warehouse_location_number: "Số vị trí kho xuất",
  Move_into_storage_location_number: "Số vị trí kho nhập",
  Create_warehouse_transfer_task: "Tạo nhiệm vụ chuyển kho",
  addWarehouseTransferTaskBtn: "Tạo nhiệm vụ chuyển kho",
  edit_warehouse_transfer_task: "Chỉnh sửa nhiệm vụ chuyển kho",
  Warehouse_transfer_type: "Loại chuyển kho",
  Partial_warehouse_transfer: "Chuyển kho một phần",
  All_positions_transferred: "Chuyển kho toàn bộ",
  Warehouse_transfer_information: "Thông tin chuyển kho",
  Move_out_warehouse_location: "Số vị trí kho xuất",
  Move_into_storage_location: "Số vị trí kho nhập",
  Please_select_the_type_of_warehouse_transfer: "Vui lòng chọn loại chuyển kho",
  Please_select_the_storage_location_number_to_be_moved_into:
    "Vui lòng chọn số vị trí kho nhập",
  Select_the_goods_that_need_to_be_transferred: "Chọn hàng hóa cần chuyển",
  Quickly_plan_storage_locations: "Lập kế hoạch vị trí kho nhanh",
  Please_select_the_goods_that_require_rapid_planning_of_storage_locations:
    "Vui lòng chọn hàng hóa cần lập kế hoạch vị trí kho nhanh",
  Only_virtual_and_temporary_storage_locations_can_be_used_at_this_location_The_virtual_and_temporary_storage_locations_of_this_warehouse_are_empty_Please_create_the_corresponding_virtual_and_temporary_storage_locations_for_the_warehouse_and_then_refresh_again:
    "Chỉ có thể sử dụng vị trí kho ảo và vị trí kho tạm thời tại đây, vị trí kho ảo và vị trí kho tạm thời của kho này đang trống, vui lòng tạo vị trí kho ảo và vị trí kho tạm thời tương ứng cho kho rồi làm mới và thử lại",
  The_number_of_listings_cannot_exceed_the_inventory_quantity_The_current_inventory_quantity_is:
    "Số lượng lên kệ không được lớn hơn số lượng tồn kho, số lượng tồn kho hiện tại là",
  Select_a_store: "Chọn cửa hàng",
  If_the_shipping_address_in_the_store_is_backend_is_not_consistent_with_the_system_warehouse_address_it_cannot_be_selected_Please_go_to_the_store_authorization_page_to_confirm:
    "Không thể chọn cửa hàng nếu địa chỉ giao hàng trong hệ thống quản lý cửa hàng không khớp với địa chỉ kho của hệ thống, vui lòng xác nhận tại trang ủy quyền cửa hàng",
  Shop_shipping_warehouse: "Kho giao hàng của cửa hàng",
  Clear_all: "Xóa tất cả",
  No_data_obtained: "Không lấy được dữ liệu",
  Selected_store: "Đã chọn cửa hàng",
  synchronousInventorySettingList: "Danh sách cài đặt đồng bộ hóa tồn kho",
  synchronousInventoryLogList: "Danh sách nhật ký đồng bộ hóa tồn kho",
  synchronousInventoryAnomaly: "Lỗi đồng bộ hóa tồn kho",
  synchronousInventoryProductList:
    "Danh sách đồng bộ hóa tồn kho hàng hóa trực tuyến",
  store: "Cửa hàng",
  online_sku: "SKU trực tuyến",
  multi_attribute_id: "ID đa thuộc tính",
  multi_attribute: "Đa thuộc tính",
  inventory_sku: "SKU tồn kho",
  sync_time: "Thời gian đồng bộ hóa",
  online_sku_image: "Hình ảnh SKU trực tuyến",
  sync_inventory_quantity: "Số lượng tồn kho đồng bộ hóa",
  rule_name: "Tên quy tắc",
  inventory_allot_policy: "Chiến lược phân bổ tồn kho",
  modifier: "Người sửa đổi",
  create_time: "Thời gian tạo",
  modify_time: "Thời gian sửa đổi",
  create: "Tạo",
  set_non_sync_online_products: "Cài đặt không đồng bộ hóa sản phẩm trực tuyến",
  The_creation_and_modification_rules_will_not_take_effect_immediately_Please_wait_patiently:
    "Quy tắc tạo/sửa đổi sẽ không có hiệu lực ngay lập tức, vui lòng kiên nhẫn chờ đợi.",
  Only_online_products_that_have_been_paired_with_inventory_SKUs_will_be_synchronized:
    "Chỉ những sản phẩm trực tuyến có SKU tồn kho phù hợp mới được đồng bộ hóa.",
  Inventory_threshold: "Giới hạn tồn kho",
  Sync_store_range: "Phạm vi đồng bộ hóa cửa hàng",
  Sync_SKU_ranges: "Phạm vi SKU đồng bộ hóa",
  Recent_run_time: "Thời gian chạy gần đây nhất",
  Sync_specified_policy_inventory:
    "Đồng bộ hóa hàng tồn kho theo chính sách chỉ định",
  The_quantity_of_available_inventory_at_that_time:
    "Số lượng hàng tồn kho có sẵn tại thời điểm đó",
  The_available_inventory_quantity_during_the_synchronization_process:
    "Số lượng hàng tồn kho có sẵn khi thực hiện đồng bộ hóa",
  Synchronized_item_ID: "ItemId lịch sử",
  synchronous_regimes: "Trạng thái đồng bộ hóa",
  synchronous_messages: "Thông báo đồng bộ hóa",
  The_name_of_the_inventory_updateable_strategy:
    "Tên chính sách có thể cập nhật hàng tồn kho",
  Inventory_synchronization_strategy: "Chính sách đồng bộ hóa hàng tồn kho",
  Inventory_synchronization_strategy_value:
    "Giá trị chính sách đồng bộ hóa hàng tồn kho",
  ExportOrderTraceTaskList: "Chi tiết giao nhận logistics",
  Are_you_sure_to_modify_the_processing_plan:
    "Xác nhận phương án xử lý sửa đổi",
  The_task_number_selection_is_inconsistent_please_choose_again:
    "Số nhiệm vụ không khớp, vui lòng chọn lại",
  Only_products_with_inventory_quantity_greater_than_0_and_inventory_quantity_greater_than_the_occupied_inventory_quantity_can_be_selected:
    "Chỉ có thể chọn hàng hóa có số lượng tồn kho lớn hơn 0 và số lượng tồn kho lớn hơn số lượng tồn kho đang sử dụng",
  There_are_not_enough_suitable_storage_locations_for_the_user_please_choose_on_your_own:
    "Không đủ vị trí kho phù hợp cho người dùng, vui lòng tự chọn",
  Import_warehouse_order: "Nhập đơn đặt hàng kho",
  Do_you_want_to_cancel_the_selected_warehouse_transfer_task:
    "Có hủy nhiệm vụ chuyển kho đã chọn không",
  Have_you_completed_the_warehouse_relocation_task:
    "Có hoàn thành nhiệm vụ chuyển kho không",
  Has_the_status_of_pending_reception_confirmed:
    "Đã xác nhận trạng thái chờ nhận chưa",
  Please_first_select_the_warehouse_transfer_task_that_needs_to_be_revoked:
    "Vui lòng chọn nhiệm vụ chuyển kho cần hủy",
  Are_you_sure: "Xác nhận",
  completeWarehouseRelocation: "Hoàn thành chuyển kho",
  exportTransferTask: "Xuất nhiệm vụ chuyển kho",
  transfer_task_list: "Danh sách nhiệm vụ chuyển kho",
  AdjustTheWarehouseRelocationTaskLocation:
    "Điều chỉnh vị trí kho của nhiệm vụ chuyển kho",
  Print_the_inventory_transfer_list: "In danh sách chuyển kho",
  Print_transfer_and_packing_information: "In thông tin đóng gói chuyển kho",
  exportWarehouseInventoryInformation: "Xuất thông tin kho hàng",
  Only_one_warehouse_transfer_task_can_be_selected:
    "Chỉ có thể chọn một nhiệm vụ chuyển kho",
  Export_existing_inventory: "Xuất kho hàng hiện có",
  Export_all_inventory: "Xuất tất cả kho hàng",
  Please_select_the_relocation_task: "Vui lòng chọn nhiệm vụ chuyển kho",
  binning: "Phân chia thùng",
  Please_download_from_the_task_center_in_five_minutes:
    "Vui lòng tải xuống tại trung tâm nhiệm vụ sau 5 phút",
  server_storage_address: "Địa chỉ lưu trữ máy chủ",
  Please_add_product_details_first: "Vui lòng thêm chi tiết hàng hóa trước",
  Please_select_products_with_SKU_and_location_numbers_that_are_not_the_same:
    "Vui lòng chọn hàng hóa có mã SKU và vị trí kho khác nhau",
  Profit_Order_payment_for_product_amount_Refund_Actual_Freight_Seller_Paid_Freight_Platform_Freight_Subsidy_Exchange_Freight_Seller_Freight_Discount_TSP_Commission_Platform_Commission_Alliance_Commission_Transaction_Fees_SFP_Service_Fees_Service_Fees_Additional_Plan_Service_Fees_Logistics_Insurance_Fees_Freight_Service_Tax_SST_Value_Added_Tax_VAT_Product_Service_Tax_Seller_Discount_Coupons_Return_Order_Freight_Other_Platform_Fees_Credit_Card_Payment_Fees_Platform_Adjustment_Amount_Ecological_Donations_Fees_Refund_Product_Amount_Return_Order_Return_Freight_x_Exchange_Rate_Product_Procurement_Cost_Initial_Freight_Warehouse_Rent_Listing_Fee_Order_Processing_Fee:
    "Lợi nhuận = (Số tiền thanh toán hàng hóa trong đơn hàng - Tiền hoàn lại - Chi phí vận chuyển thực tế + Chi phí vận chuyển do người bán thanh toán + Trợ cấp chi phí vận chuyển của nền tảng - Chi phí vận chuyển đổi hàng - Chiết khấu chi phí vận chuyển của người bán - Hoa hồng TSP - Hoa hồng nền tảng - Hoa hồng liên minh - Phí giao dịch - Phí dịch vụ SFP - Phí dịch vụ - Phí dịch vụ kế hoạch bổ sung - Phí bảo hiểm logistics - Thuế dịch vụ vận chuyển SST - Thuế giá trị gia tăng (VAT) - Thuế dịch vụ sản phẩm - Phiếu giảm giá của người bán - Phí vận chuyển đơn hàng trả lại - Các chi phí khác của nền tảng - Phí thanh toán thẻ tín dụng + Số tiền điều chỉnh của nền tảng - Đóng góp sinh thái - Phí thủ tục - Số tiền hàng hóa hoàn lại - Phí vận chuyển trả hàng) × Tỷ giá hối đoái - (Chi phí mua hàng + Phí vận chuyển đầu tiên + Phí thuê kho + Phí lên kệ + Phí xử lý đơn hàng)",
  The_value_added_tax_paid_by_the_platform_on_behalf_of_the_buyer_import_value_added_tax_value_added_tax_paid_by_the_platform_on_behalf_of_the_seller:
    "Thuế giá trị gia tăng mà nền tảng thanh toán thay mặt người mua + Thuế giá trị gia tăng nhập khẩu + Thuế giá trị gia tăng mà nền tảng thanh toán thay mặt người bán",
  Return_order_return_fee: "Phí trả hàng",
  When_the_original_currency_conversion_profit_financial_currency_exchange_rate_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_data_will_be_synchronized_after_24_00_on_the_same_day:
    "Khi chưa thiết lập tỷ giá hối đoái của đồng tiền gốc của cửa hàng để tính lợi nhuận, hệ thống sẽ không thực hiện đồng bộ hóa dữ liệu. Sau khi thiết lập, dữ liệu sẽ được đồng bộ hóa sau 24 giờ cùng ngày.",
  Gold_coin_deduction: "Khấu trừ tiền vàng",
  Platform_preferential_subsidies: "Khoản trợ cấp ưu đãi của nền tảng",
  Installment_payment_handling_fee: "Phí thanh toán trả góp",
  Sellers_free_shipping_promotion_fee_refund_of_shipping_fee_to_customer_shipping_subsidy_provided_by_seller_seller_pays_for_shipping_fee:
    "Chi phí khuyến mãi miễn phí vận chuyển của người bán + chi phí vận chuyển hoàn trả cho khách hàng + khoản trợ cấp vận chuyển do người bán cung cấp + chi phí vận chuyển do người bán thanh toán",
  The_total_amount_of_other_expenses_not_shown_such_as_FBI_project_processing_fees_buyer_review_incentives_LazFlash_additional_daily_subsidies_below_9_99_etc:
    "Tổng các chi phí khác không được hiển thị, ví dụ: phí xử lý dự án FBI, khuyến khích đánh giá của người mua, trợ cấp LazFlash bổ sung/hàng ngày dưới 9,99 đô la, v.v.",
  starting_inventory: "Kho hàng ban đầu (>=)",
  Terminate_inventory: "Kho hàng cuối cùng (<)",
  Inventory_allocation_strategy: "Chiến lược phân bổ kho hàng",
  Inventory_update_value: "Giá trị cập nhật kho hàng",
  Fixed_value: "Giá trị cố định",
  Percentage: "Tỷ lệ phần trăm",
  schema: "Chế độ",
  Add_the_maximum_inventory_range: "Thêm khoảng kho hàng tối đa",
  Shop_back_end: "Bảng điều khiển cửa hàng",
  Mapping_warehouse_address: "Địa chỉ kho hàng được ánh xạ",
  ship_address: "Địa chỉ giao hàng",
  Create_a_strategy: "Tạo chiến lược",
  Manually_synchronize_the_specified_strategy:
    "Đồng bộ hóa thủ công chiến lược chỉ định",
  Inventory_warning_threshold: "Ngưỡng cảnh báo tồn kho",
  resynchronization: "Đồng bộ hóa lại",
  Latest_synchronization_time: "Thời gian đồng bộ hóa gần nhất",
  Synchronous_logs: "Nhật ký đồng bộ hóa",
  The_shipping_address_in_the_store_is_back_end_must_be_exactly_the_same_as_the_warehouse_address_If_they_are_not_the_same_please_modify_it_in_the_store_is_back_end_and_then_click_the_Manually_Synchronize_Warehouse_button:
    "Địa chỉ giao hàng trong trang quản lý cửa hàng phải hoàn toàn trùng khớp với địa chỉ kho hàng. Nếu không trùng khớp, vui lòng sửa đổi trong trang quản lý cửa hàng và nhấp vào nút đồng bộ hóa kho hàng thủ công.",
  The_fixed_value_strategy_is_a_fixed_quantity_and_the_percentage_strategy_is_a_percentage_of_the_current_available_inventory:
    "Chiến lược giá trị cố định là số lượng cố định, chiến lược tỷ lệ phần trăm là tỷ lệ phần trăm của kho hiện có sẵn.",
  The_creation_modification_manual_synchronization_of_the_policy_will_be_completed_within_half_an_hour:
    "Tạo/sửa đổi/tạo/sửa đổi/đồng bộ hóa thủ công chiến lược sẽ được thực hiện trong vòng 30 phút.",
  Please_check_the_synchronization_status_in_the_synchronization_inventory_log_list:
    "Vui lòng xem tình trạng đồng bộ hóa trong danh sách nhật ký đồng bộ hóa kho.",
  Only_the_online_products_that_have_been_matched_with_the_inventory_SKUs_will_be_synchronized:
    "Chỉ những sản phẩm trực tuyến có SKU kho phù hợp mới được đồng bộ hóa.",
  The_shipping_address_in_the_store_is_backend_must_be_exactly_the_same_as_the_warehouse_address_in_the_system:
    "Địa chỉ giao hàng trong phần quản lý cửa hàng phải hoàn toàn trùng khớp với địa chỉ kho hàng trong hệ thống.",
  Maximum_synchronized_inventory: "Hàng tồn kho tối đa có thể đồng bộ hóa",
  total_inventory: "Tổng hàng tồn kho",
  Unshipped_inventory: "Hàng tồn kho chưa giao",
  Warehouse_orders_include_those_that_have_been_shipped_delivered_invalidated_cancelled_and_those_that_match_the_total_quantity_of_the_corresponding_SKUs:
    "Đơn hàng kho hàng trừ các đơn hàng đã giao, đã vận chuyển, đã hủy, đã hủy bỏ, tổng số lượng SKU phù hợp.",
  The_maximum_synchronizable_inventory_quantity_for_a_combined_SKU_is_equal_to_the_lowest_inventory_quantity_among_the_SKUs_in_the_combination:
    "Số lượng hàng tồn kho tối đa có thể đồng bộ hóa của SKU kết hợp bằng với SKU có hàng tồn kho ít nhất trong kết hợp.",
  Select_store: "Chọn cửa hàng",
  Specified_SKUs: "Chỉ định SKU",
  To_prevent_over_selling_when_the_synchronized_inventory_falls_below_the_warning_threshold_the_system_will_automatically_set_the_inventory_quantity_to_0:
    "Để phòng ngừa bán quá số lượng, khi kho hàng có thể đồng bộ hóa thấp hơn ngưỡng cảnh báo, hệ thống sẽ tự động đồng bộ hóa số lượng kho hàng thành 0.",
  Set_inventory_alert_threshold_100_Current_maximum_available_inventory_99_Below_the_inventory_alert_threshold_the_system_synchronizes_the_inventory_quantity_to_0:
    "Ví dụ: Đặt ngưỡng cảnh báo kho hàng: 100, kho hàng tối đa hiện có: 99 thấp hơn ngưỡng cảnh báo kho hàng, hệ thống đồng bộ hóa số lượng kho hàng thành 0.",
  Input_the_synchronous_inventory_range_interval_When_the_quantity_of_synchronous_inventory_falls_within_this_range_the_system_will_synchronize_based_on_the_set_synchronization_strategy_and_the_synchronous_inventory_quantity:
    "Nhập phạm vi kho hàng có thể đồng bộ hóa, khi số lượng kho hàng có thể đồng bộ hóa nằm trong phạm vi này, hệ thống sẽ đồng bộ hóa theo chính sách đồng bộ hóa và số lượng kho hàng đã thiết lập",
  Add_asynchronous_online_products:
    "Thêm sản phẩm trực tuyến không đồng bộ hóa",
  Asynchronous_online_product_logs:
    "Nhật ký sản phẩm trực tuyến không đồng bộ hóa",
  This_operation_will_permanently_delete_Do_you_want_to_continue:
    "Thao tác này sẽ xóa vĩnh viễn, có tiếp tục không?",
  contractList: "Danh sách hợp đồng",
  contractDetail: "Chi tiết hợp đồng",
  The_name_of_the_contract: "Tên hợp đồng",
  Contract_number: "Số hợp đồng",
  Type_of_contract: "Loại hợp đồng",
  Initiation_time: "Thời gian khởi tạo",
  Signing_time: "Thời gian ký kết",
  Expiration_time: "Thời gian hết hạn",
  voided_ontract: "Hợp đồng vô hiệu",
  Rejection_contract: "Hợp đồng bị từ chối",
  Activate_the_contract: "Hợp đồng được kích hoạt",
  contractSubject: "Chuyển đổi danh sách chủ thể",
  Apply_for_switching_the_entity: "Đăng ký chuyển đổi chủ thể",
  Rejection_time: "Thời gian từ chối",
  Those_who_rejected_it: "Người từ chối",
  Reason_for_Rejection: "Lý do từ chối",
  Details_of_the_Supplementary_Agreement: "Chi tiết thỏa thuận bổ sung",
  downLoadContract: "Tải xuống hợp đồng",
  Please_select_the_customer_type: "Vui lòng chọn loại khách hàng",
  E_signature_Treasure_Authorization_Status: "Trạng thái ủy quyền eSign",
  Invalid_review: "Xem xét vô hiệu",
  Review_rejected: "Xem xét từ chối",
  Parent_Contract_Number: "Số hợp đồng mẹ",
  Is_it_the_contracting_party: "Có phải là chủ thể ký kết hợp đồng không?",
  Without_signing_the_contract_all_functions_will_be_prohibited:
    "Nếu hợp đồng không được ký kết trong thời gian quy định, tất cả các chức năng sẽ bị vô hiệu hóa",
  protocolCode: "Mã thỏa thuận",
  Has_the_contract_and_user_information_been_verified_to_be_correct_and_approved_for_review:
    "Đã xác minh hợp đồng và thông tin người dùng là chính xác, xác nhận phê duyệt?",
  Sign_expiration_date: "Ngày hết hạn ký kết",
  Signing_link_expiration_date: "Ngày hết hạn liên kết ký kết",
  Please_contact_your_dedicated_investment_manager_to_review_the_contract_information:
    "Vui lòng liên hệ với nhân viên kinh doanh chuyên trách của bạn để phê duyệt thông tin hợp đồng.",
  Whether_to_automatically_renew: "Có tự động gia hạn không",
  Used_for_subsequent_billing_and_invoicing_functions_of_the_system_account:
    "Dùng cho chức năng lập hóa đơn sau khi thanh toán tài khoản hệ thống",
  The_phone_number_of_the_current_contract_signatory_otherwise_the_contract_cannot_be_successfully_signed:
    "Số điện thoại di động của người ký hợp đồng hiện tại, nếu không hợp đồng sẽ không thể ký kết thành công",
  Real_QQ_WeChat_contact_with_our_company_otherwise_the_contract_cannot_be_successfully_signed:
    "QQ/WeChat liên hệ thực sự với công ty chúng tôi, nếu không hợp đồng sẽ không thể ký kết thành công",
  addcompany: "Thêm công ty",
  Sign_contract_documents: "Thông tin ký hợp đồng",
  qq_wehat__non_nickname: "QQ/WeChat (không phải biệt danh)",
  Company_Name: "Tên doanh nghiệp",
  contracting_entity: "Đơn vị ký hợp đồng",
  Do_you_want_to_apply_for_switching_subjects:
    "Có yêu cầu chuyển đổi đơn vị ký hợp đồng không?",
  Please_contact_the_investment_promotion_review_to_switch_the_subject_application:
    "Vui lòng liên hệ với bộ phận thẩm định đầu tư để chuyển đổi chủ thể",
  deadline: "Hạn chót",
  Is_the_selected_contract_to_be_reviewed: "Có được phê duyệt không",
  Whether_to_void_the_selected_contract: "Có bị hủy bỏ không",
  Note_To_ensure_the_legal_validity_of_the_contract_please_verify_the_accuracy_of_relevant_materials:
    "Lưu ý: Để đảm bảo hiệu lực pháp lý của hợp đồng, vui lòng kiểm tra tính chính xác của các tài liệu liên quan",
  Inventory_information: "Thông tin đơn đặt hàng",
  Product_Details: "Chi tiết sản phẩm",
  suggest_types: "Loại đề xuất",
  stock_up_suggestions: "Đề xuất đặt hàng",
  shortage_suggestion: "Đề xuất hàng thiếu",
  generate_a_backup_order: "Tạo đơn đặt hàng",
  Total_number_of_products_awaiting_review:
    "Tổng số lượng hàng hóa chờ phê duyệt",
  Planned_stocking_inventory: "Kho hàng dự kiến",
  Sales_volume_7_14_30_60_90: "Doanh số bán hàng (7/14/30/60/90)",
  Daily_average_sales_in_the_past_30_days:
    "Doanh số bán hàng trung bình hàng ngày trong 30 ngày gần nhất",
  Stock_quantity: "Số lượng hàng dự trữ",
  Minimum_reserve_price: "Giá dự trữ tối thiểu",
  Last_stocking_price: "Giá dự trữ lần trước",
  Reserve_currency_type: "Đơn vị tiền tệ dự trữ",
  Stock_unit_price: "Giá đơn vị hàng dự trữ",
  In_stock: "Đang dự trữ",
  Total_stocking_price: "Tổng giá hàng dự trữ",
  Stock_quantity_times_Stock_unit_price:
    "Số lượng hàng dự trữ * Giá đơn vị hàng dự trữ",
  The_stage_of_inventory_management_is_equal_to_the_total_number_of_matching_SKUs_in_the_pending_review_and_inventory_process:
    "Quản lý đơn hàng dự trữ Giai đoạn tương đương với đang chờ phê duyệt, đang dự trữ, tổng số lượng SKU phù hợp",
  Daily_sales_in_the_past_30_days_purchase_days_warning_inventory_total_inventory_in_transit_inventory_if_less_than_0_display_0:
    "Doanh số bán hàng hàng ngày trong 30 ngày gần nhất*số ngày mua hàng+kho dự trữ cảnh báo-tổng lượng hàng tồn kho-hàng tồn kho đang vận chuyển, nếu nhỏ hơn 0 thì hiển thị 0",
  By_default_it_is_equal_to_the_currency_of_the_last_stocking_If_not_available_it_is_RMB_which_can_be_modified:
    "Mặc định bằng đơn vị tiền tệ của lần dự trữ hàng trước, nếu không có thì là RMB, có thể sửa đổi",
  By_default_it_is_equal_to_the_unit_price_of_the_last_stocking_If_not_available_it_is_the_purchase_price_of_the_product_which_can_be_modified:
    "Mặc định bằng đơn giá của lần dự trữ hàng trước, nếu không có thì là giá mua hàng hóa, có thể sửa đổi",
  Completed_the_last_completed_stocking_unit_price_for_matching_SKUs:
    "Đã hoàn thành, giá đơn vị hàng tồn kho cuối cùng của SKU phù hợp.",
  Starting_time_of_stocking: "Thời gian bắt đầu chuẩn bị hàng",
  Please_select_the_start_time_for_stocking:
    "Vui lòng chọn thời gian bắt đầu chuẩn bị hàng",
  Completed_matching_the_lowest_stocking_unit_price_for_SKU:
    "Đã hoàn thành, giá đơn vị hàng tồn kho thấp nhất của SKU phù hợp",
  Please_select_products_from_the_same_warehouse:
    "Vui lòng chọn hàng hóa trong cùng một kho",
  Stock_order_number: "Số đơn hàng chuẩn bị hàng",
  Stockist: "Nhân viên chuẩn bị hàng",
  LeadTime: "Thời gian chuẩn bị hàng",
  supplier: "Nhà cung cấp",
  Platform_order_status: "Tình trạng đơn hàng trên nền tảng",
  Subtotals_of_pre_discount_products:
    "Tổng giá trị hàng hóa trước khi giảm giá",
  Subtotals_of_discount_products: "Tổng giá trị hàng hóa sau khi giảm giá",
  Not_involved_in_order_profit_calculation_for_operational_analysis_reference_only_seller_discounts_product_discounts_flash_purchases_buy_more_save_more_vouchers_and_bundled_transactions:
    "Không tham gia tính toán lợi nhuận đơn hàng, chỉ dùng để tham khảo phân tích hoạt động, giảm giá của người bán (giảm giá sản phẩm, mua nhanh, mua nhiều tiết kiệm nhiều, phiếu giảm giá và giao dịch gói)",
  The_data_at_this_stage_is_the_original_data_before_merging_the_stocking_list_for_reference_only:
    "Dữ liệu ở giai đoạn này là dữ liệu gốc trước khi hợp nhất đơn hàng chuẩn bị hàng, chỉ dùng để tham khảo",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_only_for_orders_that_have_been_shipped_out_Profit_data_will_continue_to_be_updated_in_the_early_morning_until_the_settlement_time_of_platform_orders_is_updated:
    "Khi chưa thiết lập tỷ giá hối đoái của đồng tiền tài chính để chuyển đổi lợi nhuận của đồng tiền gốc của cửa hàng, hệ thống sẽ không thực hiện đồng bộ hóa dữ liệu. Sau khi thiết lập, hệ thống sẽ đồng bộ hóa dữ liệu của ngày hôm trước sau 24 giờ cùng ngày, chỉ đồng bộ hóa các đơn hàng đã xuất kho, dữ liệu lợi nhuận sẽ được cập nhật liên tục vào nửa đêm cho đến khi nền tảng thanh toán đơn hàng và cập nhật thời gian thanh toán.",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_days_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated:
    "Khi chưa thiết lập tỷ giá hối đoái của đồng tiền gốc của cửa hàng để chuyển đổi lợi nhuận, hệ thống sẽ không thực hiện đồng bộ hóa dữ liệu. Sau khi thiết lập, hệ thống sẽ đồng bộ hóa dữ liệu của ngày hôm trước sau 24 giờ cùng ngày, chỉ đồng bộ hóa các đơn hàng đã xuất kho và đã tạo hóa đơn. Dữ liệu lợi nhuận sẽ được cập nhật vào nửa đêm khi hóa đơn được tạo. Khi hóa đơn được tạo, thời gian thanh toán sẽ là thời gian tạo hóa đơn cuối cùng.",
  Exchange_rate_setting: "Cài đặt tỷ giá hối đoái",
  Total_quantity_of_stocked_goods: "Tổng số lượng hàng hóa dự trữ",
  Total_number_of_stocked_goods: "Tổng số lượng hàng hóa dự trữ",
  Total_price_of_the_purchase_order: "Tổng giá trị đơn hàng dự trữ",
  Total_cubic_meter_of_inventory_M_three:
    "Tổng khối lượng hàng hóa dự trữ (M³)",
  Total_weight_of_stock_KG: "Tổng trọng lượng hàng hóa dự trữ (KG)",
  Ending_time_of_stocking: "Thời gian kết thúc dự trữ",
  Real_payment_amount: "Số tiền thực tế thanh toán",
  Stocking_remarks: "Ghi chú dự trữ",
  Total_cubic_meters_of_goods_M_three: "Tổng khối lượng hàng hóa (M³)",
  Total_weight_of_the_product_KG: "Tổng trọng lượng hàng hóa (KG)",
  Merge_backup_documents: "Hợp nhất đơn hàng dự trữ",
  Are_you_sure_to_merge_the_selected_backup_orders:
    "Có xác nhận hợp nhất các đơn hàng dự trữ đã chọn không?",
  Change_to_void_status: "Thay đổi trạng thái thành vô hiệu",
  Change_the_status_to_abnormal: "Thay đổi trạng thái thành bất thường",
  Change_status_to_return: "Thay đổi trạng thái thành trả lại",
  Submit_to_stocking: "Gửi đến kho dự trữ",
  Have_you_submitted_it_to_the_inventory: "Có gửi đến kho dự trữ không?",
  Submit_to_Completed: "Gửi đến đã hoàn thành",
  SKUs_that_have_not_been_stocked_will_not_be_displayed_on_this_page:
    "SKU chưa nhập kho sẽ không hiển thị trên trang này.",
  Please_select_a_backup_order_to_print:
    "Vui lòng chọn một đơn hàng dự trữ để in.",
  Inventory_quantity_if_there_is_real_length_width_and_height_it_is_real_length_real_width_real_height_if_there_is_no_real_length_width_and_height_it_is_length_width_height_100000_if_less_than_0_001_it_is_equal_to_0_001:
    "Số lượng hàng dự trữ* (nếu có chiều dài, chiều rộng và chiều cao thực tế thì là chiều dài thực tế*chiều rộng thực tế*chiều cao thực tế, nếu không có chiều dài, chiều rộng và chiều cao thực tế thì là chiều dài*chiều rộng*chiều cao)/1000000, nếu nhỏ hơn 0,001 thì bằng 0,001",
  If_there_is_a_true_weight_the_stock_quantity_multiplied_by_the_true_weight_If_not_available_stock_quantity_weight:
    "Nếu có trọng lượng thực tế, thì số lượng hàng dự trữ*trọng lượng thực tế. Nếu không có, thì số lượng hàng dự trữ*trọng lượng",
  Append_contract: "Hợp đồng bổ sung",
  AppendContract: "Hợp đồng bổ sung",
  Add_supplementary_agreement: "Thỏa thuận phụ bổ sung",
  Add_an_ancillary_agreement_template: "Thêm mẫu thỏa thuận phụ",
  Addendum_to_the_subcontract: "Hợp đồng phụ bổ sung",
  Please_select_the_addendum_contract: "Vui lòng chọn hợp đồng bổ sung",
  contract: "Hợp đồng",
  To_be_signed: "Chờ ký",
  To_be_signed_contract: "Hợp đồng chờ ký",
  Go_to_sign: "Đi ký",
  You_have_contracts_to_sign: "Bạn có hợp đồng chờ ký, có muốn đi ký không?",
  Add_contract_template: "Thêm mẫu hợp đồng",
  Edit_contract_template: "Chỉnh sửa mẫu hợp đồng",
  Template_chinese_name: "Tên mẫu bằng tiếng Trung",
  Template_english_name: "Tên mẫu bằng tiếng Anh",
  Audit_contract: "Xem xét hợp đồng",
  Credit_limit: "Hạn mức tín dụng",
  Online_product_status: "Trạng thái hàng hóa trực tuyến",
  The_store_product_data_status_for_synchronizing_inventory_will_be_automatically_synchronized_at_least_once_a_day_and_other_unconfigured_items_need_to_be_manually_synchronized:
    "Cài đặt đồng bộ hóa trạng thái dữ liệu sản phẩm của cửa hàng ít nhất một lần mỗi ngày, các dữ liệu khác chưa được cấu hình cần phải đồng bộ hóa thủ công",
  Online_product_matching: "Kết hợp sản phẩm trực tuyến",
  Batch_Online_product_matching: "Kết hợp hàng loạt sản phẩm trực tuyến",
  receiveWarehousePermissions: "Quyền tiếp nhận kho",
  Choose_zones_and_shelves_for_quick_planning:
    "Chọn khu vực và kệ hàng được lên kế hoạch nhanh",
  If_a_partition_or_shelf_is_selected_only_unused_shelves_under_that_partition_or_shelf_will_be_recommended_If_partitioning_or_shelving_is_not_selected_it_will_be_recommended_that_the_corresponding_customer_s_receiving_warehouse_has_unused_storage_locations_near_the_inventory_shelves_If_there_is_no_inventory_it_will_not_be_recommended:
    "Nếu chọn khu vực hoặc kệ hàng, chỉ những kệ hàng chưa sử dụng trong khu vực hoặc kệ hàng đó mới được đề xuất. Nếu không chọn khu vực hoặc kệ hàng, những vị trí kho chưa sử dụng gần kệ hàng có hàng tồn kho của khách hàng tương ứng sẽ được đề xuất, nếu không có hàng tồn kho thì sẽ không được đề xuất.",
  Pair_product_images: "Hình ảnh sản phẩm kết hợp",
  Paired_product_barcode: "Mã vạch sản phẩm kết hợp",
  Matching_product_SKU: "SKU sản phẩm ghép đôi",
  Paired_product_Chinese_name: "Tên sản phẩm ghép đôi bằng tiếng Trung",
  Paired_product_English_name: "Tên sản phẩm ghép đôi bằng tiếng Anh",
  online_SKU: "SKU trực tuyến",
  Actual_amount: "Số tiền thực tế",
  Please_select_orders_from_the_same_platform:
    "Vui lòng chọn đơn hàng trên cùng một nền tảng",
  The_old_password_matches_the_new_password_please_re_enter:
    "Mật khẩu cũ và mật khẩu mới giống nhau, vui lòng nhập lại",
  generate_a_contract: "Tạo hợp đồng",
  Deposit_Bank: "Ngân hàng mở tài khoản",
  Deposit_Bank_No: "Số tài khoản ngân hàng mở tài khoản",
  ID_card_address: "Địa chỉ trên chứng minh nhân dân",
  ID_card_name: "Họ tên",
  Please_enter_your_name: "Vui lòng nhập họ tên",
  Please_enter_the_name_of_the_legal_representative:
    "Vui lòng nhập tên pháp nhân",
  Please_enter_the_company: "Vui lòng nhập công ty",
  Please_enter_the_legal_representative_company:
    "Vui lòng nhập công ty pháp nhân",
  Please_select_the_company: "Vui lòng chọn công ty",
  Please_enter_the_business_license_code:
    "Vui lòng nhập mã số giấy phép kinh doanh",
  contractTemplateManagemen: "Mẫu hợp đồng",
  Contract_Template_Id: "ID mẫu hợp đồng",
  Contract_signing_expiration_date: "Số ngày hết hạn ký hợp đồng",
  file_path: "Đường dẫn tệp",
  Please_select_the_contract_type: "Vui lòng chọn loại hợp đồng",
  Please_select_the_contract_template: "Vui lòng chọn mẫu hợp đồng",
  Please_upload_the_file: "Vui lòng tải lên tệp",
  Signing_effective_time: "Thời gian hiệu lực ký kết",
  Validity_period_of_ID_card: "Thời hạn hiệu lực chứng minh nhân dân",
  Please_enter_the_validity_period_of_your_ID_card:
    "Vui lòng nhập thời hạn hiệu lực chứng minh nhân dân",
  Validity_period_of_legal_person_s_ID_card:
    "Thời hạn hiệu lực chứng minh nhân dân pháp nhân",
  Please_enter_the_validity_period_of_the_legal_person_s_ID_card:
    "Vui lòng nhập thời hạn hiệu lực chứng minh nhân dân pháp nhân",
  Date_of_Birth: "Ngày sinh",
  Please_enter_your_date_of_birth: "Vui lòng nhập ngày sinh",
  Business_license_address: "Địa chỉ giấy phép kinh doanh",
  Validity_period_of_business_license: "Thời hạn hiệu lực giấy phép kinh doanh",
  Please_enter_the_validity_period_of_the_business_license:
    "Vui lòng nhập thời hạn hiệu lực của giấy phép kinh doanh",
  Please_enter_your_ID_address:
    "Vui lòng nhập địa chỉ trên chứng minh nhân dân",
  Please_enter_the_address_on_your_business_license:
    "Vui lòng nhập địa chỉ trên giấy phép kinh doanh",
  When_uploading_the_ID_card_file_the_first_one_is_the_front_of_the_ID_card_and_the_second_one_is_the_back_of_the_ID_card:
    "Khi tải lên tài liệu chứng minh nhân dân, ảnh đầu tiên là mặt trước chứng minh nhân dân, ảnh thứ hai là mặt sau chứng minh nhân dân",
  Please_select_data_from_the_same_warehouse:
    "Vui lòng chọn dữ liệu trong cùng một kho",
  Batch_modify_storage_location_types_and_store_SKU_types:
    "Sửa đổi hàng loạt loại vị trí kho, lưu trữ loại SKU",
  Single_page_signature_page: "Trang ký kết đơn trang",
  Please_enter_the_single_page_signature_page:
    "Vui lòng nhập trang ký kết đơn trang",
  Signature_page_number_of_saddle_seal: "Số trang ký kết dấu mộc",
  Please_enter_the_page_number_for_signing_the_saddle_seal:
    "Vui lòng nhập số trang ký tên trên trang ký tên",
  Total_number_of_pages_in_the_contract: "Tổng số trang hợp đồng",
  If_the_total_number_of_pages_in_the_contract_is_2_fill_in_1_2_The_total_number_of_pages_in_the_contract_is_3_please_fill_in_1:
    "Nếu tổng số trang hợp đồng là 2, hãy điền 1-2. Nếu tổng số trang hợp đồng là 3, hãy điền 1-3",
  Online_product_information: "Thông tin sản phẩm trực tuyến",
  Online_variant_ID: "ID biến thể trực tuyến",
  Import_warehouse_transfer_task: "Nhập nhiệm vụ chuyển kho",
  Export_warehouse_inventory_information: "Xuất thông tin kho hàng",
  Adjust_the_storage_location: "Điều chỉnh vị trí kho",
  The_selected_stock_quantity_cannot_be_0_please_enter_the_stock_quantity:
    "Số lượng hàng dự trữ đã chọn không được là 0, vui lòng nhập số lượng hàng dự trữ",
  Order_status: "Tình trạng đơn hàng",
  Rule_1: "Quy tắc 1",
  Rule_2: "Quy tắc 2",
  Channel_number: "Số kênh",
  Area_code: "Mã khu vực",
  Shelf_number: "Số kệ",
  Shelf_position: "Số vị trí kệ",
  Represent_with_1_2_letters_numbers_to_distinguish_different_functional_areas_for_example:
    "Sử dụng 1-2 chữ cái/số để phân biệt các khu vực chức năng khác nhau, ví dụ:",
  R_Receiving_Area: "R: Khu vực nhận hàng (Receiving)",
  S_Storage_Area: "S: Khu vực lưu trữ (Storage)",
  P_Picking_Area: "P: Khu vực lấy hàng (Picking)",
  D_Delivery_Area: "D: Khu vực giao hàng (Delivery)",
  Or_use_SA_to_distinguish_different_areas_of_different_functional_zones_heavy_shelves_light_shelves_ground_push:
    "Hoặc sử dụng SA để phân biệt các khu vực chức năng khác nhau (kệ nặng, kệ nhẹ, kệ đẩy)",
  Represented_by_1_2_digits_numbered_in_sequence_such_as_01_02__99_combined_with_the_area_number_such_as_S_01_for_storage_area:
    "Dùng 1-2 chữ số để biểu thị, đánh số theo thứ tự (ví dụ: 01, 02…99), kết hợp với số khu vực (ví dụ: S-01 biểu thị khu vực lưu trữ",
  Represent_with_1_2_digits_numbered_in_sequence_such_as_01_02_99_combined_with_the_area_channel_number_such_as_S_01_01_representing_the_first_shelf_of_the_first_channel_in_the_storage_area:
    "Dùng 1-2 chữ số để biểu thị, đánh số theo thứ tự (ví dụ: 01, 02…99), kết hợp với số lối đi khu vực (ví dụ: S-01-01 biểu thị kệ hàng thứ 1 ở lối đi thứ 1 của khu vực lưu trữ).",
  Represent_with_1_2_digits_numbered_from_bottom_to_top_such_as_01_02_03_combined_with_the_area_channel_and_shelf_number_such_as_S_01_01_01_representing_the_first_layer_of_the_first_shelf_in_the_first_channel_of_the_storage_area:
    "Dùng 1-2 chữ số để biểu thị, đánh số từ dưới lên trên (ví dụ: 01, 02, 03…), kết hợp với số khu vực, kênh, kệ (ví dụ: S-01-01-01 biểu thị tầng thứ nhất của kệ thứ nhất ở kênh thứ nhất của khu vực lưu trữ).",
  Represented_by_1_2_digits_the_same_layer_is_numbered_from_left_to_right_such_as_01_02_combined_with_the_area_channel_shelf_and_layer_numbers_such_as_S_01_01_01_01_representing_the_first_channel_first_shelf_first_layer_first_digit_grid_of_the_storage_area:
    "Sử dụng 1-2 chữ số, đánh số từ trái sang phải trên cùng một tầng (ví dụ: 01, 02…), kết hợp với khu vực, lối đi, kệ, số tầng (ví dụ: S-01-01-01-01 biểu thị vị trí đầu tiên (ô) trên tầng đầu tiên của kệ đầu tiên ở lối đi đầu tiên của khu vực lưu trữ).",
  Complete_coding_example_S_02_05_03_04: "Ví dụ mã hoàn chỉnh: S-02-05-03-04",
  if_03_is_03_rd_floor_04_is_04_th_storage_location_S_Storage_area_02_Second_aisle_05_Fifth_shelf:
    "03 Tầng thứ 3 04 Vị trí kho thứ 4 S Khu vực lưu trữ 02 Lối đi thứ hai 05 Kệ thứ năm",
  Please_enter_the_area_code: "Vui lòng nhập mã khu vực",
  Please_enter_the_channel_number: "Vui lòng nhập số lối đi",
  Please_enter_the_shelf_position: "Vui lòng nhập số vị trí kệ",
  Online_product_images: "Hình ảnh sản phẩm trực tuyến",
  increase_storage_locations: "Thêm vị trí kho",
  articleList: "Danh sách bài viết",
  article_Name: "Tên bài viết",
  whether_to_turn_it_on: "Có bật hay không",
  create_Article: "Tạo bài viết",
  edit_Article: "Chỉnh sửa bài viết",
  article_Details: "Chi tiết bài viết",
  Open: "Bật",
  Shut_down: "Tắt",
  articleDetail: "Chi tiết bài viết",
  External_ERP_Help_Documentation: "Tài liệu trợ giúp ERP bên ngoài",
  help_document: "Tài liệu trợ giúp",
  help_center: "Trung tâm trợ giúp",
  Please_enter_the_article_name: "Vui lòng nhập tên bài viết",
  Please_select_the_status: "Vui lòng chọn trạng thái",
  Please_select_the_menu: "Vui lòng chọn menu",
  helpDocument: "Tài liệu trợ giúp",
  shopeeGlobalOnlineProducts: "Sản phẩm trực tuyến toàn cầu của Shopee",
  global_item_id: "ItemId toàn cầu",
  global_multi_attribute_id: "ID đa thuộc tính toàn cầu",
  global_online_sku: "SKU trực tuyến toàn cầu",
  is_mapped: "Có ánh xạ hay không",
  product_status: "Trạng thái sản phẩm",
  pull_product_task: "Kéo nhiệm vụ sản phẩm",
  pull_log: "Kéo nhật ký",
  delete_shelves_by_layer: "Xóa kệ theo số tầng",
  The_lowest_purchase_unit_price_in_the_completed_stage_of_inventory_management:
    "Quản lý đơn hàng dự trữ Đã hoàn thành Đơn giá mua hàng thấp nhất trong giai đoạn",
  The_most_recent_purchase_unit_price_in_the_completed_stage_of_inventory_management:
    "Quản lý đơn hàng dự trữ Đã hoàn thành Đơn giá mua hàng gần nhất trong giai đoạn",
  Default_last_purchase_currency_initially_CNY:
    "Đơn vị tiền tệ mua hàng lần trước mặc định, ban đầu là CNY",
  The_default_is_the_last_purchase_unit_price_which_is_initially_the_purchase_price_of_the_product:
    "Mặc định là đơn giá mua hàng lần trước, ban đầu là giá mua hàng của sản phẩm.",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_and_planned_stock_quantity:
    "Doanh số bán hàng hàng ngày trong 30 ngày gần nhất * số ngày mua hàng + hàng tồn kho cảnh báo - tổng hàng tồn kho - hàng tồn kho đang vận chuyển - số lượng hàng dự trữ theo kế hoạch",
  Do_not_display_items_less_than_or_equal_to_0:
    "Không hiển thị nếu nhỏ hơn hoặc bằng 0",
  Daily_sales_in_the_past_30_days_multiplied_by_purchase_days_warning_inventory_total_inventory_in_transit_inventory_planned_stock_quantity_and_out_of_stock_quantity:
    "Doanh số bán hàng hàng ngày trong 30 ngày gần nhất * số ngày mua hàng + hàng tồn kho cảnh báo - tổng hàng tồn kho - hàng tồn kho đang vận chuyển - số lượng hàng dự trữ theo kế hoạch + số lượng hàng thiếu",
  Suggested_stocking_quantity_multiplied_by_purchase_unit_price:
    "Số lượng hàng dự trữ đề xuất * giá mua hàng",
  Completing_the_purchase_order_will_not_change_the_purchase_unit_price_of_the_goods:
    "Hoàn thành đơn đặt hàng, không thay đổi giá mua hàng hóa",
  The_number_of_layers_cannot_be_0: "Số tầng không thể là 0",
  Mandatory_deduction_of_fees: "Phạt tiền bắt buộc",
  Do_you_confirm_the_mandatory_deduction_of_fees: "Xác nhận phạt tiền bắt buộc",
  Unrestricted_balance_can_be_deducted_as_negative:
    "Không bị hạn chế, số dư có thể bị trừ âm",
  Inventory_management_pending_review_sum_of_stage_quantities_in_inventory_preparation:
    "Quản lý đơn đặt hàng Đang chờ phê duyệt + Đang chuẩn bị hàng Tổng số lượng giai đoạn",
  The_quantity_of_inventory_pending_review_reviewed_received_in_transit_warehouse_in_transit_in_the_final_stage_of_receiving_received_in_the_final_stage_under_quality_inspection_and_not_yet_listed_in_the_quality_inspection_stage:
    "Phiếu nhập kho Đang chờ phê duyệt, Đã phê duyệt, Nhận hàng tại kho trung chuyển, Đang vận chuyển, Đang nhận hàng cuối cùng, Đã nhận hàng cuối cùng, Đang kiểm tra chất lượng, Đã kiểm tra chất lượng Số lượng chưa lên kệ trong giai đoạn này",
  Please_enter_1_2_characters: "Vui lòng nhập 1-2 ký tự",
  Please_enter_1_2_digits: "Vui lòng nhập 1-2 chữ số",
  Please_enter_a_number: "Vui lòng nhập số",
  Is_it_an_available_storage_location:
    "Có phải là vị trí kho có thể sử dụng không",
  deduction_item: "Mục trừ phí",
  Sales_Trend_Chart: "Biểu đồ xu hướng bán hàng",
  total_occupancy_quantity: "Tổng số lượng chiếm dụng",
  Occupied_inventory_volume: "Tổng lượng hàng tồn kho chiếm dụng",
  Total_occupancy_quantity_order_occupancy_quantity_manual_outbound_occupancy_quantity_warehouse_transfer_occupancy_quantity:
    "Tổng số lượng chiếm dụng (số lượng chiếm dụng trong đơn hàng/số lượng chiếm dụng trong xuất kho thủ công/số lượng chiếm dụng trong chuyển kho)",
  Sales_time_filtering: "Lọc theo thời gian bán hàng",
  Order_occupancy_quantity: "Số lượng chiếm dụng trong đơn hàng",
  Quantity_occupied_by_manual_outbound:
    "Số lượng chiếm dụng trong xuất kho thủ công",
  Number_of_occupied_warehouses_for_relocation:
    "Số lượng chiếm dụng trong chuyển kho",
  Please_select_the_item_that_needs_to_be_deducted:
    "Vui lòng chọn mục cần trừ phí",
  Please_select_the_storage_type: "Vui lòng chọn loại lưu trữ",
  Please_select_the_type_of_storage_location: "Vui lòng chọn loại vị trí kho",
  Transfer_according_to_batches_If_the_transfer_quantity_is_less_than_or_equal_to_the_available_inventory_of_a_single_batch_transfer_the_available_inventory_first_If_the_available_inventory_of_the_batch_is_less_than_the_total_inventory_of_the_batch_it_cannot_be_transferred:
    "Chuyển theo lô, nếu số lượng chuyển <= hàng tồn kho có thể sử dụng của một lô, hãy chuyển hàng tồn kho có thể sử dụng trước. Nếu > hàng tồn kho có sẵn của lô < tổng hàng tồn kho của lô, không thể chuyển",
  If_batch_occupancy_quantity_priority_should_be_given_to_transferring_occupied_inventory_followed_by_transferring_available_inventory:
    "Nếu >= số lượng chiếm dụng của lô, ưu tiên chuyển hàng tồn kho chiếm dụng, sau đó chuyển hàng tồn kho có sẵn",
  After_transferring_a_batch_of_inventory_if_there_are_still_remaining_quantities_that_have_not_been_transferred_transfer_the_remaining_quantities_from_other_batches:
    "Sau khi chuyển xong hàng tồn kho của một lô, nếu còn số lượng chưa chuyển, hãy chuyển số lượng còn lại từ các lô khác",
  When_the_financial_currency_exchange_rate_for_converting_profits_from_the_original_currency_of_the_store_is_not_set_the_system_will_not_perform_data_synchronization_After_setting_it_the_previous_day_s_data_will_be_synchronized_after_24_00_on_the_same_day_Only_orders_that_have_been_issued_and_bills_have_been_generated_will_be_synchronized_Profit_data_will_be_updated_in_the_early_morning_when_bills_are_generated_and_the_settlement_time_will_be_based_on_the_last_time_bills_are_generated_Note_The_billing_of_platform_orders_may_be_generated_at_multiple_time_points_If_some_of_the_billing_points_are_generated_before_the_currency_exchange_rate_is_set_these_bills_will_not_be_pulled_resulting_in_incomplete_order_report_fees:
    "Khi chưa thiết lập tỷ giá hối đoái của đồng tiền gốc của cửa hàng để chuyển đổi lợi nhuận, hệ thống sẽ không thực hiện đồng bộ hóa dữ liệu. Sau khi thiết lập, hệ thống sẽ đồng bộ hóa dữ liệu của ngày hôm trước sau 24 giờ cùng ngày, chỉ đồng bộ hóa các đơn hàng đã xuất kho và đã tạo hóa đơn. Dữ liệu lợi nhuận sẽ được cập nhật vào nửa đêm khi hóa đơn được tạo. Khi hóa đơn được tạo, thời gian thanh toán sẽ là thời gian tạo hóa đơn cuối cùng. Lưu ý: Hóa đơn của đơn hàng trên nền tảng có thể được tạo ra vào nhiều thời điểm khác nhau. Nếu một phần hóa đơn được tạo ra trước khi thiết lập tỷ giá hối đoái tiền tệ, thì phần hóa đơn này sẽ không được lấy để tạo ra báo cáo đơn hàng. Vấn đề chi phí không đầy đủ",
  Currency_for_warehouse_fee_settlement: "Tiền tệ thanh toán chi phí kho",
  Original_currency_of_the_order: "Tiền tệ gốc của đơn hàng",
  BatchAddStorageLocations: "Thêm vị trí kho hàng loạt",
  Please_fill_in_the_scope_in_order: "Vui lòng điền theo thứ tự phạm vi",
  The_initial_value_cannot_be_greater_than_or_equal_to_the_end_value:
    "Giá trị ban đầu không được lớn hơn hoặc bằng giá trị kết thúc",
  The_initial_value_must_be_greater_than_0: "Giá trị ban đầu phải lớn hơn 0",
  The_interval_between_initial_and_final_values_should_not_exceed_20:
    "Khoảng cách giữa giá trị ban đầu và giá trị kết thúc không được vượt quá 20",
  Position_grid_number: "Số vị trí",
  Fetching: "Đang lấy",
  Refresh_delivery_exception: "Làm mới sự cố vận chuyển",
  Activate_Contract: "Kích hoạt hợp đồng",
  First_leg_order_log: "Nhật ký đơn hàng đầu tiên",
  Initial_billing_log: "Nhật ký hóa đơn đầu tiên",
  Create_template: "Tạo mẫu",
  Set_custom_calculation: "Cài đặt tính toán tùy chỉnh",
  Custom_calculation_log: "Nhật ký tính toán tùy chỉnh",
  Daily_sales_in_the_past_30_days: "Doanh số bán hàng trong 30 ngày gần nhất",
  Planned_stocking_quantity: "Số lượng hàng dự trữ theo kế hoạch",
  No_goods_found: "Không tìm thấy sản phẩm",
  Stock_up_suggestions_Product_information: "Thông tin sản phẩm đề xuất dự trữ",
  Out_of_stock_suggested_product_information:
    "Thông tin sản phẩm đề xuất khi hết hàng",
  Address_Business_License_Address: "Địa chỉ/Địa chỉ giấy phép kinh doanh",
  Customer_type: "Loại khách hàng",
  Customer_authorization_status: "Trạng thái ủy quyền của khách hàng",
  Authorization_effective_time: "Thời gian có hiệu lực của ủy quyền",
  Authorization_expiration_time: "Thời gian hết hiệu lực của ủy quyền",
  Go_to_authorization: "Đi đến ủy quyền",
  logistics_information: "Thông tin logistics",
  Logistics_update_time: "Thời gian cập nhật logistics",
  Current_inventory_batch_quantity: "Số lượng lô hàng tồn kho hiện tại",
  Unqualified_quantity_shortage_damage:
    "Số lượng không đạt tiêu chuẩn (số lượng thiếu/số lượng hư hỏng)",
  Positive_numbers_are_required_to_refund_fees_while_negative_numbers_are_required_to_deduct_customer_balances:
    "Số dương là số tiền phải hoàn lại, số âm là số tiền phải trừ vào số dư của khách hàng",
  ReturnedForGeneration: "Hoàn lại đang chờ tạo",
  Our_Information: "Thông tin của chúng tôi",
  the_other_party_s_information: "Thông tin của đối tác",
  Identity_witness_portrait: "Mặt ảnh thẻ căn cước",
  National_emblem_on_ID_card: "Mặt quốc huy thẻ căn cước",
  Please_enter_QQ_WeChat: "Vui lòng nhập QQ/WeChat",
  generated_person: "Người tạo",
  generation_time: "Thời gian tạo",
  The_automatic_addition_of_packaging_materials_will_only_be_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:
    "Tự động thêm vật liệu đóng gói chỉ được kích hoạt khi gửi đến chờ giao hàng hoặc lấy số vận đơn",
  preview: "Xem trước",
  Packaging_material_combination: "Kết hợp vật liệu đóng gói",
  Inventory_quantity_is_below: "Số lượng tồn kho dưới",
  Sales_in_the_last_30_days_greater_than:
    "Doanh số bán hàng trong 30 ngày gần đây trên",
  Sales_in_the_last_30_days_greater: "Doanh số bán hàng trong 30 ngày gần đây",
  Please_select_the_affiliated_warehouse: "Vui lòng chọn kho hàng thuộc về",
  The_calculated_suggested_stocking_quantity_will_be_sorted_in_descending_order:
    "Số lượng hàng dự trữ được đề xuất sau khi tính toán sẽ được sắp xếp theo thứ tự từ lớn đến nhỏ",
  Custom_calculation_settings: "Cài đặt tính toán tùy chỉnh",
  Suggested_stocking_quantity: "Số lượng hàng dự trữ được đề xuất",
  Calculate_based_on_custom_calculation_formula:
    "Tính toán theo công thức tính toán tùy chỉnh",
  Calculate_the_recommended_stocking_quantity_based_on_the_formula_in_your_custom_calculation_settings_located_in_the_top_right_corner:
    "Tính toán số lượng hàng dự trữ đề xuất dựa trên công thức của bạn ở góc trên bên phải - Cài đặt tính toán tùy chỉnh",
  When_the_available_inventory_cannot_meet_your_pending_shipment_quantity_a_shortage_recommendation_will_be_triggered_recommending_as_much_as_is_needed:
    "Khi lượng hàng tồn kho có sẵn không đủ để đáp ứng lượng hàng chờ giao, hệ thống sẽ kích hoạt đề xuất hàng thiếu, đề xuất số lượng hàng thiếu",
  The_total_quantity_of_goods_required_for_orders_in_the_pending_processing_and_review_stages_of_the_order_list:
    "Danh sách đơn hàng đang chờ xử lý + tổng số lượng hàng hóa cần thiết cho các đơn hàng đang chờ phê duyệt",
  Calculate_the_recommended_stocking_quantity_based_on_a_custom_calculation_formula:
    "Tính toán số lượng hàng tồn kho đề xuất theo công thức tính toán tùy chỉnh",
  Inventory_in_return_processing: "Hàng tồn kho đang xử lý trả hàng",
  Average_daily_sales_in_the_past_30_days_multiplied_by_purchase_days_plus_warning_inventory_at_least_one_must_be_activated:
    "(Doanh số bán hàng trung bình hàng ngày trong 30 ngày gần nhất * số ngày mua hàng) + hàng tồn kho cảnh báo, phải bật ít nhất một tùy chọn",
  Total_inventory_available_inventory_Total_number_of_goods_awaiting_review_Inventory_in_return_processing_In_transit_inventory_Planned_stocking_quantity_at_least_one_must_be_activated:
    "(Tổng lượng hàng tồn kho / hàng tồn kho có sẵn) - tổng lượng hàng hóa đang chờ phê duyệt - hàng tồn kho đang xử lý trả hàng - hàng tồn kho đang vận chuyển - số lượng hàng tồn kho dự kiến, phải bật ít nhất một tùy chọn",
  warehouse_type: "Loại kho",
  Please_enter_the_name_of_the_person_in_charge:
    "Vui lòng nhập tên người phụ trách",
  Only_process_orders_that_have_been_pending_review_and_entered_the_system_within_the_current_15_day_period:
    "Chỉ xử lý các đơn hàng đang chờ phê duyệt trong vòng 15 ngày kể từ thời điểm hiện tại",
  The_order_will_be_automatically_triggered_when_it_is_submitted_for_shipment_or_when_the_waybill_number_is_obtained:
    "Đơn hàng sẽ tự động được kích hoạt khi được gửi đến trạng thái chờ giao hàng hoặc đang lấy số vận đơn",
  Return_Order: "Đơn hàng trả lại",
  Pending_Review_Pending_Listing_In_Listing_Process_Number_of_Qualified_Items_Not_Yet_Completed_for_Listing:
    "Đang chờ phê duyệt, đang chờ lên kệ, đang lên kệ, số lượng đủ điều kiện nhưng chưa hoàn thành việc lên kệ",
  canChangeSku: "SKU có thể thay thế",
  abnormalSKUPendingProcessing: "SKU bất thường đang chờ xử lý",
  batch_change_sku: "Thay thế SKU hàng loạt",
  change_sku: "Thay thế SKU",
  please_select_the_sku_to_be_replaced: "Vui lòng chọn SKU cần thay thế",
  please_select_new_sku: "Vui lòng chọn SKU mới",
  please_select_orders_from_the_same_warehouse:
    "Vui lòng chọn đơn hàng trong cùng kho",
  The_old_and_new_sku_cannot_be_the_same: "SKU cũ và mới không được giống nhau",
  Mark_replaceable_SKU: "Đánh dấu SKU có thể thay thế",
  Month_of_cost_recalculation: "Tháng cần tính lại chi phí",
  Order_adjustment_amount: "Số tiền điều chỉnh đơn hàng",
  If_there_is_a_token_error_prompt_please_check_if_the_token_is_copied_correctly_or_if_the_authorized_Lazada_service_marketplace_site_corresponds_to_the_system_repository_country:
    "Nếu xuất hiện thông báo lỗi token, vui lòng kiểm tra xem token đã được sao chép chính xác hay chưa hoặc kiểm tra xem trang web dịch vụ Lazada có tương ứng với quốc gia kho hàng của hệ thống hay không.",
  channel_name: "Tên kênh",
  Service_Type: "Loại dịch vụ",
  Billing_Plan: "Kế hoạch tính phí",
  Delivery_countr: "Quốc gia giao hàng",
  Delivery_area: "Khu vực giao hàng",
  Logistics_provider_name: "Tên nhà vận chuyển",
  Quality_inspection_has_started: "Đã bắt đầu kiểm tra chất lượng",
  Completed_quality_inspection: "Đã hoàn thành kiểm tra chất lượng",
  Number_of_items_awaiting_quality_inspection:
    "Số lượng chờ kiểm tra chất lượng",
  The_number_of_quality_inspection_items_that_have_started:
    "Số lượng đã bắt đầu kiểm tra chất lượng",
  Number_of_completed_quality_inspections:
    "Số lượng đã hoàn thành kiểm tra chất lượng",
  Product_in_transit_details: "Chi tiết hàng hóa đang vận chuyển",
  Quick_Region_Selection: "Lựa chọn khu vực nhanh",
  Connection_error_please_check_if_the_video_plugin_is_open_and_try_again:
    "Lỗi kết nối, vui lòng kiểm tra xem plugin video đã được bật chưa, sau đó thử lại.",
  Failed_to_save_the_currently_recorded_video: "Không thể lưu video đang quay.",
  Please_enter_the_name_of_the_logistics_provider:
    "Vui lòng nhập tên nhà vận chuyển.",
  Please_enter_the_channel_name: "Vui lòng nhập tên kênh.",
  Please_select_the_delivery_country: "Vui lòng chọn quốc gia giao hàng.",
  Import_logistics_channel_management_data:
    "Nhập dữ liệu quản lý kênh logistics.",
  Export_Logistics_Channel_Management_Data:
    "Xuất dữ liệu quản lý kênh logistics.",
  Edit_channel: "Chỉnh sửa kênh.",
  Confirm_the_logistics_provider: "Xác nhận nhà vận chuyển.",
  Recording_local_address: "Địa chỉ quay video tại địa phương.",
  Confirm_Clearing_Order_Packaging: "Xác nhận xóa vật liệu đóng gói đơn hàng.",
  Operation_Successful: "Hoạt động thành công.",
  Please_Select_The_Data: "Vui lòng chọn dữ liệu.",
  Please_Select_Data_From_The_Same_Platform:
    "Vui lòng chọn dữ liệu trên cùng một nền tảng",
  Confirm_Transfer_To_Pending: "Xác nhận chuyển sang trạng thái chờ xử lý",
  Confirm_Excluding_All_Rules: "Xác nhận loại trừ tất cả các quy tắc",
  Confirm_Canceling_Exclusion_Of_All_Rules:
    "Xác nhận hủy loại trừ tất cả các quy tắc",
  Confirm_Excluding_Automatic_Packaging_Rules:
    "Xác nhận loại trừ quy tắc tự động đóng gói",
  Confirm_Canceling_Exclusion_Of_Automatic_Packaging_Rules:
    "Xác nhận hủy loại trừ quy tắc tự động đóng gói",
  Confirm_Excluding_Submission_Rules: "Xác nhận loại trừ quy tắc gửi",
  Confirm_Canceling_Exclusion_Of_Submission_Rules:
    "Xác nhận hủy loại trừ quy tắc gửi",
  Yes: "Có",
  No: "Không",
  Currently_Selected_Orders_Have_No_Shipping_Exceptions_No_Action_Required:
    "Đơn hàng hiện được chọn không có sự cố vận chuyển, không cần thao tác",
  Orders_Will_Be_Marked_As_Out_Of_Stock_If_Warehouse_Has_No_Inventory_After_Submission:
    "Sau khi thực hiện hành động gửi, các đơn hàng không có hàng trong kho sẽ được đánh dấu là hết hàng",
  Out_Of_Stock_Orders: "Đơn hàng hết hàng",
  Selected_Orders_Contain_Orders_Without_Tracking_Numbers_Cannot_Preview_Shipping_Labels:
    "Trong các đơn hàng đã chọn có đơn hàng có số vận đơn trống, không thể xem trước phiếu giao hàng",
  Preview_PDF: "Xem trước PDF",
  Sum_Of_Created_Within_Last_Seven_Days_Pending_Review_Tracking_Number_Acquisition_In_Progress_And_Shipping_Exceptions:
    "Tổng số đơn hàng cần kiểm duyệt, đang lấy số vận đơn và có sự cố vận chuyển trong vòng 7 ngày gần đây",
  Shipping_Exceptions_In_Last_Seven_Days:
    "Sự cố vận chuyển trong 7 ngày gần đây",
  Basic_Query: "Tìm kiếm cơ bản",
  Expired_Stores: "Cửa hàng đã hết hạn",
  Order_Number: "Số đơn hàng",
  Tracking_Number: "Số vận đơn",
  Creation_Time: "Thời gian tạo",
  Transaction_Number: "Số giao dịch",
  Platform: "Nền tảng",
  Order_Source: "Nguồn đơn hàng",
  API_Order: "Đơn hàng API",
  Push_Order: "Đơn hàng đẩy",
  Manual_Order: "Đơn hàng thủ công",
  Cargo_Query: "Tìm kiếm hàng hóa",
  Warehouse: "Kho",
  Logistics_Channel: "Kênh logistics",
  Country: "Quốc gia",
  Chinese_Product_Name: "Tên sản phẩm tiếng Trung",
  English_Product_Name: "Tên sản phẩm tiếng Anh",
  Order_Status_Query: "Tìm kiếm trạng thái đơn hàng",
  Logistics_Status: "Trạng thái logistics",
  Priority_Delivery: "Giao hàng ưu tiên",
  Delivery_Method: "Phương thức giao hàng",
  WMS_Status: "Trạng thái WMS",
  Platform_Status: "Trạng thái nền tảng",
  Time_Query: "Tìm kiếm thời gian",
  Confirmation_Time: "Thời gian xác nhận",
  Outbound_Time: "Thời gian xuất kho",
  Batch_Query: "Tìm kiếm hàng loạt",
  Add_Quick_Query: "Thêm tìm kiếm nhanh",
  Create_Order: "Tạo đơn hàng",
  Transfer_To_Tracking_Number_Acquisition_In_Progress_Or_Awaiting_Shipment:
    "Chuyển sang số vận đơn Đang lấy/Chờ giao hàng",
  Orders_With_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Awaiting_Shipment_Orders_Without_Tracking_Numbers_Will_Automatically_Transfer_To_Stage_Tracking_Number_Acquisition_In_Progress:
    "Đơn hàng có số vận đơn sẽ tự động chuyển sang giai đoạn: Chờ giao hàng, đơn hàng không có số vận đơn sẽ tự động chuyển sang giai đoạn: Đang lấy số vận đơn.",
  Transfer_To_Pending: "Chuyển sang chờ xử lý",
  Fetch_Orders: "Lấy đơn hàng",
  Set_Order_Packaging: "Cài đặt vật liệu đóng gói đơn hàng",
  Clear_Order_Packaging: "Xóa vật liệu đóng gói đơn hàng",
  Void_Orders: "Hủy đơn hàng",
  Delete_Orders: "Xóa đơn hàng",
  Only_Supports_Operating_API_Orders_Within_12_Hours_Of_Delivery_Deadline_And_Push_Orders_Created_More_Than_12_Hours_Ago:
    "Chỉ hỗ trợ các đơn hàng API trong vòng 12 giờ trước thời hạn giao hàng và các đơn hàng được tạo sau 12 giờ kể từ thời điểm tạo đơn hàng.",
  Return_To_Pending_Review: "Trả lại để chờ phê duyệt",
  Activate: "Kích hoạt",
  Refresh_Platform_Status: "Làm mới trạng thái nền tảng",
  Online_Product_Matching: "Kết hợp sản phẩm trực tuyến",
  Resubmit_For_Shipping: "Giao hàng lại",
  More_Operations: "Thao tác khác",
  Import: "Nhập",
  Export: "Xuất",
  Tracking_Number_Acquisition_Successful_Will_Automatically_Transfer_To_Awaiting_Shipment:
    "Sau khi lấy được số vận đơn, đơn hàng sẽ tự động chuyển sang trạng thái chờ giao hàng.",
  Shipping_Label_Operations: "Thao tác với phiếu giao hàng",
  Upload_Shipping_Label: "Tải lên phiếu giao hàng",
  System_Printing_Requires_Downloading_A_Print_Plugin:
    "Sử dụng hệ thống in cần tải xuống plugin in",
  Click_To_Download: "Nhấp để tải xuống",
  Print_Shipping_Label: "In phiếu giao hàng",
  Download_Shipping_Label: "Tải xuống phiếu giao hàng",
  Preview_Shipping_Label: "Xem trước phiếu giao hàng",
  Order_Batch_Processing: "Xử lý hàng loạt đơn hàng",
  Replace_SKU: "Thay thế SKU",
  Delete_SKU: "Xóa SKU",
  Add_SKU: "Thêm SKU",
  Modify_SKU_Quantity: "Sửa đổi số lượng SKU",
  Modify_Warehouse: "Sửa đổi kho",
  Edit_Notes: "Chỉnh sửa ghi chú",
  Rule_Processing: "Xử lý quy tắc",
  Exclude_Submission_Rules: "Loại trừ quy tắc gửi",
  Cancel_Excluding_Submission_Rules: "Hủy loại trừ quy tắc gửi",
  Exclude_Automatic_Packaging_Rules: "Loại trừ quy tắc đóng gói tự động",
  Cancel_Excluding_Automatic_Packaging_Rules:
    "Hủy loại trừ quy tắc đóng gói tự động",
  Exclude_All_Rules: "Loại trừ tất cả quy tắc",
  Cancel_Excluding_All_Rules: "Hủy loại trừ tất cả quy tắc",
  Exception: "Bất thường",
  Order_Amount: "Số tiền đơn hàng",
  Tracking_Number_Acquisition_In_Progress: "Đang lấy số vận đơn...",
  Push: "Đẩy",
  Manual: "Tay",
  Platform_Set_Priority_Delivery: "Cài đặt nền tảng ưu tiên giao hàng",
  Priority: "Ưu",
  Manual_Set_Priority_Delivery: "Cài đặt thủ công ưu tiên giao hàng",
  Pre_Sale_Orders: "Đơn hàng bán trước",
  Pre_Sale: "Bán trước",
  Out_Of_Stock: "Thiếu",
  Split_Orders: "Chia nhỏ đơn hàng",
  Split: "Chia nhỏ",
  Product_Category: "Loại hàng hóa",
  Product_Quantity: "Số lượng hàng hóa",
  Operation: "Thao tác",
  Edit: "Chỉnh sửa",
  Do_Not_Leave_Blanks_For_Line_Breaks: "Không để trống dòng",
  Warehouse_Order_List: "Danh sách đơn hàng kho",
  All: "Tất cả",
  Today: "Hôm nay",
  Yesterday: "Hôm qua",
  Day_Before_Yesterday: "Hôm kia",
  Last_Three_Days: "Ba ngày gần nhất",
  Last_Week: "Một tuần gần nhất",
  Last_Month: "Một tháng gần nhất",
  Non_Out_Of_Stock_Orders: "Đơn hàng không thiếu hàng",
  With_Tracking_Number: "Có số vận đơn",
  Without_Tracking_Number: "Không có số vận đơn",
  Notes: "Ghi chú",
  With_Notes: "Có ghi chú",
  Without_Notes: "Không có ghi chú",
  With_Platform_Notes: "Có ghi chú nền tảng",
  Without_Platform_Notes: "Không có ghi chú nền tảng",
  Platform_Notes: "Ghi chú nền tảng",
  Non_Split_Orders: "Đơn hàng không chia nhỏ",
  Non_Pre_Sale_Orders: "Đơn hàng không bán trước",
  Paired_Orders: "Đơn hàng ghép đôi",
  Already_Paired_Orders: "Đơn hàng đã ghép đôi",
  Not_Paired_Orders: "Đơn hàng chưa ghép đôi",
  Shipping_Exceptions: "Sự cố vận chuyển",
  Priority_Delivery_Orders: "Đơn hàng giao hàng ưu tiên",
  Non_Priority_Delivery_Orders: "Đơn hàng giao hàng không ưu tiên",
  With_Shipping_Exceptions: "Có sự cố vận chuyển",
  Without_Shipping_Exceptions: "Không có sự cố vận chuyển",
  Task: "Nhiệm vụ",
  All_Tasks: "Tất cả nhiệm vụ",
  Today_Tasks: "Nhiệm vụ hôm nay",
  Yesterday_Tasks: "Nhiệm vụ hôm qua",
  Submitted_Order_Tasks: "Nhiệm vụ đơn hàng đã gửi",
  Today_000000_180000_Submitted_Order_Tasks:
    "Nhiệm vụ đơn hàng được gửi từ 00:00:00 đến 18:00:00 hôm nay",
  Yesterday_000000_235959_Submitted_Order_Tasks:
    "Nhiệm vụ đơn hàng được gửi từ 00:00:00 đến 23:59:59 hôm qua",
  Not_Excluding_Submission_Rules: "Chưa loại trừ quy tắc gửi",
  Excluded_Submission_Rules: "Đã loại trừ quy tắc gửi",
  Not_Excluding_Automatic_Packaging_Rules:
    "Chưa loại trừ quy tắc đóng gói tự động",
  Excluded_Automatic_Packaging_Rules: "Đã loại trừ quy tắc đóng gói tự động",
  Shipping_Label: "Phiếu giao hàng",
  With_Shipping_Label: "Có phiếu giao hàng",
  Without_Shipping_Label: "Không có phiếu giao hàng",
  Online_Product_Image: "Hình ảnh sản phẩm trực tuyến",
  No_Online_Product_Details_Available:
    "Hiện không có chi tiết sản phẩm trực tuyến",
  Online_Product_Details: "Chi tiết sản phẩm trực tuyến",
  Product_Image: "Hình ảnh sản phẩm",
  System_Product_Details: "Chi tiết sản phẩm hệ thống",
  Quantity: "Số lượng",
  Out_Of_Stock_Status: "Có hết hàng không",
  Out: "Hết hàng",
  Total_Inventory: "Tổng lượng hàng tồn kho",
  Total_Available_Inventory: "Tổng lượng hàng tồn kho có thể sử dụng",
  Total_Occupied_Inventory: "Tổng lượng hàng tồn kho đã sử dụng",
  Total_Unavailable_Inventory: "Tổng lượng hàng tồn kho không thể sử dụng",
  Total_In_Transit_Inventory: "Tổng lượng hàng tồn kho đang vận chuyển",
  This_Operation_Will_Permanently_Delete_The_Query_Condition_Proceed:
    "Thao tác này sẽ xóa vĩnh viễn điều kiện truy vấn, có tiếp tục không?",
  Currently_Only_Single_Order_Upload_Is_Supported:
    "Hiện chỉ hỗ trợ tải lên đơn hàng đơn lẻ",
  Current_Order_Cannot_Upload_Shipping_Label_Only_Orders_With_Order_Status_As_Pending_Review_Or_Awaiting_Shipment_And_WMS_Status_As_Picking_Exception_Sorting_Exception_Shipping_Exception_Or_Cancellation_Exception_Can_Upload_Shipping_Label:
    "Đơn hàng hiện tại không thể tải lên phiếu giao hàng, chỉ những đơn hàng có trạng thái đang chờ phê duyệt hoặc đang chờ giao hàng, trạng thái wms là bất thường trong phân phối hàng, bất thường trong phân loại, bất thường trong giao hàng, bất thường trong hủy bỏ mới có thể tải lên phiếu giao hàng",
  Shipping_Label_Address_Is_Empty: "Địa chỉ phiếu giao hàng trống",
  Printing_In_Progress: "Đang in...",
  Network_Response_Failed: "Lỗi phản hồi mạng",
  Download_Failed_Please_Try_Again_Later:
    "Tải xuống không thành công, vui lòng thử lại sau",
  Select_The_SKU_To_Add_And_Enter_The_Quantity_To_Add:
    "Chọn SKU cần thêm và nhập số lượng SKU cần thêm",
  Product_Barcode: "Mã vạch sản phẩm",
  Only_One_Can_Be_Selected: "Chỉ có thể chọn một",
  Please_Enter_The_Quantity: "Vui lòng nhập số lượng",
  Please_Enter_Notes: "Vui lòng nhập ghi chú",
  Select_The_SKU_To_Delete: "Chọn SKU cần xóa",
  Please_Select_The_SKU: "Vui lòng chọn SKU",
  Order_Fetching_Time: "Thời gian nhận đơn hàng",
  Please_Enter_Separated_By_Commas_Or_Line_Breaks:
    "Vui lòng nhập, dùng dấu phẩy hoặc dấu xuống dòng để phân tách",
  Please_Select_Store: "Vui lòng chọn cửa hàng",
  Transaction_Number_And_Order_Fetching_Time_Cannot_Be_Empty_Simultaneously:
    "Số giao dịch và thời gian nhận đơn hàng không thể để trống cùng lúc",
  Fetch_Logistics_Tracking: "Lấy thông tin vận chuyển",
  Logistics_Tracking: "Thông tin vận chuyển",
  Latest_Update: "Cập nhật mới nhất",
  Logistics_Information_Is_Being_Fetched: "Đang lấy thông tin vận chuyển",
  Select_The_SKU_To_Modify_And_Enter_The_New_SKU_Quantity:
    "Vui lòng chọn SKU cần sửa đổi và nhập số lượng SKU cần sửa đổi",
  Select_Product: "Chọn hàng hóa",
  Please_Select_Warehouse: "Vui lòng chọn kho",
  Pair: "Ghép đôi",
  Paired_Product_Image: "Hình ảnh sản phẩm ghép đôi",
  Paired_Product_Barcode: "Mã vạch sản phẩm ghép đôi",
  Paired_Product_SKU: "SKU sản phẩm ghép đôi",
  Paired_Product_Chinese_Name: "Tên sản phẩm ghép đôi bằng tiếng Trung",
  Paired_Product_English_Name: "Tên sản phẩm ghép đôi bằng tiếng Anh",
  Statistics_Time_Range: "Phạm vi thời gian thống kê",
  Number_Of_People: "Số người",
  Human_Efficiency: "Hiệu suất lao động",
  Packing_Lead_Time: "Thời gian đóng gói",
  Starting_Hour: "Giờ bắt đầu",
  Corresponding_Hour_For_Calculation_Day: "Giờ tương ứng với ngày tính toán",
  Ending_Hour: "Giờ kết thúc",
  Corresponding_Hour_For_Calculation_Day_Plus_One_Day:
    "Giờ tương ứng với ngày tính toán cộng thêm một ngày",
  Changes_Take_Effect_From_The_Next_Hour:
    "Sửa đổi sẽ có hiệu lực vào giờ tiếp theo",
  Add: "Thêm",
  Operation_Log: "Nhật ký hoạt động",
  Type: "Loại",
  Calculation_Day: "Ngày tính toán",
  Calculation_Day_Starting_Hour: "Giờ bắt đầu ngày tính toán",
  Next_Day_Ending_Hour: "Giờ kết thúc ngày thứ hai",
  Calculation_Time_Field: "Trường thời gian tính toán",
  List_Row_Background_Color: "Màu nền dòng danh sách",
  Please_Enter_Starting_Hour: "Vui lòng nhập giờ bắt đầu",
  Please_Enter_A_Number_Between_0_And_23: "Vui lòng nhập số từ 0 đến 23",
  Starting_Hour_Cannot_Be_Greater_Than_Ending_Hour:
    "Giờ bắt đầu không được lớn hơn giờ kết thúc",
  Please_Enter_Ending_Hour: "Vui lòng nhập giờ kết thúc",
  Ending_Hour_Cannot_Be_Less_Than_Starting_Hour:
    "Giờ kết thúc không được nhỏ hơn giờ bắt đầu",
  Please_Enter_Type: "Vui lòng nhập loại",
  Type_Cannot_Be_Duplicated: "Loại không được trùng lặp",
  Please_Select_Background_Color: "Vui lòng chọn màu nền",
  Background_Color_Cannot_Be_Duplicated: "Màu nền không được trùng lặp",
  Please_Select_Calculation_Day: "Vui lòng chọn ngày tính toán",
  Please_Select_Calculation_Time_Field:
    "Vui lòng chọn trường thời gian tính toán",
  Auto_Update_Time: "Thời gian tự động cập nhật",
  Next_Auto_Update_Time: "Thời gian tự động cập nhật tiếp theo",
  Set_Statistical_Time_Range: "Đặt phạm vi thời gian thống kê",
  Orders_Not_Completed_For_Delivery_Before_Statistical_Time_Range:
    "Thời gian thống kê Các đơn hàng chưa hoàn thành trước đó",
  Warehouse_Orders: "Đơn hàng kho",
  Total_Orders_Awaiting_Shipment_Picking_In_Progress_And_Shipping_In_Progress_For_The_Corresponding_Warehouse:
    "Tổng số đơn hàng đang chờ giao, đang chọn hàng, đang giao của kho tương ứng",
  Total_Orders_Shipped_And_Dispatched_For_The_Corresponding_Warehouse:
    "Tổng số đơn hàng đã giao, đã vận chuyển của kho tương ứng",
  Total_Orders: "Tổng số đơn hàng",
  Total_Not_Shipped: "Tổng số đơn hàng chưa giao",
  Total_Shipped: "Tổng số đơn hàng đã giao",
  Please_Select_Time: "Vui lòng chọn thời gian",
  Hour: "Giờ",
  Minute: "Phút",
  Second: "Giây",
  Statistical_Time_Range: "Thời gian thống kê",
  Corresponding_Start_Time_Of_Execution_At_That_Time_End_Time:
    "Thời gian bắt đầu và kết thúc tương ứng được thực hiện tại thời điểm đó",
  Corresponding_Field_For_Statistical_Data:
    "Trường tương ứng được sử dụng để thống kê dữ liệu",
  Unread_Notification: "Thông báo chưa đọc",
  noticeList: "Danh sách thông báo",
  Receive_customer: "Khách hàng nhận hàng",
  Receive_staff: "Nhân viên nhận hàng",
  Receive_warehouse: "Kho nhận hàng",
  Receive_department: "Bộ phận nhận hàng",
  Receive_country: "Quốc gia nhận hàng",
  Add_Notification: "Thêm thông báo",
  Edit_Notification: "Chỉnh sửa thông báo",
  Recipient: "Đối tượng nhận hàng",
  Please_enter_a_title: "Vui lòng nhập tiêu đề",
  Please_enter_content: "Vui lòng nhập nội dung",
  Please_select_the_recipient: "Vui lòng chọn đối tượng nhận hàng",
  The_title_must_be_1_to_50_characters: "Tiêu đề phải có từ 1 đến 50 ký tự",
  Please_choose_a_logistics_provider: "Vui lòng chọn nhà vận chuyển",
  Platform_And_Shop: "Nền tảng/cửa hàng",
  Export_inventory_historical_inventory_information:
    "Xuất thông tin tồn kho + lịch sử tồn kho",
  Appointment_for_warehouse_entry_and_storage_time:
    "Đặt lịch hẹn thời gian nhập kho",
  To_be_confirmed: "Chờ xác nhận",
  Number_of_packaging_cycles: "Số vòng đóng gói",
  Please_select_the_scheduled_time_for_warehouse_entry_and_storage:
    "Vui lòng chọn thời gian đặt lịch hẹn nhập kho",
  storage_phase: "Giai đoạn nhập kho",
  quantity_in_transit: "Số lượng đang vận chuyển",
  Daily_scheduled_inbound_time: "Thời gian đặt lịch hẹn nhập kho hàng ngày",
  Select_time_range: "Chọn phạm vi thời gian",
  Maximum_number_of_reserved_storage_parties:
    "Số lượng đặt lịch hẹn nhập kho tối đa",
  Total_number_of_reserved_storage_units: "Tổng số lượng đặt lịch hẹn nhập kho",
  Available_for_appointment: "Có thể đặt lịch",
  Fully_booked: "Đã đặt lịch đầy",
  The_available_appointment_dates_are_green_and_the_remaining_number_of_available_appointments_per_day_is_displayed_below_the_dates_If_the_number_of_reserved_parties_is_full_it_will_be_marked_in_red_indicating_that_the_reservation_is_full:
    "Ngày có thể đặt lịch được hiển thị màu xanh lá cây, bên dưới ngày hiển thị số lượng còn lại có thể đặt lịch mỗi ngày. Số lượng đã đặt lịch đầy được hiển thị màu đỏ, hiển thị đã đặt lịch đầy.",
  Monday: "Thứ Hai",
  Tuesday: "Thứ Ba",
  Wednesday: "Thứ Tư",
  Thursday: "Thứ Năm",
  Friday: "Thứ Sáu",
  Saturday: "Thứ Bảy",
  Sunday: "Chủ Nhật",
  Pre_order_storage_for_the_next_seven_days:
    "Đặt lịch nhập kho trong 7 ngày tới",
};
